export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  Email: { input: any; output: any; }
  JSON: { input: any; output: any; }
  NonEmptyString: { input: any; output: any; }
  PlainID: { input: any; output: any; }
  PlainString: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export const AccelerationUnit = {
  /** Return the acceleration in seconds to 60 miles per hour. */
  SECONDS_TO_60_MILES_PER_HOUR: 'seconds_to_60_miles_per_hour',
  /** Return the acceleration in seconds to 100 kilometers per hour. */
  SECONDS_TO_100_KILOMETERS_PER_HOUR: 'seconds_to_100_kilometers_per_hour'
} as const;

export type AccelerationUnit = typeof AccelerationUnit[keyof typeof AccelerationUnit];
export const AccessType = {
  PRIVATE: 'Private',
  PUBLIC: 'Public',
  RESTRICTED: 'Restricted'
} as const;

export type AccessType = typeof AccessType[keyof typeof AccessType];
/** Information about an address. */
export type Address = {
  __typename?: 'Address';
  /** City. */
  city?: Maybe<Scalars['String']['output']>;
  /** Continent code (2 letters). */
  continent?: Maybe<Scalars['String']['output']>;
  /** Country code (2 letters). */
  country?: Maybe<Scalars['String']['output']>;
  /** County code (2 letters). */
  county?: Maybe<Scalars['String']['output']>;
  /**
   * Human-readable address of the location.
   * @deprecated In favor of `formatted_address`.
   */
  formattedAddress?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Human-readable address of the location. */
  formatted_address?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Municipality. */
  municipality?: Maybe<Scalars['String']['output']>;
  /** Street number. */
  number?: Maybe<Scalars['String']['output']>;
  /**
   * Postal code of the location.
   * @deprecated In favor of `postal_code`.
   */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** Postal code of the location. */
  postal_code?: Maybe<Scalars['String']['output']>;
  /** State or province. */
  state_province?: Maybe<Scalars['String']['output']>;
  /** Street name. */
  street?: Maybe<Scalars['String']['output']>;
  /**
   * String composed of 3 words which represent the location of an address on the globe. More details: http://w3w.co/<what3Words>.
   * @deprecated In favor of `what_3_words`.
   */
  what3Words?: Maybe<Scalars['String']['output']>;
  /** String composed of 3 words which represent the location of an address on the globe. More details: http://w3w.co/<what3Words>. */
  what_3_words?: Maybe<Scalars['String']['output']>;
};

export const AdhocAuthorisationMethod = {
  CREDIT_CARD: 'CREDIT_CARD',
  DEBIT_CARD: 'DEBIT_CARD',
  OTHER: 'OTHER',
  OTHER_APPLE_PAY: 'OTHER_Apple_Pay',
  OTHER_AUTHENTICATION_BY_CAR: 'OTHER_Authentication_by_car',
  OTHER_GOOGLE_PAY: 'OTHER_Google_Pay',
  QR_CODE: 'QR_CODE',
  SMS: 'SMS'
} as const;

export type AdhocAuthorisationMethod = typeof AdhocAuthorisationMethod[keyof typeof AdhocAuthorisationMethod];
/** Input fields to continue the navigation session to the next leg. */
export type AdvanceNavigationLegInput = {
  /** Geographic coordinates of the vehicle's current location. */
  current_location: PointInput;
  /** The unique identifier of the active navigation session. */
  id: Scalars['ID']['input'];
  /** State of charge (SOC) of the vehicle at the current location. If the current leg ends at a charging stop and this value is omitted, the navigation will assume the vehicle charges to its estimated optimal SOC. If the current leg ends at a non-charging via point and this value is omitted, the last known vehicle SOC is retained. */
  state_of_charge?: InputMaybe<StateOfChargeInput>;
};

export type AirPressure = {
  __typename?: 'AirPressure';
  /** Atmospheric pressure unit. */
  type: AirPressureUnit;
  /** Value of the atmospheric pressure. */
  value: Scalars['Float']['output'];
};

export type AirPressureInput = {
  /** Atmospheric pressure unit. */
  type: AirPressureUnit;
  /** Value of the atmospheric pressure. */
  value: Scalars['Float']['input'];
};

export const AirPressureUnit = {
  MILLIBAR: 'millibar'
} as const;

export type AirPressureUnit = typeof AirPressureUnit[keyof typeof AirPressureUnit];
export type AlternativeStationRadius = {
  __typename?: 'AlternativeStationRadius';
  /**
   * Source of inputted data.
   * @deprecated Not in use.
   */
  source: TelemetryInputSource;
  /** Preferred unit for the alternative station radius. */
  type: DistanceUnit;
  /** Value of the alternative station radius. */
  value: Scalars['Float']['output'];
};

export type AlternativeStationRadiusInput = {
  /** Source of inputted data. */
  source?: InputMaybe<TelemetryInputSource>;
  /** Preferred unit for the alternative station radius. */
  type: DistanceUnit;
  /** Value of the alternative station radius. */
  value: Scalars['Float']['input'];
};

/** Amenities available near a station. */
export const Amenities = {
  BAKERY: 'bakery',
  BATHROOM: 'bathroom',
  COFFEE: 'coffee',
  CONVENIENCE_STORE: 'convenience_store',
  HOTEL: 'hotel',
  MUSEUM: 'museum',
  PARK: 'park',
  PHARMACY: 'pharmacy',
  PLAYGROUND: 'playground',
  RESTAURANT: 'restaurant',
  SHOPPING: 'shopping',
  SUPERMARKET: 'supermarket'
} as const;

export type Amenities = typeof Amenities[keyof typeof Amenities];
/** Amenity data. */
export type Amenity = {
  __typename?: 'Amenity';
  /** Accessibility options at the amenity. */
  accessibility?: Maybe<AmenityAccessibility>;
  /** Address of the amenity. */
  address?: Maybe<Address>;
  /** Contact information for the amenity. */
  contact?: Maybe<AmenityContact>;
  /**
   * Date and time when an amenity was created.
   * @deprecated Will be removed.
   */
  createdAt?: Maybe<Scalars['String']['output']>;
  /**
   * Computed distance between station and amenity.
   * @deprecated In favor of `station_distance`.
   */
  distance?: Maybe<Scalars['Int']['output']>;
  /**
   * ID provided by an amenity data source as the row ID.
   * @deprecated In favor of `external_id`.
   */
  externalId?: Maybe<Scalars['String']['output']>;
  /** ID provided by an amenity data source as the row ID. */
  external_id: Scalars['String']['output'];
  /**
   * Full path URL to amenity foursquare page.
   * @deprecated Will be removed.
   */
  foursquareUrl?: Maybe<Scalars['String']['output']>;
  /** Unique amenity ID. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Date and time when an amenity was last updated. */
  last_updated: Scalars['DateTime']['output'];
  /** Geo location coordinates. This is a GeoJSON Point. */
  location: Point;
  /** Name of the amenity. */
  name: Scalars['String']['output'];
  /** Opening hours of the amenity. */
  opening_hours?: Maybe<AmenityOpeningHours>;
  /** Indicates whether pets are allowed. This does not apply to assistance dogs, which may have legal access. */
  pets_allowed?: Maybe<Scalars['Boolean']['output']>;
  /** Rating of an amenity, the value will be between 0.0 and 10.0. If no rating has been given, the value will be set to null. */
  rating?: Maybe<Scalars['Float']['output']>;
  /** Computed distance between station and amenity. */
  station_distance: Scalars['Float']['output'];
  /** Type of amenity. An amenity can belong to multiple categories. */
  type: Array<Maybe<Scalars['String']['output']>>;
  /**
   * Date and time when an amenity was last updated.
   * @deprecated In favor of `last_updated`.
   */
  updatedAt?: Maybe<Scalars['String']['output']>;
};


/** Amenity data. */
export type AmenityStation_DistanceArgs = {
  unit?: InputMaybe<DistanceUnit>;
};

/** Accessibility options at the amenity. */
export type AmenityAccessibility = {
  __typename?: 'AmenityAccessibility';
  /** Type of wheelchair accessibility at the amenity. */
  wheelchair?: Maybe<AmenityWheelchairAccessibilityType>;
};

/** Contact information for the amenity. */
export type AmenityContact = {
  __typename?: 'AmenityContact';
  /** Phone number to contact the amenity. */
  phone?: Maybe<Scalars['String']['output']>;
  /** Website of the amenity. */
  website?: Maybe<Scalars['String']['output']>;
};

/** Filter that can be applied to retrieve the amenity list. */
export type AmenityListFilter = {
  /** Type of amenity. An amenity can belong to multiple categories. */
  type?: InputMaybe<Array<Amenities>>;
};

/** Opening and access hours of the location. */
export type AmenityOpeningHours = {
  __typename?: 'AmenityOpeningHours';
  /** Regular hours, weekday-based. Only to be used if twentyfourseven=false, then this field needs to contain at least one RegularHours object. */
  regular_hours?: Maybe<Array<Maybe<AmenityRegularHours>>>;
  /** True to represent 24 hours a day and 7 days a week. */
  twentyfourseven?: Maybe<Scalars['Boolean']['output']>;
};

/** Amenity preferences for a route. */
export type AmenityPreferencesInput = {
  /** Desired amenities near all charge-stops along a route, with a 1 kilometer radius. */
  all_charge_stops?: InputMaybe<Array<AmenityType>>;
  /** Scheduled charge stops, with a specified amenity and timeline. */
  scheduled_charge_stops?: InputMaybe<Array<ScheduledChargeStopInput>>;
};

/** Regular hours, weekday-based. Only to be used if twentyfourseven=false, then this field needs to contain at least one RegularHours object. */
export type AmenityRegularHours = {
  __typename?: 'AmenityRegularHours';
  /** Beginning of the regular period, in local time, given in hours and minutes. Must be in 24h format with leading zeros. Example: "18:15". Hour/Minute separator: ":" Regex: ([0-1][0-9]|2[1-3]):[0-5][0-9]. */
  period_begin?: Maybe<Scalars['String']['output']>;
  /** End of the regular period, in local time, syntax as for period_begin. Must be later than period_begin. */
  period_end?: Maybe<Scalars['String']['output']>;
  /** Number of days in the week, from Monday (1) till Sunday (7). */
  weekday?: Maybe<Scalars['Int']['output']>;
};

/** A list of amenity types. */
export const AmenityType = {
  BAKERY: 'bakery',
  BATHROOM: 'bathroom',
  COFFEE: 'coffee',
  CONVENIENCE_STORE: 'convenience_store',
  HOTEL: 'hotel',
  MUSEUM: 'museum',
  PARK: 'park',
  PHARMACY: 'pharmacy',
  PLAYGROUND: 'playground',
  RESTAURANT: 'restaurant',
  SHOPPING: 'shopping',
  SUPERMARKET: 'supermarket'
} as const;

export type AmenityType = typeof AmenityType[keyof typeof AmenityType];
/** Type of wheelchair accessibility at the amenity. */
export const AmenityWheelchairAccessibilityType = {
  /** The amenity is designated or purpose-built for wheelchairs (e.g. bathroom designed for wheelchair access only). */
  DESIGNATED: 'designated',
  /** Wheelchairs have partial access (e.g some areas can be accessed and others not, areas requiring assistance by someone pushing up a steep gradient). */
  LIMITED: 'limited',
  /** Wheelchairs have no unrestricted access (e.g. stair only access). */
  NO: 'no',
  /** Wheelchairs have full unrestricted access. */
  YES: 'yes'
} as const;

export type AmenityWheelchairAccessibilityType = typeof AmenityWheelchairAccessibilityType[keyof typeof AmenityWheelchairAccessibilityType];
export type AuthorizeConnectedVehicleInput = {
  /** Id from the connected vehicle */
  id: Scalars['ID']['input'];
  /** Provider specific options. See the developer portal for more details */
  options: AuthorizeConnectedVehicleOptions;
};

export type AuthorizeConnectedVehicleOptions = {
  /** OAuth code returned as a query parameter on the OAuth callback */
  code?: InputMaybe<Scalars['PlainString']['input']>;
};

export type AuxiliaryConsumption = {
  __typename?: 'AuxiliaryConsumption';
  /** Source of inputted data. */
  source: TelemetryInputSource;
  /** Preferred unit for the vehicle's auxiliary power consumption. */
  type: AuxiliaryConsumptionUnit;
  /** Value of the vehicle's auxiliary power consumption. */
  value: Scalars['Float']['output'];
};

export type AuxiliaryConsumptionInput = {
  /** Source of inputted data, defaults to 'manual'. */
  source?: InputMaybe<TelemetryInputSource>;
  /** Preferred unit for the vehicle's auxiliary power consumption. */
  type: AuxiliaryConsumptionUnit;
  /** Value of the vehicle's auxiliary power consumption. */
  value: Scalars['Float']['input'];
};

/** Auxiliary consumption units. */
export const AuxiliaryConsumptionUnit = {
  /** Return the auxiliary consumption in kilowatt hours. */
  KILOWATT_HOUR: 'kilowatt_hour'
} as const;

export type AuxiliaryConsumptionUnit = typeof AuxiliaryConsumptionUnit[keyof typeof AuxiliaryConsumptionUnit];
/** The type of the battery value. */
export const BatteryInputType = {
  KM: 'km',
  KWH: 'kwh',
  MILES: 'miles',
  PERCENTAGE: 'percentage'
} as const;

export type BatteryInputType = typeof BatteryInputType[keyof typeof BatteryInputType];
export type BatteryTemperatureInput = {
  /** Source of inputted data, defaults to 'manual'. */
  source?: InputMaybe<TelemetryInputSource>;
  /** Preferred unit for the temperature of the battery. */
  type: TemperatureUnit;
  /** Value of the temperature of the battery. */
  value: Scalars['Float']['input'];
};

export const CarConnectivityProvider = {
  ENODE: 'Enode'
} as const;

export type CarConnectivityProvider = typeof CarConnectivityProvider[keyof typeof CarConnectivityProvider];
/** Consumption of the car. */
export type CarConsumption = {
  __typename?: 'CarConsumption';
  /** Best conditions are based on 23°C and no use of A/C. */
  best?: Maybe<Scalars['Float']['output']>;
  /** Worst conditions are based on -10°C and use of heating. */
  worst?: Maybe<Scalars['Float']['output']>;
};

/** Consumption of the car. */
export type CarConsumptionInput = {
  /** Best conditions are based on 23°C and no use of A/C. */
  best?: InputMaybe<Scalars['Float']['input']>;
  /** Worst conditions are based on -10°C and use of heating. */
  worst?: InputMaybe<Scalars['Float']['input']>;
};

/** Charging mode used at charging stations. */
export const ChargeMode = {
  /** Charges up to the maximum configured state of charge (SoC) at each station. The maximum SoC is determined by 'maximum_state_of_charge'. */
  ALWAYS_TO_MAX_CHARGE: 'ALWAYS_TO_MAX_CHARGE',
  /** Optimizes the charging time at each station, in order to decrease the total travel time. Charges the vehicle only to the SOC required to reach the next stop, without exceeding the configured 'maximum_state_of_charge'. */
  OPTIMIZE_TRAVEL_TIME: 'OPTIMIZE_TRAVEL_TIME'
} as const;

export type ChargeMode = typeof ChargeMode[keyof typeof ChargeMode];
export type ChargeSpeed = {
  __typename?: 'ChargeSpeed';
  /** Source of inputted data */
  source: TelemetryInputSource;
  /** Preferred unit for the battery's charge speed. */
  type: ChargeSpeedUnit;
  /** Value of the charge speed of the battery. */
  value: Scalars['Float']['output'];
};

export type ChargeSpeedInput = {
  /** Source of inputted data, defaults to 'manual'. */
  source?: InputMaybe<TelemetryInputSource>;
  /** Preferred unit for the battery's charge speed. */
  type: ChargeSpeedUnit;
  /** Value of the battery's charge speed. */
  value: Scalars['Float']['input'];
};

export const ChargeSpeedUnit = {
  /** Return the charge speed in kilometers per hour. */
  KILOMETERS_PER_HOUR: 'kilometers_per_hour',
  /** Return the charge speed in kilowatt hours. */
  KILOWATT_HOUR: 'kilowatt_hour',
  /** Return the charge speed in miles per hour. */
  MILES_PER_HOUR: 'miles_per_hour'
} as const;

export type ChargeSpeedUnit = typeof ChargeSpeedUnit[keyof typeof ChargeSpeedUnit];
export type ChargeTotalInput = {
  /** Source of inputted data, defaults to 'manual'. */
  source?: InputMaybe<TelemetryInputSource>;
  /** Preferred unit for the total charge amount. */
  type: StateOfChargeUnit;
  /** Value of the temperature of the battery. */
  value: Scalars['Float']['input'];
};

/** A grouped representation of EVSEs. */
export type Charger = {
  __typename?: 'Charger';
  /** Power of a charger, in kW. */
  power?: Maybe<Scalars['Float']['output']>;
  /** Price of a charger. */
  price?: Maybe<Scalars['String']['output']>;
  /** Charging speed. */
  speed?: Maybe<StationSpeedType>;
  /** Type of a charger. */
  standard?: Maybe<ConnectorType>;
  /** Statuses of all the EVSEs grouped in a charger. */
  status?: Maybe<ChargerStatuses>;
  /** Total number of EVSEs grouped in a charger. */
  total?: Maybe<Scalars['Int']['output']>;
};

export const ChargerStatus = {
  /** The charger is occupied/busy. */
  BUSY: 'busy',
  /** The charger has an error. */
  ERROR: 'error',
  /** The charger is free. */
  FREE: 'free',
  /** The charger is unknown. */
  UNKNOWN: 'unknown'
} as const;

export type ChargerStatus = typeof ChargerStatus[keyof typeof ChargerStatus];
/** Grouping by status of the chargers. */
export type ChargerStatuses = {
  __typename?: 'ChargerStatuses';
  /** How many are busy. */
  busy?: Maybe<Scalars['Int']['output']>;
  /** How many are not available. */
  error?: Maybe<Scalars['Int']['output']>;
  /** How many are free. */
  free?: Maybe<Scalars['Int']['output']>;
  /** How many are unknown. */
  unknown?: Maybe<Scalars['Int']['output']>;
};

/**
 * Chargetrip's custom real-world range provides a carefully calculated display range for all-electric vehicle models.
 * Chargetrip range is based on the theoretical distance driven using only the electric engine.
 * Vehicles that do not have a full electric drivetrain type (all except Battery Electric Vehicles / BEV) therefore return relatively small ranges.
 * More information on the CT range can be found at https://chargetrip.com/blog/what-is-ct-real-range
 */
export type ChargetripRange = {
  __typename?: 'ChargetripRange';
  /**
   * Range calculated using the best conditions.
   * Best conditions are based on 25°C, including use of A/C.
   * More information on the CT range can be found at https://chargetrip.com/blog/what-is-ct-real-range
   */
  best?: Maybe<Scalars['Float']['output']>;
  /**
   * Range calculated using the worst conditions.
   * Worst conditions are based on -0°C, including use of heating.
   * More information on the CT range can be found at https://chargetrip.com/blog/what-is-ct-real-range
   */
  worst?: Maybe<Scalars['Float']['output']>;
};


/**
 * Chargetrip's custom real-world range provides a carefully calculated display range for all-electric vehicle models.
 * Chargetrip range is based on the theoretical distance driven using only the electric engine.
 * Vehicles that do not have a full electric drivetrain type (all except Battery Electric Vehicles / BEV) therefore return relatively small ranges.
 * More information on the CT range can be found at https://chargetrip.com/blog/what-is-ct-real-range
 */
export type ChargetripRangeBestArgs = {
  unit?: InputMaybe<DistanceUnit>;
};


/**
 * Chargetrip's custom real-world range provides a carefully calculated display range for all-electric vehicle models.
 * Chargetrip range is based on the theoretical distance driven using only the electric engine.
 * Vehicles that do not have a full electric drivetrain type (all except Battery Electric Vehicles / BEV) therefore return relatively small ranges.
 * More information on the CT range can be found at https://chargetrip.com/blog/what-is-ct-real-range
 */
export type ChargetripRangeWorstArgs = {
  unit?: InputMaybe<DistanceUnit>;
};

export type ChargingBehaviour = {
  __typename?: 'ChargingBehaviour';
  /** Charging behaviour of users divided in groups, based on real-time information. */
  code?: Maybe<ChargingBehaviourCode>;
  /** Description of charging behaviour. */
  description?: Maybe<Scalars['String']['output']>;
};

export const ChargingBehaviourCode = {
  /** Mainly fast charging, with some morning and afternoon charging. */
  FAST_CHARGING: 'FAST_CHARGING',
  /** Mixed behaviour between morning, afternoon, evening, overnight, and noise charging. */
  MIXED_CHARGING: 'MIXED_CHARGING',
  /** Mainly noise charging. */
  NOISE_CHARGING: 'NOISE_CHARGING',
  /** Mainly morning charging, with some afternoon charging. */
  OFFICE_CHARGING: 'OFFICE_CHARGING',
  /** Mainly overnight charging. */
  OVERNIGHT_CHARGING: 'OVERNIGHT_CHARGING',
  /** Mainly morning charging, and some mixed afternoon and evening charging. */
  URBAN_CHARGING: 'URBAN_CHARGING'
} as const;

export type ChargingBehaviourCode = typeof ChargingBehaviourCode[keyof typeof ChargingBehaviourCode];
export const CongestionLevel = {
  /** Significant traffic volume causing heavy delays and potential standstills. */
  HIGH: 'high',
  /** Traffic is flowing freely with little to no delay. */
  LOW: 'low',
  /** Increased traffic volume causing minor delays. */
  MEDIUM: 'medium',
  /** Congestion level is unknown or could not be determined. */
  UNKNOWN: 'unknown'
} as const;

export type CongestionLevel = typeof CongestionLevel[keyof typeof CongestionLevel];
export type Connect = {
  __typename?: 'Connect';
  /** List of connectivity providers to which the vehicle can connect. This field returns null for free users. Please contact customer success for more information. */
  providers?: Maybe<Array<ConnectProvider>>;
};

export type ConnectBattery = {
  __typename?: 'ConnectBattery';
  /** Capacity of the battery, in kwh */
  capacity?: Maybe<Scalars['Float']['output']>;
  /** Date when the battery data was retrieved, as ISO-8601 date */
  date?: Maybe<Scalars['DateTime']['output']>;
  /** Percentage of the battery remaining */
  percentage?: Maybe<Scalars['Float']['output']>;
  /** Estimated range by OEM */
  range?: Maybe<Scalars['Float']['output']>;
};

export type ConnectCharge = {
  __typename?: 'ConnectCharge';
  /** Charge speed, in kwh */
  charge_speed?: Maybe<Scalars['Float']['output']>;
  /** Date when the charge data was retrieved, as ISO-8601 date */
  date?: Maybe<Scalars['DateTime']['output']>;
  /** Estimation when charging is completed, as ISO-8601 date */
  fully_charged_at?: Maybe<Scalars['DateTime']['output']>;
  /** Vehicle is charging */
  is_charging?: Maybe<Scalars['Boolean']['output']>;
  /** Battery is fully charged */
  is_fully_charged?: Maybe<Scalars['Boolean']['output']>;
  /** Vehicle is plugged in */
  is_plugged_in?: Maybe<Scalars['Boolean']['output']>;
  /** Charge limit defined by vehicle owner */
  limit?: Maybe<Scalars['Int']['output']>;
  /** Estimated minutes till charged */
  minutes_till_charged?: Maybe<Scalars['Int']['output']>;
};

export type ConnectFilter = {
  /** List of connectivity providers to which a vehicle can connect. */
  providers?: InputMaybe<Array<InputMaybe<ConnectProvider>>>;
};

/** Location of the vehicle */
export type ConnectLocation = {
  __typename?: 'ConnectLocation';
  /** Geometry of the feature */
  geometry: GeometryPoint;
  /** Properties object containing meta data about the feature point */
  properties?: Maybe<ConnectLocationProperties>;
  /** Feature type */
  type: FeatureType;
};

/** Properties of a vehicle location */
export type ConnectLocationProperties = {
  __typename?: 'ConnectLocationProperties';
  /** Date when the location was retrieved, as ISO-8601 date */
  date: Scalars['DateTime']['output'];
};

export type ConnectOdometer = {
  __typename?: 'ConnectOdometer';
  /** Date when the odometer data was retrieved, as ISO-8601 date */
  date?: Maybe<Scalars['DateTime']['output']>;
  /** Odometer value, distance driven, default in km */
  distance?: Maybe<Scalars['Float']['output']>;
};

export const ConnectProvider = {
  ENODE: 'Enode'
} as const;

export type ConnectProvider = typeof ConnectProvider[keyof typeof ConnectProvider];
export const ConnectScope = {
  /** Charge state, applicable for: Enode */
  CHARGE_STATE: 'charge_state',
  /** Vehicle location, applicable for: Enode */
  LOCATION: 'location',
  /** Odometer reading, applicable for: Enode */
  ODOMETER: 'odometer'
} as const;

export type ConnectScope = typeof ConnectScope[keyof typeof ConnectScope];
export type ConnectedVehicle = {
  __typename?: 'ConnectedVehicle';
  /** URL to connect the vehicle to the connectivity provider */
  authorization_url?: Maybe<Scalars['String']['output']>;
  /** Unique ID of the connected vehicle */
  id: Scalars['ID']['output'];
  /** Custom label for a connected vehicle that can be assigned by a user */
  label?: Maybe<Scalars['String']['output']>;
  /** Connectivity provider */
  provider: CarConnectivityProvider;
  /** Scope for accessing the vehicle */
  scope?: Maybe<Array<Maybe<ConnectScope>>>;
  /** Status of the connected vehicle */
  status: ConnectedVehicleStatus;
  /** Unique ID of the vehicle */
  vehicle_id: Scalars['ID']['output'];
  /** Vehicle identification number, unique identifier for a vehicle */
  vin?: Maybe<Scalars['String']['output']>;
};

export type ConnectedVehicleListFilter = {
  /** Status of the connected vehicle */
  status?: InputMaybe<Array<ConnectedVehicleStatus>>;
};

export const ConnectedVehicleStatus = {
  /** Vehicle was authorized. Chargetrip can retrieve data on behave of the user */
  AUTHORIZED: 'authorized',
  /** Vehicle was added to the Chargetrip Connect platform but not yet authorized */
  PENDING_AUTHORIZATION: 'pending_authorization',
  /** Pending vehicle removal */
  PENDING_REMOVAL: 'pending_removal',
  /** Vehicle was removed and access has been revoked */
  REMOVED: 'removed'
} as const;

export type ConnectedVehicleStatus = typeof ConnectedVehicleStatus[keyof typeof ConnectedVehicleStatus];
/** Connector data which extends OCPI Connector. */
export type Connector = {
  __typename?: 'Connector';
  /** Custom properties of a connector. These are vendor specific and will return null values on the fields that are not supported by your station database. */
  custom_properties?: Maybe<ConnectorCustomProperties>;
  /** Format (socket/cable) of an installed connector. */
  format?: Maybe<OcpiConnectorFormat>;
  /** Identifier of a connector within an EVSE. Two connectors may have the same ID as long as they do not belong to the same EVSE object. */
  id?: Maybe<Scalars['String']['output']>;
  /** Timestamp when a connector was last updated (or created). */
  last_updated?: Maybe<Scalars['DateTime']['output']>;
  /** Maximum amperage of a connector, in ampere [A]. */
  max_amperage?: Maybe<Scalars['Int']['output']>;
  /**
   * Maximum electric power that can be delivered by a connector, in watt [W]. When the maximum electric power is lower than the calculated value from voltage and amperage, this value should be set.
   * For example: A DC Charge Point which can deliver up to 920V and up to 400A can be limited to a maximum of 150kW. Depending on the vehicle, it may supply maximum voltage or current, but not both at the same time.
   * For AC Charge Points, the amount of phases used can also have influence on the maximum power.
   */
  max_electric_power?: Maybe<Scalars['Int']['output']>;
  /** Maximum voltage of an connector (line to neutral for AC_3_PHASE), in volt [V]. For example: DC Chargers might vary the voltage during charging when battery almost full. */
  max_voltage?: Maybe<Scalars['Int']['output']>;
  /** Maximum electric power in kW. */
  power?: Maybe<Scalars['Float']['output']>;
  /** Type of power of an installed connector. */
  power_type?: Maybe<OcpiPowerType>;
  /** Dynamic charging prices. */
  prices?: Maybe<Array<ConnectorPrice>>;
  /**
   * Charging prices.
   * @deprecated In favor of `prices`.
   */
  pricing?: Maybe<Pricing>;
  /** Optional object where you can store custom data you need in your application. This extends the current functionalities we offer. */
  properties?: Maybe<Scalars['JSON']['output']>;
  /** Standard of an installed connector. */
  standard?: Maybe<ConnectorType>;
  /** List of valid charging tariffs. */
  tariff?: Maybe<Array<Maybe<OcpiTariff>>>;
  /**
   * Identifiers of the currently valid charging tariffs. Multiple tariffs are possible, but only one of each Tariff.type can be active at the same time. Tariffs with the same type are only allowed, if they are not active at the same time: start_date_time and end_date_time period not overlapping.
   * When preference-based smart charging is supported, one tariff for every possible ProfileType should be provided. This tells the user about the options they have at this Connector, and what the tariff is for every option.
   * For a "free of charge" tariff, this field should be set and point to a defined "free of charge" tariff.
   */
  tariff_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** URL to an operator’s terms and conditions. */
  terms_and_conditions?: Maybe<Scalars['String']['output']>;
};

/** Custom properties for connectors. */
export type ConnectorCustomProperties = {
  __typename?: 'ConnectorCustomProperties';
  /** Custom connector properties for OICP databases. Station databases that not follow the OICP standard return null values. */
  oicp?: Maybe<OicpConnectorCustomProperties>;
  /**
   * Charging prices.
   * @deprecated In favor of `connector.prices`.
   */
  pricing?: Maybe<Pricing>;
};

/** Connector charging price. */
export type ConnectorPrice = {
  __typename?: 'ConnectorPrice';
  /** Price product elements. */
  elements: Array<ConnectorPriceElement>;
  /** ID for the price. */
  external_id: Scalars['String']['output'];
  /** Indicates when the pricing data was last updated. The date is in ISO 8601 standard and the time zone is UTC. The update could be a price update or any other update (for example, pricing type update). */
  last_updated?: Maybe<Scalars['DateTime']['output']>;
  /** Owner of the payment product. */
  partner?: Maybe<Scalars['String']['output']>;
  /** ID for the owner of the payment product. */
  partner_id: Scalars['String']['output'];
  /** Payment product. */
  product: ConnectorPriceProduct;
};

export type ConnectorPriceElement = {
  __typename?: 'ConnectorPriceElement';
  /** Connector price element components. */
  components: Array<ConnectorPriceElementComponent>;
  /** Connector price element restrictions. */
  restrictions?: Maybe<ConnectorPriceElementRestrictions>;
};

export type ConnectorPriceElementComponent = {
  __typename?: 'ConnectorPriceElementComponent';
  /** Applicable price excluding VAT. */
  price_excl_vat: Scalars['Float']['output'];
  /**
   * Indicates the minimum amount that is billed.
   * A unit is billed in step-size blocks. For example, if the type is TIME and step_size is 300, then the time is billed in blocks of 5 minutes. Hence, if 6 minutes is used, then 10 minutes (2 blocks of step_size) is billed.
   * Note: step_size also depends on the type. Every type (except FLAT) defines a step_size multiplier. This is the size of every 'step' and the unit. For example, PARKING_TIME has a step-size multiplier of 1 second. Therefore, the step_size of a price component is multiplied by 1 second. Thus, step_size = 300 means 300 seconds."
   */
  step_size: Scalars['Int']['output'];
  /** Type of pricing that is applicable. */
  type: ConnectorPriceElementComponentType;
  /** Applicable VAT. */
  vat: Scalars['Float']['output'];
};

/** Type of pricing that is applicable. */
export const ConnectorPriceElementComponentType = {
  /** Price per kWh. */
  ENERGY: 'energy',
  /** Fixed price per charging session. */
  FLAT: 'flat',
  /** Parking price per hour. This fee is applicable if the parked car is not charging. */
  PARKING_TIME: 'parking_time',
  /** Fixed price per unit of time defined in the step size. */
  TIME: 'time'
} as const;

export type ConnectorPriceElementComponentType = typeof ConnectorPriceElementComponentType[keyof typeof ConnectorPriceElementComponentType];
export type ConnectorPriceElementRestrictions = {
  __typename?: 'ConnectorPriceElementRestrictions';
  /** Day(s) of the week that the prices are valid. */
  day_of_week?: Maybe<Array<DayOfWeek>>;
  /** Contract signed between the eMSP and the customer. */
  emsp_contract_date?: Maybe<ConnectorPriceRestrictionsEmspContractDate>;
  /** Ending date for the prices. */
  end_date?: Maybe<Scalars['String']['output']>;
  /** Ending time of the day for the prices. */
  end_time?: Maybe<Scalars['String']['output']>;
  /** Sum of the maximum current (in Amperes) over all the phases. When the EV is charging with less than this value the prices are active. If the charging current is higher, this price is inactive. */
  maximum_current?: Maybe<Scalars['Float']['output']>;
  /** Maximum duration, in seconds. */
  maximum_duration?: Maybe<Scalars['Int']['output']>;
  /** Maximum energy used, in kWh. */
  maximum_kwh?: Maybe<Scalars['Float']['output']>;
  /** Maximum charging speed, in kW. */
  maximum_power?: Maybe<Scalars['Float']['output']>;
  /** Maximum price based on the amount of kWh that is being delivered. */
  maximum_price?: Maybe<Scalars['Float']['output']>;
  /** Sum of the minimum current (in Amperes) over all the phases. When the EV is charging with more than or equal to this value the prices are active. If the charging current is lower, this price is inactive. */
  minimum_current?: Maybe<Scalars['Float']['output']>;
  /** Minimum duration, in seconds. */
  minimum_duration?: Maybe<Scalars['Int']['output']>;
  /** Minimum energy used, in kWh. */
  minimum_kwh?: Maybe<Scalars['Float']['output']>;
  /** Minimum charging speed, in kW. */
  minimum_power?: Maybe<Scalars['Float']['output']>;
  /** Minimum price based on the amount of kWh that is being delivered. */
  minimum_price?: Maybe<Scalars['Float']['output']>;
  /** Battery percentage at which the overstay prices are active. */
  overstay_battery_percentage?: Maybe<ConnectorPriceRestrictionsOverstayBatteryPercentage>;
  /** Time after which the overstay prices are active. */
  overstay_time?: Maybe<ConnectorPriceRestrictionsOverstayTime>;
  /**
   * When this field is present, the ConnectorPriceElement describes reservation costs.
   * A reservation starts when the reservation is made, and ends when the driver starts charging on the reserved EVSE/Location,
   * or when the reservation expires. A reservation can only have: `flat` and `time` ConnectorPriceElementComponentType,
   * where time is for the duration of the reservation.
   * When a price has both, `reservation` and `reservation_expires` ConnectorPriceElement,
   * where both ConnectorPriceElement have a time ConnectorPriceElementComponent,
   * then the time based cost of an expired reservation will be calculated based on the `reservation_expires` ConnectorPriceElement.
   */
  reservation?: Maybe<ConnectorPriceRestrictionsReservationType>;
  /** Starting date for the prices. */
  start_date?: Maybe<Scalars['String']['output']>;
  /** Starting time of the day for the prices. */
  start_time?: Maybe<Scalars['String']['output']>;
};

/** Payment product. */
export type ConnectorPriceProduct = {
  __typename?: 'ConnectorPriceProduct';
  /** Three-digit currency code of the country where the charging station is located. */
  currency: CurrencyUnit;
  /** A brief description of the product. */
  description: Scalars['String']['output'];
  /** Name of the payment product. */
  name: Scalars['String']['output'];
  /** Subscription price for a month or year, excluding VAT, if applicable. */
  subscription_fee_excl_vat: Scalars['Float']['output'];
  /** Indicates the type of subscription. */
  subscription_type: ConnectorPriceProductSubscriptionType;
  /** Type of the payment product. */
  type: ConnectorPriceProductType;
};

/** Type of the payment product. */
export const ConnectorPriceProductSubscriptionType = {
  /** The subscription fee is applicable every month. */
  MONTHLY: 'monthly',
  /** The product doesn’t have a subscription option. */
  NOT_APPLICABLE: 'not_applicable',
  /** An initial fee is applicable to purchase a RFID card or chip, but there isn't a recurring subscription fee. */
  ONE_OFF: 'one_off',
  /** The subscription fee is applicable every year. */
  YEARLY: 'yearly'
} as const;

export type ConnectorPriceProductSubscriptionType = typeof ConnectorPriceProductSubscriptionType[keyof typeof ConnectorPriceProductSubscriptionType];
/** Type of the payment product. */
export const ConnectorPriceProductType = {
  AD_HOC: 'ad_hoc',
  CPO_SUBSCRIPTION: 'cpo_subscription',
  MSP: 'msp'
} as const;

export type ConnectorPriceProductType = typeof ConnectorPriceProductType[keyof typeof ConnectorPriceProductType];
export type ConnectorPriceRestrictionsEmspContractDate = {
  __typename?: 'ConnectorPriceRestrictionsEmspContractDate';
  /** Prices are active from this date, which is based on the contract signed between the eMSP and a customer. */
  from?: Maybe<Scalars['String']['output']>;
  /** Name of the contract signed between the eMSP and a customer. */
  name?: Maybe<Scalars['String']['output']>;
  /** Prices are active until this date, which is based on the contract signed between the eMSP and a customer. */
  to?: Maybe<Scalars['String']['output']>;
};

export type ConnectorPriceRestrictionsOverstayBatteryPercentage = {
  __typename?: 'ConnectorPriceRestrictionsOverstayBatteryPercentage';
  /** Battery percentage at which the overstay prices are inactive. */
  maximum?: Maybe<Scalars['Int']['output']>;
  /** Battery percentage at which the overstay prices are active. */
  minimum?: Maybe<Scalars['Int']['output']>;
  /** Unit for the time after which the prices are active. */
  unit?: Maybe<ConnectorPriceRestrictionsOverstayTimeUnit>;
};

export type ConnectorPriceRestrictionsOverstayTime = {
  __typename?: 'ConnectorPriceRestrictionsOverstayTime';
  /** Time at which the overstay prices are inactive. */
  maximum?: Maybe<Scalars['Int']['output']>;
  /** Time at which the overstay prices are active. */
  minimum?: Maybe<Scalars['Int']['output']>;
  /** Unit for the time after which the prices are active. */
  unit?: Maybe<ConnectorPriceRestrictionsOverstayTimeUnit>;
};

/** The unit of time after which the overstay restrictions are applicable. */
export const ConnectorPriceRestrictionsOverstayTimeUnit = {
  /** The overstay restrictions are applicable after a certain number of hours. */
  HOURS: 'hours',
  /** The overstay restrictions are applicable after a certain number of minutes. */
  MINUTES: 'minutes',
  /** The overstay restrictions are applicable after a certain number of seconds. */
  SECONDS: 'seconds'
} as const;

export type ConnectorPriceRestrictionsOverstayTimeUnit = typeof ConnectorPriceRestrictionsOverstayTimeUnit[keyof typeof ConnectorPriceRestrictionsOverstayTimeUnit];
/** Describes the cost associated with reserving a charging station. */
export const ConnectorPriceRestrictionsReservationType = {
  /** Describes costs for a reservation. */
  RESERVATION: 'reservation',
  /** Describes costs for a reservation that expires (i.e. driver does not start a charging session before expiry date of the reservation). */
  RESERVATION_EXPIRES: 'reservation_expires'
} as const;

export type ConnectorPriceRestrictionsReservationType = typeof ConnectorPriceRestrictionsReservationType[keyof typeof ConnectorPriceRestrictionsReservationType];
/** Socket or plug standard of the charging point. */
export const ConnectorType = {
  /** The connector type is CHAdeMO, DC. */
  CHADEMO: 'CHADEMO',
  /** The ChaoJi connector. The new generation charging connector, harmonized between CHAdeMO and GB/T. DC. */
  CHAOJI: 'CHAOJI',
  /** Standard/domestic household, type "A", NEMA 1-15, 2 pins. */
  DOMESTIC_A: 'DOMESTIC_A',
  /** Standard/domestic household, type "B", NEMA 5-15, 3 pins. */
  DOMESTIC_B: 'DOMESTIC_B',
  /** Standard/domestic household, type "C", CEE 7/17, 2 pins. */
  DOMESTIC_C: 'DOMESTIC_C',
  /** Standard/domestic household, type "D", 3 pins. */
  DOMESTIC_D: 'DOMESTIC_D',
  /** Standard/domestic household, type "E", CEE 7/5 3 pins. */
  DOMESTIC_E: 'DOMESTIC_E',
  /** Standard/domestic household, type "F", CEE 7/4, Schuko, 3 pins. */
  DOMESTIC_F: 'DOMESTIC_F',
  /** Standard/domestic household, type "G", BS 1363, Commonwealth, 3 pins. */
  DOMESTIC_G: 'DOMESTIC_G',
  /** Standard/domestic household, type "H", SI-32, 3 pins. */
  DOMESTIC_H: 'DOMESTIC_H',
  /** Standard/domestic household, type "I", AS 3112, 3 pins. */
  DOMESTIC_I: 'DOMESTIC_I',
  /** Standard/domestic household, type "J", SEV 1011, 3 pins. */
  DOMESTIC_J: 'DOMESTIC_J',
  /** Standard/domestic household, type "K", DS 60884-2-D1, 3 pins. */
  DOMESTIC_K: 'DOMESTIC_K',
  /** Standard/domestic household, type "L", CEI 23-16-VII, 3 pins. */
  DOMESTIC_L: 'DOMESTIC_L',
  /** Standard/Domestic household, type "M", BS 546, 3 pins. */
  DOMESTIC_M: 'DOMESTIC_M',
  /** Standard/Domestic household, type "N", NBR 14136, 3 pins. */
  DOMESTIC_N: 'DOMESTIC_N',
  /** Standard/Domestic household, type "O", TIS 166-2549, 3 pins. */
  DOMESTIC_O: 'DOMESTIC_O',
  /** Guobiao GB/T 20234.2 AC socket/connector. */
  GBT_AC: 'GBT_AC',
  /** Guobiao GB/T 20234.3 DC connector. */
  GBT_DC: 'GBT_DC',
  /** The connector type is GB_T (Chinese standard), DC. */
  GB_T: 'GB_T',
  /** IEC 60309-2 Industrial connector single phase 16 amperes (usually blue). */
  IEC_60309_2_SINGLE_16: 'IEC_60309_2_single_16',
  /** IEC 60309-2 Industrial connector three phase 16 amperes (usually red). */
  IEC_60309_2_THREE_16: 'IEC_60309_2_three_16',
  /** IEC 60309-2 Industrial connector three phase 32 amperes (usually red). */
  IEC_60309_2_THREE_32: 'IEC_60309_2_three_32',
  /** IEC 60309-2 Industrial connector three phase 64 amperes (usually red). */
  IEC_60309_2_THREE_64: 'IEC_60309_2_three_64',
  /** IEC 62196 Type 1 "SAE J1772". */
  IEC_62196_T1: 'IEC_62196_T1',
  /** Combo Type 1 based, DC. */
  IEC_62196_T1_COMBO: 'IEC_62196_T1_COMBO',
  /** IEC 62196 Type 2 "Mennekes". */
  IEC_62196_T2: 'IEC_62196_T2',
  /** Combo Type 2 based, DC. */
  IEC_62196_T2_COMBO: 'IEC_62196_T2_COMBO',
  /** IEC 62196 Type 3A. */
  IEC_62196_T3A: 'IEC_62196_T3A',
  /** IEC 62196 Type 3C "Scame". */
  IEC_62196_T3C: 'IEC_62196_T3C',
  /** The connector type is NEMA 5-20, 3 pins. */
  NEMA_5_20: 'NEMA_5_20',
  /** The connector type is NEMA 6-30, 3 pins. */
  NEMA_6_30: 'NEMA_6_30',
  /** The connector type is NEMA 6-50, 3 pins. */
  NEMA_6_50: 'NEMA_6_50',
  /** The connector type is NEMA 10-30, 3 pins. */
  NEMA_10_30: 'NEMA_10_30',
  /** The connector type is NEMA 10-50, 3 pins. */
  NEMA_10_50: 'NEMA_10_50',
  /** The connector type is NEMA 14-30, 3 pins, rating of 30 A. */
  NEMA_14_30: 'NEMA_14_30',
  /** The connector type is NEMA 14-50, 3 pins, rating of 50 A. */
  NEMA_14_50: 'NEMA_14_50',
  /** On-board bottom-up-pantograph typically for bus charging. */
  PANTOGRAPH_BOTTOM_UP: 'PANTOGRAPH_BOTTOM_UP',
  /** Off-board top-down-pantograph typically for bus charging. */
  PANTOGRAPH_TOP_DOWN: 'PANTOGRAPH_TOP_DOWN',
  /** Tesla connector "Roadster"-type (round, 4 pins). */
  TESLA_R: 'TESLA_R',
  /** Tesla connector "Model-S"-type (oval, 5 pins). */
  TESLA_S: 'TESLA_S'
} as const;

export type ConnectorType = typeof ConnectorType[keyof typeof ConnectorType];
export const ConsumptionUnit = {
  /** Return the consumption in kilometers per kilowatt hour. */
  KILOMETERS_PER_KILOWATT_HOUR: 'kilometers_per_kilowatt_hour',
  /** Return the consumption in kilowatt hours per 100 kilometers. */
  KILOWATT_HOURS_PER_100_KILOMETERS: 'kilowatt_hours_per_100_kilometers',
  /** Return the consumption in kilowatt hours per 100 miles. */
  KILOWATT_HOURS_PER_100_MILES: 'kilowatt_hours_per_100_miles',
  /** Return the consumption in miles per kilowatt hour. */
  MILES_PER_KILOWATT_HOUR: 'miles_per_kilowatt_hour',
  /** Return the consumption in watt hours per kilometer. */
  WATT_HOURS_PER_KILOMETER: 'watt_hours_per_kilometer',
  /** Return the consumption in watt hours per mile. */
  WATT_HOURS_PER_MILE: 'watt_hours_per_mile'
} as const;

export type ConsumptionUnit = typeof ConsumptionUnit[keyof typeof ConsumptionUnit];
/** The complete contact information. */
export type Contact = {
  __typename?: 'Contact';
  /** The email address. */
  email?: Maybe<Scalars['String']['output']>;
  /** The absolute URL of the facebook profile page. */
  facebook?: Maybe<Scalars['String']['output']>;
  /** The phone number in international format. */
  phone?: Maybe<Scalars['String']['output']>;
  /** Optional object where you can store custom data you need in your application. This extends the current functionalities we offer. */
  properties?: Maybe<Scalars['JSON']['output']>;
  /** The absolute URL of the twitter profile page. */
  twitter?: Maybe<Scalars['String']['output']>;
  /** The absolute URL of the website. */
  website?: Maybe<Scalars['String']['output']>;
};

/** ISO-3166 alpha-2 country codes. */
export const CountryCodeAlpha2 = {
  AA: 'AA',
  AD: 'AD',
  AE: 'AE',
  AF: 'AF',
  AG: 'AG',
  AI: 'AI',
  AL: 'AL',
  AM: 'AM',
  AN: 'AN',
  AO: 'AO',
  AQ: 'AQ',
  AR: 'AR',
  AS: 'AS',
  AT: 'AT',
  AU: 'AU',
  AW: 'AW',
  AX: 'AX',
  AZ: 'AZ',
  BA: 'BA',
  BB: 'BB',
  BD: 'BD',
  BE: 'BE',
  BF: 'BF',
  BG: 'BG',
  BH: 'BH',
  BI: 'BI',
  BJ: 'BJ',
  BL: 'BL',
  BM: 'BM',
  BN: 'BN',
  BO: 'BO',
  BQ: 'BQ',
  BR: 'BR',
  BS: 'BS',
  BT: 'BT',
  BV: 'BV',
  BW: 'BW',
  BY: 'BY',
  BZ: 'BZ',
  CA: 'CA',
  CC: 'CC',
  CD: 'CD',
  CF: 'CF',
  CG: 'CG',
  CH: 'CH',
  CI: 'CI',
  CK: 'CK',
  CL: 'CL',
  CM: 'CM',
  CN: 'CN',
  CO: 'CO',
  CR: 'CR',
  CS: 'CS',
  CU: 'CU',
  CV: 'CV',
  CW: 'CW',
  CX: 'CX',
  CY: 'CY',
  CZ: 'CZ',
  DE: 'DE',
  DJ: 'DJ',
  DK: 'DK',
  DM: 'DM',
  DO: 'DO',
  DZ: 'DZ',
  EC: 'EC',
  EE: 'EE',
  EG: 'EG',
  EH: 'EH',
  ER: 'ER',
  ES: 'ES',
  ET: 'ET',
  FI: 'FI',
  FJ: 'FJ',
  FK: 'FK',
  FM: 'FM',
  FO: 'FO',
  FR: 'FR',
  GA: 'GA',
  GB: 'GB',
  GD: 'GD',
  GE: 'GE',
  GF: 'GF',
  GG: 'GG',
  GH: 'GH',
  GI: 'GI',
  GL: 'GL',
  GM: 'GM',
  GN: 'GN',
  GP: 'GP',
  GQ: 'GQ',
  GR: 'GR',
  GS: 'GS',
  GT: 'GT',
  GU: 'GU',
  GW: 'GW',
  GY: 'GY',
  HK: 'HK',
  HM: 'HM',
  HN: 'HN',
  HR: 'HR',
  HT: 'HT',
  HU: 'HU',
  ID: 'ID',
  IE: 'IE',
  IL: 'IL',
  IM: 'IM',
  IN: 'IN',
  IO: 'IO',
  IQ: 'IQ',
  IR: 'IR',
  IS: 'IS',
  IT: 'IT',
  JE: 'JE',
  JM: 'JM',
  JO: 'JO',
  JP: 'JP',
  KE: 'KE',
  KG: 'KG',
  KH: 'KH',
  KI: 'KI',
  KM: 'KM',
  KN: 'KN',
  KP: 'KP',
  KR: 'KR',
  KW: 'KW',
  KY: 'KY',
  KZ: 'KZ',
  LA: 'LA',
  LB: 'LB',
  LC: 'LC',
  LI: 'LI',
  LK: 'LK',
  LR: 'LR',
  LS: 'LS',
  LT: 'LT',
  LU: 'LU',
  LV: 'LV',
  LY: 'LY',
  MA: 'MA',
  MC: 'MC',
  MD: 'MD',
  ME: 'ME',
  MF: 'MF',
  MG: 'MG',
  MH: 'MH',
  MK: 'MK',
  ML: 'ML',
  MM: 'MM',
  MN: 'MN',
  MO: 'MO',
  MP: 'MP',
  MQ: 'MQ',
  MR: 'MR',
  MS: 'MS',
  MT: 'MT',
  MU: 'MU',
  MV: 'MV',
  MW: 'MW',
  MX: 'MX',
  MY: 'MY',
  MZ: 'MZ',
  NA: 'NA',
  NC: 'NC',
  NE: 'NE',
  NF: 'NF',
  NG: 'NG',
  NI: 'NI',
  NL: 'NL',
  NO: 'NO',
  NP: 'NP',
  NR: 'NR',
  NU: 'NU',
  NZ: 'NZ',
  OM: 'OM',
  PA: 'PA',
  PE: 'PE',
  PF: 'PF',
  PG: 'PG',
  PH: 'PH',
  PK: 'PK',
  PL: 'PL',
  PM: 'PM',
  PN: 'PN',
  PR: 'PR',
  PS: 'PS',
  PT: 'PT',
  PW: 'PW',
  PY: 'PY',
  QA: 'QA',
  RE: 'RE',
  RKS: 'RKS',
  RO: 'RO',
  RS: 'RS',
  RU: 'RU',
  RW: 'RW',
  SA: 'SA',
  SB: 'SB',
  SC: 'SC',
  SD: 'SD',
  SE: 'SE',
  SG: 'SG',
  SH: 'SH',
  SI: 'SI',
  SJ: 'SJ',
  SK: 'SK',
  SL: 'SL',
  SM: 'SM',
  SN: 'SN',
  SO: 'SO',
  SR: 'SR',
  SS: 'SS',
  ST: 'ST',
  SV: 'SV',
  SX: 'SX',
  SY: 'SY',
  SZ: 'SZ',
  TC: 'TC',
  TD: 'TD',
  TF: 'TF',
  TG: 'TG',
  TH: 'TH',
  TJ: 'TJ',
  TK: 'TK',
  TL: 'TL',
  TM: 'TM',
  TN: 'TN',
  TO: 'TO',
  TR: 'TR',
  TT: 'TT',
  TV: 'TV',
  TW: 'TW',
  TZ: 'TZ',
  UA: 'UA',
  UG: 'UG',
  UM: 'UM',
  US: 'US',
  UY: 'UY',
  UZ: 'UZ',
  VA: 'VA',
  VC: 'VC',
  VE: 'VE',
  VG: 'VG',
  VI: 'VI',
  VN: 'VN',
  VU: 'VU',
  WF: 'WF',
  WS: 'WS',
  XK: 'XK',
  YE: 'YE',
  YT: 'YT',
  ZA: 'ZA',
  ZM: 'ZM',
  ZW: 'ZW'
} as const;

export type CountryCodeAlpha2 = typeof CountryCodeAlpha2[keyof typeof CountryCodeAlpha2];
export type CreateConnectedVehicleInput = {
  /** Label for a connected vehicle */
  label?: InputMaybe<Scalars['PlainString']['input']>;
  /** Provider specific options. See the developer portal for more details */
  options: CreateConnectedVehicleOptions;
  /** Connectivity provider used to retrieve data from the vehicle */
  provider: CarConnectivityProvider;
  /** Id from the vehicle */
  vehicle_id: Scalars['ID']['input'];
};

export type CreateConnectedVehicleOptions = {
  /** Redirect uri */
  redirect_uri?: InputMaybe<Scalars['PlainString']['input']>;
  /** Scope */
  scope?: InputMaybe<Array<ConnectScope>>;
};

export type CreateRoute = {
  __typename?: 'CreateRoute';
  /** [BETA] Number of alternative routes to request. */
  alternative_routes?: Maybe<Scalars['Int']['output']>;
  /** Search radius for alternative charging stations along the route. Accepts a value between 500 and 5000 meters (or unit equivalent). If not specified, disables the alternative station search for the generated route. */
  alternative_station_radius?: Maybe<AlternativeStationRadius>;
  /** [BETA] List of route features to avoid in a route. This is a best-effort preference; depending on the available routes, some features may not be fully avoidable. */
  avoid?: Maybe<Array<RouteAvoid>>;
  /** Route departure time. */
  departure_time: Scalars['DateTime']['output'];
  /** Destination of a route. */
  destination: RouteDestinationFeaturePoint;
  /** [BETA] Configuration options for the route's driving conditions. Includes factors to adjust average speed, set a maximum speed, and define a base driving style. If not specified, no adjustments are applied. */
  driving_preferences?: Maybe<RouteDrivingPreferences>;
  /** Operator preferences for a route. */
  operators?: Maybe<RouteOperatorPreferences>;
  /** Origin of a route. */
  origin: RouteOriginFeaturePoint;
  /**
   * Season of a route.
   * @deprecated In favor of `weather`.
   */
  season?: Maybe<RouteSeason>;
  /** Charging stations preferences for route calculation. */
  station_preferences?: Maybe<RouteStationPreferences>;
  /** [BETA] Indicates whether current traffic conditions were considered during route calculation. This feature is disabled by default and requires explicit enablement for your project. Please contact Chargetrip support for more information. */
  traffic_aware?: Maybe<Scalars['Boolean']['output']>;
  /** Vehicle used on a route. */
  vehicle: RouteVehicle;
  /** Via points of a route. */
  via?: Maybe<Array<RouteViaFeaturePoint>>;
  /** Weather configuration for the route. Defined by a preset or custom weather conditions. */
  weather?: Maybe<RouteWeather>;
};

/** Input for the create route mutation. */
export type CreateRouteInput = {
  /** [BETA] Additional alternative routes to calculate. Performed on a best-effort basis, it may return fewer than requested, or even none. Set to 0 to create only the recommended route. */
  alternative_routes?: InputMaybe<Scalars['Int']['input']>;
  /** Search radius for alternative charging stations along the route. Accepts a value between 500 and 5000 meters (or unit equivalent). If not specified, disables the alternative station search for the generated route. */
  alternative_station_radius?: InputMaybe<AlternativeStationRadiusInput>;
  /** [BETA] Optional list of route features to avoid in a route. This is a best-effort preference; depending on the available routes, some features may not be fully avoidable. */
  avoid?: InputMaybe<Array<RouteAvoid>>;
  /** Route departure time. Used to calculate the expected arrival time. If not specified, defaults to the route's request time. */
  departure_time?: InputMaybe<Scalars['DateTime']['input']>;
  /** Destination of a route. */
  destination: RouteDestinationFeaturePointInput;
  /** [BETA] Configuration options for the route's driving conditions. Includes factors to adjust average speed, set a maximum speed, and define a base driving style. If not specified, no adjustments are applied. */
  driving_preferences?: InputMaybe<RouteDrivingPreferencesInput>;
  /** Operator preferences and restrictions for route calculation. If not specified, excludes operators per project settings, but applies no operator ranking. */
  operators?: InputMaybe<RouteOperatorPreferencesInput>;
  /** Origin of a route. */
  origin: RouteOriginFeaturePointInput;
  /** Optional flag to specify the season. If not specified, defaults to  real-time weather data */
  season?: InputMaybe<RouteSeason>;
  /** Charging stations preferences for route calculation. */
  station_preferences?: InputMaybe<RouteStationPreferencesInput>;
  /** [BETA] Route should consider current traffic conditions. This feature is disabled by default and requires explicit enablement for your project. Please contact Chargetrip support for more information. */
  traffic_aware?: InputMaybe<Scalars['Boolean']['input']>;
  /** Vehicle specific input. */
  vehicle: RouteVehicleInput;
  /** Optional via points of a route. */
  via?: InputMaybe<Array<RouteViaFeaturePointInput>>;
  /** Weather configuration for the route. Defined by a preset or custom weather conditions. If not specified, defaults to real-time weather data. */
  weather?: InputMaybe<RouteWeatherInput>;
};

export type CreateTruckRoute = {
  __typename?: 'CreateTruckRoute';
  /** Alternative stations along a route within a specified radius of 500 to 5000 meters, or the equivalent in another unit. If not specified, no alternative stations will be discovered. */
  alternative_station_radius?: Maybe<AlternativeStationRadius>;
  /** Optional list of route features to avoid in a route. This is a best-effort preference; depending on the available routes, some features may not be fully avoidable. */
  avoid?: Maybe<Array<RouteTruckAvoid>>;
  /** Route departure time. Used to calculate the expected arrival time and, if set in the past, to apply historical weather data. If not specified, defaults to the current request time. */
  departure_time?: Maybe<Scalars['DateTime']['output']>;
  /** Destination of a route. */
  destination: RouteDestinationFeaturePoint;
  /** Maximum speed to consider when generating the route. In the segments where legal speed is lower than this value, the legal speed will be used instead. */
  maximum_speed?: Maybe<MaximumSpeed>;
  /** Prioritized operators for a route calculation. */
  operators?: Maybe<RouteOperatorPreferences>;
  /** Origin of a route. */
  origin: RouteTruckOriginFeaturePoint;
  /** Vehicle specific input. */
  vehicle: RouteTruckVehicle;
  /** Optional via points of a route. */
  via?: Maybe<Array<RouteTruckViaFeaturePoint>>;
  /** Weather configuration for the route. Defined by a preset or custom weather conditions. */
  weather?: Maybe<RouteWeather>;
};

export type CreateTruckRouteInput = {
  /** Alternative stations along a route within a specified radius of 500 to 5000 meters, or the equivalent in another unit. If not specified, no alternative stations will be discovered. */
  alternative_station_radius?: InputMaybe<AlternativeStationRadiusInput>;
  /** Optional list of route features to avoid in a route. This is a best-effort preference; depending on the available routes, some features may not be fully avoidable. */
  avoid?: InputMaybe<Array<RouteTruckAvoid>>;
  /** Route departure time. Used to calculate the expected arrival time and, if set in the past, to apply historical weather data. If not specified, defaults to the current request time. */
  departure_time?: InputMaybe<Scalars['DateTime']['input']>;
  /** Destination of a route. */
  destination: RouteDestinationFeaturePointInput;
  /** Maximum speed to consider when generating the route. In the segments where legal speed is lower than this value, the legal speed will be used instead. */
  maximum_speed?: InputMaybe<MaximumSpeedInput>;
  /** Prioritized operators for a route calculation. */
  operators?: InputMaybe<RouteOperatorPreferencesInput>;
  /** Origin of a route. */
  origin: RouteTruckOriginFeaturePointInput;
  /** Vehicle specific input. */
  vehicle: RouteTruckVehicleInput;
  /** Optional via points of a route. */
  via?: InputMaybe<Array<RouteTruckViaFeaturePointInput>>;
  /** Weather configuration for the route. Defined by a preset or custom weather conditions. */
  weather?: InputMaybe<RouteWeatherInput>;
};

/** Currency in the ISO 4217 format. */
export const Currency = {
  ADA: 'ADA',
  AED: 'AED',
  AFN: 'AFN',
  ALL: 'ALL',
  AMD: 'AMD',
  ANG: 'ANG',
  AOA: 'AOA',
  ARS: 'ARS',
  AUD: 'AUD',
  AVAX: 'AVAX',
  AWG: 'AWG',
  AZN: 'AZN',
  BAM: 'BAM',
  BBD: 'BBD',
  BDT: 'BDT',
  BGN: 'BGN',
  BHD: 'BHD',
  BIF: 'BIF',
  BMD: 'BMD',
  BNB: 'BNB',
  BND: 'BND',
  BOB: 'BOB',
  BRL: 'BRL',
  BSD: 'BSD',
  BTC: 'BTC',
  BTN: 'BTN',
  BWP: 'BWP',
  BYN: 'BYN',
  BYR: 'BYR',
  BZD: 'BZD',
  CAD: 'CAD',
  CDF: 'CDF',
  CHF: 'CHF',
  CLF: 'CLF',
  CLP: 'CLP',
  CNY: 'CNY',
  COP: 'COP',
  CRC: 'CRC',
  CUC: 'CUC',
  CUP: 'CUP',
  CVE: 'CVE',
  CZK: 'CZK',
  DJF: 'DJF',
  DKK: 'DKK',
  DOP: 'DOP',
  DOT: 'DOT',
  DZD: 'DZD',
  EGP: 'EGP',
  ERN: 'ERN',
  ETB: 'ETB',
  ETH: 'ETH',
  EUR: 'EUR',
  FJD: 'FJD',
  FKP: 'FKP',
  GBP: 'GBP',
  GEL: 'GEL',
  GGP: 'GGP',
  GHS: 'GHS',
  GIP: 'GIP',
  GMD: 'GMD',
  GNF: 'GNF',
  GTQ: 'GTQ',
  GYD: 'GYD',
  HKD: 'HKD',
  HNL: 'HNL',
  HRK: 'HRK',
  HTG: 'HTG',
  HUF: 'HUF',
  IDR: 'IDR',
  ILS: 'ILS',
  IMP: 'IMP',
  INR: 'INR',
  IQD: 'IQD',
  IRR: 'IRR',
  ISK: 'ISK',
  JEP: 'JEP',
  JMD: 'JMD',
  JOD: 'JOD',
  JPY: 'JPY',
  KES: 'KES',
  KGS: 'KGS',
  KHR: 'KHR',
  KMF: 'KMF',
  KPW: 'KPW',
  KRW: 'KRW',
  KWD: 'KWD',
  KYD: 'KYD',
  KZT: 'KZT',
  LAK: 'LAK',
  LBP: 'LBP',
  LKR: 'LKR',
  LRD: 'LRD',
  LSL: 'LSL',
  LTC: 'LTC',
  LTL: 'LTL',
  LVL: 'LVL',
  LYD: 'LYD',
  MAD: 'MAD',
  MATIC: 'MATIC',
  MDL: 'MDL',
  MGA: 'MGA',
  MKD: 'MKD',
  MMK: 'MMK',
  MNT: 'MNT',
  MOP: 'MOP',
  MRO: 'MRO',
  MUR: 'MUR',
  MVR: 'MVR',
  MWK: 'MWK',
  MXN: 'MXN',
  MYR: 'MYR',
  MZN: 'MZN',
  NAD: 'NAD',
  NGN: 'NGN',
  NIO: 'NIO',
  NOK: 'NOK',
  NPR: 'NPR',
  NZD: 'NZD',
  OMR: 'OMR',
  PAB: 'PAB',
  PEN: 'PEN',
  PGK: 'PGK',
  PHP: 'PHP',
  PKR: 'PKR',
  PLN: 'PLN',
  PYG: 'PYG',
  QAR: 'QAR',
  RON: 'RON',
  RSD: 'RSD',
  RUB: 'RUB',
  RWF: 'RWF',
  SAR: 'SAR',
  SBD: 'SBD',
  SCR: 'SCR',
  SDG: 'SDG',
  SEK: 'SEK',
  SGD: 'SGD',
  SHP: 'SHP',
  SLL: 'SLL',
  SOL: 'SOL',
  SOS: 'SOS',
  SRD: 'SRD',
  STD: 'STD',
  SVC: 'SVC',
  SYP: 'SYP',
  SZL: 'SZL',
  THB: 'THB',
  TJS: 'TJS',
  TMT: 'TMT',
  TND: 'TND',
  TOP: 'TOP',
  TRY: 'TRY',
  TTD: 'TTD',
  TWD: 'TWD',
  TZS: 'TZS',
  UAH: 'UAH',
  UGX: 'UGX',
  USD: 'USD',
  UYU: 'UYU',
  UZS: 'UZS',
  VEF: 'VEF',
  VND: 'VND',
  VUV: 'VUV',
  WST: 'WST',
  XAF: 'XAF',
  XAG: 'XAG',
  XAU: 'XAU',
  XCD: 'XCD',
  XDR: 'XDR',
  XOF: 'XOF',
  XPD: 'XPD',
  XPF: 'XPF',
  XPT: 'XPT',
  XRP: 'XRP',
  YER: 'YER',
  ZAR: 'ZAR',
  ZMK: 'ZMK',
  ZMW: 'ZMW',
  ZWL: 'ZWL'
} as const;

export type Currency = typeof Currency[keyof typeof Currency];
/** Currency according to the ISO 4217 standard. */
export const CurrencyUnit = {
  AED: 'AED',
  AFN: 'AFN',
  ALL: 'ALL',
  AMD: 'AMD',
  ANG: 'ANG',
  AOA: 'AOA',
  ARS: 'ARS',
  AUD: 'AUD',
  AWG: 'AWG',
  AZN: 'AZN',
  BAM: 'BAM',
  BBD: 'BBD',
  BDT: 'BDT',
  BGN: 'BGN',
  BIF: 'BIF',
  BMD: 'BMD',
  BND: 'BND',
  BOB: 'BOB',
  BRL: 'BRL',
  BSD: 'BSD',
  BWP: 'BWP',
  BYN: 'BYN',
  BZD: 'BZD',
  CAD: 'CAD',
  CDF: 'CDF',
  CHF: 'CHF',
  CLP: 'CLP',
  CNY: 'CNY',
  COP: 'COP',
  CRC: 'CRC',
  CVE: 'CVE',
  CZK: 'CZK',
  DJF: 'DJF',
  DKK: 'DKK',
  DOP: 'DOP',
  DZD: 'DZD',
  EGP: 'EGP',
  ETB: 'ETB',
  /** Return the currency in EUR. */
  EUR: 'EUR',
  FJD: 'FJD',
  FKP: 'FKP',
  /** Return the currency in GBP. */
  GBP: 'GBP',
  GEL: 'GEL',
  GIP: 'GIP',
  GMD: 'GMD',
  GNF: 'GNF',
  GTQ: 'GTQ',
  GYD: 'GYD',
  HKD: 'HKD',
  HNL: 'HNL',
  HTG: 'HTG',
  HUF: 'HUF',
  IDR: 'IDR',
  ILS: 'ILS',
  INR: 'INR',
  ISK: 'ISK',
  JMD: 'JMD',
  JPY: 'JPY',
  KES: 'KES',
  KGS: 'KGS',
  KHR: 'KHR',
  KMF: 'KMF',
  KRW: 'KRW',
  KYD: 'KYD',
  KZT: 'KZT',
  LAK: 'LAK',
  LBP: 'LBP',
  LKR: 'LKR',
  LRD: 'LRD',
  LSL: 'LSL',
  MAD: 'MAD',
  MDL: 'MDL',
  MGA: 'MGA',
  MKD: 'MKD',
  MMK: 'MMK',
  MNT: 'MNT',
  MOP: 'MOP',
  MUR: 'MUR',
  MVR: 'MVR',
  MWK: 'MWK',
  MXN: 'MXN',
  MYR: 'MYR',
  MZN: 'MZN',
  NAD: 'NAD',
  NGN: 'NGN',
  NIO: 'NIO',
  NOK: 'NOK',
  NPR: 'NPR',
  NZD: 'NZD',
  PAB: 'PAB',
  PEN: 'PEN',
  PGK: 'PGK',
  PHP: 'PHP',
  PKR: 'PKR',
  PLN: 'PLN',
  PYG: 'PYG',
  QAR: 'QAR',
  RON: 'RON',
  RSD: 'RSD',
  RUB: 'RUB',
  RWF: 'RWF',
  SAR: 'SAR',
  SBD: 'SBD',
  SCR: 'SCR',
  SEK: 'SEK',
  SGD: 'SGD',
  SHP: 'SHP',
  SLE: 'SLE',
  SOS: 'SOS',
  SRD: 'SRD',
  STD: 'STD',
  SZL: 'SZL',
  THB: 'THB',
  TJS: 'TJS',
  TOP: 'TOP',
  TRY: 'TRY',
  TTD: 'TTD',
  TWD: 'TWD',
  TZS: 'TZS',
  UAH: 'UAH',
  UGX: 'UGX',
  /** Return the currency in USD. */
  USD: 'USD',
  UYU: 'UYU',
  UZS: 'UZS',
  VND: 'VND',
  VUV: 'VUV',
  WST: 'WST',
  XAF: 'XAF',
  XCD: 'XCD',
  XOF: 'XOF',
  XPF: 'XPF',
  YER: 'YER',
  ZAR: 'ZAR',
  ZMW: 'ZMW'
} as const;

export type CurrencyUnit = typeof CurrencyUnit[keyof typeof CurrencyUnit];
/** Represents a day of the week. */
export const DayOfWeek = {
  FRIDAY: 'friday',
  MONDAY: 'monday',
  SATURDAY: 'saturday',
  SUNDAY: 'sunday',
  THURSDAY: 'thursday',
  TUESDAY: 'tuesday',
  WEDNESDAY: 'wednesday'
} as const;

export type DayOfWeek = typeof DayOfWeek[keyof typeof DayOfWeek];
export const DimensionUnit = {
  /** Return the dimension in feet. */
  FOOT: 'foot',
  /** Return the dimension in kilometers. */
  KILOMETER: 'kilometer',
  /** Return the dimension in meters. */
  METER: 'meter',
  /** Return the dimension in miles. */
  MILE: 'mile'
} as const;

export type DimensionUnit = typeof DimensionUnit[keyof typeof DimensionUnit];
export type DimensionsInput = {
  /** Dimension unit */
  type: MeasurementUnit;
  /** Value of the dimension */
  value: Scalars['Float']['input'];
};

export type DistanceInput = {
  /** Unit of distance. */
  unit: DistanceUnit;
  /** Value of the distance. */
  value: Scalars['Float']['input'];
};

export const DistanceUnit = {
  /** Distance in feet. */
  FOOT: 'foot',
  /** Distance in kilometers. */
  KILOMETER: 'kilometer',
  /** Distance in meters. */
  METER: 'meter',
  /** Distance in miles. */
  MILE: 'mile'
} as const;

export type DistanceUnit = typeof DistanceUnit[keyof typeof DistanceUnit];
/** EVSE data which extends OCPI EVSE. */
export type Evse = {
  __typename?: 'EVSE';
  /** List of functionalities that an EVSE is capable of. */
  capabilities?: Maybe<Array<Maybe<OcpiCapability>>>;
  /** List of available connectors on an EVSE. */
  connectors?: Maybe<Array<Maybe<Connector>>>;
  /** Coordinates of a EVSE. */
  coordinates?: Maybe<OcpiGeoLocation>;
  /** Unique ID of the location in the system of the CPO. */
  cpo_external_id?: Maybe<Scalars['String']['output']>;
  /** Custom properties of an EVSE. */
  custom_properties?: Maybe<EvseCustomProperties>;
  /** Compliant with the following specification for EVSE ID from "eMI3 standard version V1.0" (http://emi3group.com/documents-links/) "Part 2: business objects." Optional because: if an evse_id is to be re-used in the real world, the evse_id can be removed from an EVSE object if the status is set to REMOVED. */
  evse_id?: Maybe<Scalars['String']['output']>;
  /** Level on which a Charge Point is located (in garage buildings) in the locally displayed numbering scheme. */
  floor_level?: Maybe<Scalars['String']['output']>;
  /** Links to images related to an EVSE such as photos or logos. */
  images?: Maybe<Array<Maybe<OcpiImage>>>;
  /** Timestamp when this EVSE or one of its Connectors was last updated (or created). */
  last_updated?: Maybe<Scalars['DateTime']['output']>;
  /** Indicates if parking is free or paid. */
  parking_cost?: Maybe<ParkingCost>;
  /** Restrictions that apply to a parking spot. */
  parking_restrictions?: Maybe<Array<Maybe<OcpiParkingRestriction>>>;
  /** A number/string printed on the outside of an EVSE for visual identification. */
  physical_reference?: Maybe<Scalars['String']['output']>;
  /** Optional object where you can store custom data you need in your application. This extends the current functionalities we offer. */
  properties?: Maybe<Scalars['JSON']['output']>;
  /** Indicates the current status of an EVSE. */
  status?: Maybe<OcpiStatus>;
  /** Indicates a planned status update of a nEVSE. */
  status_schedule?: Maybe<Array<Maybe<OcpiStatusSchedule>>>;
  /**
   * Uniquely identifies an EVSE within the CPOs platform (and suboperator platforms). For example a database ID or the actual "EVSE ID". This field can never be changed, modified or renamed. This is the 'technical' identification of the EVSE, not to be used as 'human readable' identification, use the field evse_id for that.
   * This field is named uid instead of id, because id could be confused with evse_id which is an eMI3 defined field.
   */
  uid?: Maybe<Scalars['String']['output']>;
};

export type ElectricityGenerationMethod = {
  __typename?: 'ElectricityGenerationMethod';
  /** Fraction of total electricity production. */
  fraction: Scalars['Float']['output'];
  /** Emissions per kWh of the generation method. */
  intensity: Scalars['Float']['output'];
};


export type ElectricityGenerationMethodIntensityArgs = {
  unit?: InputMaybe<EmissionUnit>;
};

export type ElevationInput = {
  /** Source of inputted data, defaults to 'manual'. */
  source?: InputMaybe<TelemetryInputSource>;
  /** Preferred unit for the elevation. */
  type: DistanceUnit;
  /** Value of the elevation. */
  value: Scalars['Float']['input'];
};

export const ElevationUnit = {
  /** Return the elevation in feet. */
  FOOT: 'foot',
  /** Return the elevation in meters. */
  METER: 'meter'
} as const;

export type ElevationUnit = typeof ElevationUnit[keyof typeof ElevationUnit];
export const EmissionRateUnit = {
  /** Return the emission rate in grams per kilometer. */
  GRAMS_PER_KILOMETER: 'grams_per_kilometer',
  /** Return the emission rate in ounces per mile. */
  OUNCES_PER_MILE: 'ounces_per_mile'
} as const;

export type EmissionRateUnit = typeof EmissionRateUnit[keyof typeof EmissionRateUnit];
export const EmissionUnit = {
  /** Return the emissions in grams. */
  GRAM: 'gram',
  /** Return the emissions in ounces. */
  OUNCE: 'ounce'
} as const;

export type EmissionUnit = typeof EmissionUnit[keyof typeof EmissionUnit];
export type EmissionsFactor = {
  __typename?: 'EmissionsFactor';
  /** The name of the area for which the emissions factor was calculated. */
  name: Scalars['String']['output'];
  /** The type of area for which the emissions factor was calculated. */
  type: EmissionsFactorType;
  /** The base regional emissions factor in CO2e/kWh. */
  value: Scalars['Float']['output'];
};


export type EmissionsFactorValueArgs = {
  unit?: InputMaybe<EmissionUnit>;
};

/** Emissions factor type. */
export const EmissionsFactorType = {
  COUNTRY: 'country',
  REGION: 'region',
  SUBREGION: 'subregion'
} as const;

export type EmissionsFactorType = typeof EmissionsFactorType[keyof typeof EmissionsFactorType];
/** Custom EVSE properties for OICP databases such as the global Hubject database. Station databases that not follow the OICP standard return null values. */
export type EvseCustomProperties = {
  __typename?: 'EvseCustomProperties';
  /** OICP standard custom properties. */
  oicp?: Maybe<OicpEvseCustomProperties>;
};

/** A GeoJSON Feature<LineString>. */
export type FeatureLineString = {
  __typename?: 'FeatureLineString';
  /** Geometry of the feature. */
  geometry: LineString;
  /** Feature type. */
  type: FeatureType;
};

/** A GeoJSON Feature<MultiPolygon>. */
export type FeatureMultiPolygon = {
  __typename?: 'FeatureMultiPolygon';
  /** Geometry of the feature. */
  geometry: MultiPolygon;
  /** Properties of the MultiPolygon Feature. */
  properties?: Maybe<PolygonProperties>;
  /** Feature type. */
  type: FeatureType;
};

/** A GeoJSON Feature<Point>. */
export type FeatureMultiPolygonPoint = {
  __typename?: 'FeatureMultiPolygonPoint';
  /** Geometry of the feature. */
  geometry: Point;
  /** Optional object where you can store custom data you need in your application. */
  properties?: Maybe<Scalars['JSON']['output']>;
  /** Feature type. */
  type: FeatureType;
};

/** A GeoJSON Feature<Point>. */
export type FeaturePoint = {
  __typename?: 'FeaturePoint';
  /** Geometry of the feature. */
  geometry: Point;
  /** Feature ID. */
  id?: Maybe<Scalars['String']['output']>;
  /** Optional object where you can store custom data you need in your application. This extends the current functionalities we offer. */
  properties?: Maybe<Scalars['JSON']['output']>;
  /** Feature type. */
  type: FeatureType;
};

/** A GeoJSON Feature<Point> input. */
export type FeaturePointInput = {
  /** Geometry of the feature. */
  geometry: PointInput;
  /** The feature ID. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Optional object where you can store custom data you need in your application. This extends the current functionalities we offer. */
  properties?: InputMaybe<Scalars['JSON']['input']>;
  /** Feature type. */
  type: FeatureType;
};

/** A GeoJSON Feature<Point> input. */
export type FeaturePointPolygonInput = {
  /** Geometry of the feature. */
  geometry: PointInput;
  /** Optional object where you can store custom data you need in your application. */
  properties?: InputMaybe<FeaturePointPolygonPropertiesInput>;
  /** Feature type. */
  type: FeatureType;
};

/** Properties for Feature<Point> input. */
export type FeaturePointPolygonProperties = {
  __typename?: 'FeaturePointPolygonProperties';
  /** Name of the location. */
  name?: Maybe<Scalars['String']['output']>;
};

/** Properties for Feature<Point> input. */
export type FeaturePointPolygonPropertiesInput = {
  /** Name of the location. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** GeoJSON Feature type. */
export const FeatureType = {
  FEATURE: 'Feature'
} as const;

export type FeatureType = typeof FeatureType[keyof typeof FeatureType];
export type FluidEndOfLifeEmissions = {
  __typename?: 'FluidEndOfLifeEmissions';
  /** Brake fluid end of life emissions. */
  brake: Scalars['Float']['output'];
  /** Motor oil end of life emissions. */
  motor_oil?: Maybe<Scalars['Float']['output']>;
  /** Powertrain coolant fluid end of life emissions. */
  powertrain_coolant: Scalars['Float']['output'];
  /** Total fluid end of life emissions. */
  total: Scalars['Float']['output'];
  /** Transmission fluid end of life emissions. */
  transmission: Scalars['Float']['output'];
  /** Wiper fluid end of life emissions. */
  wiper: Scalars['Float']['output'];
};


export type FluidEndOfLifeEmissionsBrakeArgs = {
  unit?: InputMaybe<EmissionUnit>;
};


export type FluidEndOfLifeEmissionsMotor_OilArgs = {
  unit?: InputMaybe<EmissionUnit>;
};


export type FluidEndOfLifeEmissionsPowertrain_CoolantArgs = {
  unit?: InputMaybe<EmissionUnit>;
};


export type FluidEndOfLifeEmissionsTotalArgs = {
  unit?: InputMaybe<EmissionUnit>;
};


export type FluidEndOfLifeEmissionsTransmissionArgs = {
  unit?: InputMaybe<EmissionUnit>;
};


export type FluidEndOfLifeEmissionsWiperArgs = {
  unit?: InputMaybe<EmissionUnit>;
};

export type FluidMaintenanceEmissions = {
  __typename?: 'FluidMaintenanceEmissions';
  /** Brake fluid maintenance emissions. */
  brake: RouteOperationalMaintenanceEmissionsField;
  /** Motor oil maintenance emissions. */
  motor_oil?: Maybe<RouteOperationalMaintenanceEmissionsField>;
  /** Powertrain coolant fluid maintenance emissions. */
  powertrain_coolant: RouteOperationalMaintenanceEmissionsField;
  /** Total fluid maintenance emissions. */
  total: RouteOperationalMaintenanceEmissionsField;
  /** Transmission fluid maintenance emissions. */
  transmission: RouteOperationalMaintenanceEmissionsField;
  /** Wiper fluid maintenance emissions. */
  wiper: RouteOperationalMaintenanceEmissionsField;
};

export const FuelConsumptionUnit = {
  /** Return the fuel consumption in liters per 100 kilometers. */
  LITERS_PER_100_KILOMETERS: 'liters_per_100_kilometers',
  /** Return the fuel consumption in miles per gallon. */
  MILES_PER_GALLON: 'miles_per_gallon'
} as const;

export type FuelConsumptionUnit = typeof FuelConsumptionUnit[keyof typeof FuelConsumptionUnit];
export const FuelUnit = {
  /** Return the fuel consumption in US gallon. */
  GALLON: 'gallon',
  /** Return the fuel consumption in liters. */
  LITER: 'liter'
} as const;

export type FuelUnit = typeof FuelUnit[keyof typeof FuelUnit];
/** Geometry point with GPS coordinates */
export type GeometryPoint = {
  __typename?: 'GeometryPoint';
  coordinates: Array<Scalars['Float']['output']>;
  type: PointType;
};

/** Mode of heat pump. */
export const HeatPumpMode = {
  /** Default to the vehicle configuration. */
  DEFAULT: 'default',
  /** Vehicle has it installed. */
  INSTALLED: 'installed',
  /** Vehicle doesn't have it installed. */
  NONE: 'none'
} as const;

export type HeatPumpMode = typeof HeatPumpMode[keyof typeof HeatPumpMode];
/** Allowed N (EU) types of heavy vehicles. */
export const HeavyVehiclesEuType = {
  /** Only N1 type of heavy vehicles can be parked at the charging station. N1 vehicles have a maximum mass not exceeding 3.5 tonnes (7,700 lbs). */
  N1: 'N1',
  /** Only N2 type of heavy vehicles can be parked at the charging station. N2 vehicles have a maximum mass exceeding 3.5 tonnes but not exceeding 12 tonnes (26,000 lbs). */
  N2: 'N2',
  /** Only N3 type of heavy vehicles can be parked at the charging station. N3 vehicles have a maximum mass exceeding 12 tonnes (26,000 lbs). */
  N3: 'N3',
  /** N3 type of heavy vehicles having O4 type of trailers can be parked at the charging station. N3 vehicles have a maximum mass exceeding 12 tonnes (26,000 lbs) and O4 trailers have a maximum mass exceeding 10 tonnes (22000 lbs). */
  N3_O4: 'N3_O4'
} as const;

export type HeavyVehiclesEuType = typeof HeavyVehiclesEuType[keyof typeof HeavyVehiclesEuType];
/** List of facilities in the location. */
export const HeavyVehiclesFacility = {
  /** Secure truck parking. */
  SECURE_TRUCK_PARKING: 'SECURE_TRUCK_PARKING',
  /** Truck dealership. */
  TRUCK_DEALERSHIP: 'TRUCK_DEALERSHIP',
  /** Truck parking. */
  TRUCK_PARKING: 'TRUCK_PARKING',
  /** Truck repair. */
  TRUCK_REPAIR: 'TRUCK_REPAIR',
  /** Truck wash. */
  TRUCK_WASH: 'TRUCK_WASH'
} as const;

export type HeavyVehiclesFacility = typeof HeavyVehiclesFacility[keyof typeof HeavyVehiclesFacility];
export type Isoline = {
  __typename?: 'Isoline';
  /** List of the ferries uniting islands formed by the isoline. */
  ferries?: Maybe<Array<Maybe<FeatureLineString>>>;
  /** Isoline id. */
  id: Scalars['ID']['output'];
  /** Distance from the origin to the furthest reachable point within the isoline. Represents the longest drivable distance, not a straight-line or vehicle range. */
  maximum_distance?: Maybe<Scalars['Float']['output']>;
  /** Shape of the isoline consisting in a list of multipolygons. */
  polygons?: Maybe<Array<Maybe<FeatureMultiPolygon>>>;
  /** The inputted request data for the isoline used to compute it. */
  request_input?: Maybe<IsolineRequestInput>;
  /** Isoline status. */
  status: IsolineStatus;
};


export type IsolineMaximum_DistanceArgs = {
  unit?: InputMaybe<DistanceUnit>;
};

export type IsolineCabin = {
  __typename?: 'IsolineCabin';
  /** Desired temperature inside the cabin. Default is 20 degrees Celsius or 68 degrees Fahrenheit. */
  desired_temperature?: Maybe<Scalars['Float']['output']>;
  /** Flag which indicate if the vehicle cabin was preconditioned for the desired temperature. */
  is_preconditioned?: Maybe<Scalars['Boolean']['output']>;
};


export type IsolineCabinDesired_TemperatureArgs = {
  unit?: InputMaybe<TemperatureUnit>;
};

/** Information about the cabin of the vehicle. */
export type IsolineCabinInput = {
  /** Desired temperature inside the cabin. Default is 20 degrees Celsius or 68 degrees Fahrenheit. */
  desired_temperature?: InputMaybe<TemperatureInput>;
  /** Flag which indicate if the vehicle cabin was preconditioned for the desired temperature. */
  is_preconditioned?: InputMaybe<Scalars['Boolean']['input']>;
};

export const IsolineFerryConnectionsType = {
  /** Ferry connections should not be included. */
  NONE: 'none',
  /** Ferry connections should be taken into account but only one level deep. For example: from the European mainland to England and no other connecting ferries departing from England. */
  SINGLE: 'single'
} as const;

export type IsolineFerryConnectionsType = typeof IsolineFerryConnectionsType[keyof typeof IsolineFerryConnectionsType];
export type IsolineInput = {
  /** Vehicle cabin configuration. */
  cabin?: InputMaybe<IsolineCabinInput>;
  /** Climate is on. */
  climate_control?: InputMaybe<Scalars['Boolean']['input']>;
  /** Include ferry connections. Single and multiple ferry connections increase the calculation time and the number of polygons. */
  ferry_connections?: InputMaybe<IsolineFerryConnectionsType>;
  /** Minimum final battery state of charge. Default is 0 */
  final_state_of_charge?: InputMaybe<StateOfChargeInput>;
  /** Vehicle Heat Pump configuration. */
  heat_pump?: InputMaybe<HeatPumpMode>;
  /** [BETA] User-defined maximum speed used for the isoline. */
  maximum_speed?: InputMaybe<MaximumSpeedInput>;
  /** Number of occupants. */
  occupants?: InputMaybe<Scalars['Int']['input']>;
  /** Origin point of the request. */
  origin: FeaturePointPolygonInput;
  /** Numbers of polygons to be generated (maximum: 20). */
  polygon_count?: InputMaybe<Scalars['Int']['input']>;
  /** Polygons precision quality. */
  quality?: InputMaybe<IsolineQuality>;
  /** Vehicle should be able to return to the origin point from any point. */
  round_trip?: InputMaybe<Scalars['Boolean']['input']>;
  /** Season to be taken into account when generating the isoline. If not specified, defaults to real-time weather data. */
  season?: InputMaybe<RouteSeason>;
  /** Battery state of charge. Default is usable battery kwh of the inputted vehicle. */
  state_of_charge?: InputMaybe<StateOfChargeInput>;
  /** Cargo weight. */
  total_cargo_weight?: InputMaybe<TotalCargoWeightInput>;
  /** Cumulated weight of the occupants. */
  total_occupant_weight?: InputMaybe<TotalOccupantWeightInput>;
  /** Vehicle id. */
  vehicle_id: Scalars['ID']['input'];
  /** Weather configuration for the isoline. Defined by a preset or custom weather conditions. If not specified, defaults to real-time weather data. */
  weather?: InputMaybe<IsolineWeatherInput>;
};

/** Granularity of the isoline. */
export const IsolineQuality = {
  /** High polygons precisions. */
  HIGH: 'high',
  /** Low polygons precisions. */
  LOW: 'low'
} as const;

export type IsolineQuality = typeof IsolineQuality[keyof typeof IsolineQuality];
export type IsolineRequestInput = {
  __typename?: 'IsolineRequestInput';
  /** Vehicle cabin configuration. */
  cabin?: Maybe<IsolineCabin>;
  /** Climate is on. */
  climate_control?: Maybe<Scalars['Boolean']['output']>;
  /** Ferry connections. */
  ferry_connections?: Maybe<IsolineFerryConnectionsType>;
  /** Minimum final battery state of charge. */
  final_state_of_charge: Scalars['Float']['output'];
  /** Vehicle Heat Pump configuration. */
  heat_pump?: Maybe<HeatPumpMode>;
  /** [BETA] Maximum speed to consider when generating the isoline. In the segments where legal speed is lower than this value, the legal speed will be used instead. */
  maximum_speed?: Maybe<MaximumSpeed>;
  /** Number of occupants. */
  occupants?: Maybe<Scalars['Int']['output']>;
  /** Origin point of the request. */
  origin: FeaturePoint;
  /** Numbers of polygons that were generated. */
  polygon_count?: Maybe<Scalars['Int']['output']>;
  /** Polygons precision quality. */
  quality?: Maybe<IsolineQuality>;
  /** Vehicle should be able to return to the origin point from any point. */
  round_trip?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Season taken into account when isoline was generated.
   * @deprecated In favor of weather.
   */
  season?: Maybe<RouteSeason>;
  /** Battery state of charge. */
  state_of_charge: Scalars['Float']['output'];
  /** Cargo weight. */
  total_cargo_weight?: Maybe<Scalars['Float']['output']>;
  /** Cumulated weight of the occupants. */
  total_occupant_weight?: Maybe<Scalars['Float']['output']>;
  /** Vehicle id. */
  vehicle_id: Scalars['ID']['output'];
  /** Weather configuration for the isoline. Defined by a preset or custom weather conditions. */
  weather?: Maybe<IsolineWeather>;
};


export type IsolineRequestInputFinal_State_Of_ChargeArgs = {
  unit?: InputMaybe<StateOfChargeUnit>;
};


export type IsolineRequestInputState_Of_ChargeArgs = {
  unit?: InputMaybe<StateOfChargeUnit>;
};


export type IsolineRequestInputTotal_Cargo_WeightArgs = {
  unit?: InputMaybe<WeightUnit>;
};


export type IsolineRequestInputTotal_Occupant_WeightArgs = {
  unit?: InputMaybe<WeightUnit>;
};

/** Status of the isoline label. */
export const IsolineStatus = {
  /** Isoline label has been successfully generated. */
  DONE: 'done',
  /** There was an error while generating the isoline label. */
  ERROR: 'error',
  /** Isoline label is under processing. */
  PENDING: 'pending'
} as const;

export type IsolineStatus = typeof IsolineStatus[keyof typeof IsolineStatus];
export type IsolineWeather = {
  __typename?: 'IsolineWeather';
  /** [BETA] Custom weather conditions applied to the isoline. Only present when 'type' is set to 'CUSTOM'. */
  custom?: Maybe<IsolineWeatherCustomConditions>;
  /** Weather configuration applied to the isoline. */
  type: WeatherType;
};

export type IsolineWeatherCustomConditions = {
  __typename?: 'IsolineWeatherCustomConditions';
  /** Atmospheric pressure along the isoline. */
  air_pressure: AirPressure;
  /** Solar irradiance along the isoline. */
  solar_irradiance: SolarIrradiance;
  /** Average ambient temperature estimated along the isoline. */
  temperature: Temperature;
};

export type IsolineWeatherCustomConditionsInput = {
  /** Atmospheric pressure within the isoline. */
  air_pressure: AirPressureInput;
  /** Solar irradiance within the isoline. */
  solar_irradiance: SolarIrradianceInput;
  /** Average ambient temperature estimated within the isoline. */
  temperature: TemperatureInput;
};

export type IsolineWeatherInput = {
  /** [BETA] Custom weather conditions to apply within the isoline. Required only when 'type' is 'CUSTOM'. Must be omitted for other weather types. */
  custom?: InputMaybe<IsolineWeatherCustomConditionsInput>;
  /** Weather configuration applied within the isoline. */
  type?: InputMaybe<WeatherType>;
};

/** Types of a leg. */
export const LegType = {
  /** This leg ends at the destination, and is the last leg of the route. */
  FINAL: 'final',
  /** This leg ends at a charging station and the vehicle must recharge. */
  STATION: 'station',
  /** This leg ends at a scheduled charging station and the vehicle must recharge. */
  STATIONAMENITY: 'stationAmenity',
  /** This leg ends at the destination which is a charging station, and is the last leg of the route. */
  STATIONFINAL: 'stationFinal',
  /** This leg ends at a via charging station and the vehicle must recharge. */
  STATIONVIA: 'stationVia',
  /** This leg ends at a via location. */
  VIA: 'via'
} as const;

export type LegType = typeof LegType[keyof typeof LegType];
/** A GeoJSON LineString. */
export type LineString = {
  __typename?: 'LineString';
  /** List of coordinates arrays with longitude as first value and latitude as second one. */
  coordinates: Array<Maybe<Array<Scalars['Float']['output']>>>;
  /** LineString type. */
  type: LineStringType;
};

/** GeoJSON LineString type. */
export const LineStringType = {
  LINESTRING: 'LineString'
} as const;

export type LineStringType = typeof LineStringType[keyof typeof LineStringType];
export type MaximumSpeed = {
  __typename?: 'MaximumSpeed';
  /** Unit in which speed is measured. */
  type: SpeedUnit;
  /** Numeric value of the user-defined maximum speed. */
  value: Scalars['Int']['output'];
};

export type MaximumSpeedInput = {
  /** Unit in which speed is measured. */
  type: SpeedUnit;
  /** Numeric value of the user-defined maximum speed. */
  value: Scalars['Int']['input'];
};

export const MeasurementUnit = {
  /** Return the measurement in inches. */
  INCH: 'inch',
  /** Return the measurement in millimeters. */
  MILLIMETER: 'millimeter'
} as const;

export type MeasurementUnit = typeof MeasurementUnit[keyof typeof MeasurementUnit];
/** A GeoJSON Polygon. */
export type MultiPolygon = {
  __typename?: 'MultiPolygon';
  /** List of coordinates representing a polygon. */
  coordinates: Array<Maybe<Array<Maybe<Array<Maybe<Array<Scalars['Float']['output']>>>>>>>;
  /** MultiPolygon type. */
  type: MultiPolygonType;
};

/** GeoJSON MultiPolygon type. */
export const MultiPolygonType = {
  MULTIPOLYGON: 'MultiPolygon'
} as const;

export type MultiPolygonType = typeof MultiPolygonType[keyof typeof MultiPolygonType];
export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Add a new review.
   * If the `x-token` header is send for a valid user, the review will belong to it, otherwise will be added for an anonymouse user
   */
  addReview: Review;
  /** [BETA] Advances the active navigation session to the next route leg. */
  advanceNavigationLeg?: Maybe<Scalars['Boolean']['output']>;
  /** [BETA] Authorize a connected vehicle */
  authorizeConnectedVehicle?: Maybe<ConnectedVehicle>;
  /** [BETA] Create a connected vehicle for a given vehicle id and a connectivity provider */
  createConnectedVehicle?: Maybe<ConnectedVehicle>;
  /** Create a consumption based isoline. */
  createIsoline?: Maybe<Scalars['ID']['output']>;
  /** Create a new route from the route input. */
  createRoute: Scalars['ID']['output'];
  /** [ALPHA] Create a new truck route from the route input and its ID. */
  createTruckRoute: Scalars['ID']['output'];
  /**
   * Remove a review added by an authenticated user.
   * The `x-token` header is mandatory in order to authorize the user who wants to remove a review.
   * In case it is not sent, an error will occur.
   * In case the review was not found or belongs to another user an error will occur.
   * This is a premium feature, contact Chargetrip for more information.
   */
  deleteUserReview: Review;
  /** [BETA] End a navigation session. */
  finishNavigation?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Create a new route from the route input.
   * @deprecated In favor of `createRoute`.
   */
  newRoute?: Maybe<Scalars['ID']['output']>;
  /** [BETA] Recalculate the current navigation route */
  recalculateNavigation?: Maybe<Scalars['Boolean']['output']>;
  /** [BETA] Remove a connected vehicle and revoke access */
  removeConnectedVehicle?: Maybe<ConnectedVehicle>;
  /** [BETA] Start a new navigation session on top of an existing route */
  startNavigation?: Maybe<Scalars['ID']['output']>;
  /** [BETA] Update a connected vehicle */
  updateConnectedVehicle?: Maybe<ConnectedVehicle>;
  /** [BETA] Update the navigation session */
  updateNavigation?: Maybe<Scalars['Boolean']['output']>;
};


export type MutationAddReviewArgs = {
  review: ReviewAdd;
};


export type MutationAdvanceNavigationLegArgs = {
  input: AdvanceNavigationLegInput;
};


export type MutationAuthorizeConnectedVehicleArgs = {
  input?: InputMaybe<AuthorizeConnectedVehicleInput>;
};


export type MutationCreateConnectedVehicleArgs = {
  input?: InputMaybe<CreateConnectedVehicleInput>;
};


export type MutationCreateIsolineArgs = {
  input: IsolineInput;
};


export type MutationCreateRouteArgs = {
  input: CreateRouteInput;
};


export type MutationCreateTruckRouteArgs = {
  input: CreateTruckRouteInput;
};


export type MutationDeleteUserReviewArgs = {
  id: Scalars['ID']['input'];
};


export type MutationFinishNavigationArgs = {
  input: NavigationFinishInput;
};


export type MutationNewRouteArgs = {
  input?: InputMaybe<RequestInput>;
};


export type MutationRecalculateNavigationArgs = {
  input: NavigationRecalculateInput;
};


export type MutationRemoveConnectedVehicleArgs = {
  input: RemoveConnectedVehicleInput;
};


export type MutationStartNavigationArgs = {
  input: NavigationStartInput;
};


export type MutationUpdateConnectedVehicleArgs = {
  input: UpdateConnectedVehicleInput;
};


export type MutationUpdateNavigationArgs = {
  input: NavigationUpdateInput;
};

/** Navigation session data. */
export type Navigation = {
  __typename?: 'Navigation';
  /** ID of the navigation session. */
  id: Scalars['ID']['output'];
  /** Navigation meta information. */
  meta?: Maybe<NavigationMeta>;
  /** Navigation session details overview. */
  overview: NavigationOverview;
  /** The status of a navigation session. The status can be active or finished. */
  status: NavigationStatus;
  /** The status of the navigation session vehicle. The status can be driving, charging or parked. */
  vehicle_status: NavigationVehicleStatus;
};

/** Navigation session alternative station type. */
export type NavigationAlternativeStation = {
  __typename?: 'NavigationAlternativeStation';
  /** ID of the connector that was selected in a route. */
  connector_id: Scalars['ID']['output'];
  /** ID of the EVSE that was selected in a route. */
  evse_id?: Maybe<Scalars['ID']['output']>;
  /** Coordinates of a station. */
  location: Point;
  /** Station operator. */
  operator?: Maybe<NavigationStationOperator>;
  /** ID of the station. */
  station_id: Scalars['ID']['output'];
};

/** Represents the most recent completed meaningful change to the navigation session. */
export type NavigationChange = {
  __typename?: 'NavigationChange';
  /** Timestamp when the change was finalized. */
  created_at: Scalars['DateTime']['output'];
  /** Where the change originated from. */
  source: NavigationChangeSource;
  /** What kind of change occurred. */
  type: NavigationChangeType;
};

export const NavigationChangeSource = {
  /** Triggered by an explicit client action (e.g. a recalculateNavigation call). */
  CLIENT: 'client',
  /** Triggered by backend domain changes (e.g. station availability, background recalculation). */
  SERVER: 'server'
} as const;

export type NavigationChangeSource = typeof NavigationChangeSource[keyof typeof NavigationChangeSource];
export const NavigationChangeType = {
  /** Next station availability has changed. */
  NEXT_STATION_AVAILABILITY_UPDATED: 'next_station_availability_updated',
  /** Explicit recalculation/reroute failed. The previous route geometry was kept.  */
  ROUTE_UPDATE_FAILED: 'route_update_failed',
  /** The route has been modified or recalculated. */
  ROUTE_UPDATED: 'route_updated',
  /** Navigation session has just started. */
  STARTED: 'started'
} as const;

export type NavigationChangeType = typeof NavigationChangeType[keyof typeof NavigationChangeType];
/** Input for the navigation finish. */
export type NavigationFinishInput = {
  /** Current coordinates. */
  current_location: PointInput;
  /** ID of the navigation session. */
  id: Scalars['ID']['input'];
};

/** Navigation route leg section details. */
export type NavigationLegSection = {
  __typename?: 'NavigationLegSection';
  /** Destination point. */
  destination: RouteDetailsLegSectionFeaturePoint;
  /** Total duration of a section, in seconds. The value will be 0 for walking sections. */
  duration: Scalars['Float']['output'];
  /** Origin point. */
  origin: RouteDetailsLegSectionFeaturePoint;
  /** Polyline containing encoded coordinates. */
  polyline: Scalars['String']['output'];
  /** Aggregation of tags over the current section. */
  tags: Array<RouteDetailsTag>;
  /** Section type. */
  type: RouteDetailsLegSectionType;
};


/** Navigation route leg section details. */
export type NavigationLegSectionPolylineArgs = {
  decimals?: InputMaybe<PolylineInputDecimals>;
};

export type NavigationLiveRouteRequest = {
  __typename?: 'NavigationLiveRouteRequest';
  /** Alternative stations along a route within a specified radius of 500 to 5000 meters, or the equivalent in another unit. */
  alternative_station_radius?: Maybe<AlternativeStationRadius>;
  /** [BETA] List of route features to avoid in a route. This is a best-effort preference; depending on the available routes, some features may not be fully avoidable. */
  avoid?: Maybe<Array<RouteAvoid>>;
  /** Destination of a route. */
  destination: RouteDestinationFeaturePoint;
  /** [BETA] Configuration options for the route's driving conditions. Includes factors to adjust average speed, set a maximum speed, and define a base driving style. If not specified, no adjustments are applied. */
  driving_preferences?: Maybe<RouteDrivingPreferences>;
  /** Operator preferences for a route. When provided, prefers routes that use higher order operators. */
  operators?: Maybe<RouteOperatorPreferences>;
  /** Origin of a route. */
  origin: RouteOriginFeaturePoint;
  /** Charging stations preferences for route calculation. */
  station_preferences?: Maybe<RouteStationPreferences>;
  /** Vehicle used on a route. */
  vehicle: NavigationRouteVehicle;
  /** Via points of a route. */
  via?: Maybe<Array<NavigationViaFeaturePoint>>;
};

/** Navigation meta information. */
export type NavigationMeta = {
  __typename?: 'NavigationMeta';
  /** Creation time of the navigation session. */
  created_at: Scalars['DateTime']['output'];
  /** Last updated time of the navigation session. */
  updated_at: Scalars['DateTime']['output'];
};

/** Navigation session overview details. */
export type NavigationOverview = {
  __typename?: 'NavigationOverview';
  /** Index of the current active route leg. */
  current_leg: Scalars['Int']['output'];
  /** Continuously updated durations of the route. */
  durations: RouteDetailsDurations;
  /** Navigation route instructions. */
  instructions: Array<Maybe<RouteInstruction>>;
  /** Last known location. */
  last_known_location: Point;
  /** Continuously updated route legs. */
  legs: Array<Maybe<NavigationRouteLeg>>;
  /** Continuously updated route request input. */
  live_route_request: NavigationLiveRouteRequest;
  /** Next stop details. Can be a charging or a location stop. */
  next_stop: NavigationStop;
  /** Polyline containing encoded coordinates. */
  polyline: Scalars['String']['output'];
  /** State of charge at the last known location. */
  state_of_charge: Scalars['Float']['output'];
  /** Telemetry data. */
  telemetry?: Maybe<Telemetry>;
};


/** Navigation session overview details. */
export type NavigationOverviewPolylineArgs = {
  decimals?: InputMaybe<PolylineInputDecimals>;
};


/** Navigation session overview details. */
export type NavigationOverviewState_Of_ChargeArgs = {
  unit?: InputMaybe<StateOfChargeUnit>;
};

export type NavigationPropertiesStation = {
  __typename?: 'NavigationPropertiesStation';
  /** External ID of the station. When provided and valid, the coordinates of this station will be used. */
  external_station_id?: Maybe<Scalars['ID']['output']>;
  /** ID of the station. When provided and valid, the coordinates of this station will be used. */
  station_id?: Maybe<Scalars['ID']['output']>;
  /** Duration to stay at the station, in seconds. Includes charging time and charging penalty. When not provided, the duration is optimized based on the vehicle’s charging needs and selected charging mode. */
  stop_duration?: Maybe<Scalars['Int']['output']>;
};

export type NavigationPropertiesStationInput = {
  /** External ID of the station. When provided and valid, the coordinates of this station will be used. */
  external_station_id?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the station. When provided and valid, the coordinates of this station will be used. */
  station_id?: InputMaybe<Scalars['ID']['input']>;
  /** Duration to stay at the station, in seconds. Includes charging time and charging penalty. When not provided, the duration is optimized based on the vehicle’s charging needs and selected charging mode. */
  stop_duration?: InputMaybe<Scalars['Int']['input']>;
};

export type NavigationPropertiesVehicle = {
  __typename?: 'NavigationPropertiesVehicle';
  /** Number of occupants present in the vehicle. */
  occupants: Scalars['Int']['output'];
  /** Weight of the cargo. */
  total_cargo_weight?: Maybe<TotalCargoWeight>;
  /** Combined weight of the occupants. This can only be used in combination with occupants. */
  total_occupant_weight: TotalOccupantWeight;
};

export type NavigationPropertiesVehicleInput = {
  /** Number of occupants present in the vehicle. */
  occupants?: InputMaybe<Scalars['Int']['input']>;
  /** Weight of the cargo. */
  total_cargo_weight?: InputMaybe<TotalCargoWeightInput>;
  /** Combined weight of the occupants. This can only be used in combination with occupants. */
  total_occupant_weight?: InputMaybe<TotalOccupantWeightInput>;
};

export type NavigationPropertiesViaLocation = {
  __typename?: 'NavigationPropertiesViaLocation';
  /** Name that should overwrite the name that is automatically assigned to this location (for example: address or station name). */
  name?: Maybe<Scalars['String']['output']>;
  /** Duration to stay at this point, in seconds. */
  stop_duration?: Maybe<Scalars['Int']['output']>;
};

export type NavigationPropertiesViaLocationInput = {
  /** Name that should overwrite the name that is automatically assigned to this location (for example: address or station name). */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Duration to stay at this point, in seconds. */
  stop_duration?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for the navigation recalculate. */
export type NavigationRecalculateInput = {
  /** Origin location of a new route. */
  current_location: PointInput;
  /** ID of the navigation session. */
  id: Scalars['ID']['input'];
  /** State of charge at origin. */
  state_of_charge?: InputMaybe<StateOfChargeInput>;
  /** Telemetry data input. */
  telemetry?: InputMaybe<TelemetryInput>;
  /** Via points of a new route. If this field is not sent, the original via points will be used. */
  via?: InputMaybe<Array<NavigationViaFeaturePointInput>>;
};

/** Navigation route leg details. */
export type NavigationRouteLeg = {
  __typename?: 'NavigationRouteLeg';
  /** Destination point location. */
  destination: RouteDetailsLegFeaturePoint;
  /** Distance from the start to the end of a leg. */
  distance: Scalars['Float']['output'];
  /** Aggregation of all durations of a route leg. */
  durations: RouteDetailsDurations;
  /** Origin point location. */
  origin: RouteDetailsLegFeaturePoint;
  /** Range after charging on the leg. The ranges in kilometers and miles are estimates, calculated based on the Chargetrip range, current route conditions, weather scenario (current or seasonal), and the route input at the time of planning. For HEVs and PHEVs this field will return null. */
  range_after_charge?: Maybe<Scalars['Float']['output']>;
  /** Range available at the end of a leg. The ranges in kilometers and miles are estimates, calculated based on the Chargetrip range, current route conditions, weather scenario (current or seasonal), and the route input at the time of planning. For HEVs and PHEVs this field will return null. */
  range_at_destination?: Maybe<Scalars['Float']['output']>;
  /** Range at the start of a leg. The ranges in kilometers and miles are estimates, calculated based on the Chargetrip range, current route conditions, weather scenario (current or seasonal), and the route input at the time of planning. For HEVs and PHEVs this field will return null. */
  range_at_origin?: Maybe<Scalars['Float']['output']>;
  /** Road sections of a leg - divided by means of transportation. */
  sections: Array<NavigationLegSection>;
  /** Information about the station at the destination of a leg. */
  station?: Maybe<RouteDetailsLegStation>;
  /** Aggregation of tags over the current leg. Tags are further subdivided over individual sections and maneuvers. */
  tags: Array<RouteDetailsTag>;
  /** Type of a leg. */
  type: RouteDetailsLegType;
};


/** Navigation route leg details. */
export type NavigationRouteLegDistanceArgs = {
  unit?: InputMaybe<DistanceUnit>;
};


/** Navigation route leg details. */
export type NavigationRouteLegRange_After_ChargeArgs = {
  unit?: InputMaybe<StateOfChargeUnit>;
};


/** Navigation route leg details. */
export type NavigationRouteLegRange_At_DestinationArgs = {
  unit?: InputMaybe<StateOfChargeUnit>;
};


/** Navigation route leg details. */
export type NavigationRouteLegRange_At_OriginArgs = {
  unit?: InputMaybe<StateOfChargeUnit>;
};

export type NavigationRouteVehicle = {
  __typename?: 'NavigationRouteVehicle';
  /** EV battery specific configuration. */
  battery: RouteVehicleBattery;
  /** Vehicle cabin configuration used for the route calculation. Applied only if vehicle.climate is set to true. */
  cabin: RouteVehicleCabin;
  /** Charging configuration. */
  charging: RouteVehicleCharging;
  /** Flag indicating if climate control is on. */
  climate: Scalars['Boolean']['output'];
  /** Vehicle Heat Pump configuration. */
  heat_pump: HeatPumpMode;
  /** ID of the vehicle. */
  id: Scalars['ID']['output'];
};

/** Input for the navigation start. */
export type NavigationStartInput = {
  /** Current coordinates. */
  current_location: PointInput;
  /** ID of the route. */
  route_details_id: Scalars['ID']['input'];
  /** ID of the route request. */
  route_id: Scalars['ID']['input'];
};

/** Navigation session station type. */
export type NavigationStation = {
  __typename?: 'NavigationStation';
  /** ID of the connector that was selected in a route. */
  connector_id: Scalars['ID']['output'];
  /** ID of the EVSE that was selected in a route. */
  evse_id?: Maybe<Scalars['ID']['output']>;
  /** Station operator. */
  operator?: Maybe<NavigationStationOperator>;
  /** ID of the station. */
  station_id: Scalars['ID']['output'];
};

/** Navigation session station operator. */
export type NavigationStationOperator = {
  __typename?: 'NavigationStationOperator';
  /** Unique operator ID. */
  id?: Maybe<Scalars['ID']['output']>;
};

/** Status of navigation session. */
export const NavigationStatus = {
  /** Navigation session is live and currently tracking. */
  ACTIVE: 'active',
  /** Navigation session is completed (either manually or automatically 48 hours after the last update). */
  FINISHED: 'finished'
} as const;

export type NavigationStatus = typeof NavigationStatus[keyof typeof NavigationStatus];
/** Next stop details. Can be a charging or a location stop. */
export type NavigationStop = {
  __typename?: 'NavigationStop';
  /** A set of alternative charging stations to next station. Only present if next stop is a station. */
  alternative_stations?: Maybe<Array<NavigationAlternativeStation>>;
  /** Estimated arrival state of charge at next stop. For HEVs and PHEVs this field will return null. */
  arrival_state_of_charge: Scalars['Float']['output'];
  /** Estimated arrival time at the next stop. */
  arrival_time: Scalars['DateTime']['output'];
  /** Coordinates of the next stop. */
  location: Point;
  /** Next stop's station to charge. Only present if the next stop is a station. */
  station?: Maybe<NavigationStation>;
};


/** Next stop details. Can be a charging or a location stop. */
export type NavigationStopArrival_State_Of_ChargeArgs = {
  unit?: InputMaybe<StateOfChargeUnit>;
};

/** The navigation session subscription data */
export type NavigationSubscription = {
  __typename?: 'NavigationSubscription';
  /** Index of the current active route leg. */
  current_leg: Scalars['Int']['output'];
  /** ID of the navigation session. */
  id: Scalars['ID']['output'];
  /** Information about the latest completed change. */
  last_change: NavigationChange;
  /** Navigation meta information. */
  meta?: Maybe<NavigationMeta>;
  /** The status of the navigation session. The status can be active or finished. */
  status: NavigationStatus;
  /** The status of the navigation session vehicle. The status can be driving, charging or parked. */
  vehicle_status: NavigationVehicleStatus;
};

/** Input for the navigation update. */
export type NavigationUpdateInput = {
  /** ID of the navigation session. */
  id: Scalars['ID']['input'];
  /** A list of locations that were collected since the last update. */
  location_data: Array<NavigationUpdateLocationsInput>;
};

/** Input for the navigation update locations. */
export type NavigationUpdateLocationsInput = {
  /** Location coordinates [longitude, latitude]. */
  coordinates: Array<Scalars['Float']['input']>;
  /** Telemetry data input. */
  telemetry?: InputMaybe<TelemetryInput>;
  /** UNIX timestamp at location, in seconds. */
  timestamp: Scalars['Int']['input'];
};

/** Status of navigation session vehicle. */
export const NavigationVehicleStatus = {
  /** Vehicle is charging. */
  CHARGING: 'charging',
  /** Vehicle is driving. */
  DRIVING: 'driving',
  /** Vehicle is parked. */
  PARKED: 'parked'
} as const;

export type NavigationVehicleStatus = typeof NavigationVehicleStatus[keyof typeof NavigationVehicleStatus];
export type NavigationViaFeaturePoint = {
  __typename?: 'NavigationViaFeaturePoint';
  /** Geometry of the feature. */
  geometry: Point;
  /** ID of the feature. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Additional feature properties for via. If a `station.id` or `station.external_id` are provided, it will be treated as a charging stop.  If omitted or `location.name` is provided, the stop is treated as a non-charging stop location. */
  properties?: Maybe<NavigationViaProperties>;
  /** Feature type. */
  type: FeatureType;
};

export type NavigationViaFeaturePointInput = {
  /** Geometry of the feature. */
  geometry: PointInput;
  /** ID of the feature. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Additional feature properties for via. If a `station.id` or `station.external_id` are provided, it will be treated as a charging stop.  If omitted or `location.name` is provided, the stop is treated as a non-charging stop location. */
  properties?: InputMaybe<NavigationViaPropertiesInput>;
  /** Feature type. */
  type: FeatureType;
};

export type NavigationViaProperties = {
  __typename?: 'NavigationViaProperties';
  /** Location data of the via point. */
  location?: Maybe<NavigationPropertiesViaLocation>;
  /** Station data of the via point. */
  station?: Maybe<NavigationPropertiesStation>;
  /** Vehicle data of the via point. */
  vehicle?: Maybe<NavigationPropertiesVehicle>;
};

export type NavigationViaPropertiesInput = {
  /** Location data of the via point. */
  location?: InputMaybe<NavigationPropertiesViaLocationInput>;
  /** Specifies a charging station at the via. If a known station is provided, it will be used as charging stop. Any configured operator preferences are ignored for this stop. */
  station?: InputMaybe<NavigationPropertiesStationInput>;
  /** Vehicle data of the via point. */
  vehicle?: InputMaybe<NavigationPropertiesVehicleInput>;
};

/** This class defines an additional geo location that is relevant for the Charge Point. The geodetic system to be used is WGS 84. */
export type OcpiAdditionalGeoLocation = {
  __typename?: 'OCPIAdditionalGeoLocation';
  /** Latitude of the point in decimal degree. Example: 50.770774. Decimal separator: "." Regex: -?[0-9]{1,2}\.[0-9]{5,7} */
  latitude?: Maybe<Scalars['String']['output']>;
  /** Longitude of the point in decimal degree. Example: -126.104965. Decimal separator: "." Regex: -?[0-9]{1,3}\.[0-9]{5,7} */
  longitude?: Maybe<Scalars['String']['output']>;
  /** Name of the point in local language or as written at the location. For example the street name of a parking lot entrance or it’s number. */
  name?: Maybe<OcpiDisplayText>;
};

/** The capabilities of an EVSE. */
export const OcpiCapability = {
  /** The EVSE supports charging preferences. */
  CHARGING_PREFERENCES_CAPABLE: 'CHARGING_PREFERENCES_CAPABLE',
  /** The EVSE supports charging profiles. */
  CHARGING_PROFILE_CAPABLE: 'CHARGING_PROFILE_CAPABLE',
  /** EVSE has a payment terminal that supports chip cards. */
  CHIP_CARD_SUPPORT: 'CHIP_CARD_SUPPORT',
  /** EVSE has a payment terminal that supports contactless cards. */
  CONTACTLESS_CARD_SUPPORT: 'CONTACTLESS_CARD_SUPPORT',
  /** EVSE has a payment terminal that makes it possible to pay for charging using a credit card. */
  CREDIT_CARD_PAYABLE: 'CREDIT_CARD_PAYABLE',
  /** EVSE has a payment terminal that makes it possible to pay for charging using a debit card. */
  DEBIT_CARD_PAYABLE: 'DEBIT_CARD_PAYABLE',
  /** EVSE has a payment terminal with a pin-code entry device. */
  PED_TERMINAL: 'PED_TERMINAL',
  /** The EVSE can remotely be started/stopped. */
  REMOTE_START_STOP_CAPABLE: 'REMOTE_START_STOP_CAPABLE',
  /** The EVSE can be reserved. */
  RESERVABLE: 'RESERVABLE',
  /** Charging at this EVSE can be authorized with an RFID token. */
  RFID_READER: 'RFID_READER',
  /** When a StartSession is sent to this EVSE, the MSP is required to add the optional connector_id field in the StartSession object. */
  START_SESSION_CONNECTOR_REQUIRED: 'START_SESSION_CONNECTOR_REQUIRED',
  /** This EVSE supports token groups, two or more tokens work as one, so that a session can be started with one token and stopped with another (handy when a card and key-fob are given to the EV-driver). */
  TOKEN_GROUP_CAPABLE: 'TOKEN_GROUP_CAPABLE',
  /** Connectors have a mechanical lock that can be requested by the eMSP to be unlocked. */
  UNLOCK_CAPABLE: 'UNLOCK_CAPABLE'
} as const;

export type OcpiCapability = typeof OcpiCapability[keyof typeof OcpiCapability];
/** The format of the connector, whether it is a socket or a plug. */
export const OcpiConnectorFormat = {
  /** The connector is an attached cable; the EV users car needs to have a fitting inlet. */
  CABLE: 'CABLE',
  /** The connector is a socket; the EV user needs to bring a fitting plug. */
  SOCKET: 'SOCKET'
} as const;

export type OcpiConnectorFormat = typeof OcpiConnectorFormat[keyof typeof OcpiConnectorFormat];
/** Socket or plug standard of the charging point. */
export const OcpiConnectorType = {
  /** The connector type is CHAdeMO, DC */
  CHADEMO: 'CHADEMO',
  /** The ChaoJi connector. The new generation charging connector, harmonized between CHAdeMO and GB/T. DC. */
  CHAOJI: 'CHAOJI',
  /** Standard/domestic household, type "A", NEMA 1-15, 2 pins */
  DOMESTIC_A: 'DOMESTIC_A',
  /** Standard/domestic household, type "B", NEMA 5-15, 3 pins */
  DOMESTIC_B: 'DOMESTIC_B',
  /** Standard/domestic household, type "C", CEE 7/17, 2 pins */
  DOMESTIC_C: 'DOMESTIC_C',
  /** Standard/domestic household, type "D", 3 pins */
  DOMESTIC_D: 'DOMESTIC_D',
  /** Standard/domestic household, type "E", CEE 7/5 3 pins */
  DOMESTIC_E: 'DOMESTIC_E',
  /** Standard/domestic household, type "F", CEE 7/4, Schuko, 3 pins */
  DOMESTIC_F: 'DOMESTIC_F',
  /** Standard/domestic household, type "G", BS 1363, Commonwealth, 3 pins */
  DOMESTIC_G: 'DOMESTIC_G',
  /** Standard/domestic household, type "H", SI-32, 3 pins */
  DOMESTIC_H: 'DOMESTIC_H',
  /** Standard/domestic household, type "I", AS 3112, 3 pins */
  DOMESTIC_I: 'DOMESTIC_I',
  /** Standard/domestic household, type "J", SEV 1011, 3 pins */
  DOMESTIC_J: 'DOMESTIC_J',
  /** Standard/domestic household, type "K", DS 60884-2-D1, 3 pins */
  DOMESTIC_K: 'DOMESTIC_K',
  /** Standard/domestic household, type "L", CEI 23-16-VII, 3 pins */
  DOMESTIC_L: 'DOMESTIC_L',
  /** Standard/Domestic household, type "M", BS 546, 3 pins */
  DOMESTIC_M: 'DOMESTIC_M',
  /** Standard/Domestic household, type "N", NBR 14136, 3 pins */
  DOMESTIC_N: 'DOMESTIC_N',
  /** Standard/Domestic household, type "O", TIS 166-2549, 3 pins */
  DOMESTIC_O: 'DOMESTIC_O',
  /** Guobiao GB/T 20234.2 AC socket/connector. */
  GBT_AC: 'GBT_AC',
  /** Guobiao GB/T 20234.3 DC connector. */
  GBT_DC: 'GBT_DC',
  /** The connector type is GB_T (Chinese standard), DC */
  GB_T: 'GB_T',
  /** IEC 60309-2 Industrial connector single phase 16 amperes (usually blue) */
  IEC_60309_2_SINGLE_16: 'IEC_60309_2_single_16',
  /** IEC 60309-2 Industrial connector three phase 16 amperes (usually red) */
  IEC_60309_2_THREE_16: 'IEC_60309_2_three_16',
  /** IEC 60309-2 Industrial connector three phase 32 amperes (usually red) */
  IEC_60309_2_THREE_32: 'IEC_60309_2_three_32',
  /** IEC 60309-2 Industrial connector three phase 64 amperes (usually red) */
  IEC_60309_2_THREE_64: 'IEC_60309_2_three_64',
  /** IEC 62196 Type 1 "SAE J1772" */
  IEC_62196_T1: 'IEC_62196_T1',
  /** Combo Type 1 based, DC */
  IEC_62196_T1_COMBO: 'IEC_62196_T1_COMBO',
  /** IEC 62196 Type 2 "Mennekes" */
  IEC_62196_T2: 'IEC_62196_T2',
  /** Combo Type 2 based, DC */
  IEC_62196_T2_COMBO: 'IEC_62196_T2_COMBO',
  /** IEC 62196 Type 3A */
  IEC_62196_T3A: 'IEC_62196_T3A',
  /** IEC 62196 Type 3C "Scame" */
  IEC_62196_T3C: 'IEC_62196_T3C',
  /** The connector type is NEMA 5-20, 3 pins */
  NEMA_5_20: 'NEMA_5_20',
  /** The connector type is NEMA 6-30, 3 pins */
  NEMA_6_30: 'NEMA_6_30',
  /** The connector type is NEMA 6-50, 3 pins */
  NEMA_6_50: 'NEMA_6_50',
  /** The connector type is NEMA 10-30, 3 pins */
  NEMA_10_30: 'NEMA_10_30',
  /** The connector type is NEMA 10-50, 3 pins */
  NEMA_10_50: 'NEMA_10_50',
  /** The connector type is NEMA 14-30, 3 pins, rating of 30 A */
  NEMA_14_30: 'NEMA_14_30',
  /** The connector type is NEMA 14-50, 3 pins, rating of 50 A */
  NEMA_14_50: 'NEMA_14_50',
  /** On-board bottom-up-pantograph typically for bus charging */
  PANTOGRAPH_BOTTOM_UP: 'PANTOGRAPH_BOTTOM_UP',
  /** Off-board top-down-pantograph typically for bus charging */
  PANTOGRAPH_TOP_DOWN: 'PANTOGRAPH_TOP_DOWN',
  /** Tesla connector "Roadster"-type (round, 4 pins) */
  TESLA_R: 'TESLA_R',
  /** Tesla connector "Model-S"-type (oval, 5 pins) */
  TESLA_S: 'TESLA_S'
} as const;

export type OcpiConnectorType = typeof OcpiConnectorType[keyof typeof OcpiConnectorType];
export const OcpiDayOfWeek = {
  FRIDAY: 'FRIDAY',
  MONDAY: 'MONDAY',
  SATURDAY: 'SATURDAY',
  SUNDAY: 'SUNDAY',
  THURSDAY: 'THURSDAY',
  TUESDAY: 'TUESDAY',
  WEDNESDAY: 'WEDNESDAY'
} as const;

export type OcpiDayOfWeek = typeof OcpiDayOfWeek[keyof typeof OcpiDayOfWeek];
export type OcpiDisplayText = {
  __typename?: 'OCPIDisplayText';
  /** Language Code ISO 639-1 */
  language?: Maybe<Scalars['String']['output']>;
  /** Text to be displayed to an end user. No markup, html etc. allowed. */
  text?: Maybe<Scalars['String']['output']>;
};

/** This type is used to specify the energy mix and environmental impact of the supplied energy at a location or in a tariff. */
export type OcpiEnergyMix = {
  __typename?: 'OCPIEnergyMix';
  /** Name of the energy suppliers product/tariff plan used at this location.* */
  energy_product_name?: Maybe<Scalars['String']['output']>;
  /** Key-value pairs (enum + percentage) of energy sources of this location’s tariff. */
  energy_sources?: Maybe<Array<Maybe<OcpiEnergySource>>>;
  /** Key-value pairs (enum + percentage) of nuclear waste and CO2 exhaust of this location’s tariff. */
  environ_impact?: Maybe<Array<Maybe<OcpiEnvironmentalImpact>>>;
  /** True if the power is 100% from regenerative sources */
  is_green_energy?: Maybe<Scalars['Boolean']['output']>;
  /** Name of the energy supplier, delivering the energy for this location or tariff.* */
  supplier_name?: Maybe<Scalars['String']['output']>;
};

export type OcpiEnergySource = {
  __typename?: 'OCPIEnergySource';
  /** Percentage of this source (0-100) in the mix. */
  percentage?: Maybe<Scalars['Int']['output']>;
  /** The type of energy source. */
  source?: Maybe<OcpiEnergySourceCategory>;
};

/** Categories of energy sources. */
export const OcpiEnergySourceCategory = {
  /** Fossil power from coal. */
  COAL: 'COAL',
  /** Fossil power from gas. */
  GAS: 'GAS',
  /** All kinds of fossil power sources. */
  GENERAL_FOSSIL: 'GENERAL_FOSSIL',
  /** All kinds of regenerative power sources. */
  GENERAL_GREEN: 'GENERAL_GREEN',
  /** Nuclear power sources. */
  NUCLEAR: 'NUCLEAR',
  /** Regenerative power from PV. */
  SOLAR: 'SOLAR',
  /** Regenerative power from water turbines. */
  WATER: 'WATER',
  /** Regenerative power from wind turbines. */
  WIND: 'WIND'
} as const;

export type OcpiEnergySourceCategory = typeof OcpiEnergySourceCategory[keyof typeof OcpiEnergySourceCategory];
/** Amount of waste produced/emitted per kWh. */
export type OcpiEnvironmentalImpact = {
  __typename?: 'OCPIEnvironmentalImpact';
  /** Amount of this portion in g/kWh. */
  amount?: Maybe<Scalars['Float']['output']>;
  /** The environmental impact category of this value. */
  category?: Maybe<OcpiEnvironmentalImpactCategory>;
};

/** Categories of environmental impact values. */
export const OcpiEnvironmentalImpactCategory = {
  /** Exhausted carbon dioxide in g/kWh. */
  CARBON_DIOXIDE: 'CARBON_DIOXIDE',
  /** Produced nuclear waste in g/kWh. */
  NUCLEAR_WASTE: 'NUCLEAR_WASTE'
} as const;

export type OcpiEnvironmentalImpactCategory = typeof OcpiEnvironmentalImpactCategory[keyof typeof OcpiEnvironmentalImpactCategory];
/** Specifies one exceptional period for opening or access hours. */
export type OcpiExceptionalPeriod = {
  __typename?: 'OCPIExceptionalPeriod';
  /** Begin of the exception. In UTC, time_zone field can be used to convert to local time. */
  period_begin?: Maybe<Scalars['DateTime']['output']>;
  /** End of the exception. In UTC, time_zone field can be used to convert to local time. */
  period_end?: Maybe<Scalars['DateTime']['output']>;
};

export const OcpiFacility = {
  /** An airport. */
  AIRPORT: 'AIRPORT',
  /** A bike/e-bike/e-scooter sharing location. */
  BIKE_SHARING: 'BIKE_SHARING',
  /** A bus stop. */
  BUS_STOP: 'BUS_STOP',
  /** A cafe. */
  CAFE: 'CAFE',
  /** A carpool parking. */
  CARPOOL_PARKING: 'CARPOOL_PARKING',
  /** A Fuel station. */
  FUEL_STATION: 'FUEL_STATION',
  /** A hotel. */
  HOTEL: 'HOTEL',
  /** A mall or shopping center. */
  MALL: 'MALL',
  /** A metro station. */
  METRO_STATION: 'METRO_STATION',
  /** A museum. */
  MUSEUM: 'MUSEUM',
  /** Located in, or close to, a park, nature reserve etc. */
  NATURE: 'NATURE',
  /** A parking lot. */
  PARKING_LOT: 'PARKING_LOT',
  /** A recreation area. */
  RECREATION_AREA: 'RECREATION_AREA',
  /** A restaurant. */
  RESTAURANT: 'RESTAURANT',
  /** Sport facilities: gym, field etc. */
  SPORT: 'SPORT',
  /** A supermarket. */
  SUPERMARKET: 'SUPERMARKET',
  /** A taxi stand. */
  TAXI_STAND: 'TAXI_STAND',
  /** A train station. */
  TRAIN_STATION: 'TRAIN_STATION',
  /** A tram stop/station. */
  TRAM_STOP: 'TRAM_STOP',
  /** Wifi or other type of internet available. */
  WIFI: 'WIFI'
} as const;

export type OcpiFacility = typeof OcpiFacility[keyof typeof OcpiFacility];
/** This class defines the geo location of the Charge Point. The geodetic system to be used is WGS 84. */
export type OcpiGeoLocation = {
  __typename?: 'OCPIGeoLocation';
  /** Latitude of the point in decimal degree. Example: 50.770774. Decimal separator: "." Regex: -?[0-9]{1,2}\.[0-9]{5,7} */
  latitude?: Maybe<Scalars['String']['output']>;
  /** Longitude of the point in decimal degree. Example: -126.104965. Decimal separator: "." Regex: -?[0-9]{1,3}\.[0-9]{5,7} */
  longitude?: Maybe<Scalars['String']['output']>;
};

/** Opening and access hours of the location. */
export type OcpiHours = {
  __typename?: 'OCPIHours';
  /** Exceptions for specified calendar dates, time-range based. Periods the station is not operating/accessible. Overwriting regular_hours and exceptional_openings. Should not overlap exceptional_openings. */
  exceptional_closings?: Maybe<Array<Maybe<OcpiExceptionalPeriod>>>;
  /** Exceptions for specified calendar dates, time-range based. Periods the station is operating/accessible. Additional to regular_hours. May overlap regular rules. */
  exceptional_openings?: Maybe<Array<Maybe<OcpiExceptionalPeriod>>>;
  /** Regular hours, weekday-based. Only to be used if twentyfourseven=false, then this field needs to contain at least one RegularHours object. */
  regular_hours?: Maybe<Array<Maybe<OcpiRegularHours>>>;
  /** True to represent 24 hours a day and 7 days a week, except the given exceptions. */
  twentyfourseven?: Maybe<Scalars['Boolean']['output']>;
};

export type OcpiImage = {
  __typename?: 'OCPIImage';
  /** Category of an image */
  category?: Maybe<OcpiImageCategory>;
  /** Height of the full scale image */
  height?: Maybe<Scalars['Int']['output']>;
  /** URL from where a thumbnail of the image can be fetched through a webbrowser. */
  thumbnail?: Maybe<Scalars['String']['output']>;
  /** Image type: gif, jpeg, png, svg */
  type?: Maybe<Scalars['String']['output']>;
  /** URL from where the image data can be fetched through a web browser. */
  url?: Maybe<Scalars['String']['output']>;
  /** Width of the full scale image */
  width?: Maybe<Scalars['Int']['output']>;
};

/** The category of an image to obtain the correct usage in a user presentation. The category has to be set accordingly to the image content in order to guarantee the right usage. */
export const OcpiImageCategory = {
  /** Photo of the physical device that contains one or more EVSEs. */
  CHARGER: 'CHARGER',
  /** Location entrance photo. Should show the car entrance to the location from street side. */
  ENTRANCE: 'ENTRANCE',
  /** Location overview photo. */
  LOCATION: 'LOCATION',
  /** Logo of an associated roaming network to be displayed with the EVSE for example in lists, maps and detailed information views. */
  NETWORK: 'NETWORK',
  /** Logo of the charge point operator, for example a municipality, to be displayed in the EVSEs detailed information view or in lists and maps, if no network logo is present. */
  OPERATOR: 'OPERATOR',
  /** Other */
  OTHER: 'OTHER',
  /** Logo of the charge point owner, for example a local store, to be displayed in the EVSEs detailed information view. */
  OWNER: 'OWNER'
} as const;

export type OcpiImageCategory = typeof OcpiImageCategory[keyof typeof OcpiImageCategory];
/** This value, if provided, represents the restriction to the parking spot for different purposes. */
export const OcpiParkingRestriction = {
  /** Parking spot for customers/guests only, for example in case of a hotel or shop. */
  CUSTOMERS: 'CUSTOMERS',
  /** Reserved parking spot for disabled people with valid ID. */
  DISABLED: 'DISABLED',
  /** Reserved parking spot for electric vehicles. */
  EV_ONLY: 'EV_ONLY',
  /** Parking spot only suitable for (electric) motorcycles or scooters. */
  MOTORCYCLES: 'MOTORCYCLES',
  /** Parking is only allowed while plugged in (charging). */
  PLUGGED: 'PLUGGED'
} as const;

export type OcpiParkingRestriction = typeof OcpiParkingRestriction[keyof typeof OcpiParkingRestriction];
/** Reflects the general type of the charge point’s location. May be used for user information. */
export const OcpiParkingType = {
  /** Location on a parking facility/rest area along a motorway, freeway, interstate, highway etc. */
  ALONG_MOTORWAY: 'ALONG_MOTORWAY',
  /** Location is on the driveway of a house/building. */
  ON_DRIVEWAY: 'ON_DRIVEWAY',
  /** Parking in public space along a street. */
  ON_STREET: 'ON_STREET',
  /** Multistorey car park. */
  PARKING_GARAGE: 'PARKING_GARAGE',
  /** A cleared area that is intended for parking vehicles, i.e. at supermarkets, bars, etc. */
  PARKING_LOT: 'PARKING_LOT',
  /** Multistorey car park, mainly underground. */
  UNDERGROUND_GARAGE: 'UNDERGROUND_GARAGE'
} as const;

export type OcpiParkingType = typeof OcpiParkingType[keyof typeof OcpiParkingType];
export const OcpiPowerType = {
  /** AC single phase. */
  AC_1_PHASE: 'AC_1_PHASE',
  /** AC two phases, only two of the three available phases connected. */
  AC_2_PHASE: 'AC_2_PHASE',
  /** AC two phases using split phase system. */
  AC_2_PHASE_SPLIT: 'AC_2_PHASE_SPLIT',
  /** AC three phase. */
  AC_3_PHASE: 'AC_3_PHASE',
  /** Direct Current. */
  DC: 'DC'
} as const;

export type OcpiPowerType = typeof OcpiPowerType[keyof typeof OcpiPowerType];
export type OcpiPrice = {
  __typename?: 'OCPIPrice';
  /** Price/Cost excluding VAT. */
  excl_vat?: Maybe<Scalars['Float']['output']>;
  /** Price/Cost including VAT. */
  incl_vat?: Maybe<Scalars['Float']['output']>;
};

export type OcpiPriceComponent = {
  __typename?: 'OCPIPriceComponent';
  /** Price per unit (excl. VAT) for this tariff dimension. */
  price?: Maybe<Scalars['Float']['output']>;
  /** Minimum amount to be billed. This unit will be billed in this step_size blocks. For example: if type is TIME and step_size has a value of 300, then time will be billed in blocks of 5 minutes. If 6 minutes were used, 10 minutes (2 blocks of step_size) will be billed. */
  step_size?: Maybe<Scalars['Int']['output']>;
  /** Type of tariff dimension. */
  type?: Maybe<OcpiTariffDimensionType>;
  /** Applicable VAT percentage for this tariff dimension. If omitted, no VAT is applicable. Not providing a VAT is different from 0% VAT, which would be a value of 0.0 here. */
  vat?: Maybe<Scalars['Float']['output']>;
};

/** Regular recurring operation or access hours. */
export type OcpiRegularHours = {
  __typename?: 'OCPIRegularHours';
  /** Begin of the regular period, in local time, given in hours and minutes. Must be in 24h format with leading zeros. Example: "18:15". Hour/Minute separator: ":" Regex: ([0-1][0-9]|2[1-3]):[0-5][0-9]. */
  period_begin?: Maybe<Scalars['String']['output']>;
  /** End of the regular period, in local time, syntax as for period_begin. Must be later than period_begin. */
  period_end?: Maybe<Scalars['String']['output']>;
  /** Number of days in the week, from Monday (1) till Sunday (7) */
  weekday?: Maybe<Scalars['Int']['output']>;
};

export const OcpiReservationRestrictionType = {
  /** Used in TariffElements to describe costs for a reservation. */
  RESERVATION: 'RESERVATION',
  /** Used in TariffElements to describe costs for a reservation that expires (i.e. driver does not start a charging session before expiry_date of the reservation). */
  RESERVATION_EXPIRES: 'RESERVATION_EXPIRES'
} as const;

export type OcpiReservationRestrictionType = typeof OcpiReservationRestrictionType[keyof typeof OcpiReservationRestrictionType];
/** The status of an EVSE. */
export const OcpiStatus = {
  /** The EVSE/Connector is able to start a new charging session. */
  AVAILABLE: 'AVAILABLE',
  /** The EVSE/Connector is not accessible because of a physical barrier, i.e. a car. */
  BLOCKED: 'BLOCKED',
  /** The EVSE/Connector is in use. */
  CHARGING: 'CHARGING',
  /** The EVSE/Connector is not yet active or it is no longer available (deleted). */
  INOPERATIVE: 'INOPERATIVE',
  /** The EVSE/Connector is currently out of order. */
  OUTOFORDER: 'OUTOFORDER',
  /** The EVSE/Connector is planned, will be operating soon. */
  PLANNED: 'PLANNED',
  /** The EVSE/Connector was discontinued/removed. */
  REMOVED: 'REMOVED',
  /** The EVSE/Connector is reserved for a particular EV driver and is unavailable for other drivers. */
  RESERVED: 'RESERVED',
  /** No status information available (also used when offline). */
  UNKNOWN: 'UNKNOWN'
} as const;

export type OcpiStatus = typeof OcpiStatus[keyof typeof OcpiStatus];
/** This type is used to schedule status periods in the future. The eMSP can provide this information to the EV user for trip planning purposes. A period MAY have no end. Example: "This station will be running as of tomorrow. Today it is still planned and under construction. */
export type OcpiStatusSchedule = {
  __typename?: 'OCPIStatusSchedule';
  /** Begin of the scheduled period. */
  period_begin?: Maybe<Scalars['DateTime']['output']>;
  /** End of the scheduled period, if known. */
  period_end?: Maybe<Scalars['DateTime']['output']>;
  /** Status value during the scheduled period. */
  status?: Maybe<OcpiStatus>;
};

export type OcpiTariff = {
  __typename?: 'OCPITariff';
  /** ISO-3166 alpha-2 country code of the CPO that owns this tariff */
  country_code?: Maybe<Scalars['String']['output']>;
  /** ISO-4217 code of the currency of this tariff. */
  currency?: Maybe<Scalars['String']['output']>;
  /** List of tariff elements */
  elements?: Maybe<Array<Maybe<OcpiTariffElement>>>;
  /** Time after which this tariff is no longer valid, in UTC, time_zone field if the location can be used to convert to local time. Typically used when this tariff is going to be replaced with a different tariff in the near future */
  end_date_time?: Maybe<Scalars['DateTime']['output']>;
  /** Details about the energy supplied with this tariff */
  energy_mix?: Maybe<OcpiEnergyMix>;
  /** Uniquely identifies the tariff within the CPO’s platform (and suboperator platforms) */
  id?: Maybe<Scalars['String']['output']>;
  /** Timestamp when this tariff was last updated (or created) */
  last_updated?: Maybe<Scalars['DateTime']['output']>;
  /** When this field is set, a charging session with this tariff will NOT cost more than this amount */
  max_price?: Maybe<OcpiPrice>;
  /** When this field is set, a charging session with this tariff will cost at least the amount shown. This is different from a FLAT fee (start tariff, transaction fee), as a FLAT fee is a fixed amount that must be paid for any charging session. A minimum price indicates that when the cost of a charging session is lower than this amount, the cost of the session will be equal to this amount */
  min_price?: Maybe<OcpiPrice>;
  /** CPO ID of the CPO that owns this tariff (following the ISO-15118 standard) */
  party_id?: Maybe<Scalars['String']['output']>;
  /** Time when this tariff becomes active, in UTC, time_zone field of the Location can be used to convert to local time. Typically used for a new tariff that is already given with the location, before it becomes active */
  start_date_time?: Maybe<Scalars['DateTime']['output']>;
  /** List of alternative tariff information texts, in multiple languages */
  tariff_alt_text?: Maybe<Array<Maybe<OcpiDisplayText>>>;
  /** URL to a web page that contains an explanation of the tariff information in human readable form */
  tariff_alt_url?: Maybe<Scalars['String']['output']>;
  /** Defines the type of the tariff. This allows for distinction in case of given charging preferences. When omitted, this tariff is valid for all sessions */
  type?: Maybe<OcpiTariffType>;
};

export const OcpiTariffDimensionType = {
  /** Defined in kWh, step_size multiplier: 1 Wh */
  ENERGY: 'ENERGY',
  /** Flat fee without unit for step_size */
  FLAT: 'FLAT',
  /** Time not charging: defined in hours, step_size multiplier: 1 second */
  PARKING_TIME: 'PARKING_TIME',
  /** Time charging: defined in hours, step_size multiplier: 1 second Can also be used in combination with a RESERVATION restriction to describe the price of the reservation time. */
  TIME: 'TIME'
} as const;

export type OcpiTariffDimensionType = typeof OcpiTariffDimensionType[keyof typeof OcpiTariffDimensionType];
export type OcpiTariffElement = {
  __typename?: 'OCPITariffElement';
  /** List of price components that describe the pricing of a tariff. */
  price_components?: Maybe<Array<Maybe<OcpiPriceComponent>>>;
  /** Restrictions that describe the applicability of a tariff. */
  restrictions?: Maybe<Array<Maybe<OcpiTariffRestrictions>>>;
};

export type OcpiTariffRestrictions = {
  __typename?: 'OCPITariffRestrictions';
  /** Which day(s) of the week this tariff element is active. */
  day_of_week?: Maybe<OcpiDayOfWeek>;
  /** End date in local time, the time zone is defined in the time_zone field of the Location, for example: 2015-12-27, valid until this day (exclusive). Same syntax as start_date */
  end_date?: Maybe<Scalars['String']['output']>;
  /** End time of day in local time, the time zone is defined in the time_zone field of the Location, for example 19:45, valid until this time of the day. Same syntax as start_time. */
  end_time?: Maybe<Scalars['String']['output']>;
  /** Sum of the maximum current in over all phases, for example 20. When the EV is charging with less than the defined amount of current, this tariff element becomes/is active. If the charging current is or becomes higher, this tariff element is not or no longer valid and becomes inactive. This describes NOT the maximum current over the entire Charging Session. This restriction can make a tariff element become active when the charging current is below this value, but the tariff element MUST  no longer be active when the charging current raises above the defined value */
  max_current?: Maybe<Scalars['Float']['output']>;
  /** Maximum duration in seconds the charging session MUST last (exclusive). When the duration of a charging session is shorter than the defined value, this tariff element is or becomes active. After that moment, this tariff element is no longer active */
  max_duration?: Maybe<Scalars['Float']['output']>;
  /** Maximum consumed energy in kWh, for example 50, valid until this amount of energy being used */
  max_kwh?: Maybe<Scalars['Float']['output']>;
  /** Maximum power in kW, for example 20. When the EV is charging with less than the defined amount of power, this tariff element becomes/is active. If the charging power is or becomes higher, this tariff element is not or no longer valid and becomes inactive. This does not describe the maximum power over the entire charging session. This restriction can make a tariff element become active when the charging power is below this value, but the TariffElement MUST no longer be active when the charging power raises above the defined value */
  max_power?: Maybe<Scalars['Float']['output']>;
  /** Sum of the minimum current in over all phases, for example 5. When the EV is charging with more than the defined amount of current, this tariff element is/becomes active. If the charging current is or becomes lower, this tariff element is not or no longer valid and becomes inactive. This does not describe the minimum current over the entire charging session. This restriction can make a tariff element become active when the charging current is above the defined value, but the tariff element MUST no longer be active when the charging current drops below the defined value */
  min_current?: Maybe<Scalars['Float']['output']>;
  /** Minimum duration in seconds the charging session MUST last (inclusive). When the duration of a charging session is longer than the defined value, this TariffElement is or becomes active. Before that moment, this tariff element is not yet active */
  min_duration?: Maybe<Scalars['Float']['output']>;
  /** Minimum consumed energy in kWh, for example 20, valid from this amount of energy being used */
  min_kwh?: Maybe<Scalars['Float']['output']>;
  /** Minimum power in kW, for example 5. When the EV is charging with more than the defined amount of power, this tariff element is/becomes active. If the charging power is or becomes lower, this tariff element is not or no longer valid and becomes inactive. This does not describe the minimum power over the entire charging session. This restriction can make a tariff element become active when the charging power is above this value, but the TariffElement MUST no longer be active when the charging power drops below the defined value */
  min_power?: Maybe<Scalars['Float']['output']>;
  /** When this field is present, the tariff element describes reservation costs. A reservation starts when the reservation is made, and ends when the drivers starts charging on the reserved EVSE/Location, or when the reservation expires. A reservation can only have: FLAT and TIME TariffDimensions, where TIME is for the duration of the reservation */
  reservation?: Maybe<OcpiReservationRestrictionType>;
  /** Start date in local time, the time zone is defined in the time_zone field of the Location, for example: 2015-12-24, valid from this day. Regex: ([12][0-9]{3})-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01]) */
  start_date?: Maybe<Scalars['String']['output']>;
  /** Start time of day in local time, the time zone is defined in the time_zone field of the Location, for example 13:30, valid from this time of the day. Must be in 24h format with leading zeros. Hour/Minute separator: ":" Regex: ([0-1][0-9]|2[1-3]):[0-5][0-9] */
  start_time?: Maybe<Scalars['String']['output']>;
};

export const OcpiTariffType = {
  /** Used to describe that a tariff is valid when ad-hoc payment is used at the charge point (for example: Debit or Credit card payment terminal) */
  AD_HOC_PAYMENT: 'AD_HOC_PAYMENT',
  /** Used to describe that a tariff is valid when charging preference: CHEAP is set for the session */
  PROFILE_CHEAP: 'PROFILE_CHEAP',
  /** Used to describe that a tariff is valid when charging preference: FAST is set for the session */
  PROFILE_FAST: 'PROFILE_FAST',
  /** Used to describe that a tariff is valid when charging preference: GREEN is set for the session */
  PROFILE_GREEN: 'PROFILE_GREEN',
  /** Used to describe that a tariff is valid when using an RFID, without any charging preference, or when charging preference: REGULAR is set for the session */
  REGULAR: 'REGULAR'
} as const;

export type OcpiTariffType = typeof OcpiTariffType[keyof typeof OcpiTariffType];
/** List of charging modes that are supported. */
export const OicpChargingModes = {
  CHADEMO: 'chademo',
  MODE_1: 'mode_1',
  MODE_2: 'mode_2',
  MODE_3: 'mode_3',
  MODE_4: 'mode_4'
} as const;

export type OicpChargingModes = typeof OicpChargingModes[keyof typeof OicpChargingModes];
/** Custom connector properties for OICP databases. Station databases that not follow the OICP standard return null values. */
export type OicpConnectorCustomProperties = {
  __typename?: 'OICPConnectorCustomProperties';
  /** List of charging modes that are supported as specified by IEC 61851-1. */
  charging_modes?: Maybe<Array<OicpChargingModes>>;
  /** Returns whether the connector is able to deliver different power outputs. */
  dynamic_power_level?: Maybe<Scalars['Boolean']['output']>;
};

/** List of authentication modes that are supported. */
export const OicpEvseAuthenticationMode = {
  DIRECT_PAYMENT: 'direct_payment',
  NFC_RFID_CLASSIC: 'nfc_rfid_classic',
  NFC_RFID_DESFIRE: 'nfc_rfid_desfire',
  NO_AUTHENTICATION_REQUIRED: 'no_authentication_required',
  PNC: 'pnc',
  REMOTE: 'remote'
} as const;

export type OicpEvseAuthenticationMode = typeof OicpEvseAuthenticationMode[keyof typeof OicpEvseAuthenticationMode];
/** Custom EVSE properties for OICP databases such as the global Hubject database. Station databases that not follow the OICP standard return null values. */
export type OicpEvseCustomProperties = {
  __typename?: 'OICPEvseCustomProperties';
  /** List of additional info by locale. */
  additional_info?: Maybe<Array<OicpEvseCustomPropertiesAdditionalInfo>>;
  /** List of authentication modes that are supported. */
  authentication_modes: Array<OicpEvseAuthenticationMode>;
  /** Name of the charging point manufacturer. */
  hardware_manufacturer?: Maybe<Scalars['String']['output']>;
  /** When the value is set to false this station does not support remote start and stop by Hubject. */
  is_hubject_compatible: Scalars['Boolean']['output'];
  /** Returns a value if the EVSE has a limited capacity (e.g. built-in battery). Values are in kWh. */
  max_capacity?: Maybe<Scalars['Int']['output']>;
  /** List of payment options that are supported. */
  payment_options: Array<OicpPaymentOptions>;
  /** List of value added services that are supported. */
  value_added_services: Array<OicpValueAddedServices>;
};

export type OicpEvseCustomPropertiesAdditionalInfo = {
  __typename?: 'OICPEvseCustomPropertiesAdditionalInfo';
  /** The language in which the additional info text is provided. */
  lang?: Maybe<Scalars['String']['output']>;
  /** Additional info text value. */
  value?: Maybe<Scalars['String']['output']>;
};

/** List of payment options that are supported. */
export const OicpPaymentOptions = {
  CONTRACT: 'contract',
  DIRECT: 'direct',
  NO_PAYMENT: 'no_payment'
} as const;

export type OicpPaymentOptions = typeof OicpPaymentOptions[keyof typeof OicpPaymentOptions];
/** Custom station properties for OICP databases such as the global Hubject database. Station databases that not follow the OICP standard return null values. */
export type OicpStationCustomProperties = {
  __typename?: 'OICPStationCustomProperties';
  /** Returns information on how the charging station provides metering law data. */
  calibration_law_data_availability: Scalars['String']['output'];
  /** Identification of the corresponding clearing house in the event that roaming between different clearing houses must be processed in the future. */
  clearinghouse_id?: Maybe<Scalars['String']['output']>;
  /** Returns whether the station is a parking facility. */
  parking_facility?: Maybe<Scalars['Boolean']['output']>;
  /** Returns an identifier for the precise parking spot. Eg. 36 or 12-1. */
  parking_spot?: Maybe<Scalars['String']['output']>;
};

/** List of value added services that are supported. */
export const OicpValueAddedServices = {
  CHARGING_PLANS: 'charging_plans',
  DYNAMIC_PRICING: 'dynamic_pricing',
  MAXIMUM_POWER_CHARGING: 'maximum_power_charging',
  NONE: 'none',
  PARKING_SENSORS: 'parking_sensors',
  PREDICTIVE_CHARGE_POINT_USAGE: 'predictive_charge_point_usage',
  RESERVATION: 'reservation',
  ROOF_PROVIDED: 'roof_provided'
} as const;

export type OicpValueAddedServices = typeof OicpValueAddedServices[keyof typeof OicpValueAddedServices];
export type Odometer = {
  __typename?: 'Odometer';
  /** Source of inputted data. */
  source: TelemetryInputSource;
  /** Preferred unit for the vehicle's odometer. */
  type: DistanceUnit;
  /** Value of the vehicle's odometer. */
  value: Scalars['Float']['output'];
};

export type OdometerInput = {
  /** Source of inputted data, defaults to 'manual'. */
  source?: InputMaybe<TelemetryInputSource>;
  /** Preferred unit for the vehicle's odometer. */
  type: DistanceUnit;
  /** Value of the vehicle's odometer. */
  value: Scalars['Float']['input'];
};

/** Operator data which extends OCPI BusinessDetails. */
export type Operator = {
  __typename?: 'Operator';
  /** List of countries where the operator is avoided. Default operator preference applied to routes created through createRoute mutation if no operator preference is specified in the request. */
  avoided_countries?: Maybe<Array<CountryCodeAlpha2>>;
  /** Contact information. */
  contact?: Maybe<Contact>;
  /** ISO-3166 alpha-2 country codes an operator is active in. */
  countries?: Maybe<Array<CountryCodeAlpha2>>;
  /**
   * ISO-3166 alpha-2 country code an operator is active in.
   * @deprecated In favor of `countries`.
   */
  country?: Maybe<Scalars['String']['output']>;
  /**
   * Flag which indicates if the operator is in the excluded list. Default operator preference applied to routes created through newRoute mutation if no operator preference is specified in the request.
   * @deprecated In favor of `excluded_countries`.
   */
  excluded?: Maybe<Scalars['Boolean']['output']>;
  /** List of countries where the operator is excluded. Default operator preference applied to routes created through createRoute mutation if no operator preference is specified in the request. */
  excluded_countries?: Maybe<Array<CountryCodeAlpha2>>;
  /** External ID of an operator provided by the operator data source. */
  external_id?: Maybe<Scalars['String']['output']>;
  /** Unique operator ID. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Image link to an operator’s logo. */
  logo?: Maybe<OcpiImage>;
  /** Name of an operator. */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * Ranking level on which the operator is placed or null in case the operator is not on any ranking level. Default operator preference applied to routes created through newRoute mutation if no operator preference is specified in the request.
   * @deprecated In favor of `ranking_levels`.
   */
  ranking?: Maybe<Scalars['Int']['output']>;
  /** Ranking configuration for the operator. An operator can be ranked on different levels in different countries. Default operator preference applied to routes created through createRoute mutation if no operator preference is specified in the request. */
  ranking_levels?: Maybe<OperatorRankingLevels>;
  /** Link to an operator’s website. */
  website?: Maybe<Scalars['String']['output']>;
};

/** Criteria to filter operators in the operator list query. */
export type OperatorListFilter = {
  /** ISO-3166 alpha-2 country codes an operator is active in. */
  countries?: InputMaybe<Array<CountryCodeAlpha2>>;
  /** Only retrieve operators that are in the excluded list. Default operator preference applied to routes created through newRoute mutation if no operator preference is specified in the request. */
  excluded?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of countries where the operator is excluded. Default operator preference applied to routes created through createRoute mutation if no operator preference is specified in the request. */
  excluded_countries?: InputMaybe<Array<CountryCodeAlpha2>>;
  /** List of ranking level(s) to be retrieved. Valid values are 1 to 10. Default operator preference applied to routes created through newRoute mutation if no operator preference is specified in the request. */
  ranking?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** List of ranking level(s) to be retrieved. An operator can be ranked on different levels in different countries. Default operator preference applied to routes created through createRoute mutation if no operator preference is specified in the request. */
  ranking_levels?: InputMaybe<OperatorRankingLevelsFilter>;
};

/** Query parameters to filter operators in the operator list query. */
export type OperatorListQuery = {
  /** Exact country code. */
  country?: InputMaybe<Scalars['String']['input']>;
  /** External ID of an operator provided by an operator data source. */
  external_id?: InputMaybe<Scalars['String']['input']>;
  /** Unique operator ID. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Exact name. */
  name?: InputMaybe<Scalars['String']['input']>;
};

export const OperatorPreferenceType = {
  /** Operators that have been set to be avoided. */
  AVOIDED: 'avoided',
  /** Operators that have been set to be excluded. */
  EXCLUDED: 'excluded',
  /** Operators that have been set as preferred or required. */
  RANKED: 'ranked',
  /** Operators that have not been set as neither preferred or required or avoided nor excluded. */
  UNRANKED: 'unranked'
} as const;

export type OperatorPreferenceType = typeof OperatorPreferenceType[keyof typeof OperatorPreferenceType];
/** Operator ranking level. */
export const OperatorRankingLevel = {
  HIGH: 'high',
  LOW: 'low',
  MEDIUM: 'medium'
} as const;

export type OperatorRankingLevel = typeof OperatorRankingLevel[keyof typeof OperatorRankingLevel];
/** Ranking configuration for the operator. An operator can be ranked on different levels in different countries. Default operator preference applied to routes created through createRoute mutation if no operator preference is specified in the request. */
export type OperatorRankingLevels = {
  __typename?: 'OperatorRankingLevels';
  /** High level for operators ranking. */
  high?: Maybe<Array<CountryCodeAlpha2>>;
  /** Low level for operators ranking. */
  low?: Maybe<Array<CountryCodeAlpha2>>;
  /** Medium level for operators ranking. */
  medium?: Maybe<Array<CountryCodeAlpha2>>;
};

/** Filter operators by ranking levels. */
export type OperatorRankingLevelsFilter = {
  /** High level for operators ranking. */
  high?: InputMaybe<Array<CountryCodeAlpha2>>;
  /** Low level for operators ranking. */
  low?: InputMaybe<Array<CountryCodeAlpha2>>;
  /** Medium level for operators ranking. */
  medium?: InputMaybe<Array<CountryCodeAlpha2>>;
};

export type OutsideTempInput = {
  /** Source of inputted data, defaults to 'manual'. */
  source?: InputMaybe<TelemetryInputSource>;
  /** Preferred unit for the outside temperature. */
  type: TemperatureUnit;
  /** Value of the outside temperature. */
  value: Scalars['Float']['input'];
};

export type OutsideTemperature = {
  __typename?: 'OutsideTemperature';
  /** Source of inputted data. */
  source: TelemetryInputSource;
  /** Preferred unit for the outside temperature. */
  type: TemperatureUnit;
  /** Value of the temperature. */
  value: Scalars['Float']['output'];
};

export type OutsideTemperatureInput = {
  /** Source of inputted data. */
  source?: InputMaybe<TelemetryInputSource>;
  /** Preferred unit for the outside temperature. */
  type: TemperatureUnit;
  /** Value of the outside temperature. */
  value: Scalars['Float']['input'];
};

/** Information about the list page. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** Cursor of the last connection of the page. If the page is empty, this is null. */
  end_cursor?: Maybe<Scalars['String']['output']>;
  /** Flag that indicates if it has a next page. */
  has_next_page: Scalars['Boolean']['output'];
  /** Flag that indicates if it has a previous page. */
  has_previous_page: Scalars['Boolean']['output'];
  /** Cursor of the first connection of the page. If the page is empty, this is null. */
  start_cursor?: Maybe<Scalars['String']['output']>;
};

export const ParkingCost = {
  /** Parking is free. */
  FREE: 'free',
  /** Parking includes a fee. */
  PAID: 'paid'
} as const;

export type ParkingCost = typeof ParkingCost[keyof typeof ParkingCost];
export type PathSegment = {
  __typename?: 'PathSegment';
  /** Average speed, in km/h, for this route path segment. */
  averageSpeed?: Maybe<Scalars['Float']['output']>;
  /** Consumption, in kWh, of a route path segment. */
  consumption?: Maybe<Scalars['Float']['output']>;
  /** Consumption, in kWh per km, of a route path segment. */
  consumptionPerKm?: Maybe<Scalars['Float']['output']>;
  /** Distance, in meters, of a route path segment. */
  distance?: Maybe<Scalars['Float']['output']>;
  /** Duration, in seconds, of a route path segment. */
  duration?: Maybe<Scalars['Float']['output']>;
  /** Elevation (altitude) in meters. */
  elevation?: Maybe<Scalars['Int']['output']>;
  /** State of charge, in kWh, of a route path segment. */
  stateOfCharge?: Maybe<Scalars['Float']['output']>;
};

/** A GeoJSON Point. */
export type Point = {
  __typename?: 'Point';
  /** The coordinates array with longitude as first value and latitude as second one. */
  coordinates: Array<Scalars['Float']['output']>;
  /** Point type. */
  type: PointType;
};

/** A GeoJSON Point input. */
export type PointInput = {
  /** Coordinates [longitude, latitude]. */
  coordinates: Array<Scalars['Float']['input']>;
  /** Point type. */
  type: PointType;
};

/** GeoJSON Point type. */
export const PointType = {
  POINT: 'Point'
} as const;

export type PointType = typeof PointType[keyof typeof PointType];
/** Polygon properties. */
export type PolygonProperties = {
  __typename?: 'PolygonProperties';
  /** Index of the feature inside the list. */
  index?: Maybe<Scalars['Int']['output']>;
};

/** Number of decimals for a polyline. */
export const PolylineInputDecimals = {
  FIVE: 'five',
  SIX: 'six'
} as const;

export type PolylineInputDecimals = typeof PolylineInputDecimals[keyof typeof PolylineInputDecimals];
export type PowerInput = {
  /** Source of inputted data, defaults to 'manual'. */
  source?: InputMaybe<TelemetryInputSource>;
  /** Preferred unit for the power. */
  type: PowerUnit;
  /** Value of the positive or negative power. When negative the vehicle is charging. */
  value: Scalars['Float']['input'];
};

export const PowerSupported = {
  /** Power is announced, but not yet supported. */
  ANNOUNCED: 'announced',
  /** Power is supported. */
  AVAILABLE: 'available',
  /** Power is not supported. */
  NOT_AVAILABLE: 'not_available'
} as const;

export type PowerSupported = typeof PowerSupported[keyof typeof PowerSupported];
export const PowerUnit = {
  /** Return the power in horsepower. */
  HORSEPOWER: 'horsepower',
  /** Return the power in kilowatts. */
  KILOWATT: 'kilowatt'
} as const;

export type PowerUnit = typeof PowerUnit[keyof typeof PowerUnit];
export const PressureUnit = {
  /** Return the pressure in bar. */
  BAR: 'bar',
  /** Return the pressure in pounds per square inch. */
  POUNDS_PER_SQUARE_INCH: 'pounds_per_square_inch'
} as const;

export type PressureUnit = typeof PressureUnit[keyof typeof PressureUnit];
export type Pricing = {
  __typename?: 'Pricing';
  /** Unique ID of a price. */
  id?: Maybe<Scalars['String']['output']>;
  /** Price details. */
  price_list?: Maybe<Array<Maybe<PricingList>>>;
};

export type PricingList = {
  __typename?: 'PricingList';
  /** Price product elements. */
  elements?: Maybe<Array<Maybe<PricingListElement>>>;
  /** (MSP) Mobility Service Provider. */
  partner?: Maybe<Scalars['String']['output']>;
  /** Product details. */
  product?: Maybe<PricingListProduct>;
};

export type PricingListElement = {
  __typename?: 'PricingListElement';
  /** Price of the element type without VAT. */
  price_excl_vat?: Maybe<Scalars['Float']['output']>;
  /** Price element type. */
  type?: Maybe<PricingListElementType>;
  /** VAT percentage to apply. */
  vat?: Maybe<Scalars['Float']['output']>;
};

export const PricingListElementType = {
  /** Price per kWh. */
  ENERGY: 'ENERGY',
  /** Starting price, fixed fee per charge session. */
  FLAT: 'FLAT',
  /** Parking price per hour. */
  PARKING_TIME: 'PARKING_TIME',
  /** Fixed price per hour. */
  TIME: 'TIME'
} as const;

export type PricingListElementType = typeof PricingListElementType[keyof typeof PricingListElementType];
export type PricingListProduct = {
  __typename?: 'PricingListProduct';
  /** Currency. */
  currency?: Maybe<Scalars['String']['output']>;
  /** Description of the product. */
  description?: Maybe<Scalars['String']['output']>;
  /** Name of the payment card or subscription. If name is 'Adhoc price' the price is the CPO price. */
  name?: Maybe<Scalars['String']['output']>;
  /** Subscription fee without VAT. */
  subscription_fee_excl_vat?: Maybe<Scalars['Float']['output']>;
  /** Subscription type. */
  subscription_type?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  /** Get a full list of amenities around a station. */
  amenityList?: Maybe<Array<Maybe<Amenity>>>;
  /** [BETA] Get a connected vehicles by id */
  connectedVehicle?: Maybe<ConnectedVehicle>;
  /** [BETA] Retrieve live vehicle data by connected vehicle id */
  connectedVehicleData?: Maybe<VehicleData>;
  /** [BETA] Get the connected vehicles for the current user */
  connectedVehicleList?: Maybe<Array<Maybe<ConnectedVehicle>>>;
  /** Get a route by ID. */
  getRoute: RouteResponse;
  /** Get emissions for a route. */
  getRouteEmissions: RouteDetailsEmissions;
  /** [BETA] Search for stations with amenities within a specific time window and distance of a previously calculated route. */
  getRouteStationsWithAmenities: RouteStationsWithAmenitiesConnection;
  /** [ALPHA] Get a e-truck route by ID. */
  getTruckRoute: TruckRouteResponse;
  /** Get an isoline by ID. */
  isoline?: Maybe<Isoline>;
  /** [BETA] Get a navigation session by ID */
  navigation?: Maybe<Navigation>;
  /** Get information about an operator by its ID. */
  operator?: Maybe<Operator>;
  /** Get a full list of operators. */
  operatorList?: Maybe<Array<Maybe<Operator>>>;
  /** Get all reviews of a station by the station ID. */
  reviewList?: Maybe<Array<Review>>;
  /**
   * Get a route by ID.
   * @deprecated In favor of `getRoute`.
   */
  route?: Maybe<Route>;
  /**
   * Get emissions for a route.
   * @deprecated In favor of `getRouteEmissions`.
   */
  routeEmissions: RouteEmissions;
  /**
   * Get a route path segment by ID.
   * @deprecated In favor of `RouteDetails.path_plot`.
   */
  routePath?: Maybe<RoutePath>;
  /** Get information about a station by its ID. */
  station?: Maybe<Station>;
  /** Search for stations around a GeoJSON point with a specific distance in meters. */
  stationAround?: Maybe<Array<Maybe<Station>>>;
  /** Get a full list of stations. */
  stationList?: Maybe<Array<Maybe<Station>>>;
  /** Get information about a tariff by the tariff ID. */
  tariff?: Maybe<OcpiTariff>;
  /** Get the full list of tariffs. */
  tariffList?: Maybe<Array<Maybe<OcpiTariff>>>;
  /**
   * Get all reviews of stations that were added by an authenticated user.
   * The `x-token` header is mandatory in order to authorize the user who wants to retrieve all the reviews added by him/her.
   * This is a premium feature, contact Chargetrip for more information.
   */
  userReviewList?: Maybe<Array<Review>>;
  /** Get information about a vehicle by its ID. */
  vehicle?: Maybe<Vehicle>;
  /** Get a full list of vehicles. */
  vehicleList?: Maybe<Array<Maybe<VehicleList>>>;
  /** [BETA] Get a full list of vehicle makes. */
  vehicleMakes?: Maybe<VehicleMakesConnection>;
  /** [BETA] Get a full list of vehicle make models. */
  vehicleModels?: Maybe<VehicleModelsConnection>;
  /** Vehicle premium data provides even more information about your vehicle: tire pressure, prices, drivetrain data, and more. Please contact us for access to premium data. */
  vehiclePremium?: Maybe<VehiclePremium>;
};


export type QueryAmenityListArgs = {
  filter?: InputMaybe<AmenityListFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  stationId: Scalars['ID']['input'];
};


export type QueryConnectedVehicleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryConnectedVehicleDataArgs = {
  id: Scalars['ID']['input'];
};


export type QueryConnectedVehicleListArgs = {
  filter?: InputMaybe<ConnectedVehicleListFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetRouteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetRouteEmissionsArgs = {
  route_details_id: Scalars['ID']['input'];
  route_id: Scalars['ID']['input'];
};


export type QueryGetRouteStationsWithAmenitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  amenity_types: Array<AmenityType>;
  filter?: InputMaybe<RouteStationsWithAmenityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  route_details_id: Scalars['ID']['input'];
  route_id: Scalars['ID']['input'];
  time_window: RouteTimeWindow;
};


export type QueryGetTruckRouteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryIsolineArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNavigationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOperatorArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOperatorListArgs = {
  filter?: InputMaybe<OperatorListFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<OperatorListQuery>;
  search?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryReviewListArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  stationId: Scalars['ID']['input'];
};


export type QueryRouteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRouteEmissionsArgs = {
  route_alternative_id?: InputMaybe<Scalars['ID']['input']>;
  route_id: Scalars['ID']['input'];
};


export type QueryRoutePathArgs = {
  alternativeId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  location: PointInput;
};


export type QueryStationArgs = {
  evse_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryStationAroundArgs = {
  filter?: InputMaybe<StationAroundFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<StationAroundQuery>;
  search?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryStationListArgs = {
  filter?: InputMaybe<StationListFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<StationListQuery>;
  search?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTariffArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTariffListArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserReviewListArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryVehicleArgs = {
  country?: InputMaybe<CountryCodeAlpha2>;
  id: Scalars['ID']['input'];
};


export type QueryVehicleListArgs = {
  country?: InputMaybe<CountryCodeAlpha2>;
  filter?: InputMaybe<VehicleListFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryVehicleMakesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCodeAlpha2>;
  filter?: InputMaybe<VehicleMakesFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryVehicleModelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCodeAlpha2>;
  filter?: InputMaybe<VehicleModelsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryVehiclePremiumArgs = {
  country?: InputMaybe<CountryCodeAlpha2>;
  id: Scalars['ID']['input'];
};

export type RemoveConnectedVehicleInput = {
  /** Id from the connected vehicle */
  id: Scalars['ID']['input'];
};

/** EV specific data for a route request. */
export type RequestEv = {
  __typename?: 'RequestEv';
  /** Supported adapters of plugs for an EV. */
  adapters?: Maybe<Array<Maybe<RequestEvPlug>>>;
  /** EV battery specific data. */
  battery?: Maybe<RequestEvBattery>;
  /** Vehicle cabin configuration. */
  cabin?: Maybe<RequestEvCabin>;
  /** Cargo weight, in kg. */
  cargo?: Maybe<Scalars['Float']['output']>;
  /** Climate is on. */
  climate?: Maybe<Scalars['Boolean']['output']>;
  /** Consumption specific to an EV or inputted by a request. */
  consumption?: Maybe<RequestEvConsumption>;
  /** Vehicle Heat Pump configuration. */
  heatPump?: Maybe<HeatPumpMode>;
  /** Internal ID of a Vehicle. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Minimum desired power of chargers. */
  minPower?: Maybe<Scalars['Int']['output']>;
  /**
   * Number of passengers on board.
   * @deprecated In favor of `occupants`.
   */
  numberOfPassengers?: Maybe<Scalars['Int']['output']>;
  /** Number of occupants. */
  occupants?: Maybe<Scalars['Int']['output']>;
  /** Supported plugs for an EV. */
  plugs?: Maybe<Array<Maybe<RequestEvPlug>>>;
};

export type RequestEvBattery = {
  __typename?: 'RequestEvBattery';
  /** Usable capacity of the battery used to compute the route. If this in not filled in, value as the vehicle battery.usable_kwh. */
  capacity?: Maybe<RequestEvBatteryValue>;
  /** Usable capacity of a battery, in kWh. This value is computed from the provided capacity value. */
  capacityKwh?: Maybe<Scalars['Float']['output']>;
  /** Desired final amount of energy in a battery. If this is not filled in, it will be set to 20% of the vehicle battery.usable_kwh. */
  finalStateOfCharge?: Maybe<RequestEvBatteryValue>;
  /** Desired final amount of energy in a battery, in kWh. This value is computed from the provided final state of charge. */
  finalStateOfChargeKwh?: Maybe<Scalars['Float']['output']>;
  /** Current amount of energy in a battery. If this is not filled in, we assume the battery is full and it will be equal to the battery.usable_kwh. */
  stateOfCharge?: Maybe<RequestEvBatteryValue>;
  /** Current amount of energy in a battery, in kWh. This value is computed from the provided state of charge. */
  stateOfChargeKwh?: Maybe<Scalars['Float']['output']>;
};

export type RequestEvBatteryInput = {
  /** Usable capacity of a battery used to compute a route. We recommend you stay between 50% and 150%. If this in not filled in, we assume it is the same value as the vehicle battery.usable_kwh. */
  capacity?: InputMaybe<RequestEvBatteryInputValue>;
  /** Desired final amount of energy in a battery. The value should be between 0 and 80% of the vehicle battery.usable_kwh If this is not filled in, we assume it is 20% of the vehicle battery.usable_kwh. */
  finalStateOfCharge?: InputMaybe<RequestEvBatteryInputValue>;
  /** Current amount of energy in a battery. If this is not filled in, we assume the battery is full and we fill it in with vehicle battery.usable_kwh. */
  stateOfCharge?: InputMaybe<RequestEvBatteryInputValue>;
};

export type RequestEvBatteryInputValue = {
  /** Type of a desired final amount of energy in a battery. */
  type: BatteryInputType;
  /** Value of a desired final amount of energy in a battery. */
  value: Scalars['Float']['input'];
};

export type RequestEvBatteryValue = {
  __typename?: 'RequestEvBatteryValue';
  /** Type of the desired final amount of energy in a battery. */
  type: BatteryInputType;
  /** Value of the desired final amount of energy in a battery. */
  value: Scalars['Float']['output'];
};

/** Vehicle cabin configuration. */
export type RequestEvCabin = {
  __typename?: 'RequestEvCabin';
  /** Desired cabin temperature. Default is 20 degrees Celsius or 68 degrees Fahrenheit. */
  desiredTemperature?: Maybe<Scalars['Float']['output']>;
  /** Flag which indicate if the vehicle cabin was preconditioned for the desired temperature. */
  isPreconditioned?: Maybe<Scalars['Boolean']['output']>;
};


/** Vehicle cabin configuration. */
export type RequestEvCabinDesiredTemperatureArgs = {
  unit?: InputMaybe<TemperatureUnit>;
};

/** Vehicle cabin configuration. */
export type RequestEvCabinInput = {
  /** Desired cabin temperature. Default is 20 degrees Celsius or 68 degrees Fahrenheit. */
  desiredTemperature?: InputMaybe<TemperatureInput>;
  /** Flag which indicate if the vehicle cabin was preconditioned for the desired temperature. */
  isPreconditioned?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RequestEvConsumption = {
  __typename?: 'RequestEvConsumption';
  /**
   * Consumption, in kWh, of the auxiliaries.
   * @deprecated In favor of `auxiliary`
   */
  aux?: Maybe<CarConsumption>;
  /** The amount of energy, in kWh, used by the auxiliary systems of the vehicle in an hour, like media box, etc */
  auxiliary?: Maybe<Scalars['Float']['output']>;
  /**
   * Consumption, in kWh, of the battery management system.
   * @deprecated In favor of `auxiliary`
   */
  bms?: Maybe<CarConsumption>;
  /**
   * Consumption, in kWh, of the vehicle in idle mode.
   * @deprecated In favor of `auxiliary`
   */
  idle?: Maybe<CarConsumption>;
};

export type RequestEvConsumptionInput = {
  /** Consumption, in kWh, of the auxiliaries. */
  aux?: InputMaybe<CarConsumptionInput>;
  /** Amount of energy, in kWh, used by the auxiliary systems of the vehicle in an hour, like media box, etc. */
  auxiliary?: InputMaybe<Scalars['Float']['input']>;
  /** Consumption, in kWh, of the battery management system. */
  bms?: InputMaybe<CarConsumptionInput>;
  /** Consumption, in kWh, of the vehicle in idle mode. */
  idle?: InputMaybe<CarConsumptionInput>;
};

export type RequestEvInput = {
  /** Supported adapters of plugs of an EV. */
  adapters?: InputMaybe<Array<InputMaybe<RequestEvPlugInput>>>;
  /** Consumption, in kWh, of the auxiliaries. */
  auxConsumption?: InputMaybe<Scalars['Float']['input']>;
  /** The EV battery specific data. */
  battery?: InputMaybe<RequestEvBatteryInput>;
  /** Consumption, in kWh, of the battery management system. */
  bmsConsumption?: InputMaybe<Scalars['Float']['input']>;
  /** Vehicle cabin configuration. */
  cabin?: InputMaybe<RequestEvCabinInput>;
  /** Cargo weight, in kg. */
  cargo?: InputMaybe<Scalars['Int']['input']>;
  /** Flag which indicates if the climate is on. */
  climate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Consumption specific to the EV or inputted by the request. */
  consumption?: InputMaybe<RequestEvConsumptionInput>;
  /** Vehicle Heat Pump configuration. */
  heatPump?: InputMaybe<HeatPumpMode>;
  /** Internal ID of a Vehicle. */
  id: Scalars['ID']['input'];
  /** Minimum desired power of chargers. */
  minPower?: InputMaybe<Scalars['Int']['input']>;
  /** Number of passengers on board. */
  numberOfPassengers?: InputMaybe<Scalars['Int']['input']>;
  /** Number of occupants. */
  occupants?: InputMaybe<Scalars['Int']['input']>;
  /** Supported plugs of an EV. */
  plugs?: InputMaybe<Array<InputMaybe<RequestEvPlugInput>>>;
};

export type RequestEvPlug = {
  __typename?: 'RequestEvPlug';
  /** Maximum charging speed for a plug. */
  chargingPower?: Maybe<Scalars['Float']['output']>;
  /** Type of the plug. */
  standard?: Maybe<ConnectorType>;
};

export type RequestEvPlugInput = {
  /** Maximum charging speed for this plug. */
  chargingPower: Scalars['Float']['input'];
  /** Type of a plug. */
  standard: ConnectorType;
};

export type RequestInput = {
  /** EV specific data for a route request. */
  ev: RequestEvInput;
  /** Route request data. */
  routeRequest: RequestRouteInput;
  /** Telemetry data used to overwrite routing parameters. */
  telemetry?: InputMaybe<Scalars['JSON']['input']>;
};

export type RequestRoute = {
  __typename?: 'RequestRoute';
  /**
   * Requested amenities near the stations, within a 1 kilometer radius.
   * @deprecated In favor of `amenity_preferences`.
   */
  amenities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Amenity preferences for a route. */
  amenity_preferences?: Maybe<RouteAmenityPreferences>;
  /** Mode that indicates if we optimize the charging time or always charge to the maximum capacity. */
  chargeMode?: Maybe<ChargeMode>;
  /** Destination of a route. */
  destination?: Maybe<FeaturePoint>;
  /**
   * Flag indicating wether the turn-by-turn navigation instructions should be prepared. Disclaimer: The functionality is under active development and the final API is a subject to change. Not ready for production.
   * @deprecated All routes will have turn-by-turn instructions prepared. Boolean will be ignored.
   */
  instructions?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Requested operators.
   * @deprecated In favor of `operators`.
   */
  operatorIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**
   * Encourage the route to use preferred operators. In case there are no preferred operators the route can still be calculated.
   * @deprecated In favor of `operators`.
   */
  operatorPrefer?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Preferred operators are required. In case there are no preferred operators the route cannot be calculated.
   * @deprecated In favor of `operators`.
   */
  operatorRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Operator prioritization for a route. */
  operators?: Maybe<RouteOperators>;
  /** Origin of a route. */
  origin?: Maybe<FeaturePoint>;
  /** Percentage for the minimum limit of the battery capacity before a recharge. The value should be between 0 and 60. When omitted, the project configuration is used. */
  safeRiskMargin?: Maybe<Scalars['Int']['output']>;
  /** Season. */
  season?: Maybe<RouteSeason>;
  /** Radius in meters for alternative stations along a route (min 500 - max 5000). */
  stationsAlongRouteRadius?: Maybe<Scalars['Int']['output']>;
  /** Locations where a route will stop. */
  via?: Maybe<Array<Maybe<FeaturePoint>>>;
};

export type RequestRouteInput = {
  /** A list of desired amenities near the stations, with a 1 kilometer radius. */
  amenities?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Amenity preferences for a route. */
  amenity_preferences?: InputMaybe<AmenityPreferencesInput>;
  /** Mode that indicates if we optimize the charging time or always charge to the maximum capacity. */
  chargeMode?: InputMaybe<ChargeMode>;
  /** Destination of a route. */
  destination: FeaturePointInput;
  /** Flag to enable turn-by-turn instructions. */
  instructions?: InputMaybe<Scalars['Boolean']['input']>;
  /** A list of requested operators. */
  operatorIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Flag which indicates if the preferred operators should be loaded. */
  operatorPrefer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Flag which indicates if the operators are required. */
  operatorRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Operator prioritization for a route. */
  operators?: InputMaybe<RouteOperatorsInput>;
  /** Origin of a route. */
  origin: FeaturePointInput;
  /** Percentage for a minimum limit of a battery capacity before a recharge. The value should be between 0 and 60. When omitted, the project configuration is used. */
  safeRiskMargin?: InputMaybe<Scalars['Int']['input']>;
  /** Optional flag to specify the season. */
  season?: InputMaybe<RouteSeason>;
  /** Alternative stations along a route within a specified radius in meters (minimum 500, maximum 5000). */
  stationsAlongRouteRadius?: InputMaybe<Scalars['Int']['input']>;
  /** An optional list of locations where we should stop. */
  via?: InputMaybe<Array<InputMaybe<FeaturePointInput>>>;
};

export type RequestUser = {
  __typename?: 'RequestUser';
  /** ID of the user. */
  id?: Maybe<Scalars['ID']['output']>;
};

/** Review model. */
export type Review = {
  __typename?: 'Review';
  /** Date and time when a review was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Vehicle that was provided/selected by a user. */
  ev?: Maybe<Vehicle>;
  /** ID of a review. */
  id: Scalars['ID']['output'];
  /** Locale of a message. */
  locale?: Maybe<Scalars['String']['output']>;
  /** Message of a review. */
  message?: Maybe<Scalars['String']['output']>;
  /** Plug type that was provided/selected by a user. */
  plugType?: Maybe<ConnectorType>;
  /** Optional object where you can store custom data you need in your application. This extends the current functionalities we offer. */
  properties?: Maybe<Scalars['JSON']['output']>;
  /** Rating of a review. */
  rating?: Maybe<Scalars['Int']['output']>;
  /** Station for which a review was provided. */
  station?: Maybe<Station>;
  /** Boolean tags for a station review. */
  tags?: Maybe<ReviewTags>;
  /** Date and time when a review was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User who added a review. If a review was added by an anonymous user, this will be null. */
  user?: Maybe<ReviewUser>;
};

/** Form input to add a new review. */
export type ReviewAdd = {
  /** ID of the vehicle that was provided/selected by a user. */
  ev?: InputMaybe<Scalars['String']['input']>;
  /** Locale of a message. */
  locale?: InputMaybe<Scalars['String']['input']>;
  /** Review message. */
  message?: InputMaybe<Scalars['String']['input']>;
  /** Plug type that was provided/selected by a user. */
  plugType?: InputMaybe<ConnectorType>;
  /** Optional object where you can store custom data you need in your application. This extends the current functionalities we offer. */
  properties?: InputMaybe<Scalars['JSON']['input']>;
  /** Rating of a review. */
  rating: Scalars['Int']['input'];
  /** Station ID for which a review is provided. */
  stationId: Scalars['String']['input'];
  /** Boolean tags for a station review. */
  tags?: InputMaybe<ReviewTagsInput>;
};

/** Form input for edit an existing review. */
export type ReviewEdit = {
  /** Locale of a message. */
  locale?: InputMaybe<Scalars['String']['input']>;
  /** Review message. */
  message?: InputMaybe<Scalars['String']['input']>;
  /** Optional object where you can store custom data you need in your application. This extends the current functionalities we offer. */
  properties?: InputMaybe<Scalars['JSON']['input']>;
  /** Rating of a review. */
  rating: Scalars['Int']['input'];
  /** Boolean tags for a station review. */
  tags?: InputMaybe<ReviewTagsInput>;
};

/** Statistical information for reviews of a station. */
export type ReviewStats = {
  __typename?: 'ReviewStats';
  /** 'Total number of reviews. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Average of all reviews. */
  rating?: Maybe<Scalars['Float']['output']>;
};

/** Boolean tags for the station review. */
export type ReviewTags = {
  __typename?: 'ReviewTags';
  /** Flag which indicates if the user recommended the station when the review was added. */
  recommended?: Maybe<Scalars['Boolean']['output']>;
  /** Flag which indicates if the station was working when the review was added. */
  working?: Maybe<Scalars['Boolean']['output']>;
};

/** Boolean tags for a station review. */
export type ReviewTagsInput = {
  /** Flag which indicates if a user recommended a station when the review was added. */
  recommended?: InputMaybe<Scalars['Boolean']['input']>;
  /** Flag which indicates if a station was working when the review was added. */
  working?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Special format for the user of a review. */
export type ReviewUser = {
  __typename?: 'ReviewUser';
  /** User full name. If a review was added by an anonymous user, this will be null. */
  name?: Maybe<Scalars['String']['output']>;
};

export type Route = {
  __typename?: 'Route';
  /** Available alternatives. */
  alternatives?: Maybe<Array<Maybe<RouteAlternative>>>;
  /** Application who requested a route. */
  app?: Maybe<RouteApp>;
  /** EV specific data for a route request. */
  ev?: Maybe<RequestEv>;
  /** Recommended route. */
  route?: Maybe<RouteAlternative>;
  /** Route request data. */
  routeRequest?: Maybe<RequestRoute>;
  /** Route status. */
  status?: Maybe<RouteStatus>;
  /** Route telemetry data. */
  telemetry?: Maybe<Scalars['JSON']['output']>;
  /** @deprecated You will receive null values. */
  user?: Maybe<RequestUser>;
};

export type RouteAlternative = {
  __typename?: 'RouteAlternative';
  /**
   * Amenity ranking for an alternative.
   * @deprecated Will be removed.
   */
  amenityRanking?: Maybe<Scalars['Int']['output']>;
  /** Total time required to charge for an entire route, in seconds. */
  chargeTime?: Maybe<Scalars['Float']['output']>;
  /** Number of charging stops required for this route. */
  charges?: Maybe<Scalars['Int']['output']>;
  /** Number of available charges along a route. */
  chargesAvailable?: Maybe<Scalars['Int']['output']>;
  /** Number of occupied charges along a route. */
  chargesOccupied?: Maybe<Scalars['Int']['output']>;
  /** Number of out of order charges along a route. */
  chargesOutOfOrder?: Maybe<Scalars['Int']['output']>;
  /** Number of unknown charges along a route. */
  chargesUnknown?: Maybe<Scalars['Int']['output']>;
  /** Total energy used for a route in kWh. */
  consumption?: Maybe<Scalars['Float']['output']>;
  /** Total distance of a route in meters. */
  distance?: Maybe<Scalars['Int']['output']>;
  /** Total duration of a route, including charge time, in seconds. */
  duration?: Maybe<Scalars['Int']['output']>;
  /** Total number of meters which are going down on a route. */
  elevationDown?: Maybe<Scalars['Float']['output']>;
  /** Highest value from the elevation array. */
  elevationMax?: Maybe<Scalars['Float']['output']>;
  /**
   * Elevation values. Each elevationPlot has a hundred points, independent of the length of a route.
   * @deprecated In favor of `pathPlot`.
   */
  elevationPlot?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** Total number of meters which are going up on a route. */
  elevationUp?: Maybe<Scalars['Float']['output']>;
  /** ID of a route alternative. */
  id?: Maybe<Scalars['ID']['output']>;
  /** List of raw turn-by-turn navigation instructions. */
  instructions?: Maybe<Array<Maybe<RouteInstruction>>>;
  /** Legs of the route. */
  legs?: Maybe<Array<Maybe<RouteLeg>>>;
  /** Path elevation, distance, duration, consumption and speed values, grouped into 100 segments. */
  pathPlot?: Maybe<Array<Maybe<PathSegment>>>;
  /** Polyline containing encoded coordinates. */
  polyline?: Maybe<Scalars['String']['output']>;
  /** Display value that indicates the range, in meters, available at the end of the trip. This range is calculated using the Chargetrip range, the conditions at the time of planning the route, weather scenario (current or seasonal) and the route input. Please note: In case of a non BEV where the range end is negative, the value will be 0. */
  rangeEnd?: Maybe<Scalars['Int']['output']>;
  /** Remaining range, energy in kWh, at the end of a trip. In the case of a non BEV where the range end is negative, the value will be 0. */
  rangeEndKwh?: Maybe<Scalars['Float']['output']>;
  /** Remaining range, energy in percentage, at the end of a trip. */
  rangeEndPercentage?: Maybe<Scalars['Int']['output']>;
  /** Display value that indicates the range, in meters, available at the beginning of the trip. This range is calculated using the Chargetrip range, the conditions at the time of planning the route, weather scenario (current or seasonal) and the route input. */
  rangeStart?: Maybe<Scalars['Int']['output']>;
  /** Total energy in a battery at the beginning of a trip, in kWh. */
  rangeStartKwh?: Maybe<Scalars['Float']['output']>;
  /** Total energy in a battery at the beginning of a trip, in percentage. */
  rangeStartPercentage?: Maybe<Scalars['Int']['output']>;
  /** Money and CO2 saving information. */
  saving?: Maybe<RouteAlternativeSaving>;
  /** Alternative stations along a route within specified radius in meters. Only if it was provided at newRoute mutation. */
  stationsAlongRoute?: Maybe<Array<Maybe<RouteStationsAlong>>>;
  /** Tags of a route alternative. Values: road, highway, toll, ferry, etc. */
  tags?: Maybe<Array<Maybe<RouteTagType>>>;
  /** Type of alternative route. */
  type?: Maybe<RouteAlternativeType>;
  /** Text information about a route direction. */
  via?: Maybe<Scalars['String']['output']>;
};


export type RouteAlternativePolylineArgs = {
  decimals?: InputMaybe<Scalars['Int']['input']>;
};

export type RouteAlternativeSaving = {
  __typename?: 'RouteAlternativeSaving';
  /** Average energy price with which the calculation was made. */
  averageEnergyPrice?: Maybe<Scalars['String']['output']>;
  /** Average gas price with which the calculation was made. */
  averageGasPrice?: Maybe<Scalars['String']['output']>;
  /** Total amount of CO2, in grams, which would be used with a gasoline vehicle. */
  co2?: Maybe<Scalars['String']['output']>;
  /** Currency. */
  currency?: Maybe<Scalars['String']['output']>;
  /** Money saved by a user driving this route with the electric vehicle. */
  money?: Maybe<Scalars['String']['output']>;
};

/** Types of an alternative route. */
export const RouteAlternativeType = {
  /** An alternative to the fastest route. */
  ALTERNATIVE: 'alternative',
  /** Best matching route based on operator and amenities preferences. */
  BESTMATCHING: 'bestMatching',
  /** Fastest route between origin and destination. */
  FASTEST: 'fastest'
} as const;

export type RouteAlternativeType = typeof RouteAlternativeType[keyof typeof RouteAlternativeType];
export type RouteAmenityFilter = {
  /** Maximum distance from the station to the amenity. The value must be between 0 and 1 000 meters. If not specified, defaults to 250 meters. */
  maximum_distance_from_station?: InputMaybe<DistanceInput>;
};

/** Amenity preferences for a route. */
export type RouteAmenityPreferences = {
  __typename?: 'RouteAmenityPreferences';
  /** Desired amenities near all charge-stops along a route, with a 1 kilometer radius. */
  all_charge_stops?: Maybe<Array<AmenityType>>;
  /** Scheduled charge stops, with a specified amenity and timeline. */
  scheduled_charge_stops?: Maybe<Array<RouteScheduledChargeStop>>;
};

export type RouteApp = {
  __typename?: 'RouteApp';
  /** ID of the app who requested a route. */
  id?: Maybe<Scalars['ID']['output']>;
};

/** Types of route features that can be avoided in routing. */
export const RouteAvoid = {
  FERRY: 'ferry',
  TOLL_ROAD: 'toll_road'
} as const;

export type RouteAvoid = typeof RouteAvoid[keyof typeof RouteAvoid];
export type RouteDestinationFeaturePoint = {
  __typename?: 'RouteDestinationFeaturePoint';
  /** Geometry of the feature. */
  geometry?: Maybe<Point>;
  /** ID of the feature. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Additional feature properties. */
  properties?: Maybe<RouteDestinationProperties>;
  /** Feature type. */
  type: FeatureType;
};

export type RouteDestinationFeaturePointInput = {
  /** Geometry of the feature. */
  geometry?: InputMaybe<PointInput>;
  /** ID of the feature. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Additional feature properties. */
  properties?: InputMaybe<RouteDestinationPropertiesInput>;
  /** Feature type. */
  type: FeatureType;
};

export type RouteDestinationProperties = {
  __typename?: 'RouteDestinationProperties';
  /** Data about the destination location. */
  location?: Maybe<RoutePropertiesLocation>;
  /** Data about the destination station. */
  station?: Maybe<RoutePropertiesStation>;
};

export type RouteDestinationPropertiesInput = {
  /** Data about the destination location. */
  location?: InputMaybe<RoutePropertiesLocationInput>;
  /** Specifies a charging station at the destination. If an existing station is provided, it is treated as a regular location stop and no charging will be scheduled at this location. Any configured operator preferences are ignored for this stop. */
  station?: InputMaybe<RoutePropertiesStationInput>;
};

export type RouteDetails = {
  __typename?: 'RouteDetails';
  /**
   * Alternative stations along a route within a specified radius.
   *
   * Includes stations from preferred/required/avoided operators but excludes stations from excluded operators.
   * This list is only populated if `alternative_station_radius` was specified in the `createRoute` mutation.
   */
  alternative_stations: Array<RouteDetailsAlternativeStation>;
  /** Number of charging stops required for this route. */
  charges: Scalars['Int']['output'];
  /** Total energy used for a route in kilowatt hours. For HEVs and PHEVs this field will return null. */
  consumption?: Maybe<Scalars['Float']['output']>;
  /** Total distance of a route. */
  distance: Scalars['Float']['output'];
  /** Aggregation of all durations of a route. */
  durations: RouteDetailsDurations;
  /** Details about elevation on a route. */
  elevation: RouteDetailsElevation;
  /** ID of a route computation. */
  id: Scalars['ID']['output'];
  /** Legs of a route. */
  legs: Array<RouteDetailsLeg>;
  /** Path elevation, distance, duration, consumption and speed values, grouped into 100 segments. */
  path_plot: Array<RouteDetailsPathSegment>;
  /** Polyline containing encoded coordinates. */
  polyline: Scalars['String']['output'];
  /** Range available at the end of a trip. Note: The ranges in kilometers and miles are estimates, calculated based on the Chargetrip range, current route conditions, weather scenario (current or seasonal), and the route input at the time of planning. For HEVs and PHEVs this field will return null. */
  range_at_destination?: Maybe<Scalars['Float']['output']>;
  /** Range available at the start of a trip. The ranges in kilometers and miles are estimates, calculated based on the Chargetrip range, current route conditions, weather scenario (current or seasonal), and the route input at the time of planning. For HEVs and PHEVs this field will return null. */
  range_at_origin?: Maybe<Scalars['Float']['output']>;
  /** Money saving information. */
  savings?: Maybe<RouteDetailsSavings>;
  /** Aggregation of tags over the current RouteDetails. Tags are available on legs and further subdivided over individual sections and maneuvers. */
  tags: Array<RouteDetailsTag>;
  /** [BETA] Traffic conditions along the route. Only returns data if `traffic_aware` is set to true in the `createRoute` mutation. */
  traffic?: Maybe<RouteDetailsTraffic>;
  /** [BETA] Warnings that certain conditions specified in a route mutation are not respected. */
  warnings?: Maybe<Array<RouteWarning>>;
};


export type RouteDetailsDistanceArgs = {
  unit?: InputMaybe<DistanceUnit>;
};


export type RouteDetailsPolylineArgs = {
  decimals?: InputMaybe<PolylineInputDecimals>;
};


export type RouteDetailsRange_At_DestinationArgs = {
  unit?: InputMaybe<StateOfChargeUnit>;
};


export type RouteDetailsRange_At_OriginArgs = {
  unit?: InputMaybe<StateOfChargeUnit>;
};

export type RouteDetailsAlternativeStation = {
  __typename?: 'RouteDetailsAlternativeStation';
  /** ID of a station. */
  id: Scalars['ID']['output'];
  /** GeoJSON location of a station. */
  location: Point;
  /** ID of the station's operator. */
  operator_id?: Maybe<Scalars['ID']['output']>;
  /** The value indicates the operator's ranking based on the station's location, in accordance with the list of countries from the configuration or request. */
  operator_ranking?: Maybe<OperatorRankingLevel>;
  /** Speed of a station. A station along a route can be either fast or turbo. */
  speed: StationSpeedType;
  /** Status of a station. */
  status: ChargerStatus;
};

export type RouteDetailsDurations = {
  __typename?: 'RouteDetailsDurations';
  /** Total charging duration, in seconds. */
  charging: Scalars['Int']['output'];
  /** Total driving duration, in seconds. Takes into account traffic congestion when `traffic_aware` is set to true in the `createRoute` mutation. */
  driving: Scalars['Int']['output'];
  /** Total ferry duration, in seconds. */
  ferry: Scalars['Int']['output'];
  /** Total duration stopped at a location via or at a station via, excluding charging time and charging penalty, in seconds. */
  stopover: Scalars['Int']['output'];
  /** Total duration, in seconds. */
  total: Scalars['Int']['output'];
};

export type RouteDetailsElevation = {
  __typename?: 'RouteDetailsElevation';
  /** Total value driving downhill on a route. */
  down: Scalars['Float']['output'];
  /** Maximum elevation on a route. */
  maximum: Scalars['Float']['output'];
  /** Minimum elevation on a route. */
  minimum: Scalars['Float']['output'];
  /** Total value driving uphill on a route. */
  up: Scalars['Float']['output'];
};


export type RouteDetailsElevationDownArgs = {
  unit?: InputMaybe<DistanceUnit>;
};


export type RouteDetailsElevationMaximumArgs = {
  unit?: InputMaybe<DistanceUnit>;
};


export type RouteDetailsElevationMinimumArgs = {
  unit?: InputMaybe<DistanceUnit>;
};


export type RouteDetailsElevationUpArgs = {
  unit?: InputMaybe<DistanceUnit>;
};

export type RouteDetailsEmissions = {
  __typename?: 'RouteDetailsEmissions';
  /** Estimated GHG emissions saved by a user driving this route with the electric vehicle in grams of CO2e. */
  co2e_saved: Scalars['Float']['output'];
  internal_combustion_vehicle: RouteInternalCombustionVehicleEmissions;
  route_alternative_id: Scalars['ID']['output'];
  /** ID of the route for which we retrieve the emissions profile. */
  route_id: Scalars['ID']['output'];
  /** Emissions profile for the vehicle used in route. */
  route_vehicle: RouteVehicleEmissions;
};


export type RouteDetailsEmissionsCo2e_SavedArgs = {
  unit?: InputMaybe<EmissionUnit>;
};


export type RouteDetailsEmissionsInternal_Combustion_VehicleArgs = {
  fuel_type?: InputMaybe<RouteOperationalFuelType>;
};

/** Leg of a route detail. */
export type RouteDetailsLeg = {
  __typename?: 'RouteDetailsLeg';
  /** Total energy used in a leg in kilowatt hours. For HEVs and PHEVs this field will return null. */
  consumption?: Maybe<Scalars['Float']['output']>;
  /** Destination point location. */
  destination: RouteDetailsLegFeaturePoint;
  /** Distance from the start to the end of a leg. */
  distance: Scalars['Float']['output'];
  /** Aggregation of all durations of a route leg. */
  durations: RouteDetailsDurations;
  /** Maneuvers of a leg - used to generate turn-by-turn instructions. */
  maneuvers: Array<RouteDetailsManeuver>;
  /** Origin point location. */
  origin: RouteDetailsLegFeaturePoint;
  /** Polyline containing encoded coordinates. */
  polyline: Scalars['String']['output'];
  /** Range after charging on the leg. The ranges in kilometers and miles are estimates, calculated based on the Chargetrip range, current route conditions, weather scenario (current or seasonal), and the route input at the time of planning. For HEVs and PHEVs this field will return null. */
  range_after_charge?: Maybe<Scalars['Float']['output']>;
  /** Range available at the end of a leg. The ranges in kilometers and miles are estimates, calculated based on the Chargetrip range, current route conditions, weather scenario (current or seasonal), and the route input at the time of planning. For HEVs and PHEVs this field will return null. */
  range_at_destination?: Maybe<Scalars['Float']['output']>;
  /** Range at the start of a leg. The ranges in kilometers and miles are estimates, calculated based on the Chargetrip range, current route conditions, weather scenario (current or seasonal), and the route input at the time of planning. For HEVs and PHEVs this field will return null. */
  range_at_origin?: Maybe<Scalars['Float']['output']>;
  /** Road sections of a leg - divided by means of transportation. */
  sections: Array<RouteDetailsLegSection>;
  /** Information about the station at the destination of a leg. */
  station?: Maybe<RouteDetailsLegStation>;
  /** Aggregation of tags over the current leg. Tags are further subdivided over individual sections and maneuvers. */
  tags: Array<RouteDetailsTag>;
  /** [BETA] Traffic conditions along the leg. Only returns data if `traffic_aware` is set to true in the `createRoute` mutation. */
  traffic?: Maybe<RouteDetailsLegTraffic>;
  /** Type of a leg. */
  type: RouteDetailsLegType;
  /** [BETA] Warnings that certain conditions specified in a route mutation are not respected. */
  warnings?: Maybe<Array<RouteDetailsLegWarning>>;
};


/** Leg of a route detail. */
export type RouteDetailsLegDistanceArgs = {
  unit?: InputMaybe<DistanceUnit>;
};


/** Leg of a route detail. */
export type RouteDetailsLegPolylineArgs = {
  decimals?: InputMaybe<PolylineInputDecimals>;
};


/** Leg of a route detail. */
export type RouteDetailsLegRange_After_ChargeArgs = {
  unit?: InputMaybe<StateOfChargeUnit>;
};


/** Leg of a route detail. */
export type RouteDetailsLegRange_At_DestinationArgs = {
  unit?: InputMaybe<StateOfChargeUnit>;
};


/** Leg of a route detail. */
export type RouteDetailsLegRange_At_OriginArgs = {
  unit?: InputMaybe<StateOfChargeUnit>;
};

export type RouteDetailsLegFeaturePoint = {
  __typename?: 'RouteDetailsLegFeaturePoint';
  /** Geometry of the feature. */
  geometry: Point;
  /** ID of the feature. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Properties of the feature. */
  properties?: Maybe<RouteDetailsLegFeatureProperties>;
  /** Feature type. */
  type: FeatureType;
};

export type RouteDetailsLegFeatureProperties = {
  __typename?: 'RouteDetailsLegFeatureProperties';
  /** Air pressure at the location. */
  air_pressure?: Maybe<Scalars['Float']['output']>;
  /**
   * Duration, in seconds, of time spent at this location.
   * @deprecated In favor of `legs.durations`.
   */
  duration?: Maybe<Scalars['Int']['output']>;
  /** External ID of the station. */
  external_station_id?: Maybe<Scalars['ID']['output']>;
  /** Name of the location. */
  name?: Maybe<Scalars['String']['output']>;
  /** Number of occupants present in the vehicle. */
  occupants?: Maybe<Scalars['Int']['output']>;
  /** Solar irradiance at the location. */
  solar_irradiance?: Maybe<Scalars['Float']['output']>;
  /** ID of the station. */
  station_id?: Maybe<Scalars['ID']['output']>;
  /** Temperature at the location. */
  temperature?: Maybe<Scalars['Int']['output']>;
  /** Value of the current weight of the cargo. */
  total_cargo_weight?: Maybe<Scalars['Float']['output']>;
  /** Value of the combined weight of the occupants. */
  total_occupant_weight?: Maybe<Scalars['Float']['output']>;
};


export type RouteDetailsLegFeaturePropertiesTemperatureArgs = {
  unit?: InputMaybe<TemperatureUnit>;
};


export type RouteDetailsLegFeaturePropertiesTotal_Cargo_WeightArgs = {
  unit?: InputMaybe<WeightUnit>;
};


export type RouteDetailsLegFeaturePropertiesTotal_Occupant_WeightArgs = {
  unit?: InputMaybe<WeightUnit>;
};

export type RouteDetailsLegManeuverPoints = {
  __typename?: 'RouteDetailsLegManeuverPoints';
  /** Interval of points included in this instruction, represented as an array with two values: the first is the index of the polyline where the interval starts, and the second is where it ends. */
  interval: Array<Scalars['Int']['output']>;
  /** Number of polyline points which are included in this instruction. */
  size: Scalars['Int']['output'];
};

/** Type of a maneuver indicating the main action. */
export const RouteDetailsLegManeuverType = {
  CONTINUE_ON_STREET: 'CONTINUE_ON_STREET',
  FINISH: 'FINISH',
  IGNORE: 'IGNORE',
  KEEP_LEFT: 'KEEP_LEFT',
  KEEP_RIGHT: 'KEEP_RIGHT',
  LEAVE_ROUNDABOUT: 'LEAVE_ROUNDABOUT',
  PT_END_TRIP: 'PT_END_TRIP',
  PT_START_TRIP: 'PT_START_TRIP',
  PT_TRANSFER: 'PT_TRANSFER',
  REACHED_CHARGING_STATION: 'REACHED_CHARGING_STATION',
  REACHED_VIA: 'REACHED_VIA',
  TURN_LEFT: 'TURN_LEFT',
  TURN_RIGHT: 'TURN_RIGHT',
  TURN_SHARP_LEFT: 'TURN_SHARP_LEFT',
  TURN_SHARP_RIGHT: 'TURN_SHARP_RIGHT',
  TURN_SLIGHT_LEFT: 'TURN_SLIGHT_LEFT',
  TURN_SLIGHT_RIGHT: 'TURN_SLIGHT_RIGHT',
  UNKNOWN: 'UNKNOWN',
  USE_ROUNDABOUT: 'USE_ROUNDABOUT',
  U_TURN_LEFT: 'U_TURN_LEFT',
  U_TURN_RIGHT: 'U_TURN_RIGHT',
  U_TURN_UNKNOWN: 'U_TURN_UNKNOWN'
} as const;

export type RouteDetailsLegManeuverType = typeof RouteDetailsLegManeuverType[keyof typeof RouteDetailsLegManeuverType];
export type RouteDetailsLegSection = {
  __typename?: 'RouteDetailsLegSection';
  /** Total energy used in a section in kilowatt-hours. The value will be 0 for walking sections. */
  consumption?: Maybe<Scalars['Float']['output']>;
  /** Destination point. */
  destination: RouteDetailsLegSectionFeaturePoint;
  /** Distance from the start to the end of a section. */
  distance: Scalars['Float']['output'];
  /** Total duration of a section, in seconds. The value will be 0 for walking sections. */
  duration: Scalars['Float']['output'];
  /** Origin point. */
  origin: RouteDetailsLegSectionFeaturePoint;
  /** Polyline containing encoded coordinates. */
  polyline: Scalars['String']['output'];
  /** Aggregation of tags over the current section. */
  tags: Array<RouteDetailsTag>;
  /** [BETA] Information regarding traffic conditions along the leg's section. Available for routes created with traffic_aware set to true. */
  traffic?: Maybe<RouteDetailsLegSectionTraffic>;
  /** Section type. */
  type: RouteDetailsLegSectionType;
};


export type RouteDetailsLegSectionDistanceArgs = {
  unit?: InputMaybe<DistanceUnit>;
};


export type RouteDetailsLegSectionPolylineArgs = {
  decimals?: InputMaybe<PolylineInputDecimals>;
};

export type RouteDetailsLegSectionFeaturePoint = {
  __typename?: 'RouteDetailsLegSectionFeaturePoint';
  /** Geometry of the feature. */
  geometry: Point;
  /** ID of the feature. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Properties of the feature. */
  properties: RouteDetailsLegSectionFeaturePointProperties;
  /** Feature type. */
  type: FeatureType;
};

export type RouteDetailsLegSectionFeaturePointProperties = {
  __typename?: 'RouteDetailsLegSectionFeaturePointProperties';
  /** Number of occupants present in the vehicle. */
  occupants: Scalars['Int']['output'];
  /** Value of the current weight of the cargo. */
  total_cargo_weight?: Maybe<Scalars['Float']['output']>;
  /** Value of the combined weight of the occupants. */
  total_occupant_weight?: Maybe<Scalars['Float']['output']>;
};


export type RouteDetailsLegSectionFeaturePointPropertiesTotal_Cargo_WeightArgs = {
  unit?: InputMaybe<WeightUnit>;
};


export type RouteDetailsLegSectionFeaturePointPropertiesTotal_Occupant_WeightArgs = {
  unit?: InputMaybe<WeightUnit>;
};

export type RouteDetailsLegSectionTraffic = {
  __typename?: 'RouteDetailsLegSectionTraffic';
  /** [BETA] Traffic congestion intervals mapped to the polyline indices of the leg's section. */
  congestions: Array<TrafficCongestionInterval>;
};

/** Type of a route details leg section. */
export const RouteDetailsLegSectionType = {
  DRIVING: 'driving',
  FERRY: 'ferry',
  WALKING: 'walking'
} as const;

export type RouteDetailsLegSectionType = typeof RouteDetailsLegSectionType[keyof typeof RouteDetailsLegSectionType];
export type RouteDetailsLegStation = {
  __typename?: 'RouteDetailsLegStation';
  /** ID of the connector that was selected in a route. */
  connector_id: Scalars['ID']['output'];
  /** ID of the EVSE that was selected in a route. */
  evse_id?: Maybe<Scalars['ID']['output']>;
  /** ID of a station. */
  station_id: Scalars['ID']['output'];
};

export type RouteDetailsLegTraffic = {
  __typename?: 'RouteDetailsLegTraffic';
  /** [BETA] Traffic congestion intervals mapped to the polyline indices of the leg. */
  congestions: Array<TrafficCongestionInterval>;
};

/** Type of a leg. */
export const RouteDetailsLegType = {
  /** This leg ends at the destination, and is the last leg of the route. */
  FINAL: 'final',
  /** This leg ends at a charging station and the vehicle must recharge. */
  STATION: 'station',
  /** This leg ends at a scheduled charging station and the vehicle must recharge. */
  STATION_AMENITY: 'station_amenity',
  /** This leg ends at the destination which is a charging station, and is the last leg of the route. */
  STATION_FINAL: 'station_final',
  /** This leg ends at a via charging station and the vehicle must recharge. */
  STATION_VIA: 'station_via',
  /** This leg ends at a via location. */
  VIA: 'via'
} as const;

export type RouteDetailsLegType = typeof RouteDetailsLegType[keyof typeof RouteDetailsLegType];
export type RouteDetailsLegWarning = {
  __typename?: 'RouteDetailsLegWarning';
  /** The code of the warning. */
  code: RouteDetailsLegWarningCode;
};

/** Types of warnings that can be encountered in a route leg. */
export const RouteDetailsLegWarningCode = {
  /** The charging station at the destination does not have any connectors compatible with the selected vehicle. */
  DESTINATION_CHARGER_INCOMPATIBLE: 'destination_charger_incompatible',
  /** The charging station at the destination is restricted to heavy-duty trucks. */
  DESTINATION_STATION_TRUCK_ONLY: 'destination_station_truck_only',
  /** Requested final state of charge value is below the specified safe risk margin. Safe risk margin is used instead. */
  FINAL_SOC_BELOW_RISK_MARGIN: 'final_soc_below_risk_margin',
  /** Vehicle's load may exceed the maximum supported weight of the vehicle. */
  MAXIMUM_WEIGHT_EXCEEDED: 'maximum_weight_exceeded',
  /** The leg could not use stations from the preferred operator(s). */
  OPERATORS_PREFERRED_NOT_AVAILABLE: 'operators_preferred_not_available',
  /** Expected arrival state of charge for the leg is below the safety risk margin. */
  RISK_MARGIN_SOC_NOT_POSSIBLE: 'risk_margin_soc_not_possible',
  /** The leg includes sections requested to be avoided. */
  SEGMENT_UNAVOIDABLE: 'segment_unavoidable',
  /** The leg's charging station is closed at the estimated time of arrival. */
  STATION_CLOSED: 'station_closed',
  /** The leg's charging station is closing within 45 minutes of the estimated time of arrival. */
  STATION_CLOSING_SOON: 'station_closing_soon',
  /** The charging station used in the leg has limited opening hours. */
  STATION_LIMITED_OPEN_HOURS: 'station_limited_open_hours',
  /** The leg's charging station has unknown open hours. */
  STATION_UNKNOWN_OPEN_HOURS: 'station_unknown_open_hours',
  /** The specified stop duration at the via charging station is insufficient to start a charging session. */
  VIA_INSUFFICIENT_CHARGING_TIME: 'via_insufficient_charging_time',
  /** The via location cannot be reached by vehicle. */
  VIA_NOT_VEHICLE_ACCESSIBLE: 'via_not_vehicle_accessible',
  /** The selected via station does not have compatible connectors that meet the minimum power threshold. The route still includes this charging stop, but charging will be slower than requested. */
  VIA_STATION_BELOW_MINIMUM_POWER: 'via_station_below_minimum_power'
} as const;

export type RouteDetailsLegWarningCode = typeof RouteDetailsLegWarningCode[keyof typeof RouteDetailsLegWarningCode];
export type RouteDetailsManeuver = {
  __typename?: 'RouteDetailsManeuver';
  /** Distance, in meters, of a route instruction. */
  distance: Scalars['Float']['output'];
  /** Duration, in seconds, of a route instruction. */
  duration: Scalars['Int']['output'];
  /** Exit number on a roundabout. This field exists only on sign `USE_ROUNDABOUT` (6), otherwise this value is null. */
  exit_number?: Maybe<Scalars['Int']['output']>;
  /** Location of the maneuver. */
  location: RouteDetailsLegSectionFeaturePoint;
  /** Name of the street associated with the instruction. */
  name?: Maybe<Scalars['String']['output']>;
  /** Information about the points on a polyline. */
  points: RouteDetailsLegManeuverPoints;
  /** Aggregation of tags over the current maneuver. */
  tags: Array<RouteDetailsTag>;
  /** Curvature angle between the roundabout and the exit of the roundabout. This field exists only on sign USE_ROUNDABOUT (6), otherwise this value is `null`. */
  turn_angle?: Maybe<Scalars['Float']['output']>;
  /** Type of instruction. */
  type: RouteDetailsLegManeuverType;
};


export type RouteDetailsManeuverDistanceArgs = {
  unit?: InputMaybe<DistanceUnit>;
};

export type RouteDetailsPathSegment = {
  __typename?: 'RouteDetailsPathSegment';
  /** Average speed of a route path segment. This value is determined using legal maximum speed and, if provided, the user defined maximum speed. */
  average_speed: Scalars['Float']['output'];
  /** Consumption, in kilowatt hours, of a route path segment. For HEVs and PHEVs this field will return null. */
  consumption?: Maybe<Scalars['Float']['output']>;
  /** Distance of a route path segment. */
  distance: Scalars['Float']['output'];
  /** Duration, in seconds, of a route path segment. */
  duration: Scalars['Float']['output'];
  /** Elevation value of a route path segment. */
  elevation: Scalars['Float']['output'];
  /**
   * Maximum vehicle speed of a route path segment.
   * @deprecated Will be removed.
   */
  maximum_speed: Scalars['Float']['output'];
  /** State of charge, in kilowatt hours, of a route path segment. For HEVs and PHEVs this field will return null. */
  state_of_charge?: Maybe<Scalars['Float']['output']>;
};


export type RouteDetailsPathSegmentAverage_SpeedArgs = {
  unit?: InputMaybe<SpeedUnit>;
};


export type RouteDetailsPathSegmentDistanceArgs = {
  unit?: InputMaybe<DistanceUnit>;
};


export type RouteDetailsPathSegmentElevationArgs = {
  unit?: InputMaybe<DistanceUnit>;
};


export type RouteDetailsPathSegmentMaximum_SpeedArgs = {
  unit?: InputMaybe<SpeedUnit>;
};


export type RouteDetailsPathSegmentState_Of_ChargeArgs = {
  unit?: InputMaybe<StateOfChargeUnit>;
};

/** Money saving information. */
export type RouteDetailsSavings = {
  __typename?: 'RouteDetailsSavings';
  /** Average energy price with which the calculation was made. */
  average_energy_price: Scalars['Float']['output'];
  /** Average gas price with which the calculation was made. */
  average_gas_price: Scalars['Float']['output'];
  /** Money saved by a user driving this route with an electric vehicle. */
  money?: Maybe<Scalars['Float']['output']>;
};


/** Money saving information. */
export type RouteDetailsSavingsAverage_Energy_PriceArgs = {
  currency?: InputMaybe<Currency>;
};


/** Money saving information. */
export type RouteDetailsSavingsAverage_Gas_PriceArgs = {
  currency?: InputMaybe<Currency>;
};


/** Money saving information. */
export type RouteDetailsSavingsMoneyArgs = {
  currency?: InputMaybe<Currency>;
};

/** Tags of a route. */
export const RouteDetailsTag = {
  CROSSBORDER: 'crossborder',
  FERRY: 'ferry',
  HIGHWAY: 'highway',
  ROAD: 'road',
  TOLL: 'toll',
  WALKING: 'walking'
} as const;

export type RouteDetailsTag = typeof RouteDetailsTag[keyof typeof RouteDetailsTag];
export type RouteDetailsTraffic = {
  __typename?: 'RouteDetailsTraffic';
  /** [BETA] Traffic congestion intervals mapped to the polyline indices of the leg. */
  congestions: Array<Maybe<TrafficCongestionInterval>>;
  /** [BETA] Additional driving duration, in seconds, caused by traffic congestion compared to free-flow conditions. This value is already included in route total and driving durations. */
  delay: Scalars['Int']['output'];
};

export type RouteDrivingPreferences = {
  __typename?: 'RouteDrivingPreferences';
  /** [BETA] Maximum speed to consider when generating the route. In the segments where legal speed is lower than this value, the legal speed will be used instead. If provided in combination with 'style, this overrides the maximum speed implied by the selected 'style'. */
  maximum_speed?: Maybe<MaximumSpeed>;
  /** [BETA] Factor to adjust the route's calculated average speed. Accepts values between 0.80 and 1.20. 1.0 is neutral. Values below 1.0 reduce speed (e.g. 0.95 is -5%), values above increase it. If provided in combination with style, this overrides the speed factor implied by the selected 'style'. */
  speed_factor?: Maybe<Scalars['Float']['output']>;
  /** [BETA] Defines a driving style. If provided in combination with 'maximum_speed' or 'speed_factor', those values override the values defined by the selected 'style'. */
  style?: Maybe<RouteDrivingStyle>;
};

export type RouteDrivingPreferencesInput = {
  /** [BETA] Maximum speed to consider when generating the route. In the segments where legal speed is lower than this value, the legal speed will be used instead. If provided in combination with 'style, this overrides the maximum speed implied by the selected 'style'. */
  maximum_speed?: InputMaybe<MaximumSpeedInput>;
  /** [BETA] Factor to adjust the route's calculated average speed. Accepts values between 0.80 and 1.20. 1.0 is neutral. Values below 1.0 reduce speed (e.g. 0.95 is -5%), values above increase it. If provided in combination with style, this overrides the speed factor implied by the selected 'style'. */
  speed_factor?: InputMaybe<Scalars['Float']['input']>;
  /** [BETA] Defines a driving style. If provided in combination with 'maximum_speed' or 'speed_factor', those values override the values defined by the selected 'style'. */
  style?: InputMaybe<RouteDrivingStyle>;
};

export const RouteDrivingStyle = {
  /** Lower average driving speed and lower energy consumption. Applies a speed limit of 110 km/h to all segments where a higher legal limit is allowed and reduces by 5% the route's average driving speed. */
  ECO: 'eco',
  /** Higher average driving speed and higher energy consumption. Applies no speed limit and increases by 5% the route's average driving speed. */
  SPORT: 'sport'
} as const;

export type RouteDrivingStyle = typeof RouteDrivingStyle[keyof typeof RouteDrivingStyle];
export type RouteEmbeddedEmissions = {
  __typename?: 'RouteEmbeddedEmissions';
  /** Total distribution emissions. */
  distribution: Scalars['Float']['output'];
  /** Distribution land segment emissions. */
  land: RouteEmbeddedLandEmissions;
  /** Manufacturing emissions. */
  manufacturing: RouteEmbeddedManufacturingEmissions;
  /** Distribution sea segment emissions. */
  maritime: RouteEmbeddedMaritimeEmissions;
  /** Total embedded emissions. */
  total: Scalars['Float']['output'];
};


export type RouteEmbeddedEmissionsDistributionArgs = {
  unit?: InputMaybe<EmissionUnit>;
};


export type RouteEmbeddedEmissionsTotalArgs = {
  unit?: InputMaybe<EmissionUnit>;
};

export type RouteEmbeddedLandEmissions = {
  __typename?: 'RouteEmbeddedLandEmissions';
  /** Distribution land segment emissions from fuel consumption. */
  fuel: Scalars['Float']['output'];
  /** Distribution land segment lifecycle emissions. */
  lifecycle: Scalars['Float']['output'];
  /** Total embedded land segment emissions. */
  total: Scalars['Float']['output'];
};


export type RouteEmbeddedLandEmissionsFuelArgs = {
  unit?: InputMaybe<EmissionUnit>;
};


export type RouteEmbeddedLandEmissionsLifecycleArgs = {
  unit?: InputMaybe<EmissionUnit>;
};


export type RouteEmbeddedLandEmissionsTotalArgs = {
  unit?: InputMaybe<EmissionUnit>;
};

export type RouteEmbeddedManufacturingEmissions = {
  __typename?: 'RouteEmbeddedManufacturingEmissions';
  /** Lithium ion battery manufacturing emissions. */
  battery?: Maybe<Scalars['Float']['output']>;
  /** Vehicle body manufacturing emissions. */
  body: Scalars['Float']['output'];
  /** Total embedded manufacturing emissions. */
  total: Scalars['Float']['output'];
};


export type RouteEmbeddedManufacturingEmissionsBatteryArgs = {
  unit?: InputMaybe<EmissionUnit>;
};


export type RouteEmbeddedManufacturingEmissionsBodyArgs = {
  unit?: InputMaybe<EmissionUnit>;
};


export type RouteEmbeddedManufacturingEmissionsTotalArgs = {
  unit?: InputMaybe<EmissionUnit>;
};

export type RouteEmbeddedMaritimeEmissions = {
  __typename?: 'RouteEmbeddedMaritimeEmissions';
  /** Fuel related maritime segment emissions. */
  fuel: Scalars['Float']['output'];
  /** Idling related maritime segment emissions. */
  idle: Scalars['Float']['output'];
  /** Distributed lifecycle related maritime segment emissions. */
  lifecycle: Scalars['Float']['output'];
  /** Port facility related maritime segment emissions. */
  port: Scalars['Float']['output'];
  /** Total embedded maritime emissions. */
  total: Scalars['Float']['output'];
};


export type RouteEmbeddedMaritimeEmissionsFuelArgs = {
  unit?: InputMaybe<EmissionUnit>;
};


export type RouteEmbeddedMaritimeEmissionsIdleArgs = {
  unit?: InputMaybe<EmissionUnit>;
};


export type RouteEmbeddedMaritimeEmissionsLifecycleArgs = {
  unit?: InputMaybe<EmissionUnit>;
};


export type RouteEmbeddedMaritimeEmissionsPortArgs = {
  unit?: InputMaybe<EmissionUnit>;
};


export type RouteEmbeddedMaritimeEmissionsTotalArgs = {
  unit?: InputMaybe<EmissionUnit>;
};

export type RouteEmissions = {
  __typename?: 'RouteEmissions';
  /** Emissions profile for an equivalent internal combustion engine vehicle. */
  internal_combustion_vehicle: RouteInternalCombustionVehicleEmissions;
  /** ID of the route alternative for which we retrieve the emissions profile. */
  route_alternative_id: Scalars['ID']['output'];
  /** ID of the route for which we retrieve the emissions profile. */
  route_id: Scalars['ID']['output'];
  /** Emissions profile for the vehicle used in route. */
  route_vehicle: RouteVehicleEmissions;
};


export type RouteEmissionsInternal_Combustion_VehicleArgs = {
  fuel_type?: InputMaybe<RouteOperationalFuelType>;
};

export type RouteEndOfLifeEmissions = {
  __typename?: 'RouteEndOfLifeEmissions';
  /** Battery related end of life emissions. */
  battery: Scalars['Float']['output'];
  /** Body end of life emissions. */
  body: Scalars['Float']['output'];
  /** Fluid related end of life emissions. */
  fluids: FluidEndOfLifeEmissions;
  /** Tire related end of life emissions. */
  tires: Scalars['Float']['output'];
  /** Total end of life emissions. */
  total: Scalars['Float']['output'];
  /** Transport end of life emissions. */
  transport: Scalars['Float']['output'];
};


export type RouteEndOfLifeEmissionsBatteryArgs = {
  unit?: InputMaybe<EmissionUnit>;
};


export type RouteEndOfLifeEmissionsBodyArgs = {
  unit?: InputMaybe<EmissionUnit>;
};


export type RouteEndOfLifeEmissionsTiresArgs = {
  unit?: InputMaybe<EmissionUnit>;
};


export type RouteEndOfLifeEmissionsTotalArgs = {
  unit?: InputMaybe<EmissionUnit>;
};


export type RouteEndOfLifeEmissionsTransportArgs = {
  unit?: InputMaybe<EmissionUnit>;
};

export type RouteInstruction = {
  __typename?: 'RouteInstruction';
  /** Distance, in meters, of the current route instruction. */
  distance?: Maybe<Scalars['Int']['output']>;
  /** Exit number on a roundabout. This field exists only on sign `USE_ROUNDABOUT` (6), otherwise is null. */
  exit_number?: Maybe<Scalars['Int']['output']>;
  /** Name of the street on which the instruction is. */
  name?: Maybe<Scalars['String']['output']>;
  /** Information about the points on the polyline. */
  points?: Maybe<RouteInstructionPoints>;
  /** Sign of the instruction. See `RouteInstructionSign`. */
  sign?: Maybe<RouteInstructionSign>;
  /** Duration, in seconds, of the current route instruction. */
  time?: Maybe<Scalars['Int']['output']>;
  /** Curvature angle between the roundabout and street you exit the roundabout. This field exists only on sign USE_ROUNDABOUT (6), otherwise is null. */
  turn_angle?: Maybe<Scalars['Float']['output']>;
};

export type RouteInstructionPoints = {
  __typename?: 'RouteInstructionPoints';
  /** The interval of points that are included in this instruction, an array with 2 values, where the first value is the index of the polyline where the interval starts. The second value is where it ends. */
  interval?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Number of polyline points which are included in this instruction. */
  size?: Maybe<Scalars['Int']['output']>;
};

/** Sign belonging to the instruction indicating the main maneuver. */
export const RouteInstructionSign = {
  CONTINUE_ON_STREET: 'CONTINUE_ON_STREET',
  FINISH: 'FINISH',
  IGNORE: 'IGNORE',
  KEEP_LEFT: 'KEEP_LEFT',
  KEEP_RIGHT: 'KEEP_RIGHT',
  LEAVE_ROUNDABOUT: 'LEAVE_ROUNDABOUT',
  PT_END_TRIP: 'PT_END_TRIP',
  PT_START_TRIP: 'PT_START_TRIP',
  PT_TRANSFER: 'PT_TRANSFER',
  REACHED_CHARGING_STATION: 'REACHED_CHARGING_STATION',
  REACHED_VIA: 'REACHED_VIA',
  TURN_LEFT: 'TURN_LEFT',
  TURN_RIGHT: 'TURN_RIGHT',
  TURN_SHARP_LEFT: 'TURN_SHARP_LEFT',
  TURN_SHARP_RIGHT: 'TURN_SHARP_RIGHT',
  TURN_SLIGHT_LEFT: 'TURN_SLIGHT_LEFT',
  TURN_SLIGHT_RIGHT: 'TURN_SLIGHT_RIGHT',
  UNKNOWN: 'UNKNOWN',
  USE_ROUNDABOUT: 'USE_ROUNDABOUT',
  U_TURN_LEFT: 'U_TURN_LEFT',
  U_TURN_RIGHT: 'U_TURN_RIGHT',
  U_TURN_UNKNOWN: 'U_TURN_UNKNOWN'
} as const;

export type RouteInstructionSign = typeof RouteInstructionSign[keyof typeof RouteInstructionSign];
export type RouteInternalCombustionVehicleEmissions = {
  __typename?: 'RouteInternalCombustionVehicleEmissions';
  /** Embedded emissions, for example emissions produced during manufacturing, transportation, and delivery. */
  embedded: RouteEmbeddedEmissions;
  /** End of life emissions. */
  end_of_life: RouteEndOfLifeEmissions;
  /** Total co2e emissions from vehicle operational processes calculated using the methodology in section 5.2.2 of ISO 14083:2023 and default emissions intensities in Annex K of the same document. */
  iso_14083_2023: Scalars['Float']['output'];
  /** Emissions info for the legs in the same order as in the route. */
  legs: Array<RouteInternalCombustionVehicleLegEmissions>;
  /** Operational emissions. */
  operational: RouteInternalCombustionVehicleOperationalEmissions;
  /** Total co2e emissions. */
  total: Scalars['Float']['output'];
};


export type RouteInternalCombustionVehicleEmissionsIso_14083_2023Args = {
  unit?: InputMaybe<EmissionUnit>;
};


export type RouteInternalCombustionVehicleEmissionsTotalArgs = {
  unit?: InputMaybe<EmissionUnit>;
};

export type RouteInternalCombustionVehicleLegEmissions = {
  __typename?: 'RouteInternalCombustionVehicleLegEmissions';
  /** Embedded emissions, for example emissions produced during manufacturing, transportation, and delivery. */
  embedded: RouteEmbeddedEmissions;
  /** End of life emissions. */
  end_of_life: RouteEndOfLifeEmissions;
  /** Total co2e emissions from vehicle operational processes calculated using the methodology in section 5.2.2 of ISO 14083:2023 and default emissions intensities in Annex K of the same document. */
  iso_14083_2023: Scalars['Float']['output'];
  /** Operational emissions. */
  operational: RouteInternalCombustionVehicleOperationalEmissions;
  /** Total co2e emissions. */
  total: Scalars['Float']['output'];
};


export type RouteInternalCombustionVehicleLegEmissionsIso_14083_2023Args = {
  unit?: InputMaybe<EmissionUnit>;
};


export type RouteInternalCombustionVehicleLegEmissionsTotalArgs = {
  unit?: InputMaybe<EmissionUnit>;
};

export type RouteInternalCombustionVehicleOperationalEmissions = {
  __typename?: 'RouteInternalCombustionVehicleOperationalEmissions';
  /** Fuel emissions. */
  fuel: RouteOperationalFuelEmissions;
  /** Road infrastructure emissions. */
  infrastructure: RouteOperationalInfrastructureEmissions;
  /** Maintenance emissions. */
  maintenance: RouteOperationalMaintenanceEmissions;
  /** Total operational emissions. */
  total: Scalars['Float']['output'];
};


export type RouteInternalCombustionVehicleOperationalEmissionsTotalArgs = {
  unit?: InputMaybe<EmissionUnit>;
};

export type RouteLeg = {
  __typename?: 'RouteLeg';
  /** Cargo weight in a vehicle for the duration of a leg, in kg. */
  cargo?: Maybe<Scalars['Float']['output']>;
  /** Total time required to charge a battery until 80%, in seconds. */
  chargeTime?: Maybe<Scalars['Int']['output']>;
  /** Recommended connector for charging. */
  connector?: Maybe<Connector>;
  /** Total energy used in a leg in kWh. */
  consumption?: Maybe<Scalars['Float']['output']>;
  /** Destination point location. */
  destination?: Maybe<FeaturePoint>;
  /** Distance from the start to the end of a leg, in meters. */
  distance?: Maybe<Scalars['Int']['output']>;
  /** Total drive time from the start to the end of a leg, in seconds. */
  duration?: Maybe<Scalars['Int']['output']>;
  /** Recommended EVSE where to charge. */
  evse?: Maybe<Evse>;
  /** ID of a leg. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Name of a destination. This is the station name in case a user should charge or the name of the location in case this was provided. */
  name?: Maybe<Scalars['String']['output']>;
  /** Number of occupants in a vehicle for the duration of a leg. */
  occupants?: Maybe<Scalars['Int']['output']>;
  /** ID of an operator. */
  operatorId?: Maybe<Scalars['String']['output']>;
  /** Name of an operator. */
  operatorName?: Maybe<Scalars['String']['output']>;
  /** Ranking of an operator. */
  operatorRanking?: Maybe<Scalars['Int']['output']>;
  /** Origin point location. */
  origin?: Maybe<FeaturePoint>;
  /** Number of compatible plugs available at a charge station. */
  plugsAvailable?: Maybe<Scalars['Int']['output']>;
  /** Total number of compatible plugs at a charge station. */
  plugsCount?: Maybe<Scalars['Int']['output']>;
  /** Number of compatible plugs occupied at a charge station. */
  plugsOccupied?: Maybe<Scalars['Int']['output']>;
  /** Number of compatible plugs out of order at a charge station. */
  plugsOutOfOrder?: Maybe<Scalars['Int']['output']>;
  /** Number of compatible plugs unknown at a charge station. */
  plugsUnknown?: Maybe<Scalars['Int']['output']>;
  /** Polyline containing encoded coordinates. */
  polyline?: Maybe<Scalars['String']['output']>;
  /** Display value that indicates the range, in meters, available at the end of the leg. This range is calculated using the Chargetrip range, the conditions at the time of planning the route, weather scenario (current or seasonal) and the route input. Please note: In case of a non BEV where the range end is negative, the value will be 0. */
  rangeEnd?: Maybe<Scalars['Int']['output']>;
  /** Total energy left in a battery at the end of a leg, in kWh. In the case of a non BEV where the range end is negative, the value will be 0. */
  rangeEndKwh?: Maybe<Scalars['Float']['output']>;
  /** Remaining range, energy in percentage, at the end of a trip. */
  rangeEndPercentage?: Maybe<Scalars['Int']['output']>;
  /** Display value that indicates the range, in meters, available at the beginning of the leg. This range is calculated using the Chargetrip range, the conditions at the time of planning the route, weather scenario (current or seasonal) and the route input. */
  rangeStart?: Maybe<Scalars['Int']['output']>;
  /** Total energy in a battery at the beginning of a leg, in kWh. */
  rangeStartKwh?: Maybe<Scalars['Float']['output']>;
  /** Total energy in a battery at the beginning of a trip, in percentage. */
  rangeStartPercentage?: Maybe<Scalars['Int']['output']>;
  /** ID of a station. */
  stationId?: Maybe<Scalars['String']['output']>;
  /** Steps of a leg. */
  steps?: Maybe<Array<Maybe<RouteStep>>>;
  /** Tags of a leg. Values: road, highway, toll, ferry. */
  tags?: Maybe<Array<Maybe<RouteTagType>>>;
  /** Type of a leg. */
  type?: Maybe<LegType>;
};


export type RouteLegPolylineArgs = {
  decimals?: InputMaybe<Scalars['Int']['input']>;
};

export type RouteLegMeta = {
  __typename?: 'RouteLegMeta';
  /** Warnings that certain conditions specified in a route mutation are not respected. */
  warnings: Array<RouteMetaWarning>;
};

export type RouteLegOperationalElectricityEmissions = {
  __typename?: 'RouteLegOperationalElectricityEmissions';
  /** Base emissions without efficiency losses. */
  base_value: Scalars['Float']['output'];
  /** Emissions for electricity lost in the battery. */
  battery_losses: Scalars['Float']['output'];
  /** Emissions for electricity lost during charging. */
  chargepoint_losses: Scalars['Float']['output'];
  /** Electricity efficiency information. */
  efficiency: RouteOperationalElectricityEmissionsEfficiency;
  /** Electricity intensity information. */
  intensity: RouteLegOperationalElectricityEmissionsIntensity;
  /** Total electricity emissions. */
  total: Scalars['Float']['output'];
  /** Emissions for electricity lost in transmission. */
  transmission_losses: Scalars['Float']['output'];
};


export type RouteLegOperationalElectricityEmissionsBase_ValueArgs = {
  unit?: InputMaybe<EmissionUnit>;
};


export type RouteLegOperationalElectricityEmissionsBattery_LossesArgs = {
  unit?: InputMaybe<EmissionUnit>;
};


export type RouteLegOperationalElectricityEmissionsChargepoint_LossesArgs = {
  unit?: InputMaybe<EmissionUnit>;
};


export type RouteLegOperationalElectricityEmissionsTotalArgs = {
  unit?: InputMaybe<EmissionUnit>;
};


export type RouteLegOperationalElectricityEmissionsTransmission_LossesArgs = {
  unit?: InputMaybe<EmissionUnit>;
};

/** Electricity emission intensity for a leg */
export type RouteLegOperationalElectricityEmissionsIntensity = {
  __typename?: 'RouteLegOperationalElectricityEmissionsIntensity';
  /** Estimated electricity demand at the time and place the electricity for this leg was obtained as a fraction of the annual average demand. */
  average_demand: Scalars['Float']['output'];
  /** Base regional electricity intensity used for the ISO 14083:2023 emissions estimation. */
  base_iso_14083_2023_regional_value: EmissionsFactor;
  /** Fraction of regional power generation that is not affected by demand (is assumed to always be on). */
  base_load_fraction: Scalars['Float']['output'];
  /** Base regional electricity emissions intensity for the leg. */
  base_regional_value: EmissionsFactor;
  /** Climate for which the leg was calculated. */
  climate: RouteOperationalElectricityClimate;
  /** Model used to estimate the electricity mix. */
  energy_source_model: RouteOperationalElectricityEnergySourceModel;
  /** Electricity mix for the leg. */
  energy_sources: RouteOperationalElectricityEnergySources;
  /** Average emissions intensity of processing and transport of primary energy, power generation infrastructure, etc. in unit CO2e/kWh. */
  infrastructure: Scalars['Float']['output'];
  /** Season for which the leg was calculated. */
  season: RouteOperationalElectricitySeason;
  /** Total average electricity emissions intensity in unit CO2e/kWh. */
  total: Scalars['Float']['output'];
};


/** Electricity emission intensity for a leg */
export type RouteLegOperationalElectricityEmissionsIntensityInfrastructureArgs = {
  unit?: InputMaybe<EmissionUnit>;
};


/** Electricity emission intensity for a leg */
export type RouteLegOperationalElectricityEmissionsIntensityTotalArgs = {
  unit?: InputMaybe<EmissionUnit>;
};

export type RouteMeta = {
  __typename?: 'RouteMeta';
  /** Warnings that certain conditions specified in a route mutation are not respected. */
  warnings: Array<RouteMetaWarning>;
};

export type RouteMetaWarning = {
  __typename?: 'RouteMetaWarning';
  /** Static identifier, can be used for production purposes such as i18n. */
  code: Scalars['String']['output'];
  /** Optional JSON object containing data explaining the warning, for development purposes. */
  data?: Maybe<Scalars['JSON']['output']>;
  /** Human readable explanation of the warning, for development purposes. */
  message: Scalars['String']['output'];
};

export type RouteMetadata = {
  __typename?: 'RouteMetadata';
  /** Refers to the x-app-id specified in the headers. */
  app_id: Scalars['ID']['output'];
  /** Length of time required to successfully calculate a route, in milliseconds. */
  computation_time?: Maybe<Scalars['Int']['output']>;
  /** Date when a route was created by a createRoute mutation. */
  created_at: Scalars['DateTime']['output'];
  /** Last updated date of a route. */
  updated_at: Scalars['DateTime']['output'];
};

/** Köppen climate classification. */
export const RouteOperationalElectricityClimate = {
  /** Tropical rain forest climate. */
  AF: 'Af',
  /** Tropical monsoon climate. */
  AM: 'Am',
  /** Tropical savanna climate, dry winter. */
  AS: 'As',
  /** Tropical savanna climate, dry summer. */
  AW: 'Aw',
  /** Hot semi-arid climate. */
  BSH: 'BSh',
  /** Cold semi-arid climate. */
  BSK: 'BSk',
  /** Hot desert climate. */
  BWH: 'BWh',
  /** Cold desert climate. */
  BWK: 'BWk',
  /** Humid subtropical climate. */
  CFA: 'Cfa',
  /** Temperate oceanic climate. */
  CFB: 'Cfb',
  /** Sub polar oceanic climate. */
  CFC: 'Cfc',
  /** Hot-summer Mediterranean climate. */
  CSA: 'Csa',
  /** Warm-summer Mediterranean climate. */
  CSB: 'Csb',
  /** Cold-summer Mediterranean climate. */
  CSC: 'Csc',
  /** Monsoon-influenced humid subtropical climate. */
  CWA: 'Cwa',
  /** Subtropical highland climate. */
  CWB: 'Cwb',
  /** Cold subtropical highland climate. */
  CWC: 'Cwc',
  /** Hot-summer humid continental climate. */
  DFA: 'Dfa',
  /** Warm-summer humid continental climate. */
  DFB: 'Dfb',
  /** Subarctic climate. */
  DFC: 'Dfc',
  /** Extremely cold subarctic climate. */
  DFD: 'Dfd',
  /** Mediterranean-influenced hot-summer humid continental climate. */
  DSA: 'Dsa',
  /** Mediterranean-influenced warm-summer humid continental climate. */
  DSB: 'Dsb',
  /** Mediterranean-influenced subarctic climate. */
  DSC: 'Dsc',
  /** Mediterranean-influenced extremely cold subarctic climate. */
  DSD: 'Dsd',
  /** Monsoon-influenced hot-summer humid continental climate. */
  DWA: 'Dwa',
  /** Monsoon-influenced warm-summer humid continental climate. */
  DWB: 'Dwb',
  /** Monsoon-influenced subarctic climate. */
  DWC: 'Dwc',
  /** Monsoon-influenced extremely cold subarctic climate. */
  DWD: 'Dwd',
  /** Ice cap climate. */
  EF: 'EF',
  /** Tundra climate. */
  ET: 'ET'
} as const;

export type RouteOperationalElectricityClimate = typeof RouteOperationalElectricityClimate[keyof typeof RouteOperationalElectricityClimate];
export type RouteOperationalElectricityEmissions = {
  __typename?: 'RouteOperationalElectricityEmissions';
  /** Base emissions without efficiency losses. */
  base_value: Scalars['Float']['output'];
  /** Emissions for electricity lost in the battery. */
  battery_losses: Scalars['Float']['output'];
  /** Emissions for electricity lost during charging. */
  chargepoint_losses: Scalars['Float']['output'];
  /** Electricity efficiency information. */
  efficiency: RouteOperationalElectricityEmissionsEfficiency;
  /** Electricity intensity information. */
  intensity: RouteOperationalElectricityEmissionsIntensity;
  /** Total electricity emissions. */
  total: Scalars['Float']['output'];
  /** Emissions for electricity lost in transmission. */
  transmission_losses: Scalars['Float']['output'];
};


export type RouteOperationalElectricityEmissionsBase_ValueArgs = {
  unit?: InputMaybe<EmissionUnit>;
};


export type RouteOperationalElectricityEmissionsBattery_LossesArgs = {
  unit?: InputMaybe<EmissionUnit>;
};


export type RouteOperationalElectricityEmissionsChargepoint_LossesArgs = {
  unit?: InputMaybe<EmissionUnit>;
};


export type RouteOperationalElectricityEmissionsTotalArgs = {
  unit?: InputMaybe<EmissionUnit>;
};


export type RouteOperationalElectricityEmissionsTransmission_LossesArgs = {
  unit?: InputMaybe<EmissionUnit>;
};

export type RouteOperationalElectricityEmissionsEfficiency = {
  __typename?: 'RouteOperationalElectricityEmissionsEfficiency';
  /** Average charging current in amperes. */
  average_charging_current: Scalars['Float']['output'];
  /** Average charging voltage in volts. */
  average_charging_voltage: Scalars['Float']['output'];
  /** Average regional temperature. */
  average_regional_temperature: Scalars['Float']['output'];
  /** Average outside temperature. */
  average_temperature: Scalars['Float']['output'];
  /** Average base regional grid transmission efficiency. */
  base_transmission: Scalars['Float']['output'];
  /** Average efficiency of the battery. */
  battery: Scalars['Float']['output'];
  /** Average circuit breaker efficiency of the chargepoint. */
  breaker: Scalars['Float']['output'];
  /** Average efficiency of the chargepoint. */
  chargepoint: Scalars['Float']['output'];
  /** Change in chargepoint efficiency due to temperature. */
  chargepoint_temperature_modifier: Scalars['Float']['output'];
  /** Average evse (electric vehicle supply equipment) efficiency of the chargepoint. */
  evse: Scalars['Float']['output'];
  /** Average power electronics unit efficiency of the chargepoint. */
  power_electronics_unit: Scalars['Float']['output'];
  /** Average total electricity efficiency. */
  total: Scalars['Float']['output'];
  /** Average transformer efficiency of the chargepoint. */
  transformer: Scalars['Float']['output'];
  /** Average estimated transmission efficiency using the base transmission efficiency adjusting for temperature. */
  transmission: Scalars['Float']['output'];
  /** Average transmission efficiency change due to temperature. */
  transmission_temperature_modifier: Scalars['Float']['output'];
};


export type RouteOperationalElectricityEmissionsEfficiencyAverage_Regional_TemperatureArgs = {
  unit?: InputMaybe<TemperatureUnit>;
};


export type RouteOperationalElectricityEmissionsEfficiencyAverage_TemperatureArgs = {
  unit?: InputMaybe<TemperatureUnit>;
};

/** Electricity emission intensity for the route */
export type RouteOperationalElectricityEmissionsIntensity = {
  __typename?: 'RouteOperationalElectricityEmissionsIntensity';
  /** Average base regional electricity emissions intensity in unit CO2e/kWh. */
  average_base_regional_value: Scalars['Float']['output'];
  /** Average electricity demand at the time of route charges as a fraction of the annual average demand. */
  average_demand: Scalars['Float']['output'];
  /** Fraction of regional power generation that is not affected by demand (is assumed to always be on). */
  base_load_fraction: Scalars['Float']['output'];
  /** Average electricity mix for the route. */
  energy_sources: RouteOperationalElectricityEnergySources;
  /** Average emissions intensity of processing and transport of primary energy, power generation infrastructure, etc. in unit CO2e/kWh. */
  infrastructure: Scalars['Float']['output'];
  /** Total electricity intensity used for iso 14083:2023 scope emissions estimate in unit CO2e/kWh. */
  iso_14083_2023: Scalars['Float']['output'];
  /** Total average electricity emissions intensity in unit CO2e/kWh. */
  total: Scalars['Float']['output'];
};


/** Electricity emission intensity for the route */
export type RouteOperationalElectricityEmissionsIntensityAverage_Base_Regional_ValueArgs = {
  unit?: InputMaybe<EmissionUnit>;
};


/** Electricity emission intensity for the route */
export type RouteOperationalElectricityEmissionsIntensityInfrastructureArgs = {
  unit?: InputMaybe<EmissionUnit>;
};


/** Electricity emission intensity for the route */
export type RouteOperationalElectricityEmissionsIntensityIso_14083_2023Args = {
  unit?: InputMaybe<EmissionUnit>;
};


/** Electricity emission intensity for the route */
export type RouteOperationalElectricityEmissionsIntensityTotalArgs = {
  unit?: InputMaybe<EmissionUnit>;
};

/** Energy source models. */
export const RouteOperationalElectricityEnergySourceModel = {
  /** Estimate using the seasonal average electricity demand for the hour and climate. */
  CLIMATE_DEMAND_BASED_HOURLY_AVERAGE: 'climate_demand_based_hourly_average',
  /** Estimate using the seasonal average electricity demand for the climate. */
  CLIMATE_DEMAND_BASED_SEASONAL_AVERAGE: 'climate_demand_based_seasonal_average',
  /** Regional default energy mix. */
  DEFAULT: 'default',
  /** Estimate using historical average electricity demand for the month and hour. */
  GRID_DEMAND_BASED_HOURLY_AVERAGE: 'grid_demand_based_hourly_average',
  /** Estimate using historical average electricity demand for the month. */
  GRID_DEMAND_BASED_MONTHLY_AVERAGE: 'grid_demand_based_monthly_average',
  /** Historical average energy mix for the month and hour. */
  GRID_HOURLY_AVERAGE: 'grid_hourly_average',
  /** Historical average energy mix for the month. */
  GRID_MONTHLY_AVERAGE: 'grid_monthly_average',
  /** The current energy mix of the charging station provided by the CPO was used. */
  OCPI_STATION_ENERGY_MIX: 'ocpi_station_energy_mix'
} as const;

export type RouteOperationalElectricityEnergySourceModel = typeof RouteOperationalElectricityEnergySourceModel[keyof typeof RouteOperationalElectricityEnergySourceModel];
export type RouteOperationalElectricityEnergySources = {
  __typename?: 'RouteOperationalElectricityEnergySources';
  /** Electricity produced by biofuel/biomass. */
  biofuel: ElectricityGenerationMethod;
  /** Electricity produced by coal power plants. */
  coal: ElectricityGenerationMethod;
  /** Electricity produced by natural gas power plants. */
  gas: ElectricityGenerationMethod;
  /** Electricity produced by geothermal power plants. */
  geothermal: ElectricityGenerationMethod;
  /** Electricity produced by hydroelectric power. */
  hydro: ElectricityGenerationMethod;
  /** Electricity produced by nuclear power plants. */
  nuclear: ElectricityGenerationMethod;
  /** Electricity produced by oil and other miscellaneous fossil fuel power plants. */
  oil: ElectricityGenerationMethod;
  /** Electricity produced by other means. */
  other: ElectricityGenerationMethod;
  /** Electricity produced by solar power. */
  solar: ElectricityGenerationMethod;
  /** Electricity produced by wind power. */
  wind: ElectricityGenerationMethod;
};

/** Yearly seasons. */
export const RouteOperationalElectricitySeason = {
  /** Fall season. */
  FALL: 'fall',
  /** Spring season. */
  SPRING: 'spring',
  /** Summer season. */
  SUMMER: 'summer',
  /** Winter season. */
  WINTER: 'winter'
} as const;

export type RouteOperationalElectricitySeason = typeof RouteOperationalElectricitySeason[keyof typeof RouteOperationalElectricitySeason];
export type RouteOperationalFuelEmissions = {
  __typename?: 'RouteOperationalFuelEmissions';
  /** Average speed of the vehicle. */
  average_speed: Scalars['Float']['output'];
  /** Average base powertrain efficiency. */
  base_powertrain_efficiency: Scalars['Float']['output'];
  /** Total fuel consumption for the route. */
  consumption: Scalars['Float']['output'];
  /** Direct (tank to wheels) fuel emissions for the route. */
  direct: Scalars['Float']['output'];
  /** Estimated internal combustion vehicle engine torque. */
  engine_torque: Scalars['Float']['output'];
  /** Indirect (well to tank) fuel emissions for the route. */
  indirect: Scalars['Float']['output'];
  /** Average powertrain efficiency. */
  powertrain_efficiency: Scalars['Float']['output'];
  /** Speed related change in powertrain efficiency from the base. */
  powertrain_efficiency_speed_modifier: Scalars['Float']['output'];
  /** Total fuel emissions for the route. */
  total: Scalars['Float']['output'];
  /** Estimated internal combustion vehicle weight. */
  vehicle_weight: Scalars['Float']['output'];
};


export type RouteOperationalFuelEmissionsAverage_SpeedArgs = {
  unit?: InputMaybe<SpeedUnit>;
};


export type RouteOperationalFuelEmissionsConsumptionArgs = {
  unit?: InputMaybe<FuelUnit>;
};


export type RouteOperationalFuelEmissionsDirectArgs = {
  unit?: InputMaybe<EmissionUnit>;
};


export type RouteOperationalFuelEmissionsEngine_TorqueArgs = {
  unit?: InputMaybe<TorqueUnit>;
};


export type RouteOperationalFuelEmissionsIndirectArgs = {
  unit?: InputMaybe<EmissionUnit>;
};


export type RouteOperationalFuelEmissionsTotalArgs = {
  unit?: InputMaybe<EmissionUnit>;
};


export type RouteOperationalFuelEmissionsVehicle_WeightArgs = {
  unit?: InputMaybe<WeightUnit>;
};

/** Fuel types. */
export const RouteOperationalFuelType = {
  /** Diesel fuel. */
  DIESEL: 'diesel',
  /** Gasoline fuel. */
  GASOLINE: 'gasoline'
} as const;

export type RouteOperationalFuelType = typeof RouteOperationalFuelType[keyof typeof RouteOperationalFuelType];
export type RouteOperationalInfrastructureEmissions = {
  __typename?: 'RouteOperationalInfrastructureEmissions';
  /** Embedded (construction, decommissioning, etc) road infrastructure emissions. */
  embedded: Scalars['Float']['output'];
  /** Induced road infrastructure maintenance emissions. */
  maintenance: Scalars['Float']['output'];
  /** Total road infrastructure emissions. */
  total: Scalars['Float']['output'];
};


export type RouteOperationalInfrastructureEmissionsEmbeddedArgs = {
  unit?: InputMaybe<EmissionUnit>;
};


export type RouteOperationalInfrastructureEmissionsMaintenanceArgs = {
  unit?: InputMaybe<EmissionUnit>;
};


export type RouteOperationalInfrastructureEmissionsTotalArgs = {
  unit?: InputMaybe<EmissionUnit>;
};

export type RouteOperationalMaintenanceEmissions = {
  __typename?: 'RouteOperationalMaintenanceEmissions';
  /** Battery related maintenance emissions. */
  battery: RouteOperationalMaintenanceEmissionsField;
  /** Miscellaneous component maintenance emissions. */
  components: RouteOperationalMaintenanceEmissionsField;
  /** Fluid related maintenance emissions. */
  fluids: FluidMaintenanceEmissions;
  /** Accident repair related maintenance emissions. */
  repair: RouteOperationalMaintenanceEmissionsField;
  /** Tire related maintenance emissions. */
  tires: RouteOperationalMaintenanceEmissionsField;
  /** Total maintenance emissions. */
  total: RouteOperationalMaintenanceEmissionsField;
};

export type RouteOperationalMaintenanceEmissionsField = {
  __typename?: 'RouteOperationalMaintenanceEmissionsField';
  /** Emissions from disposal. */
  disposal: Scalars['Float']['output'];
  /** Emissions from replacement production and transport. */
  production: Scalars['Float']['output'];
  /** Total emissions. */
  total: Scalars['Float']['output'];
};


export type RouteOperationalMaintenanceEmissionsFieldDisposalArgs = {
  unit?: InputMaybe<EmissionUnit>;
};


export type RouteOperationalMaintenanceEmissionsFieldProductionArgs = {
  unit?: InputMaybe<EmissionUnit>;
};


export type RouteOperationalMaintenanceEmissionsFieldTotalArgs = {
  unit?: InputMaybe<EmissionUnit>;
};

export type RouteOperatorPreferences = {
  __typename?: 'RouteOperatorPreferences';
  /** Operators that should be avoided, but not excluded, for a route calculation. */
  avoid?: Maybe<Array<RouteOperatorsValue>>;
  /** Operators that should be excluded for a route calculation. */
  exclude?: Maybe<Array<RouteOperatorsValue>>;
  /** Ranking of an operator with multiple levels, each level having its own penalty value. */
  ranking?: Maybe<RouteOperatorPreferencesRanking>;
};

/** Prioritized operators for a route calculation. */
export type RouteOperatorPreferencesInput = {
  /** Operators that should be avoided, but not excluded, for a route calculation. */
  avoid?: InputMaybe<Array<RouteOperatorsValueInput>>;
  /** Operators to be excluded from route calculation. If specified, overrides project-configured operator exclusions. If not specified, applies project-configured operator exclusions. */
  exclude?: InputMaybe<Array<RouteOperatorsValueInput>>;
  /** Operators to be preferred in route calculation. If not specified, no operator ranking is applied (including project-configured ranking). */
  ranking?: InputMaybe<RouteOperatorPreferencesRankingInput>;
};

export type RouteOperatorPreferencesRanking = {
  __typename?: 'RouteOperatorPreferencesRanking';
  /** Ranking levels for operator ranking. */
  levels?: Maybe<RouteOperatorPreferencesRankingLevels>;
  /** Flag indicating if an operator should be preferred or required. */
  type: RouteOperatorsType;
};

export type RouteOperatorPreferencesRankingInput = {
  /** Priority levels for operator ranking. If not specified, applies the specified enforcement type to the project-configured operator ranking. */
  levels?: InputMaybe<RouteOperatorPreferencesRankingLevelsInput>;
  /** Determines how operator preferences are applied to stations during route calculation. If no ranking is provided through 'levels' or project settings, no operator preference is applied. */
  type: RouteOperatorsType;
};

export type RouteOperatorPreferencesRankingLevels = {
  __typename?: 'RouteOperatorPreferencesRankingLevels';
  /** Most significant level for operator ranking. */
  high?: Maybe<Array<RouteOperatorsValue>>;
  /** Least significant level for operators ranking. */
  low?: Maybe<Array<RouteOperatorsValue>>;
  /** Medium level for operators ranking. */
  medium?: Maybe<Array<RouteOperatorsValue>>;
};

export type RouteOperatorPreferencesRankingLevelsInput = {
  /** Most significant level for operator ranking. */
  high?: InputMaybe<Array<RouteOperatorsValueInput>>;
  /** Least significant level for operator ranking. */
  low?: InputMaybe<Array<RouteOperatorsValueInput>>;
  /** Medium level for operator ranking. */
  medium?: InputMaybe<Array<RouteOperatorsValueInput>>;
};

/** Prioritized operators for a route calculation. */
export type RouteOperators = {
  __typename?: 'RouteOperators';
  /** Operator IDs which should be excluded from a route. */
  exclude?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  /** Ranking of an operator with multiple levels, each level having it's own penalty value. */
  ranking?: Maybe<RouteOperatorsRanking>;
  /** Flag indicating if the operators ranking should be preferred or required. */
  type?: Maybe<RouteOperatorsType>;
};

/** Prioritized operators for a route calculation. */
export type RouteOperatorsInput = {
  /** Operator IDs which should be excluded from a route. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Ranking of an operator with multiple levels, each level having it's own penalty value. */
  ranking?: InputMaybe<RouteOperatorsRankingInput>;
  /** Flag indicating if the operators ranking should be preferred or required. */
  type?: InputMaybe<RouteOperatorsType>;
};

/** Ranking configuration for prioritized operators. */
export type RouteOperatorsRanking = {
  __typename?: 'RouteOperatorsRanking';
  /** Level 1 (most significant) for operator ranking. */
  level1?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  /** Level 2 for operator ranking. */
  level2?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  /** Level 3 for operator ranking. */
  level3?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  /** Level 4 for operator ranking. */
  level4?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  /** Level 5 for operator ranking. */
  level5?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  /** Level 6 for operator ranking. */
  level6?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  /** Level 7 for operator ranking. */
  level7?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  /** Level 8 for operator ranking. */
  level8?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  /** Level 9 for operator ranking. */
  level9?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  /** Level 10 (least significant) for operator ranking. */
  level10?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
};

/** Ranking configuration for prioritized operators. */
export type RouteOperatorsRankingInput = {
  /** Level 1 (most significant) for operator ranking. */
  level1?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Level 2 for operator ranking. */
  level2?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Level 3 for operator ranking. */
  level3?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Level 4 for operator ranking. */
  level4?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Level 5 for operator ranking. */
  level5?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Level 6 for operator ranking. */
  level6?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Level 7 for operator ranking. */
  level7?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Level 8 for operator ranking. */
  level8?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Level 9 for operator ranking. */
  level9?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Level 10 (least significant) for operator ranking. */
  level10?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

/** Type of operator prioritization for a route. */
export const RouteOperatorsType = {
  /** Operators ranking will not be taken into account if no type is given. */
  NONE: 'none',
  /** Operators given in the operators ranking will be preferred when calculating routes. */
  PREFERRED: 'preferred',
  /** Operators given in the operators ranking will be required when calculating routes, all other operators will be ignored. */
  REQUIRED: 'required'
} as const;

export type RouteOperatorsType = typeof RouteOperatorsType[keyof typeof RouteOperatorsType];
export type RouteOperatorsValue = {
  __typename?: 'RouteOperatorsValue';
  /** List of countries in which the operator should be preferred/excluded. When omitted the operator will be preferred/excluded in every country. */
  countries?: Maybe<Array<CountryCodeAlpha2>>;
  /** ID of an operator. */
  id: Scalars['ID']['output'];
};

export type RouteOperatorsValueInput = {
  /** List of countries in which the operator should be preferred/excluded/avoided. When omitted the operator will be preferred/excluded in every country. */
  countries?: InputMaybe<Array<CountryCodeAlpha2>>;
  /** ID of an operator. */
  id: Scalars['ID']['input'];
};

export type RouteOriginFeaturePoint = {
  __typename?: 'RouteOriginFeaturePoint';
  /** Geometry of the feature. */
  geometry: Point;
  /** ID of the feature. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Optional object where additional properties can be specified. */
  properties?: Maybe<RouteOriginProperties>;
  /** Feature type. */
  type: FeatureType;
};

export type RouteOriginFeaturePointInput = {
  /** Geometry of the feature. */
  geometry: PointInput;
  /** ID of the feature. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Optional object where additional properties can be specified. */
  properties?: InputMaybe<RouteOriginPropertiesInput>;
  /** Feature type. */
  type: FeatureType;
};

export type RouteOriginProperties = {
  __typename?: 'RouteOriginProperties';
  /** Data about the origin location. */
  location?: Maybe<RoutePropertiesLocation>;
  /** Vehicle data at the origin location. */
  vehicle?: Maybe<RoutePropertiesVehicle>;
};

export type RouteOriginPropertiesInput = {
  /** Data about the origin location. */
  location?: InputMaybe<RoutePropertiesLocationInput>;
  /** Vehicle data at the origin location. */
  vehicle?: InputMaybe<RoutePropertiesVehicleInput>;
};

export type RoutePath = {
  __typename?: 'RoutePath';
  /** Average speed, in km/h, for this route path segment. */
  averageSpeed?: Maybe<Scalars['Float']['output']>;
  /** Consumption, in kWh, of a route path segment. */
  consumption?: Maybe<Scalars['Float']['output']>;
  /** Consumption, in kWh per km, of a route path segment. */
  consumptionPerKm?: Maybe<Scalars['Float']['output']>;
  /** Distance, in meters, of a route path segment. */
  distance?: Maybe<Scalars['Float']['output']>;
  /** Duration, in seconds, of a route path segment. */
  duration?: Maybe<Scalars['Float']['output']>;
  /** Elevation (altitude) in meters. */
  elevation?: Maybe<Scalars['Int']['output']>;
  /** GeoJSON location of a route path segment. */
  location?: Maybe<Point>;
  /** Recommended speed, in km/h for this route path segment to optimise the consumption. */
  recommendedSpeed?: Maybe<Scalars['Float']['output']>;
  /** State of charge, in kWh, of a route path segment. */
  stateOfCharge?: Maybe<Scalars['Float']['output']>;
};

export type RoutePropertiesLocation = {
  __typename?: 'RoutePropertiesLocation';
  /** Name that should overwrite the name that is automatically assigned to this location (for example: address or station name). */
  name?: Maybe<Scalars['String']['output']>;
};

export type RoutePropertiesLocationInput = {
  /** Name that should overwrite the name that is automatically assigned to this location (for example: address or station name). */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type RoutePropertiesStation = {
  __typename?: 'RoutePropertiesStation';
  /** External ID of the station. When provided and valid, the coordinates of this station will be used. */
  external_station_id?: Maybe<Scalars['ID']['output']>;
  /** ID of the station. When provided and valid, the coordinates of this station will be used. */
  station_id?: Maybe<Scalars['ID']['output']>;
  /** Duration to stay at the station, in seconds. */
  stop_duration?: Maybe<Scalars['Int']['output']>;
};

export type RoutePropertiesStationInput = {
  /** External ID of the station. When provided and valid, the coordinates of this station will be used. */
  external_station_id?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the station. When provided and valid, the coordinates of this station will be used. */
  station_id?: InputMaybe<Scalars['ID']['input']>;
  /** Duration to stay at the station, in seconds. */
  stop_duration?: InputMaybe<Scalars['Int']['input']>;
};

export type RoutePropertiesVehicle = {
  __typename?: 'RoutePropertiesVehicle';
  /** Number of occupants present in the vehicle. */
  occupants: Scalars['Int']['output'];
  /** Weight of the cargo. */
  total_cargo_weight?: Maybe<TotalCargoWeight>;
  /** Combined weight of the occupants. This can only be used in combination with occupants. */
  total_occupant_weight: TotalOccupantWeight;
};

export type RoutePropertiesVehicleInput = {
  /** Number of occupants present in the vehicle. */
  occupants?: InputMaybe<Scalars['Int']['input']>;
  /** Weight of the cargo. */
  total_cargo_weight?: InputMaybe<TotalCargoWeightInput>;
  /** Combined weight of the occupants. This can only be used in combination with occupants. */
  total_occupant_weight?: InputMaybe<TotalOccupantWeightInput>;
};

export type RoutePropertiesViaLocation = {
  __typename?: 'RoutePropertiesViaLocation';
  /** Name that should overwrite the name that is automatically assigned to this location (for example: address or station name). */
  name?: Maybe<Scalars['String']['output']>;
  /** Duration to stay at this point, in seconds. */
  stop_duration?: Maybe<Scalars['Int']['output']>;
};

export type RoutePropertiesViaLocationInput = {
  /** Name that should overwrite the name that is automatically assigned to this location (for example: address or station name). */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Duration to stay at this point, in seconds. */
  stop_duration?: InputMaybe<Scalars['Int']['input']>;
};

export type RouteResponse = {
  __typename?: 'RouteResponse';
  /** [BETA] Alternative routes. */
  alternatives?: Maybe<Array<RouteDetails>>;
  /** ID of a route calculation. */
  id: Scalars['ID']['output'];
  /** Meta data for a route. */
  meta: RouteMetadata;
  /** Recommended route. */
  recommended?: Maybe<RouteDetails>;
  /** Route request. */
  request_input: CreateRoute;
  /** Status of a route. */
  status: RouteStatus;
};

/** Scheduled charge stop along a route. */
export type RouteScheduledChargeStop = {
  __typename?: 'RouteScheduledChargeStop';
  /** Duration at the amenity, in seconds. */
  duration?: Maybe<Scalars['Int']['output']>;
  /** Maximum distance from a station to an amenity, in meters. */
  max_distance_from_station?: Maybe<Scalars['Int']['output']>;
  /** Maximum allowed offset from the stop_after value in seconds. Default is 1800. */
  offset?: Maybe<Scalars['Int']['output']>;
  /** Desired drive time before a scheduled stop after leaving the previous stop, in seconds. */
  stop_after?: Maybe<Scalars['Int']['output']>;
  /** List of amenity types. */
  types?: Maybe<Array<Maybe<AmenityType>>>;
};

/** The season of the route. */
export const RouteSeason = {
  /** We fetch the current weather conditions. */
  CURRENT: 'current',
  /** We suppose it is summer and we have the best weather conditions. */
  SUMMER: 'summer',
  /** We suppose it is winter and we have the worst weather conditions. */
  WINTER: 'winter'
} as const;

export type RouteSeason = typeof RouteSeason[keyof typeof RouteSeason];
export type RouteStationFilter = {
  /** Filters stations within this distance from the route path. The value must be between 0 and 10 000 meters. If not specified, defaults to 1 000 meters. */
  maximum_distance_from_path?: InputMaybe<DistanceInput>;
  /** Filters stations by operator preference types. This filter depends exclusively on the preferences used for the route calculation. If not specified, stations from all preference types (ranked, unranked, avoided, excluded) are returned. */
  operator_preference?: InputMaybe<Array<OperatorPreferenceType>>;
};

export type RouteStationOperator = {
  __typename?: 'RouteStationOperator';
  /** Unique operator ID. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Operator's preference status specifically for this route calculation. */
  preference_type: OperatorPreferenceType;
};

export type RouteStationPreferences = {
  __typename?: 'RouteStationPreferences';
  /** Prioritises charging stations located directly on the highway, avoiding exiting highways to charge. It's considered alongside final SOC and operator preferences, and may reduce their influence if they conflict. */
  prefer_highway_charging?: Maybe<Scalars['Boolean']['output']>;
};

export type RouteStationPreferencesInput = {
  /** Prioritises charging stations located directly on the highway, avoiding exiting highways to charge. It's considered alongside final SOC and operator preferences, and may reduce their influence if they conflict. This logic may require additional client-specific tuning. Please contact Chargetrip if the behavior seems suboptimal. */
  prefer_highway_charging?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RouteStationWithAmenities = {
  __typename?: 'RouteStationWithAmenities';
  /** Distance of the station to the closest point in the original route. */
  distance_from_path: Scalars['Float']['output'];
  /** ID of the station provided by the station data source. */
  external_id?: Maybe<Scalars['ID']['output']>;
  /** ID of the station. */
  id: Scalars['ID']['output'];
  /** GeoJSON location of the station. */
  location: Point;
  /** List of up to 5 amenities matching the specified amenity type. Sorted by ascending distance from the station. */
  matching_amenities: Array<Amenity>;
  /** Information about the station's operator. */
  operator: RouteStationOperator;
};


export type RouteStationWithAmenitiesDistance_From_PathArgs = {
  unit?: InputMaybe<DistanceUnit>;
};

export type RouteStationsAlong = {
  __typename?: 'RouteStationsAlong';
  /** Distance in meters between station and route path. */
  distance?: Maybe<Scalars['Int']['output']>;
  /** The ID of station. */
  id?: Maybe<Scalars['String']['output']>;
  /** Geojson location of a station. */
  location?: Maybe<Point>;
  /** The station uses a preferred operator. */
  preferredOperator?: Maybe<Scalars['Boolean']['output']>;
  /** Speed of a station. A station along a route can be either fast or turbo. */
  speed?: Maybe<StationSpeedType>;
  /** Status of a station. */
  status?: Maybe<ChargerStatus>;
};

export type RouteStationsWithAmenitiesConnection = {
  __typename?: 'RouteStationsWithAmenitiesConnection';
  /** List of stations with amenities of the specified type. */
  nodes: Array<RouteStationWithAmenities>;
  /** Information about the current page. */
  page_info: PageInfo;
  /** Total number of stations with amenities of the specified type. */
  total_count: Scalars['Int']['output'];
};

export type RouteStationsWithAmenityFilter = {
  /** Amenity filters. */
  amenity?: InputMaybe<RouteAmenityFilter>;
  /** Station filters. */
  station?: InputMaybe<RouteStationFilter>;
};

/** The status of a route. The status can be pending, processing, done, not_found or error. */
export const RouteStatus = {
  /** We finished computing the route, with a result. Final status. */
  DONE: 'done',
  /** An error occurred while computing the route. Final status. */
  ERROR: 'error',
  /** We finished computing the route, without any result. Final status. */
  NOT_FOUND: 'not_found',
  /** Route is queued and pending processing. Temporary status. */
  PENDING: 'pending',
  /** We are computing the route for your request. Temporary status. */
  PROCESSING: 'processing'
} as const;

export type RouteStatus = typeof RouteStatus[keyof typeof RouteStatus];
export type RouteStep = {
  __typename?: 'RouteStep';
  /** Total energy used in a step in kWh. */
  consumption?: Maybe<Scalars['Float']['output']>;
  /** Distance from the start to the end of a step, in meters. */
  distance?: Maybe<Scalars['Int']['output']>;
  /** Total drive time from the start to the end of a step, in seconds. */
  duration?: Maybe<Scalars['Int']['output']>;
  /** ID of a step. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Polyline containing encoded coordinates. */
  polyline?: Maybe<Scalars['String']['output']>;
  /** Type of a step. */
  type?: Maybe<StepType>;
};


export type RouteStepPolylineArgs = {
  decimals?: InputMaybe<Scalars['Int']['input']>;
};

/** Tags of a route. */
export const RouteTagType = {
  CROSSBORDER: 'crossborder',
  FERRY: 'ferry',
  HIGHWAY: 'highway',
  ROAD: 'road',
  TOLL: 'toll',
  WALKING: 'walking'
} as const;

export type RouteTagType = typeof RouteTagType[keyof typeof RouteTagType];
/** Specifies a temporal window to search for stations with matching amenity types. Defined by a center from the journey origin and a surrounding time margin. */
export type RouteTimeWindow = {
  /** Center point of the search, expressed as the travel time, in seconds, from the journey's origin. */
  center: Scalars['Int']['input'];
  /** Duration in seconds to extend the search on either side of the 'center'. Maximum allowed value is 2700 (45 minutes). If not specified, defaults to 900 seconds (15 minutes). */
  margin?: InputMaybe<Scalars['Int']['input']>;
};

/** Types of route features that can be avoided in truck routing. */
export const RouteTruckAvoid = {
  FERRY: 'ferry',
  TOLL_ROAD: 'toll_road'
} as const;

export type RouteTruckAvoid = typeof RouteTruckAvoid[keyof typeof RouteTruckAvoid];
export type RouteTruckOriginFeaturePoint = {
  __typename?: 'RouteTruckOriginFeaturePoint';
  /** Geometry of the feature. */
  geometry: Point;
  /** ID of the feature. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Additional location and vehicle properties can be specified. */
  properties?: Maybe<RouteTruckOriginProperties>;
  /** Feature type. */
  type: FeatureType;
};

export type RouteTruckOriginFeaturePointInput = {
  /** Geometry of the feature. */
  geometry: PointInput;
  /** ID of the feature. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Additional location and vehicle properties can be specified. */
  properties?: InputMaybe<RouteTruckOriginPropertiesInput>;
  /** Feature type. */
  type: FeatureType;
};

export type RouteTruckOriginProperties = {
  __typename?: 'RouteTruckOriginProperties';
  /** Data about the origin location. */
  location?: Maybe<RouteTruckPropertiesLocation>;
  /** Vehicle configuration at this point. Properties defined here are persistent and will be applied to all subsequent via points in the route unless explicitly overridden at a specific point. If not specified, assumes one occupant, with 80kg of mass and no trailers added */
  vehicle?: Maybe<RouteTruckPropertiesVehicle>;
};

export type RouteTruckOriginPropertiesInput = {
  /** Data about the origin location. */
  location?: InputMaybe<RouteTruckPropertiesLocationInput>;
  /** Vehicle configuration at this point. Properties defined here are persistent and will be applied to all subsequent via points in the route unless explicitly overridden at a specific point. If not specified, assumes one occupant, with 80kg of mass and no trailers added */
  vehicle?: InputMaybe<RouteTruckPropertiesVehicleInput>;
};

export type RouteTruckPropertiesLocation = {
  __typename?: 'RouteTruckPropertiesLocation';
  /** Name override for the choosen location. */
  name?: Maybe<Scalars['String']['output']>;
};

export type RouteTruckPropertiesLocationInput = {
  /** Name override for the choosen location. */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type RouteTruckPropertiesVehicle = {
  __typename?: 'RouteTruckPropertiesVehicle';
  /** The number of axles of the main vehicle (e.g., rigid truck or tractor unit) in contact with the road. Excludes semi-trailer axles, those should be provided in trailer object. If not specified, it assumes  main vehicle's all axles (liftable and rigid) are in use. */
  axles_in_use?: Maybe<Scalars['Int']['output']>;
  /** Number of occupants in the vehicle. */
  occupants: Scalars['Int']['output'];
  /** Total weight of all cargo in the vehicle, including the cargo in any attached trailers. */
  total_cargo_weight?: Maybe<TotalCargoWeight>;
  /** Combined weight of the all occupants. Defaults to 80kg if not specified. */
  total_occupant_weight?: Maybe<TotalOccupantWeight>;
  /** Configuration and dimensions for attached trailers. Required when the choosen vehicle is tractor unit. If not specified, no trailer configuration is set . */
  trailer?: Maybe<RouteTruckVehicleTrailer>;
};

export type RouteTruckPropertiesVehicleInput = {
  /** The number of axles of the main vehicle (e.g., rigid truck or tractor unit) in contact with the road. Excludes semi-trailer axles, those should be provided in trailer object. If not specified, it assumes  main vehicle's all axles (liftable and rigid) are in use. */
  axles_in_use?: InputMaybe<Scalars['Int']['input']>;
  /** Number of occupants in the vehicle. Defaults to 1 if not specified. */
  occupants?: InputMaybe<Scalars['Int']['input']>;
  /** Total weight of all cargo in the vehicle, including the cargo in any attached trailers. */
  total_cargo_weight?: InputMaybe<TotalCargoWeightInput>;
  /** Combined weight of the all occupants. Defaults to 80kg if not specified. */
  total_occupant_weight?: InputMaybe<TotalOccupantWeightInput>;
  /** Configuration and dimensions for attached trailers. Required when the choosen vehicle is tractor unit. If not specified, no trailer configuration is set . */
  trailer?: InputMaybe<RouteTruckVehicleTrailerInput>;
};

export type RouteTruckVehicle = {
  __typename?: 'RouteTruckVehicle';
  /** Value of the auxiliary power consumption of the vehicle. */
  auxiliary_consumption: AuxiliaryConsumption;
  /** EV battery specific configuration. */
  battery: RouteVehicleBattery;
  /** Vehicle cabin configuration used for the route calculation. Applied only if vehicle.climate is set to true. */
  cabin: RouteVehicleCabin;
  /** Charging configuration. */
  charging: RouteVehicleCharging;
  /** Flag indicating if climate control is on. */
  climate: Scalars['Boolean']['output'];
  /** Vehicle Heat Pump configuration. */
  heat_pump: HeatPumpMode;
  /** ID of the vehicle. */
  id: Scalars['ID']['output'];
  /** Tire pressures of all wheels, ordered from front right to front left, then rear left to rear right. */
  tire_pressure: TirePressure;
};

export type RouteTruckVehicleInput = {
  /** Value of the auxiliary power consumption of the vehicle. */
  auxiliary_consumption?: InputMaybe<AuxiliaryConsumptionInput>;
  /** EV battery specific configuration. */
  battery?: InputMaybe<RouteVehicleBatteryInput>;
  /** Vehicle cabin configuration used for the route calculation. Applied only if vehicle.climate is set to true. */
  cabin?: InputMaybe<RouteVehicleCabinInput>;
  /** Charging configuration. */
  charging?: InputMaybe<RouteVehicleChargingInput>;
  /** Flag indicating if climate control is on. */
  climate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Vehicle Heat Pump configuration. */
  heat_pump?: InputMaybe<HeatPumpMode>;
  /** ID of the vehicle. */
  id: Scalars['ID']['input'];
  /** Tire pressures of all wheels, ordered from front right to front left, then rear left to rear right. */
  tire_pressure?: InputMaybe<TirePressureInput>;
};

export type RouteTruckVehicleTrailer = {
  __typename?: 'RouteTruckVehicleTrailer';
  /** Number of axles of all attached trailers in contact with the road. This value does not include the main vehicle/tractor unit axles. Will be combined with the main vehicle's known number of axles. */
  axles_in_use: Scalars['Int']['output'];
  /** Total physical dimensions of the vehicle combination of the main vehicle and trailers. */
  combined_vehicle_dimensions: TruckTrailerCombinedDimensions;
  /** Number of trailers. */
  count: Scalars['Int']['output'];
  /** Total unladen (empty) weight of all attached trailers. Will be combined with the main vehicle's known unladen weight. */
  unladen_weight: Scalars['Float']['output'];
};


export type RouteTruckVehicleTrailerUnladen_WeightArgs = {
  unit?: InputMaybe<WeightUnit>;
};

export type RouteTruckVehicleTrailerInput = {
  /** Number of axles of all attached trailers in contact with the road. This value does not include the main vehicle/tractor unit axles. Will be combined with the main vehicle's known number of axles. */
  axles_in_use: Scalars['Int']['input'];
  /** Total physical dimensions of the vehicle combination of the main vehicle and trailers. */
  combined_vehicle_dimensions: TruckTrailerCombinedDimensionsInput;
  /** Number of trailers. */
  count: Scalars['Int']['input'];
  /** Total unladen (empty) weight of all attached trailers. Will be combined with the main vehicle's known unladen weight. */
  unladen_weight: WeightInput;
};

export type RouteTruckViaFeaturePoint = {
  __typename?: 'RouteTruckViaFeaturePoint';
  /** Geometry of the feature. */
  geometry?: Maybe<Point>;
  /** ID of the feature. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Optional object where additional properties can be specified. */
  properties?: Maybe<RouteTruckViaProperties>;
  /** Feature type. */
  type: FeatureType;
};

export type RouteTruckViaFeaturePointInput = {
  /** Geometry of the feature. */
  geometry?: InputMaybe<PointInput>;
  /** ID of the feature. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Optional object where additional properties can be specified. */
  properties?: InputMaybe<RouteTruckViaPropertiesInput>;
  /** Feature type. */
  type: FeatureType;
};

export type RouteTruckViaProperties = {
  __typename?: 'RouteTruckViaProperties';
  /** Location data of the via point. */
  location?: Maybe<RoutePropertiesViaLocation>;
  /** Station data of the via point. */
  station?: Maybe<RoutePropertiesStation>;
  /** Vehicle configuration at this point. Properties defined here override previous settings and persist for all subsequent segments of the route until changed again. If not specified, the vehicle state from the previous point remains in effect. */
  vehicle?: Maybe<RouteTruckPropertiesVehicle>;
};

export type RouteTruckViaPropertiesInput = {
  /** Location data of the via point. */
  location?: InputMaybe<RoutePropertiesViaLocationInput>;
  /** Station data of the via point. */
  station?: InputMaybe<RoutePropertiesStationInput>;
  /** Vehicle configuration at this point. Properties defined here override previous settings and persist for all subsequent segments of the route until changed again. If not specified, the vehicle state from the previous point remains in effect. */
  vehicle?: InputMaybe<RouteTruckPropertiesVehicleInput>;
};

export type RouteVehicle = {
  __typename?: 'RouteVehicle';
  /** Value of the auxiliary power consumption of the vehicle. */
  auxiliary_consumption: AuxiliaryConsumption;
  /** EV battery specific configuration. */
  battery: RouteVehicleBattery;
  /** Vehicle cabin configuration used for the route calculation. Applied only if vehicle.climate is set to true. */
  cabin: RouteVehicleCabin;
  /** Charging configuration. */
  charging: RouteVehicleCharging;
  /** Flag indicating if climate control is on. */
  climate: Scalars['Boolean']['output'];
  /** Current heading in degrees. */
  heading?: Maybe<Scalars['Float']['output']>;
  /** Vehicle Heat Pump configuration. */
  heat_pump: HeatPumpMode;
  /** ID of the vehicle. */
  id: Scalars['ID']['output'];
  /** Flag indicating if a vehicle is in park, neutral, or turned off. */
  is_parked?: Maybe<Scalars['Boolean']['output']>;
  /** Revolutions per minute of the motor, a measure of the rotational speed of the motor's rotor component. */
  motor_rpm?: Maybe<Scalars['Int']['output']>;
  /** Value of the vehicle's odometer. */
  odometer?: Maybe<Odometer>;
  /** Value of the outside temperature. */
  outside_temperature?: Maybe<OutsideTemperature>;
  /** Tire pressures of all wheels, ordered from front right to front left, then rear left to rear right. */
  tire_pressure: TirePressure;
  /** Value of the vehicle's speed. */
  vehicle_speed?: Maybe<VehicleSpeed>;
};

export type RouteVehicleBattery = {
  __typename?: 'RouteVehicleBattery';
  /** Usable capacity of a battery used to compute a route. The value must be between 50% and 150% of a vehicle's baseline battery capacity. If not provided, the vehicle's full usable capacity by default. */
  capacity: StateOfCharge;
  /** Battery current in ampere. */
  current?: Maybe<Scalars['Float']['output']>;
  /** Desired final amount of energy in a battery at the end of a trip. The value must be between 0 and 80% of the vehicle's battery capacity. If not provided, or if the specified value is below the safe risk margin, the safe risk margin is used by default. */
  final_state_of_charge: StateOfCharge;
  /** Flag indicating if the vehicle is charging. */
  is_charging?: Maybe<Scalars['Boolean']['output']>;
  /** Value of the positive or negative power, in kWh. When negative, the vehicle is charging. */
  power?: Maybe<Scalars['Float']['output']>;
  /** Current amount of energy in a battery. If not provided, battery is assumed to be fully charged. */
  state_of_charge: StateOfCharge;
  /** Temperature of the battery. */
  temperature?: Maybe<Temperature>;
  /** Battery voltage in volts. */
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** EV battery specific configuration for a create route mutation. */
export type RouteVehicleBatteryInput = {
  /** Usable capacity of a battery used to compute a route. The value must be between 50% and 150% of a vehicle's baseline battery capacity. If not provided, the vehicle's full usable capacity by default. */
  capacity?: InputMaybe<StateOfChargeInput>;
  /** Battery current in ampere. */
  current?: InputMaybe<Scalars['Float']['input']>;
  /** Desired final amount of energy in a battery at the end of a trip. The value must be between 0 and 80% of the vehicle's battery capacity. If not provided, or if the specified value is below the safe risk margin, the safe risk margin is used by default. */
  final_state_of_charge?: InputMaybe<StateOfChargeInput>;
  /** Flag indicating if the vehicle is charging. */
  is_charging?: InputMaybe<Scalars['Boolean']['input']>;
  /** Value of the positive or negative power, in kWh. When negative, the vehicle is charging. */
  power?: InputMaybe<Scalars['Float']['input']>;
  /** Current amount of energy in a battery. If not provided, battery is assumed to be fully charged. */
  state_of_charge?: InputMaybe<StateOfChargeInput>;
  /** Battery temperature. */
  temperature?: InputMaybe<TemperatureInput>;
  /** Battery voltage in volts. */
  voltage?: InputMaybe<Scalars['Float']['input']>;
};

export type RouteVehicleCabin = {
  __typename?: 'RouteVehicleCabin';
  /** Desired cabin temperature. Default is 20 degrees Celsius or 68 degrees Fahrenheit. */
  desired_temperature: Temperature;
  /** Flag indicating if the vehicle cabin was preconditioned for the desired temperature. */
  is_preconditioned: Scalars['Boolean']['output'];
};

export type RouteVehicleCabinInput = {
  /** Desired cabin temperature. Default is 20 degrees Celsius or 68 degrees Fahrenheit. */
  desired_temperature?: InputMaybe<TemperatureInput>;
  /** Flag indicating if the vehicle cabin was preconditioned for the desired temperature. */
  is_preconditioned?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RouteVehicleCharging = {
  __typename?: 'RouteVehicleCharging';
  /** Supported adapters. If not specified, adapters will not be considered. */
  adapters: Array<RouteVehicleChargingConnector>;
  /** Supported connectors. If not specified, it defaults to the vehicle's connectors. */
  connectors: Array<RouteVehicleChargingConnector>;
  /** Maximum state of charge (%) the vehicle can reach at any charging stop. If not specified defaults to 80%. */
  maximum_state_of_charge: Scalars['Int']['output'];
  /** Minimum desired power of chargers, in kWh. */
  minimum_power: Scalars['Float']['output'];
  /** Mode that indicates if the charging time is optimized or if always charged to the maximum state of charge. */
  mode: ChargeMode;
  /** Minimum remaining state of charge at charging stops, expressed as a percentage. The value must be between 0 and 60. If not provided, the project configuration value is used. */
  risk_margin: Scalars['Int']['output'];
};

export type RouteVehicleChargingConnector = {
  __typename?: 'RouteVehicleChargingConnector';
  /** Maximum charging speed for this plug. */
  maximum_charge_speed: ChargeSpeed;
  /** Type of the plug. */
  standard: ConnectorType;
};

export type RouteVehicleChargingConnectorInput = {
  /** Maximum charging speed for this plug. */
  maximum_charge_speed: ChargeSpeedInput;
  /** Plug type. */
  standard: ConnectorType;
};

export type RouteVehicleChargingInput = {
  /** Supported adapters. If not specified, adapters will not be considered. */
  adapters?: InputMaybe<Array<RouteVehicleChargingConnectorInput>>;
  /** Supported connectors. If not specified, it defaults to the vehicle's connectors. */
  connectors?: InputMaybe<Array<RouteVehicleChargingConnectorInput>>;
  /** Maximum state of charge (%) the vehicle can reach at any charging stop. The value must be between 80 and 100. */
  maximum_state_of_charge?: Scalars['Int']['input'];
  /** Minimum desired power of chargers, in kWh. */
  minimum_power?: InputMaybe<Scalars['Float']['input']>;
  /** Mode that indicates if the charging time is optimized or if always charged to the maximum state of charge. */
  mode?: InputMaybe<ChargeMode>;
  /** Minimum remaining state of charge at charging stops, expressed as a percentage. The value must be between 0 and 60. If not provided, the project configuration value is used. */
  risk_margin?: InputMaybe<Scalars['Int']['input']>;
};

export type RouteVehicleEmissions = {
  __typename?: 'RouteVehicleEmissions';
  /** Embedded emissions, for example emissions produced during manufacturing, transportation, and delivery. */
  embedded: RouteEmbeddedEmissions;
  /** End of life emissions. */
  end_of_life: RouteEndOfLifeEmissions;
  /** Total co2e emissions from vehicle operational processes calculated using the methodology in section 5.2.2 of ISO 14083:2023 and default emissions intensities in Annex K of the same document. */
  iso_14083_2023: Scalars['Float']['output'];
  /** Emissions info for the legs in the same order as in the route. */
  legs: Array<RouteVehicleLegEmissions>;
  /** Operational emissions. */
  operational: RouteVehicleOperationalEmissions;
  /** Total co2e emissions. */
  total: Scalars['Float']['output'];
};


export type RouteVehicleEmissionsIso_14083_2023Args = {
  unit?: InputMaybe<EmissionUnit>;
};


export type RouteVehicleEmissionsTotalArgs = {
  unit?: InputMaybe<EmissionUnit>;
};

/** Vehicle specific input for a create route mutation. */
export type RouteVehicleInput = {
  /** Average auxiliary power consumption. */
  auxiliary_consumption?: InputMaybe<AuxiliaryConsumptionInput>;
  /** EV battery specific configuration. */
  battery?: InputMaybe<RouteVehicleBatteryInput>;
  /** Vehicle cabin configuration used for the route calculation. Applied only if vehicle.climate is set to true. */
  cabin?: InputMaybe<RouteVehicleCabinInput>;
  /** Charging configuration. */
  charging?: InputMaybe<RouteVehicleChargingInput>;
  /** Flag indicating if climate control is on. */
  climate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Current heading in degrees. */
  heading?: InputMaybe<Scalars['Float']['input']>;
  /** Vehicle Heat Pump configuration. */
  heat_pump?: InputMaybe<HeatPumpMode>;
  /** ID of the vehicle. */
  id: Scalars['ID']['input'];
  /** Flag indicating if a vehicle is in park, neutral, or turned off. */
  is_parked?: InputMaybe<Scalars['Boolean']['input']>;
  /** Revolutions per minute of the motor, a measure of the rotational speed of the motor's rotor component. */
  motor_rpm?: InputMaybe<Scalars['Int']['input']>;
  /** Odometer (mileage) reading. */
  odometer?: InputMaybe<OdometerInput>;
  /** Outside temperature. */
  outside_temperature?: InputMaybe<OutsideTemperatureInput>;
  /** Tire pressures of all wheels, ordered from front right to front left, then rear left to rear right. */
  tire_pressure?: InputMaybe<TirePressureInput>;
  /** Vehicle speed. */
  vehicle_speed?: InputMaybe<VehicleSpeedInput>;
};

export type RouteVehicleLegEmissions = {
  __typename?: 'RouteVehicleLegEmissions';
  /** Embedded emissions, for example emissions produced during manufacturing, transportation, and delivery. */
  embedded: RouteEmbeddedEmissions;
  /** End of life emissions for the leg. */
  end_of_life: RouteEndOfLifeEmissions;
  /** Total leg co2e emissions from vehicle operational processes using the methodology in section 5.2.2 of ISO 14083:2023 and default emissions intensities in Annex K of the same document. */
  iso_14083_2023: Scalars['Float']['output'];
  /** Operational emissions for the leg. */
  operational: RouteVehicleLegOperationalEmissions;
  /** Total co2e emissions for the leg. */
  total: Scalars['Float']['output'];
};


export type RouteVehicleLegEmissionsIso_14083_2023Args = {
  unit?: InputMaybe<EmissionUnit>;
};


export type RouteVehicleLegEmissionsTotalArgs = {
  unit?: InputMaybe<EmissionUnit>;
};

export type RouteVehicleLegOperationalEmissions = {
  __typename?: 'RouteVehicleLegOperationalEmissions';
  /** Electricity emissions data for the leg. */
  electricity: RouteLegOperationalElectricityEmissions;
  /** Total road infrastructure emissions for the leg. */
  infrastructure: RouteOperationalInfrastructureEmissions;
  /** Total maintenance emissions for the leg. */
  maintenance: RouteOperationalMaintenanceEmissions;
  /** Total operational emissions for the leg. */
  total: Scalars['Float']['output'];
};


export type RouteVehicleLegOperationalEmissionsTotalArgs = {
  unit?: InputMaybe<EmissionUnit>;
};

export type RouteVehicleOperationalEmissions = {
  __typename?: 'RouteVehicleOperationalEmissions';
  /** Electricity emissions. */
  electricity: RouteOperationalElectricityEmissions;
  /** Road infrastructure emissions. */
  infrastructure: RouteOperationalInfrastructureEmissions;
  /** Maintenance emissions. */
  maintenance: RouteOperationalMaintenanceEmissions;
  /** Total operational emissions. */
  total: Scalars['Float']['output'];
};


export type RouteVehicleOperationalEmissionsTotalArgs = {
  unit?: InputMaybe<EmissionUnit>;
};

export type RouteViaFeaturePoint = {
  __typename?: 'RouteViaFeaturePoint';
  /** Geometry of the feature. */
  geometry?: Maybe<Point>;
  /** ID of the feature. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Additional feature properties for via. If a `station.id` or `station.external_id` are provided, it will be treated as a charging stop.  If omitted or `location.name` is provided, the stop is treated as a non-charging stop location. */
  properties?: Maybe<RouteViaProperties>;
  /** Feature type. */
  type: FeatureType;
};

export type RouteViaFeaturePointInput = {
  /** Geometry of the feature. */
  geometry?: InputMaybe<PointInput>;
  /** ID of the feature. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Additional feature properties for via. If a `station.id` or `station.external_id` are provided, it will be treated as a charging stop.  If omitted or `location.name` is provided, the stop is treated as a non-charging stop location. */
  properties?: InputMaybe<RouteViaPropertiesInput>;
  /** Feature type. */
  type: FeatureType;
};

export type RouteViaProperties = {
  __typename?: 'RouteViaProperties';
  /** Location data of the via point. */
  location?: Maybe<RoutePropertiesViaLocation>;
  /** Station data of the via point. */
  station?: Maybe<RoutePropertiesStation>;
  /** Vehicle data of the via point. */
  vehicle?: Maybe<RoutePropertiesVehicle>;
};

export type RouteViaPropertiesInput = {
  /** Location data of the via point. */
  location?: InputMaybe<RoutePropertiesViaLocationInput>;
  /** Specifies a charging station at the via. If a known station is provided, it will be used as charging stop. Any configured operator preferences are ignored for this stop. */
  station?: InputMaybe<RoutePropertiesStationInput>;
  /** Vehicle data of the via point. */
  vehicle?: InputMaybe<RoutePropertiesVehicleInput>;
};

export type RouteWarning = {
  __typename?: 'RouteWarning';
  /** The code of the warning. */
  code: RouteWarningCode;
};

/** Types of warnings that can be encountered in a route. */
export const RouteWarningCode = {
  /** Destination location cannot be reached by vehicle and requires a walking section to reach the point. */
  DESTINATION_NOT_VEHICLE_ACCESSIBLE: 'destination_not_vehicle_accessible',
  /** Route is calculated using only the battery range of the extended-range vehicle.  */
  EREV_BATTERY_ONLY_RANGE: 'erev_battery_only_range',
  /** Selected vehicle model is unavailable on one or more regions along the route. */
  EV_UNAVAILABLE_IN_REGION: 'ev_unavailable_in_region',
  /** Requested final state of charge cannot be achieved. */
  FINAL_SOC_NOT_POSSIBLE: 'final_soc_not_possible',
  /** Route excludes charging stations as a hybrid vehicle does not require external charging. */
  HEV_NO_CHARGING_STATIONS: 'hev_no_charging_stations',
  /** Set maximum speed is too low (below 50 km/h) and may result in an inefficient route. */
  LOW_SPEED: 'low_speed',
  /** Operator preferences were ignored because they have not been configured for this project nor provided in the route create request. */
  OPERATOR_PREFERENCES_NOT_FOUND: 'operator_preferences_not_found',
  /** One or more preferred, excluded, or avoided operators have no active stations available and were ignored. */
  OPERATORS_IGNORED: 'operators_ignored',
  /** Origin location cannot be reached by vehicle and requires a walking section to reach the point. */
  ORIGIN_NOT_VEHICLE_ACCESSIBLE: 'origin_not_vehicle_accessible',
  /** Traffic data for this route is not available. */
  TRAFFIC_DATA_NOT_AVAILABLE: 'traffic_data_not_available',
  /** Not possible to fetch weather data for a departure time further than 4 days in the future. Current weather used as alternative. */
  WEATHER_FORECAST_NOT_AVAILABLE: 'weather_forecast_not_available',
  /** Not possible to fetch weather data for a departure time longer than 2 years ago. Current weather used as an alternative. */
  WEATHER_HISTORY_NOT_AVAILABLE: 'weather_history_not_available'
} as const;

export type RouteWarningCode = typeof RouteWarningCode[keyof typeof RouteWarningCode];
export type RouteWeather = {
  __typename?: 'RouteWeather';
  /** [BETA] Custom weather conditions applied to the route. Only present when 'type' is set to 'CUSTOM'. */
  custom?: Maybe<RouteWeatherCustomConditions>;
  /** Weather configuration applied to the route. */
  type: WeatherType;
};

export type RouteWeatherCustomConditions = {
  __typename?: 'RouteWeatherCustomConditions';
  /** Atmospheric pressure along the route. */
  air_pressure: AirPressure;
  /** Solar irradiance along the route. */
  solar_irradiance: SolarIrradiance;
  /** Average ambient temperature estimated along the route. */
  temperature: Temperature;
};

export type RouteWeatherCustomConditionsInput = {
  /** Atmospheric pressure along the route. */
  air_pressure: AirPressureInput;
  /** Solar irradiance along the route. */
  solar_irradiance: SolarIrradianceInput;
  /** Average ambient temperature estimated along the route. */
  temperature: TemperatureInput;
};

export type RouteWeatherInput = {
  /** [BETA] Custom weather conditions to apply to the route. Required only when 'type' is 'CUSTOM'. Must be omitted for other weather types. */
  custom?: InputMaybe<RouteWeatherCustomConditionsInput>;
  /** Weather configuration applied to the route. */
  type?: InputMaybe<WeatherType>;
};

/** Scheduled charge stop along a route. */
export type ScheduledChargeStopInput = {
  /** Duration at the amenity, in seconds. The value should be between 900 and 86400. */
  duration: Scalars['Int']['input'];
  /** Maximum distance from a station to an amenity, in meters. The value should be between 0 and 1000. */
  max_distance_from_station?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum allowed offset from the stop_after value in seconds. */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Desired drive time for a scheduled stop after leaving the origin point, in seconds. */
  stop_after: Scalars['Int']['input'];
  /** List of amenity types. */
  types: Array<AmenityType>;
};

export type SolarIrradiance = {
  __typename?: 'SolarIrradiance';
  /** Solar irradiance unit. */
  type: SolarIrradianceUnit;
  /** Value of the solar irradiance. */
  value: Scalars['Float']['output'];
};

export type SolarIrradianceInput = {
  /** Solar irradiance unit. */
  type: SolarIrradianceUnit;
  /** Value of the solar irradiance. */
  value: Scalars['Float']['input'];
};

export const SolarIrradianceUnit = {
  WATTS_PER_SQUARE_METER: 'watts_per_square_meter'
} as const;

export type SolarIrradianceUnit = typeof SolarIrradianceUnit[keyof typeof SolarIrradianceUnit];
export const SortDirection = {
  ASCENDING: 'ascending',
  DESCENDING: 'descending'
} as const;

export type SortDirection = typeof SortDirection[keyof typeof SortDirection];
export const SpeedUnit = {
  /** Return the speed in kilometers per hour. */
  KILOMETERS_PER_HOUR: 'kilometers_per_hour',
  /** Return the speed in miles per hour. */
  MILES_PER_HOUR: 'miles_per_hour'
} as const;

export type SpeedUnit = typeof SpeedUnit[keyof typeof SpeedUnit];
export type StateOfCharge = {
  __typename?: 'StateOfCharge';
  /** Source of inputted data. */
  source: TelemetryInputSource;
  /** Preferred unit for the vehicle's state of charge. */
  type: StateOfChargeUnit;
  /** Value of the state of charge of the vehicle. */
  value: Scalars['Float']['output'];
};

export type StateOfChargeInput = {
  /** Source of inputted data, defaults to 'manual'. */
  source?: InputMaybe<TelemetryInputSource>;
  /** Preferred unit for the vehicle's state of charge. */
  type: StateOfChargeUnit;
  /** Value of the vehicle's state of charge. */
  value: Scalars['Float']['input'];
};

export const StateOfChargeUnit = {
  /** Return the state of charge in kilometers. */
  KILOMETER: 'kilometer',
  /** Return the state of charge in kilowatt hours. */
  KILOWATT_HOUR: 'kilowatt_hour',
  /** Return the state of charge in miles. */
  MILE: 'mile',
  /** Return the state of charge as a percentage. */
  PERCENTAGE: 'percentage'
} as const;

export type StateOfChargeUnit = typeof StateOfChargeUnit[keyof typeof StateOfChargeUnit];
/** Station data which extends OCPI Location. */
export type Station = {
  __typename?: 'Station';
  /** Type of access to the charging station. */
  access_type?: Maybe<AccessType>;
  /** Street/block name and house number if available. */
  address?: Maybe<Scalars['String']['output']>;
  /** Indicates the authentication and payment methods. */
  adhoc_authorisation_payment_method?: Maybe<Array<StationAdhocAuthorisationPaymentMethod>>;
  /** Amenities located at this location. */
  amenities?: Maybe<Scalars['JSON']['output']>;
  /** [ALPHA] List of active boosting groups to which the station belongs. */
  boosting_group_ids?: Maybe<Array<Scalars['ID']['output']>>;
  /** Groups of EVSEs by power and type. */
  chargers?: Maybe<Array<Maybe<Charger>>>;
  /** Charging behavior of a station. */
  charging_behaviour?: Maybe<ChargingBehaviour>;
  /** Indicates if the EVSEs are still charging outside the opening hours. E.g. when a parking garage closes its barriers overnight, is it allowed to charge till the next morning? Default: true. */
  charging_when_closed?: Maybe<Scalars['Boolean']['output']>;
  /** City or town */
  city?: Maybe<Scalars['String']['output']>;
  /** Coordinates of a location. */
  coordinates?: Maybe<OcpiGeoLocation>;
  /** ISO 3166-1 alpha-3 code for the country of this station. */
  country?: Maybe<Scalars['String']['output']>;
  /** ISO-3166 alpha-2 country code of a station. */
  country_code?: Maybe<Scalars['String']['output']>;
  /** Custom properties of a station. These are vendor specific and will return null values on the fields that are not supported by your station database. */
  custom_properties?: Maybe<StationCustomProperties>;
  /** Human-readable directions on how to reach a station. */
  directions?: Maybe<Array<Maybe<OcpiDisplayText>>>;
  /** Elevation (altitude) level. */
  elevation?: Maybe<Scalars['Int']['output']>;
  /** Details of the energy supplied at a location. */
  energy_mix?: Maybe<OcpiEnergyMix>;
  /** Coordinates for the location's entrances in decimal degrees. If available, there can be more than one entrances to the location. */
  entrance_for_navigation?: Maybe<Array<OcpiAdditionalGeoLocation>>;
  /** EVSEs that belong to a station. */
  evses?: Maybe<Array<Maybe<Evse>>>;
  /** ID provided by a station data source. */
  external_id?: Maybe<Scalars['String']['output']>;
  /** Facilities a charging station belongs to. */
  facilities?: Maybe<Array<Maybe<OcpiFacility>>>;
  /** Describes the heavy vehicle properties at the location. */
  heavy_vehicles_properties?: Maybe<StationHeavyVehiclesProperties>;
  /** Describes the heavy vehicle restrictions at the location. */
  heavy_vehicles_restrictions?: Maybe<StationHeavyVehiclesRestrictions>;
  /** Unique ID of a station. */
  id: Scalars['ID']['output'];
  /** Links to images related to a location such as photos or logos. */
  images?: Maybe<Array<Maybe<OcpiImage>>>;
  /** Timestamp when a location, or one of its EVSEs or Connectors were last updated (or created). */
  last_updated?: Maybe<Scalars['DateTime']['output']>;
  /** GeoJSON location of a charging station. */
  location?: Maybe<Point>;
  /** Type of location where the charge point is located. For example, shop. */
  location_category?: Maybe<Scalars['String']['output']>;
  /** Name of a charging station. */
  name?: Maybe<Scalars['String']['output']>;
  /** Times when an EVSEs at a location can be accessed for charging. */
  opening_times?: Maybe<OcpiHours>;
  /** Information about an operator. */
  operator?: Maybe<Operator>;
  /** Information about an owner if available. */
  owner?: Maybe<Operator>;
  /** Type of parking at a charge point location. */
  parking_type?: Maybe<OcpiParkingType>;
  /** CPO ID of a CPO that 'owns' this station (following the ISO-15118 standard). */
  party_id?: Maybe<Scalars['String']['output']>;
  /** Enriched information about the physical address of a station. */
  physical_address?: Maybe<Address>;
  /** Postal code of a location, may only be omitted when a location has no postal code: in some countries charging locations at highways don’t have postal codes. */
  postal_code?: Maybe<Scalars['String']['output']>;
  /** Connectors grouped by power. */
  power?: Maybe<Scalars['JSON']['output']>;
  /** Predicted station occupancy. */
  predicted_occupancy?: Maybe<Array<Maybe<StationPredictedOccupancy>>>;
  /**
   * Optional object where you can store custom data you need in your application. This extends the current functionalities we offer.
   * @deprecated No longer used.
   */
  properties?: Maybe<Scalars['JSON']['output']>;
  /**
   * Defines if a location may be published on a website or app etc.
   * When this is set to false, only tokens identified in the field: publish_allowed_to are allowed to show this location.
   * When the same location has EVSEs that may be published and may not be published, two 'locations' should be created.
   */
  publish?: Maybe<Scalars['Boolean']['output']>;
  /** A flag that indicates if a station has real-time information about the availability of its connectors. */
  realtime?: Maybe<Scalars['Boolean']['output']>;
  /** Geographical location of related points relevant to a user. */
  related_locations?: Maybe<Array<Maybe<OcpiAdditionalGeoLocation>>>;
  /** Shows how reliable a charging station is (1 to 5; 1 = unreliable, 5 = reliable), taking into account the charging behaviour history and error values. */
  reliability_score?: Maybe<Scalars['Int']['output']>;
  /** Review of a station. */
  review?: Maybe<ReviewStats>;
  /** List of eMSP cards accepted at a charging station. */
  roaming?: Maybe<Array<Maybe<StationRoaming>>>;
  /** Charging speed for a station. */
  speed?: Maybe<StationSpeedType>;
  /** State or province of a location, only to be used when relevant. */
  state?: Maybe<Scalars['String']['output']>;
  /** Global status for a station. */
  status?: Maybe<ChargerStatus>;
  /** Information about a suboperator if applicable. */
  suboperator?: Maybe<Operator>;
  /** Phone number for assistance at a charging station. */
  support_phone_number?: Maybe<Scalars['String']['output']>;
  /** Value from the IANA time zone database representing the time zone of a location. Examples: "Europe/Oslo", "Europe/Zurich". (http://www.iana.org/time-zones). */
  time_zone?: Maybe<Scalars['String']['output']>;
  /** Describes the vehicle restrictions at the location. */
  vehicle_restrictions?: Maybe<StationVehicleRestrictions>;
};

export const StationAdhocAuthorisationPaymentMethod = {
  /** Authentication by car through Auto Charge. */
  AUTH_BY_CAR_AUTOCHARGE: 'AUTH_BY_CAR_AUTOCHARGE',
  /** Authentication by car through Plug and Charge. */
  AUTH_BY_CAR_PLUG_AND_CHARGE: 'AUTH_BY_CAR_PLUG_AND_CHARGE',
  /** Apple Pay. */
  ONLINE_APPLE_PAY: 'ONLINE_APPLE_PAY',
  /** Bank Payment. */
  ONLINE_BANK_PAYMENT: 'ONLINE_BANK_PAYMENT',
  /** Credit Card. */
  ONLINE_CREDIT_CARD: 'ONLINE_CREDIT_CARD',
  /** Google Pay. */
  ONLINE_GOOGLE_PAY: 'ONLINE_GOOGLE_PAY',
  /** PayPal. */
  ONLINE_PAYPAL: 'ONLINE_PAYPAL',
  /** Other. */
  OTHER_OTHER: 'OTHER_OTHER',
  /** Service Provider RFID Card. */
  SERVICE_PROVIDER_RFID_CARD: 'SERVICE_PROVIDER_RFID_CARD',
  /** Terminal Contactless. */
  TERMINAL_CONTACTLESS: 'TERMINAL_CONTACTLESS',
  /** Terminal Credit Card. */
  TERMINAL_CREDIT_CARD: 'TERMINAL_CREDIT_CARD',
  /** Terminal Debit Card. */
  TERMINAL_DEBIT_CARD: 'TERMINAL_DEBIT_CARD',
  /** Terminal in app. */
  TERMINAL_IN_APP: 'TERMINAL_IN_APP',
  /** Terminal QR Code. */
  TERMINAL_QR_CODE: 'TERMINAL_QR_CODE',
  /** Terminal SMS. */
  TERMINAL_SMS: 'TERMINAL_SMS'
} as const;

export type StationAdhocAuthorisationPaymentMethod = typeof StationAdhocAuthorisationPaymentMethod[keyof typeof StationAdhocAuthorisationPaymentMethod];
/** Criteria to filter stations in the station around query. */
export type StationAroundFilter = {
  /** Amenities available near a station. */
  amenities?: InputMaybe<Array<InputMaybe<Amenities>>>;
  /** Flag that allows you to return only available stations. */
  available_only?: InputMaybe<Scalars['Boolean']['input']>;
  /** Station socket or plug standards. */
  connectors?: InputMaybe<Array<InputMaybe<ConnectorType>>>;
  /** Distance, in meters, to search around. */
  distance?: InputMaybe<Scalars['Int']['input']>;
  /** GeoJSON Point of the center of the around me circle. */
  location?: InputMaybe<PointInput>;
  /** Station speed. */
  power_groups?: InputMaybe<Array<InputMaybe<StationSpeedType>>>;
  /** Powers in kW. */
  powers?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Flag to filter for stations operated by an operator present in the project's ranking list. */
  preferred_operator?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Query parameters to filter stations in the station around query. */
export type StationAroundQuery = {
  /** Amenities available near a station. Values: restaurant, bathroom, supermarket, playground, coffee, shopping, museum, hotel, park. */
  amenities?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Distance, in meters, to search around. */
  distance?: InputMaybe<Scalars['Int']['input']>;
  /** GeoJSON Point of the center of the around me circle. */
  location?: InputMaybe<PointInput>;
  /** Power in kW. */
  power?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type StationCustomProperties = {
  __typename?: 'StationCustomProperties';
  /** Custom station properties for OICP databases such as the global Hubject database. Station databases that not follow the OICP standard return null values. */
  oicp?: Maybe<OicpStationCustomProperties>;
  /**
   * Shows how reliable a charging station is (1 to 5; 1 = unreliable, 5 = reliable), taking into account the charging behaviour history and error values.
   * @deprecated In favor of `station.reliability_score`.
   */
  reliability_score?: Maybe<Scalars['Int']['output']>;
};

/** Describes the heavy vehicle properties at the location. */
export type StationHeavyVehiclesProperties = {
  __typename?: 'StationHeavyVehiclesProperties';
  /** Indicates whether the location allows charging of heavy vehicles transporting dangerous goods. */
  allows_dangerous_goods?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the location allows overnight charging of heavy vehicles. */
  allows_overnight_parking?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the location is suitable for rigid heavy vehicles. */
  allows_rigid_vehicles?: Maybe<Scalars['Boolean']['output']>;
  /** List of facilities in the location. */
  facilities?: Maybe<Array<HeavyVehiclesFacility>>;
  /** Indicates whether the location was constructed mainly for the purpose of heavy vehicles like trucks. */
  is_dedicated?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the location is drive-through. */
  is_drive_through?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the location is suitable for trucks with trailers. */
  is_trailer_accessible?: Maybe<Scalars['Boolean']['output']>;
};

/** Describes the heavy vehicle restrictions at the location. */
export type StationHeavyVehiclesRestrictions = {
  __typename?: 'StationHeavyVehiclesRestrictions';
  /** Allowed N (EU) types of heavy vehicles. */
  allowed_types_EU?: Maybe<Array<HeavyVehiclesEuType>>;
  /** Maximum height of the heavy vehicle that is allowed to be parked at the charging station. */
  height?: Maybe<Scalars['Float']['output']>;
  /** Maximum length of the heavy vehicle that is allowed to be parked at the charging station. */
  length?: Maybe<Scalars['Float']['output']>;
  /** Maximum mass of the heavy vehicle that is allowed to be parked at the charging station. */
  mass?: Maybe<Scalars['Float']['output']>;
  /** Maximum width of the heavy vehicle that is allowed to be parked at the charging station. */
  width?: Maybe<Scalars['Float']['output']>;
};


/** Describes the heavy vehicle restrictions at the location. */
export type StationHeavyVehiclesRestrictionsHeightArgs = {
  unit?: InputMaybe<DimensionUnit>;
};


/** Describes the heavy vehicle restrictions at the location. */
export type StationHeavyVehiclesRestrictionsLengthArgs = {
  unit?: InputMaybe<DimensionUnit>;
};


/** Describes the heavy vehicle restrictions at the location. */
export type StationHeavyVehiclesRestrictionsMassArgs = {
  unit?: InputMaybe<WeightUnit>;
};


/** Describes the heavy vehicle restrictions at the location. */
export type StationHeavyVehiclesRestrictionsWidthArgs = {
  unit?: InputMaybe<DimensionUnit>;
};

/** Criteria to filter stations in the station list query. */
export type StationListFilter = {
  /** Amenities available near a station. */
  amenities?: InputMaybe<Array<InputMaybe<Amenities>>>;
  /** Flag that allows you to return only available stations. */
  available_only?: InputMaybe<Scalars['Boolean']['input']>;
  /** Station socket or plug standards. */
  connectors?: InputMaybe<Array<InputMaybe<ConnectorType>>>;
  /** Station speed. */
  power_groups?: InputMaybe<Array<InputMaybe<StationSpeedType>>>;
  /** Powers in kW. */
  powers?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Flag to filter for stations operated by an operator present in the project's ranking list. */
  preferred_operator?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Query parameters to filter stations in the station list query. */
export type StationListQuery = {
  /** External ID of the station provided by the station data source. */
  external_id?: InputMaybe<Scalars['String']['input']>;
  /** ID of the station. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Exact name. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Station availability for each weekday and hour. */
export type StationPredictedAvailability = {
  __typename?: 'StationPredictedAvailability';
  /** The prediction for each hour 0-23 from 1 to 5 (1 - very busy ... 5 very quiet (free)). */
  prediction?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Number of weekday from 1 (monday) to 7 (sunday). */
  weekday?: Maybe<Scalars['Int']['output']>;
};

/** Station occupancy for each weekday and hour. */
export type StationPredictedOccupancy = {
  __typename?: 'StationPredictedOccupancy';
  /** Occupancy on a scale from 1 to 10, where 1 means free for charging and 10 means fully occupied. */
  occupancy?: Maybe<Scalars['Int']['output']>;
  /** Start of the period of the occupancy prediction (string of 'hh-mmZ' format). */
  period_begin?: Maybe<Scalars['String']['output']>;
  /** End of the period of the occupancy prediction (string of 'hh-mmZ' format). */
  period_end?: Maybe<Scalars['String']['output']>;
  /** Number of weekday from 1 (monday) to 7 (sunday). */
  weekday?: Maybe<Scalars['Int']['output']>;
};

export type StationRoaming = {
  __typename?: 'StationRoaming';
  /** Link to native Android app for card accepted at a charging station. */
  android_app_link?: Maybe<Scalars['String']['output']>;
  /** Name of the card accepted at a charging station. */
  card?: Maybe<Scalars['String']['output']>;
  /**
   * Unique E-Mobility Account Identifier (eMA ID) for a provider.
   * It is created by Eco-Movement by combining the country code where the charging station is located, and the party id of the provider.
   * For example, NL-ECO. Note: A provider can have multiple eMA IDs.
   * For example, if a company named 'Example Company A' acquired 'Example Company B' and owns the charging stations of Example Company B,
   * then this attribute maps Example Company B's eMA IDs to Example Company A's eMA IDs. For example, ['NL-EXA', 'NL-EXB'].
   */
  ema_id?: Maybe<Array<Scalars['String']['output']>>;
  /** Name of the EMSP provider. */
  emsp?: Maybe<Scalars['String']['output']>;
  /** Link to native iOS app for card accepted at a charging station. */
  ios_app_link?: Maybe<Scalars['String']['output']>;
  /** Unique id for a provider. It is created by Eco-Movement, and it is stable. */
  partner_id?: Maybe<Scalars['String']['output']>;
};

/** The station speed type. */
export const StationSpeedType = {
  /** Fast charging stations (above 43 kW and below 150 kW). */
  FAST: 'fast',
  /** Slow charging (below 43 kW). */
  SLOW: 'slow',
  /** Ultra fast charging stations (above 150 kW). */
  TURBO: 'turbo'
} as const;

export type StationSpeedType = typeof StationSpeedType[keyof typeof StationSpeedType];
/** Describes the vehicle restrictions at the location. */
export type StationVehicleRestrictions = {
  __typename?: 'StationVehicleRestrictions';
  /** Maximum height for a vehicle that is allowed at the location. */
  height?: Maybe<Scalars['Float']['output']>;
  /** Maximum length for a vehicle that is allowed at the location. */
  length?: Maybe<Scalars['Float']['output']>;
  /** Maximum weight for a vehicle that is allowed at the location. */
  mass?: Maybe<Scalars['Float']['output']>;
  /** Maximum width for a vehicle that is allowed at the location. */
  width?: Maybe<Scalars['Float']['output']>;
};


/** Describes the vehicle restrictions at the location. */
export type StationVehicleRestrictionsHeightArgs = {
  unit?: InputMaybe<DimensionUnit>;
};


/** Describes the vehicle restrictions at the location. */
export type StationVehicleRestrictionsLengthArgs = {
  unit?: InputMaybe<DimensionUnit>;
};


/** Describes the vehicle restrictions at the location. */
export type StationVehicleRestrictionsMassArgs = {
  unit?: InputMaybe<WeightUnit>;
};


/** Describes the vehicle restrictions at the location. */
export type StationVehicleRestrictionsWidthArgs = {
  unit?: InputMaybe<DimensionUnit>;
};

/** Types of a route step. */
export const StepType = {
  /** This step is a crossborder. */
  CROSSBORDER: 'crossborder',
  /** This step is a ferry. */
  FERRY: 'ferry',
  /** This step is a highway. */
  HIGHWAY: 'highway',
  /** This step is a road. */
  ROAD: 'road',
  /** This step is a toll road. */
  TOLL: 'toll',
  /** This step is reachable by walking. */
  WALKING: 'walking'
} as const;

export type StepType = typeof StepType[keyof typeof StepType];
export type Subscription = {
  __typename?: 'Subscription';
  /** [BETA] Subscribe to a connected vehicle. */
  connectedVehicle?: Maybe<ConnectedVehicle>;
  /** Subscribe to an isoline in order to receive updates. */
  isoline?: Maybe<Isoline>;
  /** [BETA] Subscribe to navigation session system event updates. We strongly recommend using this at all times to not miss any updates. */
  navigation?: Maybe<NavigationSubscription>;
  /** Subscribe to a specific route to receive system event updates. */
  route: RouteResponse;
  /**
   * Subscribe to a specific route to receive system event updates.
   * @deprecated In favor of `route`.
   */
  routeUpdatedById?: Maybe<Route>;
  /** [ALPHA] Subscribe to e-truck route to receive system event updates. */
  truckRoute: TruckRouteResponse;
};


export type SubscriptionConnectedVehicleArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionIsolineArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionNavigationArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionRouteArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionRouteUpdatedByIdArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionTruckRouteArgs = {
  id: Scalars['ID']['input'];
};

export type Telemetry = {
  __typename?: 'Telemetry';
  /** Value of the auxiliary power consumption of the vehicle. */
  auxiliary_consumption?: Maybe<Scalars['Float']['output']>;
  /** Battery current in ampere. */
  battery_current?: Maybe<Scalars['Float']['output']>;
  /** Value of the temperature of the battery. */
  battery_temperature?: Maybe<Scalars['Float']['output']>;
  /** Battery voltage in volts. */
  battery_voltage?: Maybe<Scalars['Float']['output']>;
  /** Value of the rate of charge of the battery. */
  charge_speed?: Maybe<Scalars['Float']['output']>;
  /** Value of the amount of battery charged. */
  charge_total?: Maybe<Scalars['Float']['output']>;
  /** Custom input fields can be added based on telemetry architecture. */
  custom?: Maybe<Scalars['JSON']['output']>;
  /** Value of the current elevation. */
  elevation?: Maybe<Scalars['Float']['output']>;
  /** Current heading in degrees. */
  heading?: Maybe<Scalars['Float']['output']>;
  /** Is the vehicle currently charging. */
  is_charging?: Maybe<Scalars['Boolean']['output']>;
  /** Vehicle is in park, neutral or turned off. */
  is_parked?: Maybe<Scalars['Boolean']['output']>;
  /** RPM of the motor. */
  motor_rpm?: Maybe<Scalars['Int']['output']>;
  /** Number of occupants present in the vehicle. */
  occupants?: Maybe<Scalars['Int']['output']>;
  /** Value of the vehicle's odometer. */
  odometer?: Maybe<Scalars['Float']['output']>;
  /** Value of the outside temperature. */
  outside_temperature?: Maybe<Scalars['Float']['output']>;
  /** Value of the positive or negative power. When negative the vehicle is charging. */
  power?: Maybe<Scalars['Float']['output']>;
  /** Value of the state of charge of the vehicle. */
  state_of_charge?: Maybe<Scalars['Float']['output']>;
  /** Values for the average tire pressures of all wheels, starting from the front side right to left and to the rear. */
  tire_pressure?: Maybe<Array<Scalars['Float']['output']>>;
  /** Value of the current weight of the cargo. */
  total_cargo_weight?: Maybe<Scalars['Float']['output']>;
  /** Value of the current weight of the occupants. */
  total_occupant_weight?: Maybe<Scalars['Float']['output']>;
  /** Value of the vehicle speed. */
  vehicle_speed?: Maybe<Scalars['Float']['output']>;
};


export type TelemetryAuxiliary_ConsumptionArgs = {
  unit?: InputMaybe<AuxiliaryConsumptionUnit>;
};


export type TelemetryBattery_TemperatureArgs = {
  unit?: InputMaybe<TemperatureUnit>;
};


export type TelemetryCharge_SpeedArgs = {
  unit?: InputMaybe<ChargeSpeedUnit>;
};


export type TelemetryCharge_TotalArgs = {
  unit?: InputMaybe<StateOfChargeUnit>;
};


export type TelemetryElevationArgs = {
  unit?: InputMaybe<ElevationUnit>;
};


export type TelemetryOdometerArgs = {
  unit?: InputMaybe<DistanceUnit>;
};


export type TelemetryOutside_TemperatureArgs = {
  unit?: InputMaybe<TemperatureUnit>;
};


export type TelemetryPowerArgs = {
  unit?: InputMaybe<PowerUnit>;
};


export type TelemetryState_Of_ChargeArgs = {
  unit?: InputMaybe<StateOfChargeUnit>;
};


export type TelemetryTire_PressureArgs = {
  unit?: InputMaybe<PressureUnit>;
};


export type TelemetryTotal_Cargo_WeightArgs = {
  unit?: InputMaybe<WeightUnit>;
};


export type TelemetryTotal_Occupant_WeightArgs = {
  unit?: InputMaybe<WeightUnit>;
};


export type TelemetryVehicle_SpeedArgs = {
  unit?: InputMaybe<SpeedUnit>;
};

export type TelemetryInput = {
  /** Average auxiliary power consumption. */
  auxiliary_consumption?: InputMaybe<AuxiliaryConsumptionInput>;
  /** Battery current in ampere. */
  battery_current?: InputMaybe<Scalars['Float']['input']>;
  /** Battery temperature. */
  battery_temperature?: InputMaybe<BatteryTemperatureInput>;
  /** Battery voltage in volts. */
  battery_voltage?: InputMaybe<Scalars['Float']['input']>;
  /** Rate of charge. */
  charge_speed?: InputMaybe<ChargeSpeedInput>;
  /** Amount charged. */
  charge_total?: InputMaybe<ChargeTotalInput>;
  /** Custom input fields can be added based on telemetry architecture. */
  custom?: InputMaybe<Scalars['JSON']['input']>;
  /** Current elevation. */
  elevation?: InputMaybe<ElevationInput>;
  /** Current heading in degrees. */
  heading?: InputMaybe<Scalars['Float']['input']>;
  /** Is the vehicle currently charging. */
  is_charging?: InputMaybe<Scalars['Boolean']['input']>;
  /** Vehicle is in park, neutral or turned off. */
  is_parked?: InputMaybe<Scalars['Boolean']['input']>;
  /** RPM of the motor. */
  motor_rpm?: InputMaybe<Scalars['Int']['input']>;
  /** Number of occupants in the vehicle. */
  occupants?: InputMaybe<Scalars['Int']['input']>;
  /** Mileage or odometer reading. */
  odometer?: InputMaybe<OdometerInput>;
  /** Outside temperature. */
  outside_temperature?: InputMaybe<OutsideTempInput>;
  /** Vehicle power. */
  power?: InputMaybe<PowerInput>;
  /** Battery state of charge. */
  state_of_charge?: InputMaybe<StateOfChargeInput>;
  /** Average tire pressures of all wheels, starting from the front side right to left and to the rear. */
  tire_pressure?: InputMaybe<TirePressureInput>;
  /** Weight of the cargo. */
  total_cargo_weight?: InputMaybe<TotalCargoWeightInput>;
  /** Cumulated weight of the occupants. */
  total_occupant_weight?: InputMaybe<TotalOccupantWeightInput>;
  /** Vehicle speed. */
  vehicle_speed?: InputMaybe<VehicleSpeedInput>;
};

export const TelemetryInputSource = {
  /** Default value. */
  DEFAULT: 'default',
  /** Manually inputted value. */
  MANUAL: 'manual',
  /** Value from the vehicle's telemetry. */
  TELEMETRY: 'telemetry'
} as const;

export type TelemetryInputSource = typeof TelemetryInputSource[keyof typeof TelemetryInputSource];
export type Temperature = {
  __typename?: 'Temperature';
  /** Preferred unit for the temperature. */
  type: TemperatureUnit;
  /** Value of the temperature. */
  value: Scalars['Float']['output'];
};

export type TemperatureInput = {
  /** Preferred unit for the temperature. */
  type: TemperatureUnit;
  /** Value of the temperature. */
  value: Scalars['Float']['input'];
};

export const TemperatureUnit = {
  /** Return the temperature in Celsius. */
  CELSIUS: 'Celsius',
  /** Return the temperature in Fahrenheit. */
  FAHRENHEIT: 'Fahrenheit'
} as const;

export type TemperatureUnit = typeof TemperatureUnit[keyof typeof TemperatureUnit];
export type TirePressure = {
  __typename?: 'TirePressure';
  /** Source of inputted data. */
  source: TelemetryInputSource;
  /** Preferred unit for the tire pressure. */
  type: PressureUnit;
  /** Values for the tire pressure, ordered from front right to front left, then rear left to rear right. */
  value: Array<Scalars['Float']['output']>;
};

export type TirePressureInput = {
  /** Source of inputted data, defaults to 'manual'. */
  source?: InputMaybe<TelemetryInputSource>;
  /** Preferred unit for the tire pressure. */
  type: PressureUnit;
  /** Values for the tire pressure, ordered from front right to front left, then rear left to rear right. */
  value: Array<Scalars['Float']['input']>;
};

export const TorqueUnit = {
  /** Return the torque in foot pounds. */
  FOOT_POUND: 'foot_pound',
  /** Return the torque in newton meters. */
  NEWTON_METER: 'newton_meter'
} as const;

export type TorqueUnit = typeof TorqueUnit[keyof typeof TorqueUnit];
export type TotalCargoWeight = {
  __typename?: 'TotalCargoWeight';
  /** Source of inputted data. */
  source: TelemetryInputSource;
  /** Preferred unit for the current weight of the cargo. */
  type: WeightUnit;
  /** Value of the current weight of the cargo. */
  value: Scalars['Float']['output'];
};

export type TotalCargoWeightInput = {
  /** Source of inputted data, defaults to 'manual'. */
  source?: InputMaybe<TelemetryInputSource>;
  /** Preferred unit for the current weight of the cargo. */
  type: WeightUnit;
  /** Value of the current weight of the cargo. */
  value: Scalars['Float']['input'];
};

export type TotalOccupantWeight = {
  __typename?: 'TotalOccupantWeight';
  /** Source of inputted data. */
  source: TelemetryInputSource;
  /** Preferred unit for the current weight of the occupants. */
  type: WeightUnit;
  /** Value of the combined weight of the occupants. */
  value: Scalars['Float']['output'];
};

export type TotalOccupantWeightInput = {
  /** Source of inputted data, defaults to 'manual'. */
  source?: InputMaybe<TelemetryInputSource>;
  /** Preferred unit for the current weight of the occupants. */
  type: WeightUnit;
  /** Value of the combined weight of the occupants. */
  value: Scalars['Float']['input'];
};

export type TrafficCongestionInterval = {
  __typename?: 'TrafficCongestionInterval';
  /** Ending index of this interval in the polyline. */
  end_index: Scalars['Int']['output'];
  /** Congestion level for this specific interval. */
  level: CongestionLevel;
  /** Starting index of this interval in the polyline. */
  start_index: Scalars['Int']['output'];
};

export type TruckRouteDetails = {
  __typename?: 'TruckRouteDetails';
  /** Alternative stations along a route within a specified radius. Will only return stations if alternative_station_radius was specified in the createRoute mutation. */
  alternative_stations: Array<RouteDetailsAlternativeStation>;
  /** Number of charging stops required for this route. */
  charges: Scalars['Int']['output'];
  /** Total energy used for a route in kilowatt hours. For HEVs and PHEVs this field will return null. */
  consumption?: Maybe<Scalars['Float']['output']>;
  /** Total distance of a route. */
  distance: Scalars['Float']['output'];
  /** Aggregation of all durations of a route. */
  durations: RouteDetailsDurations;
  /** Details about elevation on a route. */
  elevation: RouteDetailsElevation;
  /** ID of a route computation. */
  id: Scalars['ID']['output'];
  /** Legs of a route. */
  legs: Array<TruckRouteDetailsLeg>;
  /** Path elevation, distance, duration, consumption and speed values, grouped into 100 segments. */
  path_plot: Array<RouteDetailsPathSegment>;
  /** Polyline containing encoded coordinates. */
  polyline: Scalars['String']['output'];
  /** Range available at the end of a trip. Note: The ranges in kilometers and miles are estimates, calculated based on the Chargetrip range, current route conditions, weather scenario (current or seasonal), and the route input at the time of planning. For HEVs and PHEVs this field will return null. */
  range_at_destination?: Maybe<Scalars['Float']['output']>;
  /** Range available at the start of a trip. The ranges in kilometers and miles are estimates, calculated based on the Chargetrip range, current route conditions, weather scenario (current or seasonal), and the route input at the time of planning. For HEVs and PHEVs this field will return null. */
  range_at_origin?: Maybe<Scalars['Float']['output']>;
  /** Money saving information. */
  savings?: Maybe<RouteDetailsSavings>;
  /** Aggregation of tags over the current RouteDetails. Tags are available on legs and further subdivided over individual sections and maneuvers. */
  tags: Array<RouteDetailsTag>;
};


export type TruckRouteDetailsDistanceArgs = {
  unit?: InputMaybe<DistanceUnit>;
};


export type TruckRouteDetailsPolylineArgs = {
  decimals?: InputMaybe<PolylineInputDecimals>;
};


export type TruckRouteDetailsRange_At_DestinationArgs = {
  unit?: InputMaybe<StateOfChargeUnit>;
};


export type TruckRouteDetailsRange_At_OriginArgs = {
  unit?: InputMaybe<StateOfChargeUnit>;
};

/** Leg of a route detail. */
export type TruckRouteDetailsLeg = {
  __typename?: 'TruckRouteDetailsLeg';
  /** Total energy used in a leg in kilowatt hours. For HEVs and PHEVs this field will return null. */
  consumption?: Maybe<Scalars['Float']['output']>;
  /** Destination point location. */
  destination: TruckRouteDetailsLegFeaturePoint;
  /** Distance from the start to the end of a leg. */
  distance: Scalars['Float']['output'];
  /** Aggregation of all durations of a route leg. */
  durations: RouteDetailsDurations;
  /** Maneuvers of a leg - used to generate turn-by-turn instructions. */
  maneuvers: Array<RouteDetailsManeuver>;
  /** Origin point location. */
  origin: TruckRouteDetailsLegFeaturePoint;
  /** Polyline containing encoded coordinates. */
  polyline: Scalars['String']['output'];
  /** Range after charging on the leg. The ranges in kilometers and miles are estimates, calculated based on the Chargetrip range, current route conditions, weather scenario (current or seasonal), and the route input at the time of planning. For HEVs and PHEVs this field will return null. */
  range_after_charge?: Maybe<Scalars['Float']['output']>;
  /** Range available at the end of a leg. The ranges in kilometers and miles are estimates, calculated based on the Chargetrip range, current route conditions, weather scenario (current or seasonal), and the route input at the time of planning. For HEVs and PHEVs this field will return null. */
  range_at_destination?: Maybe<Scalars['Float']['output']>;
  /** Range at the start of a leg. The ranges in kilometers and miles are estimates, calculated based on the Chargetrip range, current route conditions, weather scenario (current or seasonal), and the route input at the time of planning. For HEVs and PHEVs this field will return null. */
  range_at_origin?: Maybe<Scalars['Float']['output']>;
  /** Road sections of a leg - divided by means of transportation. */
  sections: Array<TruckRouteDetailsLegSection>;
  /** Information about the station at the destination of a leg. */
  station?: Maybe<RouteDetailsLegStation>;
  /** Aggregation of tags over the current leg. Tags are further subdivided over individual sections and maneuvers. */
  tags: Array<RouteDetailsTag>;
  /** Type of a leg. */
  type: RouteDetailsLegType;
};


/** Leg of a route detail. */
export type TruckRouteDetailsLegDistanceArgs = {
  unit?: InputMaybe<DistanceUnit>;
};


/** Leg of a route detail. */
export type TruckRouteDetailsLegPolylineArgs = {
  decimals?: InputMaybe<PolylineInputDecimals>;
};


/** Leg of a route detail. */
export type TruckRouteDetailsLegRange_After_ChargeArgs = {
  unit?: InputMaybe<StateOfChargeUnit>;
};


/** Leg of a route detail. */
export type TruckRouteDetailsLegRange_At_DestinationArgs = {
  unit?: InputMaybe<StateOfChargeUnit>;
};


/** Leg of a route detail. */
export type TruckRouteDetailsLegRange_At_OriginArgs = {
  unit?: InputMaybe<StateOfChargeUnit>;
};

export type TruckRouteDetailsLegFeaturePoint = {
  __typename?: 'TruckRouteDetailsLegFeaturePoint';
  /** Geometry of the feature. */
  geometry: Point;
  /** ID of the feature. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Properties of the feature. */
  properties?: Maybe<TruckRouteDetailsLegFeatureProperties>;
  /** Feature type. */
  type: FeatureType;
};

export type TruckRouteDetailsLegFeatureProperties = {
  __typename?: 'TruckRouteDetailsLegFeatureProperties';
  /** Air pressure at the location. */
  air_pressure?: Maybe<Scalars['Float']['output']>;
  /** Duration, in seconds, of time spent at this location. */
  duration?: Maybe<Scalars['Int']['output']>;
  /** External ID of the station. */
  external_station_id?: Maybe<Scalars['ID']['output']>;
  /** Name of the location. */
  name?: Maybe<Scalars['String']['output']>;
  /** Number of occupants present in the vehicle. */
  occupants: Scalars['Int']['output'];
  /** Solar irradiance at the location. */
  solar_irradiance?: Maybe<Scalars['Float']['output']>;
  /** ID of the station. */
  station_id?: Maybe<Scalars['ID']['output']>;
  /** Temperature at the location. */
  temperature?: Maybe<Scalars['Int']['output']>;
  /** Value of the current weight of the cargo. */
  total_cargo_weight?: Maybe<Scalars['Float']['output']>;
  /** Value of the combined weight of the occupants. */
  total_occupant_weight: Scalars['Float']['output'];
  /** Number of trailers. */
  trailer_count: Scalars['Int']['output'];
};


export type TruckRouteDetailsLegFeaturePropertiesTemperatureArgs = {
  unit?: InputMaybe<TemperatureUnit>;
};


export type TruckRouteDetailsLegFeaturePropertiesTotal_Cargo_WeightArgs = {
  unit?: InputMaybe<WeightUnit>;
};


export type TruckRouteDetailsLegFeaturePropertiesTotal_Occupant_WeightArgs = {
  unit?: InputMaybe<WeightUnit>;
};

export type TruckRouteDetailsLegSection = {
  __typename?: 'TruckRouteDetailsLegSection';
  /** Total energy used in a section in kilowatt-hours. The value will be 0 for walking sections. */
  consumption?: Maybe<Scalars['Float']['output']>;
  /** Destination point. */
  destination: TruckRouteDetailsLegSectionFeaturePoint;
  /** Distance from the start to the end of a section. */
  distance: Scalars['Float']['output'];
  /** Total duration of a section, in seconds. The value will be 0 for walking sections. */
  duration: Scalars['Float']['output'];
  /** Origin point. */
  origin: TruckRouteDetailsLegSectionFeaturePoint;
  /** Polyline containing encoded coordinates. */
  polyline: Scalars['String']['output'];
  /** Aggregation of tags over the current section. */
  tags: Array<RouteDetailsTag>;
  /** Section type. */
  type: RouteDetailsLegSectionType;
};


export type TruckRouteDetailsLegSectionDistanceArgs = {
  unit?: InputMaybe<DistanceUnit>;
};


export type TruckRouteDetailsLegSectionPolylineArgs = {
  decimals?: InputMaybe<PolylineInputDecimals>;
};

export type TruckRouteDetailsLegSectionFeaturePoint = {
  __typename?: 'TruckRouteDetailsLegSectionFeaturePoint';
  /** Geometry of the feature. */
  geometry: Point;
  /** ID of the feature. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Properties of the feature. */
  properties: TruckRouteDetailsLegSectionFeaturePointProperties;
  /** Feature type. */
  type: FeatureType;
};

export type TruckRouteDetailsLegSectionFeaturePointProperties = {
  __typename?: 'TruckRouteDetailsLegSectionFeaturePointProperties';
  /** Number of occupants present in the vehicle. */
  occupants: Scalars['Int']['output'];
  /** Value of the current weight of the cargo. */
  total_cargo_weight?: Maybe<Scalars['Float']['output']>;
  /** Value of the combined weight of the occupants. */
  total_occupant_weight?: Maybe<Scalars['Float']['output']>;
  /** Number of trailers. */
  trailer_count: Scalars['Int']['output'];
};


export type TruckRouteDetailsLegSectionFeaturePointPropertiesTotal_Cargo_WeightArgs = {
  unit?: InputMaybe<WeightUnit>;
};


export type TruckRouteDetailsLegSectionFeaturePointPropertiesTotal_Occupant_WeightArgs = {
  unit?: InputMaybe<WeightUnit>;
};

export type TruckRouteResponse = {
  __typename?: 'TruckRouteResponse';
  /** ID of a route calculation. */
  id: Scalars['ID']['output'];
  /** Meta data for a route. */
  meta: RouteMetadata;
  /** Recommended route. */
  recommended?: Maybe<TruckRouteDetails>;
  /** Route request. */
  request_input: CreateTruckRoute;
  /** Status of a route. */
  status: RouteStatus;
};

/** Physical dimensions of the vehicle and trailers combination. */
export type TruckTrailerCombinedDimensions = {
  __typename?: 'TruckTrailerCombinedDimensions';
  /** Maximum height of the combination trailer and main vehicle combination (ground to highest vehicle point). */
  height: Scalars['Float']['output'];
  /** Total length of the trailers and main vehicle combination (bumper to bumper). */
  length: Scalars['Float']['output'];
  /** Maximum width of the trailers and main vehicle combination. */
  width: Scalars['Float']['output'];
};


/** Physical dimensions of the vehicle and trailers combination. */
export type TruckTrailerCombinedDimensionsHeightArgs = {
  unit?: InputMaybe<MeasurementUnit>;
};


/** Physical dimensions of the vehicle and trailers combination. */
export type TruckTrailerCombinedDimensionsLengthArgs = {
  unit?: InputMaybe<MeasurementUnit>;
};


/** Physical dimensions of the vehicle and trailers combination. */
export type TruckTrailerCombinedDimensionsWidthArgs = {
  unit?: InputMaybe<MeasurementUnit>;
};

/** Physical dimensions of the vehicle and trailers combination. */
export type TruckTrailerCombinedDimensionsInput = {
  /** Maximum height of the combination trailer and main vehicle combination (ground to highest vehicle point). */
  height: DimensionsInput;
  /** Total length of the trailers and main vehicle combination (bumper to bumper). */
  length: DimensionsInput;
  /** Maximum width of the trailers and main vehicle combination. */
  width: DimensionsInput;
};

export const TurningCircleUnit = {
  /** Return the turning circle in feet. */
  FOOT: 'foot',
  /** Return the turning circle in meters. */
  METER: 'meter'
} as const;

export type TurningCircleUnit = typeof TurningCircleUnit[keyof typeof TurningCircleUnit];
export type UpdateConnectedVehicleInput = {
  /** Id from the connected vehicle */
  id: Scalars['ID']['input'];
  /** New label for a connected vehicle */
  label?: InputMaybe<Scalars['PlainString']['input']>;
};

/** Output of a vehicle query. */
export type Vehicle = {
  __typename?: 'Vehicle';
  /** Adapters for the connectors of the vehicle. Please note that for HEVs this will always be an empty array. */
  adapters: Array<VehicleConnector>;
  /** Availability of the vehicle. */
  availability: VehicleAvailability;
  /** Battery of the vehicle. */
  battery: VehicleBattery;
  /** Body of the vehicle. */
  body: VehicleBody;
  /** Information about vehicle connectivity. */
  connect: Connect;
  /** Available connectors for the vehicle. Please note that for HEVs this will always be an empty array. */
  connectors: Array<VehicleConnector>;
  /** Drivetrain of the vehicle. */
  drivetrain: VehicleDrivetrain;
  /** Details about Heat Pump. */
  heat_pump?: Maybe<VehicleHeatPump>;
  /** Vehicles unique ID. */
  id: Scalars['ID']['output'];
  /** Media of the vehicle. */
  media: VehicleMedia;
  /** Naming of the vehicle. */
  naming: VehicleNaming;
  /** Performance of the vehicle. */
  performance?: Maybe<VehiclePerformance>;
  /** Vehicle intended use. Can be passenger, cargo, or utility. */
  purpose: VehiclePurpose;
  /** Range of the vehicle. */
  range: VehicleRange;
  /** Regions in which the vehicle is available. Based on the continent code (CC) standard. */
  region: Array<VehicleRegion>;
  /** Routing of the vehicle. */
  routing: VehicleRouting;
  /** Type of vehicle. */
  type: VehicleType;
};

export type VehicleAvailability = {
  __typename?: 'VehicleAvailability';
  /** Availability of the vehicle. */
  status: VehicleAvailabilityStatus;
};

/** Availability status of a vehicle. */
export const VehicleAvailabilityStatus = {
  /** Vehicle currently for sale in at least one market / region. */
  AVAILABLE: 'available',
  /** Concept vehicle, nearing production and/or confirmed, pre-order unknown or not open. */
  CONCEPT_VEHICLE: 'concept_vehicle',
  /** Concept vehicle, nearing production and/or confirmed, pre-order open. */
  CONCEPT_VEHICLE_PREORDERABLE: 'concept_vehicle_preorderable',
  /** Concept vehicle, not close to production and/or unconfirmed, pre-order unknown. */
  CONCEPT_VEHICLE_RELEASE_DATE_TBA: 'concept_vehicle_release_date_tba',
  /** Concept vehicle, not close to production and/or unconfirmed, pre-order open. */
  CONCEPT_VEHICLE_RELEASE_DATE_TBA_PREORDERABLE: 'concept_vehicle_release_date_tba_preorderable',
  /** Vehicle no longer for sale in any market / region. */
  NO_LONGER_AVAILABLE: 'no_longer_available',
  /** Vehicle expected in market from Date_From (estimated), pre-order unknown or not open. */
  RELEASE_DATE_ANNOUNCED: 'release_date_announced',
  /** Vehicle expected in market from Date_From (estimated), pre-order open. */
  RELEASE_DATE_ANNOUNCED_PREORDERABLE: 'release_date_announced_preorderable',
  /** Status uncertain, introduction date and/or pricing unclear. */
  UNCERTAIN: 'uncertain'
} as const;

export type VehicleAvailabilityStatus = typeof VehicleAvailabilityStatus[keyof typeof VehicleAvailabilityStatus];
export type VehicleBattery = {
  __typename?: 'VehicleBattery';
  /** Full battery capacity in kWh. */
  full_kwh: Scalars['Float']['output'];
  /** Type of battery. */
  type?: Maybe<VehicleBatteryType>;
  /** Usable battery capacity in kWh. */
  usable_kwh: Scalars['Float']['output'];
};

/** Battery field estimated. */
export const VehicleBatteryFieldEstimations = {
  /** Both of the battery kWh fields are estimations. */
  B: 'B',
  /** full_kwh field is estimated. */
  F: 'F',
  /** None of the battery kWh fields are estimations. */
  N: 'N',
  /** usable_kwh field is estimated. */
  U: 'U'
} as const;

export type VehicleBatteryFieldEstimations = typeof VehicleBatteryFieldEstimations[keyof typeof VehicleBatteryFieldEstimations];
export const VehicleBatteryType = {
  /** Lithium-Ion Battery. */
  LITHIUM_ION: 'lithium_ion'
} as const;

export type VehicleBatteryType = typeof VehicleBatteryType[keyof typeof VehicleBatteryType];
export type VehicleBody = {
  __typename?: 'VehicleBody';
  /** Height (average height for adjustable suspensions). */
  height: Scalars['Float']['output'];
  /** Number of seats. */
  seats: Scalars['Int']['output'];
  /** Weight (unladen). */
  weight: VehicleBodyWeight;
  /** Width with folded mirrors. */
  width: Scalars['Float']['output'];
};


export type VehicleBodyHeightArgs = {
  unit?: InputMaybe<MeasurementUnit>;
};


export type VehicleBodyWidthArgs = {
  unit?: InputMaybe<MeasurementUnit>;
};

export type VehicleBodyWeight = {
  __typename?: 'VehicleBodyWeight';
  /** Maximal weight. */
  maximal?: Maybe<Scalars['Float']['output']>;
  /** Minimum weight. */
  minimum?: Maybe<Scalars['Float']['output']>;
  /** Nominal weight. */
  nominal?: Maybe<Scalars['Float']['output']>;
};


export type VehicleBodyWeightMaximalArgs = {
  unit?: InputMaybe<WeightUnit>;
};


export type VehicleBodyWeightMinimumArgs = {
  unit?: InputMaybe<WeightUnit>;
};


export type VehicleBodyWeightNominalArgs = {
  unit?: InputMaybe<WeightUnit>;
};

/** Vehicle plug model. */
export type VehicleConnector = {
  __typename?: 'VehicleConnector';
  /** Charging speed. */
  charge_speed: Scalars['Float']['output'];
  /** Maximum electric power. */
  max_electric_power: Scalars['Float']['output'];
  /** Usable electric power. */
  power: Scalars['Float']['output'];
  /**
   * Charging speed.
   * @deprecated In favor of `charge_speed`.
   */
  speed: Scalars['Float']['output'];
  /** Connector type, known as connector standard in OCPI. */
  standard: ConnectorType;
  /** Time it takes to charge from 10 to 80% with a fast charger, shown in minutes. */
  time: Scalars['Int']['output'];
};


/** Vehicle plug model. */
export type VehicleConnectorCharge_SpeedArgs = {
  unit?: InputMaybe<ChargeSpeedUnit>;
};


/** Vehicle plug model. */
export type VehicleConnectorMax_Electric_PowerArgs = {
  unit?: InputMaybe<PowerUnit>;
};


/** Vehicle plug model. */
export type VehicleConnectorPowerArgs = {
  unit?: InputMaybe<PowerUnit>;
};


/** Vehicle plug model. */
export type VehicleConnectorSpeedArgs = {
  unit?: InputMaybe<SpeedUnit>;
};

/** The consumption of the vehicle. */
export type VehicleConsumptionInput = {
  /** Best conditions are based on 23°C and no use of A/C. */
  best?: InputMaybe<Scalars['Float']['input']>;
  /** Worst conditions are based on -10°C and use of heating. */
  worst?: InputMaybe<Scalars['Float']['input']>;
};

export type VehicleData = {
  __typename?: 'VehicleData';
  /** Battery data */
  battery?: Maybe<ConnectBattery>;
  /** Charge data */
  charge?: Maybe<ConnectCharge>;
  /** Location data */
  location?: Maybe<ConnectLocation>;
  /** Odometer data */
  odometer?: Maybe<ConnectOdometer>;
};

export const VehicleDataProvider = {
  /** Internal data provider. */
  CHARGETRIP: 'chargetrip',
  /** EV database data provider. */
  EVDATABASE: 'evdatabase'
} as const;

export type VehicleDataProvider = typeof VehicleDataProvider[keyof typeof VehicleDataProvider];
export type VehicleDrivetrain = {
  __typename?: 'VehicleDrivetrain';
  /** Type of drivetrain. */
  type: VehicleDrivetrainType;
};

/** Drivetrain. */
export const VehicleDrivetrainType = {
  /** Battery Electric Vehicle. */
  BEV: 'BEV',
  /** Extended Range Electric Vehicle. */
  EREV: 'EREV',
  /** Hybrid Electric Vehicle. */
  HEV: 'HEV',
  /** Plug-in Hybrid Electric Vehicle. */
  PHEV: 'PHEV'
} as const;

export type VehicleDrivetrainType = typeof VehicleDrivetrainType[keyof typeof VehicleDrivetrainType];
/** Fuel type. */
export const VehicleFuel = {
  /** ICE engine available. Uses diesel. */
  D: 'D',
  /** Electricity only. Full electric vehicle. */
  E: 'E',
  /** ICE engine available. Uses gasoline. */
  P: 'P'
} as const;

export type VehicleFuel = typeof VehicleFuel[keyof typeof VehicleFuel];
export type VehicleHeatPump = {
  __typename?: 'VehicleHeatPump';
  /** Indicates if a heat pump is available for a specific vehicle. */
  is_available?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if a heat pump is standard equipment for a specific vehicle. */
  is_standard_equipment?: Maybe<Scalars['Boolean']['output']>;
};

export type VehicleImage = {
  __typename?: 'VehicleImage';
  /** Height of a large image in pixels. */
  height: Scalars['Int']['output'];
  /** Image id. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Height of a thumbnail image in pixels. */
  thumbnail_height: Scalars['Int']['output'];
  /** Full path URL of a thumbnail image. */
  thumbnail_url: Scalars['String']['output'];
  /** Width of a thumbnail image in pixels. */
  thumbnail_width: Scalars['Int']['output'];
  /** Image type. */
  type: VehicleImageType;
  /** Full path URL of a large image. */
  url: Scalars['String']['output'];
  /** Width of a large image in pixels. */
  width: Scalars['Int']['output'];
};

/** Available types of images which can be found for a vehicle. Each type has specific image sizes. */
export const VehicleImageType = {
  /** Full-sized brand (make) logo at 768x432 px. */
  BRAND: 'brand',
  /** Thumbnail of a full-sized brand (make) logo at 56x24 px. */
  BRAND_THUMBNAIL: 'brand_thumbnail',
  /** Full-sized image at 1536x864 px. */
  IMAGE: 'image',
  /** Premium image. */
  IMAGE_PREMIUM: 'image_premium',
  /** Thumbnail of a full-sized image at 131x72 px. */
  IMAGE_THUMBNAIL: 'image_thumbnail',
  /** Placeholder image at 1536x864 px. */
  PLACEHOLDER: 'placeholder',
  /** Thumbnail of a premium image. */
  PREMIUM_IMAGE_THUMBNAIL: 'premium_image_thumbnail',
  /** Images provided by a Vehicle Datasource. */
  PROVIDER: 'provider'
} as const;

export type VehicleImageType = typeof VehicleImageType[keyof typeof VehicleImageType];
/** When uploading images to a vehicle, you can select one of this types. The rest of the types are automatically generated by the system. */
export const VehicleImageTypeUploadable = {
  /** Freemium vehicle image. */
  IMAGE: 'image',
  /** Premium vehicle image. */
  IMAGE_PREMIUM: 'image_premium'
} as const;

export type VehicleImageTypeUploadable = typeof VehicleImageTypeUploadable[keyof typeof VehicleImageTypeUploadable];
/** The output element of the vehicleList query. */
export type VehicleList = {
  __typename?: 'VehicleList';
  /** Adapters available for the vehicle. Please note that for HEVs this will always be an empty array. */
  adapters: Array<VehicleConnector>;
  /** Availability of the vehicle. */
  availability: VehicleListAvailability;
  /** Battery of the vehicle. */
  battery: VehicleListBattery;
  /** Body of the vehicle. */
  body: VehicleListBody;
  /** Information about vehicle connectivity. */
  connect: Connect;
  /** Connectors available for the vehicle. Please note that for HEVs this will always be an empty array. */
  connectors: Array<VehicleConnector>;
  /** Drivetrain of the vehicle. */
  drivetrain: VehicleDrivetrain;
  /** Vehicles unique ID. */
  id: Scalars['ID']['output'];
  /** Media of the vehicle. */
  media: VehicleListMedia;
  /** Naming of the vehicle. */
  naming: VehicleListNaming;
  /** Vehicle intended use. Can be passenger, cargo, or utility. */
  purpose: VehiclePurpose;
  /** Range of the vehicle. */
  range: VehicleListRange;
  /** Regions in which the vehicle is available. Based on the continent code (CC) standard. */
  region: Array<VehicleRegion>;
  /** Routing of the vehicle. */
  routing: VehicleListRouting;
  /** Type of vehicle. */
  type: VehicleType;
};

export type VehicleListAvailability = {
  __typename?: 'VehicleListAvailability';
  /** Availability of the vehicle. */
  status: VehicleAvailabilityStatus;
};

export type VehicleListBattery = {
  __typename?: 'VehicleListBattery';
  /** Full battery capacity in kWh. */
  full_kwh: Scalars['Float']['output'];
  /** Type of battery. */
  type?: Maybe<VehicleBatteryType>;
  /** Usable battery capacity in kWh. */
  usable_kwh: Scalars['Float']['output'];
};

export type VehicleListBody = {
  __typename?: 'VehicleListBody';
  /** Number of seats in a vehicle. */
  seats: Scalars['Int']['output'];
};

export type VehicleListFilter = {
  /** Availability of a vehicle. */
  availability?: InputMaybe<Array<VehicleAvailabilityStatus>>;
  /** Information about vehicle connectivity. */
  connect?: InputMaybe<ConnectFilter>;
  /** Drivetrain type of a vehicle. */
  drivetrain?: InputMaybe<Array<VehicleDrivetrainType>>;
  /** ID of the vehicle make. */
  make?: InputMaybe<Scalars['String']['input']>;
  /** [BETA] Model of vehicle. */
  model?: InputMaybe<Scalars['String']['input']>;
  /** Vehicle intended use. Can be passenger, cargo, or utility. */
  purpose?: InputMaybe<Array<VehiclePurpose>>;
  /** Regions in which the vehicle is available. Based on the continent code (CC) standard. */
  region?: InputMaybe<Array<VehicleRegion>>;
  /** Type of vehicle. */
  type?: InputMaybe<Array<VehicleType>>;
};

export type VehicleListMedia = {
  __typename?: 'VehicleListMedia';
  /**
   * Latest make logo of the vehicle.
   * @deprecated In favor of `make`.
   */
  brand: VehicleImage;
  /** Featured image of the vehicle from a 45-degree angle. */
  image: VehicleImage;
  /** Latest make logo of the vehicle. */
  make: VehicleImage;
  /** Latest video of the vehicle. */
  video?: Maybe<VehicleVideo>;
};

export type VehicleListNaming = {
  __typename?: 'VehicleListNaming';
  /** Vehicle model version. Added by Chargetrip as an alternative for when a vehicle manufacturer does not provide an version name, or uses the same version name across all trims or consecutive years. */
  chargetrip_version: Scalars['String']['output'];
  /** Another submodel level of the vehicle. */
  edition?: Maybe<Scalars['String']['output']>;
  /** Vehicle manufacturer name. */
  make: Scalars['String']['output'];
  /** Vehicle model name. */
  model: Scalars['String']['output'];
  /** Version, edition or submodel of the vehicle. */
  version?: Maybe<Scalars['String']['output']>;
};

export type VehicleListRange = {
  __typename?: 'VehicleListRange';
  /**
   * Chargetrip's custom real-world range provides a carefully calculated display range for all-electric vehicle models.
   * Chargetrip range is based on the theoretical distance driven using only the electric engine.
   * Vehicles that do not have a full electric drivetrain type (all except Battery Electric Vehicles / BEV) therefore return relatively small ranges.
   * More information on the CT range can be found at https://chargetrip.com/blog/what-is-ct-real-range
   */
  chargetrip_range: ChargetripRange;
};

export type VehicleListRouting = {
  __typename?: 'VehicleListRouting';
  /** Vehicles that support fast charging have a minimum charging speed of 43 kWh. */
  fast_charging_support: Scalars['Boolean']['output'];
};

/** Vehicle make data. */
export type VehicleMake = {
  __typename?: 'VehicleMake';
  /** ID of the vehicle make. */
  id: Scalars['ID']['output'];
  /** Vehicle make image. */
  image: VehicleImage;
  /** Number of public and private unique models manufactured by the make. */
  model_count: Scalars['Int']['output'];
  /** Vehicle make name. */
  name: Scalars['String']['output'];
};

/** Vehicle makes response object. */
export type VehicleMakesConnection = {
  __typename?: 'VehicleMakesConnection';
  /** List of vehicle makes. */
  nodes: Array<VehicleMake>;
  /** Information about the current page. */
  page_info: PageInfo;
  /** Total number of unique vehicle makes. */
  total_count: Scalars['Int']['output'];
};

/** Filter vehicle make list result. */
export type VehicleMakesFilter = {
  /** Regions in which the Make has vehicles. */
  region?: InputMaybe<Array<VehicleRegion>>;
  /** Type of vehicle which the Make has vehicles. */
  type?: InputMaybe<Array<VehicleType>>;
};

export type VehicleMedia = {
  __typename?: 'VehicleMedia';
  /**
   * Latest make logo.
   * @deprecated In favor of `make`.
   */
  brand: VehicleImage;
  /** Featured image of the vehicle from a 45-degree angle. */
  image: VehicleImage;
  /** All images of the vehicle. */
  image_list: Array<VehicleImage>;
  /** Latest make logo. */
  make: VehicleImage;
  /** Latest video. */
  video?: Maybe<VehicleVideo>;
  /** All videos of the vehicle. */
  video_list?: Maybe<Array<VehicleVideo>>;
};

/** Mode (state) of the current production. */
export const VehicleMode = {
  /** Future releases of a vehicle, a concept of the vehicle, specs may change over time. */
  CONCEPT: 'concept',
  /** Old vehicle that is no longer manufactured. */
  INDEX_ONLY: 'index_only',
  /** Vehicle is in production and has been released. */
  PRODUCTION: 'production'
} as const;

export type VehicleMode = typeof VehicleMode[keyof typeof VehicleMode];
/** Vehicle model data. */
export type VehicleModel = {
  __typename?: 'VehicleModel';
  /** Vehicle model name. */
  name: Scalars['String']['output'];
  /** Number of public and private vehicles associated to this model. */
  vehicle_count: Scalars['Int']['output'];
};

/** Vehicle models response object. */
export type VehicleModelsConnection = {
  __typename?: 'VehicleModelsConnection';
  /** List of vehicle models. */
  nodes: Array<VehicleModel>;
  /** Information about the current page. */
  page_info: PageInfo;
  /** Total number of unique vehicle models. */
  total_count: Scalars['Int']['output'];
};

/** Filter vehicle model list result. */
export type VehicleModelsFilter = {
  /** Vehicle make. */
  make: Scalars['ID']['input'];
};

export type VehicleNaming = {
  __typename?: 'VehicleNaming';
  /** Vehicle model version. Added by Chargetrip as an alternative for when a vehicle manufacturer does not provide an version name, or uses the same version name across all trims or consecutive years. */
  chargetrip_version: Scalars['String']['output'];
  /** Another submodel level of the vehicle. */
  edition?: Maybe<Scalars['String']['output']>;
  /** Vehicle manufacturer name. */
  make: Scalars['String']['output'];
  /** Vehicle model name. */
  model: Scalars['String']['output'];
  /** Version, edition or submodel of the vehicle. */
  version?: Maybe<Scalars['String']['output']>;
};

export type VehiclePerformance = {
  __typename?: 'VehiclePerformance';
  /** Acceleration. */
  acceleration?: Maybe<Scalars['Float']['output']>;
  /** Top speed of the vehicle. */
  top_speed?: Maybe<Scalars['Float']['output']>;
};


export type VehiclePerformanceAccelerationArgs = {
  unit?: InputMaybe<AccelerationUnit>;
};


export type VehiclePerformanceTop_SpeedArgs = {
  unit?: InputMaybe<SpeedUnit>;
};

export const VehiclePlugAndChargeSupport = {
  /** Plug and charge is announced, but not yet available. */
  ANNOUNCED: 'announced',
  /** Plug and charge is available. */
  AVAILABLE: 'available',
  /** Plug and charge is available in a limited context. */
  LIMITED: 'limited',
  /** Plug and charge is not available. */
  NOT_AVAILABLE: 'not_available'
} as const;

export type VehiclePlugAndChargeSupport = typeof VehiclePlugAndChargeSupport[keyof typeof VehiclePlugAndChargeSupport];
/** The output element of the vehiclePremium query. */
export type VehiclePremium = {
  __typename?: 'VehiclePremium';
  /** Adapters of connectors available for a connectors of the vehicle. Please note that for HEVs this will always be an empty array. */
  adapters: Array<VehicleConnector>;
  /** Availability of the vehicle. */
  availability: VehiclePremiumAvailability;
  /** Battery of the vehicle. */
  battery: VehiclePremiumBattery;
  /** Body of the vehicle. */
  body: VehiclePremiumBody;
  /** Charge details. */
  charge: VehiclePremiumCharge;
  /** Information about vehicle connectivity. */
  connect: Connect;
  /** Connectors available for the vehicle. Please note that for HEVs this will always be an empty array. */
  connectors: Array<VehicleConnector>;
  /** Drivetrain of the vehicle. */
  drivetrain: VehiclePremiumDrivetrain;
  /** Efficiency of the vehicle. */
  efficiency: VehiclePremiumEfficiency;
  /** Fast charge details. */
  fast_charge: VehiclePremiumFastCharge;
  /** Details about Heat Pump. */
  heat_pump?: Maybe<VehicleHeatPump>;
  /** Vehicles unique ID. */
  id: Scalars['ID']['output'];
  /** Media of the vehicle. */
  media: VehiclePremiumMedia;
  /** Naming of the vehicle. */
  naming: VehiclePremiumNaming;
  /** Performance of the vehicle. */
  performance?: Maybe<VehiclePremiumPerformance>;
  /** Starting price in the currency defined in the field argument. If not defined, it will return the starting price in the currency returned in the currency field. */
  pricing: VehiclePremiumPriceValueWithGrant;
  /** Vehicle intended use. Can be passenger, cargo, or utility. */
  purpose: VehiclePurpose;
  /** Range of the vehicle. */
  range: VehiclePremiumRange;
  /** Regions in which the vehicle is available. Based on the continent code (CC) standard. */
  region: Array<VehicleRegion>;
  /** Routing of the vehicle. */
  routing: VehiclePremiumRouting;
  /** Safety of the vehicle. */
  safety?: Maybe<VehiclePremiumSafety>;
  /** Internal ID of the successor vehicle trim. */
  succesor_id?: Maybe<Scalars['String']['output']>;
  /** Type of vehicle. */
  type: VehicleType;
};

export type VehiclePremiumAvailability = {
  __typename?: 'VehiclePremiumAvailability';
  /** Date of introduction, mm-yyyy. */
  date_from?: Maybe<Scalars['String']['output']>;
  /** Indicates if date from field is estimated. */
  date_from_is_estimated?: Maybe<Scalars['Boolean']['output']>;
  /** Date last available, mm-yyyy. */
  date_to?: Maybe<Scalars['String']['output']>;
  /** Availability of the vehicle. */
  status: VehicleAvailabilityStatus;
};

export type VehiclePremiumBattery = {
  __typename?: 'VehiclePremiumBattery';
  /** Number of cells in the battery pack, can include configuration (s = serial, p = parallel). */
  cells?: Maybe<Scalars['String']['output']>;
  /** Chemistry of the battery. */
  chemistry?: Maybe<Scalars['String']['output']>;
  /** Indicates which battery fields are estimated. */
  estimated_fields?: Maybe<VehicleBatteryFieldEstimations>;
  /** Full battery capacity in kWh. */
  full_kwh: Scalars['Float']['output'];
  /** Manufacturer of the battery. */
  manufacturer?: Maybe<Scalars['String']['output']>;
  /** Number of battery modules. */
  modules?: Maybe<Scalars['Float']['output']>;
  /** Nominal voltage of battery. */
  nominal_voltage?: Maybe<Scalars['Float']['output']>;
  /** Battery thermal management system (active/passive, air/liquid). */
  thermal_management_system?: Maybe<Scalars['String']['output']>;
  /** Type of battery. */
  type?: Maybe<VehicleBatteryType>;
  /** Usable battery capacity in kWh. */
  usable_kwh: Scalars['Float']['output'];
  /** Mileage of battery warranty in kilometers. */
  warranty_mileage?: Maybe<Scalars['Float']['output']>;
  /** Duration of battery warranty in years. */
  warranty_period?: Maybe<Scalars['Float']['output']>;
  /** Weight of the battery pack. */
  weight?: Maybe<Scalars['Float']['output']>;
};


export type VehiclePremiumBatteryWeightArgs = {
  unit?: InputMaybe<WeightUnit>;
};

export type VehiclePremiumBody = {
  __typename?: 'VehiclePremiumBody';
  /** Body type, listed in local naming convention where applicable. */
  body_type?: Maybe<Scalars['String']['output']>;
  /** Standard luggage capacity. */
  boot_capacity?: Maybe<Scalars['Float']['output']>;
  /** Maximum luggage capacity. */
  boot_capacity_max?: Maybe<Scalars['Float']['output']>;
  /** Storage capacity of front trunk/under the hood (frunk). */
  boot_front_capacity?: Maybe<Scalars['Float']['output']>;
  /** Width of vehicle including mirrors. */
  full_width?: Maybe<Scalars['Float']['output']>;
  /** Ground clearance of a vehicle as specified by the OEM. */
  ground_clearance?: Maybe<Scalars['Float']['output']>;
  /** Indicates whether a vehicle has roof rails as a standard. */
  has_roofrails?: Maybe<Scalars['Boolean']['output']>;
  /** Height (average height for adjustable suspensions). */
  height: Scalars['Float']['output'];
  /** Length. */
  length?: Maybe<Scalars['Float']['output']>;
  /** Maximum load on roof of the vehicle. */
  roof_load_max?: Maybe<Scalars['Float']['output']>;
  /** Number of seats. */
  seats: Scalars['Int']['output'];
  /** Segment, listed in local naming convention where applicable. */
  segment?: Maybe<Scalars['String']['output']>;
  /** Indicates if length/width/height fields are estimations. */
  size_is_estimated?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if a tow hitch/towbar can be fitted according to vehicle homologation. */
  tow_hitch_compatible?: Maybe<Scalars['Boolean']['output']>;
  /** Maximum braked towing weight. */
  tow_weight_braked?: Maybe<Scalars['Float']['output']>;
  /** Indicates if tow weight fields are estimations. */
  tow_weight_is_estimated?: Maybe<Scalars['Boolean']['output']>;
  /** Maximum unbraked towing weight. */
  tow_weight_unbraked?: Maybe<Scalars['Float']['output']>;
  /** Maximum vertical load / noseweight on tow hitch according to vehicle homologation. */
  tow_weight_vertical_load?: Maybe<Scalars['Float']['output']>;
  /** Turning circle of the vehicle kerb-to-kerb. */
  turning_circle?: Maybe<Scalars['Float']['output']>;
  /** Name of the vehicle platform used for vehicle (often abbreviated to indicate group platforms). */
  vehicle_platform?: Maybe<Scalars['String']['output']>;
  /** Indicates if the vehicle platform used for vehicle is a dedicated battery electric vehicle platform. */
  vehicle_platform_is_dedicated?: Maybe<Scalars['Boolean']['output']>;
  /** Weight (unladen EU). */
  weight: VehicleBodyWeight;
  /** Maximum allowed vehicle and trailer weight with payload. */
  weight_gtw?: Maybe<VehicleBodyWeight>;
  /** Maximum allowed vehicle weight with payload. */
  weight_gvwr?: Maybe<VehicleBodyWeight>;
  /** Indicates if weight field is estimated. */
  weight_is_estimated?: Maybe<Scalars['Boolean']['output']>;
  /** Maximum payload allowed for the vehicle. */
  weight_max_payload?: Maybe<Scalars['Float']['output']>;
  /** Allowed payload weight. */
  weight_payload?: Maybe<VehicleBodyWeight>;
  /** Wheelbase. */
  wheelbase?: Maybe<Scalars['Float']['output']>;
  /** Indicates if wheelbase field is estimated. */
  wheelbase_is_estimated?: Maybe<Scalars['Boolean']['output']>;
  /** Width with folded mirrors. */
  width: Scalars['Float']['output'];
};


export type VehiclePremiumBodyBoot_CapacityArgs = {
  unit?: InputMaybe<VolumeUnit>;
};


export type VehiclePremiumBodyBoot_Capacity_MaxArgs = {
  unit?: InputMaybe<VolumeUnit>;
};


export type VehiclePremiumBodyBoot_Front_CapacityArgs = {
  unit?: InputMaybe<VolumeUnit>;
};


export type VehiclePremiumBodyFull_WidthArgs = {
  unit?: InputMaybe<MeasurementUnit>;
};


export type VehiclePremiumBodyGround_ClearanceArgs = {
  unit?: InputMaybe<MeasurementUnit>;
};


export type VehiclePremiumBodyHeightArgs = {
  unit?: InputMaybe<MeasurementUnit>;
};


export type VehiclePremiumBodyLengthArgs = {
  unit?: InputMaybe<MeasurementUnit>;
};


export type VehiclePremiumBodyRoof_Load_MaxArgs = {
  unit?: InputMaybe<WeightUnit>;
};


export type VehiclePremiumBodyTow_Weight_BrakedArgs = {
  unit?: InputMaybe<WeightUnit>;
};


export type VehiclePremiumBodyTow_Weight_UnbrakedArgs = {
  unit?: InputMaybe<WeightUnit>;
};


export type VehiclePremiumBodyTow_Weight_Vertical_LoadArgs = {
  unit?: InputMaybe<WeightUnit>;
};


export type VehiclePremiumBodyTurning_CircleArgs = {
  unit?: InputMaybe<TurningCircleUnit>;
};


export type VehiclePremiumBodyWeight_Max_PayloadArgs = {
  unit?: InputMaybe<WeightUnit>;
};


export type VehiclePremiumBodyWheelbaseArgs = {
  unit?: InputMaybe<MeasurementUnit>;
};


export type VehiclePremiumBodyWidthArgs = {
  unit?: InputMaybe<MeasurementUnit>;
};

export type VehiclePremiumCharge = {
  __typename?: 'VehiclePremiumCharge';
  /** Alternative upgrade for the standard onboard charger when available. */
  alternative?: Maybe<VehiclePremiumChargeAlternativeObc>;
  /** Optional upgrade for the standard onboard charger when available. */
  option?: Maybe<VehiclePremiumChargeOptionObc>;
  /** Information about the main connector. */
  plug?: Maybe<VehiclePremiumChargePlug>;
  /** Information about vehicles secondary onboard charger. */
  second_plug?: Maybe<VehiclePremiumChargeSecondPlug>;
  /** Information about the vehicle standard onboard charger. */
  standard?: Maybe<VehiclePremiumChargeStandardObc>;
  /** Vehicle-to-everything charge support. */
  vehicle_to_everything?: Maybe<VehicleToEverything>;
};

export type VehiclePremiumChargeAlternativeObc = {
  __typename?: 'VehiclePremiumChargeAlternativeOBC';
  /** Charging speed when charging at maximum power (alternative OBC). */
  charge_speed?: Maybe<Scalars['Float']['output']>;
  /** Minutes needed to charge from 0% to 100% (alternative OBC). */
  charge_time?: Maybe<Scalars['Int']['output']>;
  /** Maximum current the OBC accepts per phase to achieve maximum power (alternative OBC). */
  phase_amperage?: Maybe<Scalars['Float']['output']>;
  /** Number of phases the OBC accepts to achieve maximum power (alternative OBC). */
  phases?: Maybe<Scalars['Int']['output']>;
  /** Maximum power OBC can accept to charge a battery (alternative OBC). */
  power?: Maybe<Scalars['Float']['output']>;
  /** Charging details for the alternative OBC at several charging points. */
  table?: Maybe<Array<Maybe<VehiclePremiumChargeObcTable>>>;
};


export type VehiclePremiumChargeAlternativeObcCharge_SpeedArgs = {
  unit?: InputMaybe<ChargeSpeedUnit>;
};


export type VehiclePremiumChargeAlternativeObcPowerArgs = {
  unit?: InputMaybe<PowerUnit>;
};

export type VehiclePremiumChargeObcTable = {
  __typename?: 'VehiclePremiumChargeOBCTable';
  /** Current per phase used by standard OBC (phase current). */
  charge_phase_amperage?: Maybe<Scalars['Float']['output']>;
  /** Voltage between phase and neutral used by standard OBC (phase voltage). */
  charge_phase_voltage?: Maybe<Scalars['Int']['output']>;
  /** Number of phases used by standard OBC. */
  charge_phases?: Maybe<Scalars['Int']['output']>;
  /** Power used by standard OBC (before OBC losses). */
  charge_power?: Maybe<Scalars['Float']['output']>;
  /** Charging speed when charging at maximum power (standard OBC with this EVSE). */
  charge_speed?: Maybe<Scalars['Float']['output']>;
  /** Minutes needed to charge from 0% to 100% (standard OBC with this EVSE). */
  charge_time?: Maybe<Scalars['Int']['output']>;
  /** Current per phase for this EVSE (phase current). */
  evse_phase_amperage?: Maybe<Scalars['Int']['output']>;
  /** Voltage between phase and neutral for this EVSE (phase voltage). */
  evse_phase_voltage?: Maybe<Scalars['Int']['output']>;
  /** Number of phases for this EVSE. */
  evse_phases?: Maybe<Scalars['Int']['output']>;
};


export type VehiclePremiumChargeObcTableCharge_PowerArgs = {
  unit?: InputMaybe<PowerUnit>;
};


export type VehiclePremiumChargeObcTableCharge_SpeedArgs = {
  unit?: InputMaybe<ChargeSpeedUnit>;
};

export type VehiclePremiumChargeOptionObc = {
  __typename?: 'VehiclePremiumChargeOptionOBC';
  /** Charging speed when charging at maximum power (standard OBC). */
  charge_speed?: Maybe<Scalars['Float']['output']>;
  /** Minutes needed to charge from 0% to 100% (standard OBC). */
  charge_time?: Maybe<Scalars['Int']['output']>;
  /** Maximum current the OBC accepts per phase to achieve maximum power (standard OBC). */
  phase_amperage?: Maybe<Scalars['Float']['output']>;
  /** Number of phases the OBC accepts to achieve maximum power (standard OBC). */
  phases?: Maybe<Scalars['Int']['output']>;
  /** Maximum power OBC can accept to charge a battery (standard OBC). */
  power?: Maybe<Scalars['Float']['output']>;
  /** Charging details for the standard OBC at several charging points. */
  table?: Maybe<Array<Maybe<VehiclePremiumChargeObcTable>>>;
};


export type VehiclePremiumChargeOptionObcCharge_SpeedArgs = {
  unit?: InputMaybe<ChargeSpeedUnit>;
};


export type VehiclePremiumChargeOptionObcPowerArgs = {
  unit?: InputMaybe<PowerUnit>;
};

export type VehiclePremiumChargePlug = {
  __typename?: 'VehiclePremiumChargePlug';
  /** Indicates if value is an estimate. */
  is_estimated?: Maybe<Scalars['Boolean']['output']>;
  /** Location of charge port. */
  location?: Maybe<Scalars['String']['output']>;
  /** Type of charge port on vehicle. */
  value?: Maybe<ConnectorType>;
};

export type VehiclePremiumChargePower = {
  __typename?: 'VehiclePremiumChargePower';
  /** Average value. */
  average?: Maybe<Scalars['Float']['output']>;
  /** Maximum value. */
  max?: Maybe<Scalars['Float']['output']>;
};


export type VehiclePremiumChargePowerAverageArgs = {
  unit?: InputMaybe<PowerUnit>;
};


export type VehiclePremiumChargePowerMaxArgs = {
  unit?: InputMaybe<PowerUnit>;
};

export type VehiclePremiumChargeSecondPlug = {
  __typename?: 'VehiclePremiumChargeSecondPlug';
  /** Indicates if second charge port is optional. */
  is_optional?: Maybe<Scalars['Boolean']['output']>;
  /** Location of charge port. */
  location?: Maybe<Scalars['String']['output']>;
};

export type VehiclePremiumChargeStandardObc = {
  __typename?: 'VehiclePremiumChargeStandardOBC';
  /** Charging speed when charging at maximum power (standard OBC). */
  charge_speed?: Maybe<Scalars['Float']['output']>;
  /** Minutes needed to charge from 0% to 100% (standard OBC). */
  charge_time?: Maybe<Scalars['Int']['output']>;
  /** Indicates if Charge_Standard fields are estimated. */
  is_estimated?: Maybe<Scalars['Boolean']['output']>;
  /** Maximum current the OBC accepts per phase to achieve maximum power (standard OBC). */
  phase_amperage?: Maybe<Scalars['Float']['output']>;
  /** Number of phases the OBC accepts to achieve maximum power (standard OBC). */
  phases?: Maybe<Scalars['Int']['output']>;
  /** Maximum power OBC can accept to charge a battery (standard OBC). */
  power?: Maybe<Scalars['Float']['output']>;
  /** Charging details for the standard OBC at several charging points. */
  table?: Maybe<Array<Maybe<VehiclePremiumChargeObcTable>>>;
};


export type VehiclePremiumChargeStandardObcCharge_SpeedArgs = {
  unit?: InputMaybe<ChargeSpeedUnit>;
};


export type VehiclePremiumChargeStandardObcPowerArgs = {
  unit?: InputMaybe<PowerUnit>;
};

export type VehiclePremiumDrivetrain = {
  __typename?: 'VehiclePremiumDrivetrain';
  /** Fuel type. */
  fuel?: Maybe<VehicleFuel>;
  /** Maximum (combined) power output. */
  power?: Maybe<Scalars['Float']['output']>;
  /** Maximum (combine) power output. */
  power_hp?: Maybe<Scalars['Float']['output']>;
  /** Indicates if power field is estimated. */
  power_is_estimated?: Maybe<Scalars['Boolean']['output']>;
  /** Propulsion type. */
  propulsion?: Maybe<VehiclePropulsion>;
  /** Indicates if propulsion field is estimated. */
  propulsion_is_estimated?: Maybe<Scalars['Boolean']['output']>;
  /** Maximum (combine) torque output. */
  torque?: Maybe<Scalars['Float']['output']>;
  /** Indicates if torque field is estimated. */
  torque_is_estimated?: Maybe<Scalars['Boolean']['output']>;
  /** Type of drivetrain. */
  type: VehicleDrivetrainType;
};


export type VehiclePremiumDrivetrainPowerArgs = {
  unit?: InputMaybe<PowerUnit>;
};


export type VehiclePremiumDrivetrainPower_HpArgs = {
  unit?: InputMaybe<PowerUnit>;
};


export type VehiclePremiumDrivetrainTorqueArgs = {
  unit?: InputMaybe<TorqueUnit>;
};

export type VehiclePremiumEfficiency = {
  __typename?: 'VehiclePremiumEfficiency';
  /** Rated efficiency in NEDC combined cycle. */
  nedc?: Maybe<VehiclePremiumEfficiencyNedc>;
  /** Vehicle efficiency based on provider range. */
  provider?: Maybe<VehiclePremiumEfficiencyProvider>;
  /** Rated efficiency in WLTP combined cycle. */
  wltp?: Maybe<VehiclePremiumEfficiencyWltp>;
  /** Rated efficiency in WLTP combined cycle (TEH / least efficient trim). */
  wltp_teh?: Maybe<VehiclePremiumEfficiencyWltpteh>;
};

export type VehiclePremiumEfficiencyNedc = {
  __typename?: 'VehiclePremiumEfficiencyNEDC';
  /** Rated CO2 emissions in NEDC combined cycle in battery-only mode (NULL if not NEDC rated). */
  co2?: Maybe<Scalars['Float']['output']>;
  /** Rated efficiency in NEDC combined cycle presented in gas equivalent. */
  fuel_equivalent?: Maybe<Scalars['Float']['output']>;
  /** Rated efficiency in NEDC combined cycle. */
  value?: Maybe<Scalars['Float']['output']>;
  /** Rated vehicle efficiency in NEDC combined cycle (based on value). */
  vehicle?: Maybe<Scalars['Float']['output']>;
  /** Rated vehicle efficiency in NEDC combined cycle presented in gas equivalent. */
  vehicle_fuel_equivalent?: Maybe<Scalars['Float']['output']>;
};


export type VehiclePremiumEfficiencyNedcCo2Args = {
  unit?: InputMaybe<EmissionRateUnit>;
};


export type VehiclePremiumEfficiencyNedcFuel_EquivalentArgs = {
  unit?: InputMaybe<FuelConsumptionUnit>;
};


export type VehiclePremiumEfficiencyNedcValueArgs = {
  unit?: InputMaybe<ConsumptionUnit>;
};


export type VehiclePremiumEfficiencyNedcVehicleArgs = {
  unit?: InputMaybe<ConsumptionUnit>;
};


export type VehiclePremiumEfficiencyNedcVehicle_Fuel_EquivalentArgs = {
  unit?: InputMaybe<FuelConsumptionUnit>;
};

export type VehiclePremiumEfficiencyProvider = {
  __typename?: 'VehiclePremiumEfficiencyProvider';
  /** Best conditions are based on 23°C and no use of A/C. */
  best?: Maybe<VehiclePremiumEfficiencyProviderValue>;
  /** Vehicle efficiency based on RealRange presented in gas equivalent. */
  fuel_equivalent?: Maybe<Scalars['Float']['output']>;
  /** Vehicle efficiency based on RealRange (usable battery/range). */
  value?: Maybe<Scalars['Float']['output']>;
  /** Worst conditions are based on -10°C and use of heating. */
  worst?: Maybe<VehiclePremiumEfficiencyProviderValue>;
};


export type VehiclePremiumEfficiencyProviderFuel_EquivalentArgs = {
  unit?: InputMaybe<FuelConsumptionUnit>;
};


export type VehiclePremiumEfficiencyProviderValueArgs = {
  unit?: InputMaybe<ConsumptionUnit>;
};

export type VehiclePremiumEfficiencyProviderValue = {
  __typename?: 'VehiclePremiumEfficiencyProviderValue';
  /** Estimated value on city roads. */
  city?: Maybe<Scalars['Float']['output']>;
  /** Estimated combined value. */
  combined?: Maybe<Scalars['Float']['output']>;
  /** Estimated value on highway or express roads. */
  highway?: Maybe<Scalars['Float']['output']>;
};


export type VehiclePremiumEfficiencyProviderValueCityArgs = {
  unit?: InputMaybe<DistanceUnit>;
};


export type VehiclePremiumEfficiencyProviderValueCombinedArgs = {
  unit?: InputMaybe<DistanceUnit>;
};


export type VehiclePremiumEfficiencyProviderValueHighwayArgs = {
  unit?: InputMaybe<DistanceUnit>;
};

export type VehiclePremiumEfficiencyWltp = {
  __typename?: 'VehiclePremiumEfficiencyWLTP';
  /** Rated CO2 emissions in WLTP combined cycle in battery-only mode (NULL if not WLTP rated). */
  co2?: Maybe<Scalars['Float']['output']>;
  /** Rated efficiency in WLTP combined cycle presented in gas equivalent. */
  fuel_equivalent?: Maybe<Scalars['Float']['output']>;
  /** Rated efficiency in WLTP combined cycle. */
  value?: Maybe<Scalars['Float']['output']>;
  /** Rated vehicle efficiency in WLTP combined cycle (based on value). */
  vehicle?: Maybe<Scalars['Float']['output']>;
  /** Rated vehicle efficiency in WLTP combined cycle presented in gas equivalent. */
  vehicle_fuel_equivalent?: Maybe<Scalars['Float']['output']>;
};


export type VehiclePremiumEfficiencyWltpCo2Args = {
  unit?: InputMaybe<EmissionRateUnit>;
};


export type VehiclePremiumEfficiencyWltpFuel_EquivalentArgs = {
  unit?: InputMaybe<FuelConsumptionUnit>;
};


export type VehiclePremiumEfficiencyWltpValueArgs = {
  unit?: InputMaybe<ConsumptionUnit>;
};


export type VehiclePremiumEfficiencyWltpVehicleArgs = {
  unit?: InputMaybe<ConsumptionUnit>;
};


export type VehiclePremiumEfficiencyWltpVehicle_Fuel_EquivalentArgs = {
  unit?: InputMaybe<FuelConsumptionUnit>;
};

export type VehiclePremiumEfficiencyWltpteh = {
  __typename?: 'VehiclePremiumEfficiencyWLTPTEH';
  /** Rated CO2 emissions in WLTP TEH combined cycle in battery-only mode (NULL if not WLTP TEH rated). */
  co2?: Maybe<Scalars['Float']['output']>;
  /** Rated efficiency in WLTP TEH combined cycle presented in gas equivalent. */
  fuel_equivalent?: Maybe<Scalars['Float']['output']>;
  /** Rated efficiency in WLTP TEH combined cycle (TEH/least efficient trim). */
  value?: Maybe<Scalars['Float']['output']>;
  /** Rated vehicle efficiency in WLTP TEH combined cycle (based on value). */
  vehicle?: Maybe<Scalars['Float']['output']>;
  /** Rated vehicle efficiency in WLTP TEH combined cycle presented in gas equivalent. */
  vehicle_fuel_equivalent?: Maybe<Scalars['Float']['output']>;
};


export type VehiclePremiumEfficiencyWltptehCo2Args = {
  unit?: InputMaybe<EmissionRateUnit>;
};


export type VehiclePremiumEfficiencyWltptehFuel_EquivalentArgs = {
  unit?: InputMaybe<FuelConsumptionUnit>;
};


export type VehiclePremiumEfficiencyWltptehValueArgs = {
  unit?: InputMaybe<ConsumptionUnit>;
};


export type VehiclePremiumEfficiencyWltptehVehicleArgs = {
  unit?: InputMaybe<ConsumptionUnit>;
};


export type VehiclePremiumEfficiencyWltptehVehicle_Fuel_EquivalentArgs = {
  unit?: InputMaybe<FuelConsumptionUnit>;
};

export type VehiclePremiumFastCharge = {
  __typename?: 'VehiclePremiumFastCharge';
  /** Charging speed during fast charging from 10% to 80% (optimal conditions, fastest charger). */
  charge_speed?: Maybe<Scalars['Float']['output']>;
  /** Minutes needed to charge from 10% to 80%, with average charging power (optimal conditions, fastest charger). */
  charge_time?: Maybe<Scalars['Float']['output']>;
  /** Indicates if autocharge is available. */
  has_autocharge?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates what fields are estimated. */
  is_estimated?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the fastcharge data is based on a real-world test by Fastned. */
  is_fastned_tested?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if fast charge is optional in some markets/regions. */
  is_optional?: Maybe<Scalars['Boolean']['output']>;
  /** Status of Plug & Charge (PnC ISO15118) support for vehicle. */
  iso_15118_pnc_support?: Maybe<VehiclePlugAndChargeSupport>;
  /** Status of Plug & Charge (PnC ISO15118) -2 protocol support for vehicle. */
  iso_15118_pnc_support_2?: Maybe<VehiclePlugAndChargeSupport>;
  /** Status of Plug & Charge (PnC ISO15118) -20 protocol support for vehicle. */
  iso_15118_pnc_support_20?: Maybe<VehiclePlugAndChargeSupport>;
  /** Details about the connector. */
  plug?: Maybe<VehiclePremiumChargePlug>;
  /** Power during fast charging from 10% to 80% SoC (optimal conditions, fastest charger). */
  power?: Maybe<VehiclePremiumChargePower>;
  /** Charging details for fast charging. */
  table?: Maybe<Array<Maybe<VehiclePremiumFastChargeTable>>>;
};


export type VehiclePremiumFastChargeCharge_SpeedArgs = {
  unit?: InputMaybe<ChargeSpeedUnit>;
};

export type VehiclePremiumFastChargeTable = {
  __typename?: 'VehiclePremiumFastChargeTable';
  /** Indicates if average power during fast charging is limited by the vehicle. */
  average_is_limited?: Maybe<Scalars['Boolean']['output']>;
  /** Charging speed during fast charging from 10% to 80% (optimal conditions). */
  charge_speed?: Maybe<Scalars['Float']['output']>;
  /** Minutes needed to charge from 10% to 80% (optimal conditions). */
  charge_time?: Maybe<Scalars['Int']['output']>;
  /** Charging details for fast charging (format: ChargerConnector-ChargerPower-AC/DC). */
  format?: Maybe<Scalars['String']['output']>;
  /** Indicates if maximum power during fast charging is limited by the vehicle. */
  is_limited?: Maybe<Scalars['Boolean']['output']>;
  /** Fast charge power. */
  power?: Maybe<VehiclePremiumChargePower>;
};


export type VehiclePremiumFastChargeTableCharge_SpeedArgs = {
  unit?: InputMaybe<ChargeSpeedUnit>;
};

export type VehiclePremiumMedia = {
  __typename?: 'VehiclePremiumMedia';
  /**
   * Latest make logo.
   * @deprecated In favor of `make`.
   */
  brand: VehicleImage;
  /** Featured image of the vehicle from a 45-degree angle. */
  image: VehicleImage;
  /** All images of the vehicle. */
  image_list: Array<VehicleImage>;
  /** Latest make logo. */
  make: VehicleImage;
  /** URL of the OEM page for this vehicle. */
  oem_details_url?: Maybe<Scalars['String']['output']>;
  /** URL for more details. */
  provider_details_url?: Maybe<Scalars['String']['output']>;
  /** Latest video. */
  video?: Maybe<VehicleVideo>;
  /** All videos of the vehicle. */
  video_list?: Maybe<Array<VehicleVideo>>;
};

export type VehiclePremiumNaming = {
  __typename?: 'VehiclePremiumNaming';
  /** Vehicle model version. Added by Chargetrip as an alternative for when a vehicle manufacturer does not provide a version name, or uses the same version name across all trims or consecutive years. */
  chargetrip_version: Scalars['String']['output'];
  /** Another submodel level of the vehicle. */
  edition?: Maybe<Scalars['String']['output']>;
  /** Vehicle model height version. */
  height_version?: Maybe<Scalars['String']['output']>;
  /** Vehicle model length version. */
  length_version?: Maybe<Scalars['String']['output']>;
  /** Vehicle manufacturer name. */
  make: Scalars['String']['output'];
  /** Vehicle model name. */
  model: Scalars['String']['output'];
  /** Version, edition or submodel of the vehicle. */
  version?: Maybe<Scalars['String']['output']>;
};

export type VehiclePremiumPerformance = {
  __typename?: 'VehiclePremiumPerformance';
  /** Acceleration 0-100 km/h. */
  acceleration?: Maybe<Scalars['Float']['output']>;
  /** Indicates if acceleration field is estimated. */
  acceleration_is_estimated?: Maybe<Scalars['Boolean']['output']>;
  /** Top speed of the vehicle. */
  top_speed?: Maybe<Scalars['Float']['output']>;
  /** Indicates if top_speed field is estimated. */
  top_speed_is_estimated?: Maybe<Scalars['Boolean']['output']>;
};


export type VehiclePremiumPerformanceAccelerationArgs = {
  unit?: InputMaybe<AccelerationUnit>;
};


export type VehiclePremiumPerformanceTop_SpeedArgs = {
  unit?: InputMaybe<SpeedUnit>;
};

export type VehiclePremiumPrice = {
  __typename?: 'VehiclePremiumPrice';
  /** Starting price for German market. */
  DE?: Maybe<VehiclePremiumPriceValueWithGrant>;
  /** Starting price for British market. */
  GB?: Maybe<VehiclePremiumPriceValueWithGrant>;
  /** Starting price for Dutch market. */
  NL?: Maybe<VehiclePremiumPriceValueWithGrant>;
};

export type VehiclePremiumPriceValueWithGrant = {
  __typename?: 'VehiclePremiumPriceValueWithGrant';
  /** Currency in which the value without optional field conversion is expressed. */
  currency?: Maybe<CurrencyUnit>;
  /** Grant that is applied to the starting price. */
  grant_applied?: Maybe<Scalars['Int']['output']>;
  /** Indicates if the starting price is based on an estimate. */
  is_estimated?: Maybe<Scalars['Boolean']['output']>;
  /** Total delivery fees (be aware that this field does not include grant). */
  price_delivery?: Maybe<Scalars['Int']['output']>;
  /** First registration fee (be aware that this field does not include grant). */
  price_first_registration_fee?: Maybe<Scalars['Int']['output']>;
  /** Starting price for local market expressed in the currency in the field currency. */
  value?: Maybe<Scalars['Float']['output']>;
};


export type VehiclePremiumPriceValueWithGrantValueArgs = {
  unit?: InputMaybe<CurrencyUnit>;
};

export type VehiclePremiumRange = {
  __typename?: 'VehiclePremiumRange';
  /** Best conditions are based on 23°C and no use of A/C. */
  best: VehiclePremiumRangeValue;
  /**
   * Chargetrip's custom real-world range provides a carefully calculated display range for all-electric vehicle models.
   * Chargetrip range is based on the theoretical distance driven using only the electric engine.
   * Vehicles that do not have a full electric drivetrain type (all except Battery Electric Vehicles / BEV) therefore return relatively small ranges.
   * More information on the CT range can be found at https://chargetrip.com/blog/what-is-ct-real-range
   */
  chargetrip_range: ChargetripRange;
  /** Rated range in NEDC combined cycle (NULL if not NEDC rated). */
  nedc?: Maybe<Scalars['Float']['output']>;
  /** Indicates if NEDC range is estimated (NULL if not NEDC rated). */
  nedc_is_estimated?: Maybe<Scalars['Boolean']['output']>;
  /** Index range. */
  provider?: Maybe<Scalars['Float']['output']>;
  /** Indicates if index range is estimated. */
  provider_is_estimated?: Maybe<Scalars['Boolean']['output']>;
  /** Rated range in WLTP combined cycle (NULL if not WLTP rated). */
  wltp?: Maybe<Scalars['Float']['output']>;
  /** Indicates if WLTP range is estimated (NULL if not WLTP rated). */
  wltp_is_estimated?: Maybe<Scalars['Boolean']['output']>;
  /** Rated range in WLTP (TEH/least efficient trim) combined cycle (NULL if not WLTP rated). */
  wltp_teh?: Maybe<Scalars['Float']['output']>;
  /** Worst conditions are based on -10°C and use of heating. */
  worst: VehiclePremiumRangeValue;
};


export type VehiclePremiumRangeNedcArgs = {
  unit?: InputMaybe<DistanceUnit>;
};


export type VehiclePremiumRangeProviderArgs = {
  unit?: InputMaybe<DistanceUnit>;
};


export type VehiclePremiumRangeWltpArgs = {
  unit?: InputMaybe<DistanceUnit>;
};


export type VehiclePremiumRangeWltp_TehArgs = {
  unit?: InputMaybe<DistanceUnit>;
};

export type VehiclePremiumRangeValue = {
  __typename?: 'VehiclePremiumRangeValue';
  /** Estimated value on city roads. */
  city: Scalars['Float']['output'];
  /** Estimated combined value. */
  combined: Scalars['Float']['output'];
  /** Estimated value on highway or express roads. */
  highway: Scalars['Float']['output'];
};


export type VehiclePremiumRangeValueCityArgs = {
  unit?: InputMaybe<DistanceUnit>;
};


export type VehiclePremiumRangeValueCombinedArgs = {
  unit?: InputMaybe<DistanceUnit>;
};


export type VehiclePremiumRangeValueHighwayArgs = {
  unit?: InputMaybe<DistanceUnit>;
};

export type VehiclePremiumRouting = {
  __typename?: 'VehiclePremiumRouting';
  /** Extra consumption model. */
  consumption?: Maybe<VehiclePremiumRoutingConsumption>;
  /** Drag coefficient. */
  drag_coefficient: Scalars['Float']['output'];
  /** Vehicles that support fast charging have a minimum charging speed of 43 kWh. */
  fast_charging_support: Scalars['Boolean']['output'];
  /** Amount of gasoline that an equivalent gasoline vehicle would consume. */
  fuel_consumption?: Maybe<Scalars['Float']['output']>;
  /** Tire pressure recommended by manufacturer. */
  tire_pressure: Scalars['Float']['output'];
};


export type VehiclePremiumRoutingFuel_ConsumptionArgs = {
  unit?: InputMaybe<FuelConsumptionUnit>;
};


export type VehiclePremiumRoutingTire_PressureArgs = {
  unit?: InputMaybe<PressureUnit>;
};

export type VehiclePremiumRoutingConsumption = {
  __typename?: 'VehiclePremiumRoutingConsumption';
  /** The amount of energy, in kWh, used by the auxiliary systems of the vehicle in an hour, like media box, etc */
  auxiliary?: Maybe<Scalars['Float']['output']>;
};


export type VehiclePremiumRoutingConsumptionAuxiliaryArgs = {
  unit?: InputMaybe<AuxiliaryConsumptionUnit>;
};

export type VehiclePremiumSafety = {
  __typename?: 'VehiclePremiumSafety';
  /** EuroNCAP results. */
  euro_ncap?: Maybe<VehiclePremiumSafetyEuroNcap>;
  /** Number of seats equipped with ISOFIX. */
  isofix_seats?: Maybe<Scalars['Int']['output']>;
};

export type VehiclePremiumSafetyEuroNcap = {
  __typename?: 'VehiclePremiumSafetyEuroNcap';
  /** EuroNCAP rating of adult protection (out of 100%). */
  adult?: Maybe<Scalars['Int']['output']>;
  /** EuroNCAP rating of child protection (out of 100%). */
  child?: Maybe<Scalars['Int']['output']>;
  /** EuroNCAP rating (out of 5 stars). */
  rating?: Maybe<Scalars['Int']['output']>;
  /** EuroNCAP rating of safety assists (out of 100%). */
  sa?: Maybe<Scalars['Int']['output']>;
  /** Link to the EuroNCAP test report. */
  url?: Maybe<Scalars['String']['output']>;
  /** EuroNCAP rating of vulnerable road users (out of 100%). */
  vru?: Maybe<Scalars['Int']['output']>;
  /** EuroNCAP year of rating. */
  year?: Maybe<Scalars['Int']['output']>;
};

/** Propulsion. */
export const VehiclePropulsion = {
  /** All-wheel drive vehicle. */
  AWD: 'AWD',
  /** Front-wheel drive vehicle. */
  FRONT: 'Front',
  /** Rear-wheel drive vehicle. */
  REAR: 'Rear'
} as const;

export type VehiclePropulsion = typeof VehiclePropulsion[keyof typeof VehiclePropulsion];
/** Status of a vehicle provider. */
export const VehicleProviderStatus = {
  /** Has been archived by database maintainer. */
  ARCHIVED: 'archived',
  /** Has been attached to core vehicle. */
  ATTACHED: 'attached',
  /** Has been detached from a core vehicle. */
  DETACHED: 'detached',
  /** Is imported from any of the data providers. */
  NEW: 'new'
} as const;

export type VehicleProviderStatus = typeof VehicleProviderStatus[keyof typeof VehicleProviderStatus];
export const VehiclePurpose = {
  /** Vehicle intended for the transportation of cargo. */
  CARGO: 'cargo',
  /** Vehicle intended for the transportation of passengers. */
  PASSENGER: 'passenger',
  /** Vehicle intended for the transportation of everything except cargo or passengers. Eg: ambulances, agricultural vehicles, etcetera. */
  UTILITY: 'utility'
} as const;

export type VehiclePurpose = typeof VehiclePurpose[keyof typeof VehiclePurpose];
export type VehicleRange = {
  __typename?: 'VehicleRange';
  /** Best conditions are based on 23°C and no use of A/C. */
  best: VehicleRangeValue;
  /**
   * Chargetrip's custom real-world range provides a carefully calculated display range for all-electric vehicle models.
   * Chargetrip range is based on the theoretical distance driven using only the electric engine.
   * Vehicles that do not have a full electric drivetrain type (all except Battery Electric Vehicles / BEV) therefore return relatively small ranges.
   * More information on the CT range can be found at https://chargetrip.com/blog/what-is-ct-real-range
   */
  chargetrip_range: ChargetripRange;
  /** Index range. */
  provider?: Maybe<Scalars['Float']['output']>;
  /** Indicates if index range is estimated. */
  provider_is_estimated?: Maybe<Scalars['Boolean']['output']>;
  /** Worst conditions are based on -10°C and use of heating. */
  worst: VehicleRangeValue;
};


export type VehicleRangeProviderArgs = {
  unit?: InputMaybe<DistanceUnit>;
};

export type VehicleRangeValue = {
  __typename?: 'VehicleRangeValue';
  /** Estimated value on the cities road. */
  city: Scalars['Float']['output'];
  /** Estimated combined value. */
  combined: Scalars['Float']['output'];
  /** Estimated value on the highway or express roads. */
  highway: Scalars['Float']['output'];
};


export type VehicleRangeValueCityArgs = {
  unit?: InputMaybe<DistanceUnit>;
};


export type VehicleRangeValueCombinedArgs = {
  unit?: InputMaybe<DistanceUnit>;
};


export type VehicleRangeValueHighwayArgs = {
  unit?: InputMaybe<DistanceUnit>;
};

export const VehicleRegion = {
  /** Africa. */
  AF: 'AF',
  /** Asia. */
  AS: 'AS',
  /** Europe. */
  EU: 'EU',
  /** North America. */
  NA: 'NA',
  /** Oceania. */
  OC: 'OC',
  /** South America. */
  SA: 'SA'
} as const;

export type VehicleRegion = typeof VehicleRegion[keyof typeof VehicleRegion];
export type VehicleRouting = {
  __typename?: 'VehicleRouting';
  /** Vehicles that support fast charging have a minimum charging speed of 43 kWh. */
  fast_charging_support: Scalars['Boolean']['output'];
};

export type VehicleSpeed = {
  __typename?: 'VehicleSpeed';
  /** Source of inputted data. */
  source: TelemetryInputSource;
  /** Preferred unit for the vehicle's speed. */
  type: SpeedUnit;
  /** Value of the vehicle speed. */
  value: Scalars['Float']['output'];
};

export type VehicleSpeedInput = {
  /** Source of inputted data, defaults to 'manual'. */
  source?: InputMaybe<TelemetryInputSource>;
  /** Preferred unit for the vehicle's speed. */
  type: SpeedUnit;
  /** Value of the vehicle's speed. */
  value: Scalars['Float']['input'];
};

export type VehicleToEverything = {
  __typename?: 'VehicleToEverything';
  /** Information about Vehicle-to-Grid. */
  vehicle_to_grid?: Maybe<VehicleToEverythingHomeGrid>;
  /** Information about Vehicle-to-Home. */
  vehicle_to_home?: Maybe<VehicleToEverythingHomeGrid>;
  /** Information about Vehicle-to-Load. */
  vehicle_to_load?: Maybe<VehicleToEverythingLoad>;
};

export type VehicleToEverythingHomeGrid = {
  __typename?: 'VehicleToEverythingHomeGrid';
  /** Vehicle-to-Home/Grid AC power information. */
  ac?: Maybe<VehicleToEverythingPower>;
  /** Vehicle-to-Home/Grid DC power information */
  dc?: Maybe<VehicleToEverythingPower>;
};

export type VehicleToEverythingLoad = {
  __typename?: 'VehicleToEverythingLoad';
  /** Vehicle-to-Load power information. */
  ac?: Maybe<VehicleToEverythingPower>;
  /** Details on exterior ports available for V2L. */
  exterior_ports?: Maybe<Scalars['String']['output']>;
  /** Details on interior ports available for V2L. */
  interior_ports?: Maybe<Scalars['String']['output']>;
};

export type VehicleToEverythingPower = {
  __typename?: 'VehicleToEverythingPower';
  /** Indicates if this charging is supported. */
  is_supported?: Maybe<PowerSupported>;
  /** Maximum power output, in kilowatts. */
  maximum_power?: Maybe<Scalars['String']['output']>;
};

export const VehicleType = {
  /** A motor vehicle that does not have an enclosed cab, is not a Utility vehicle, and is capable of carrying 20 or more people in its default configuration. */
  BUS: 'bus',
  /** A motor vehicle that does not have an enclosed cab, is not a microcar or utility vehicle, is capable of carrying eight or fewer people, and that has less than one third of its internal volume dedicated to cargo, living, or sleeping space in its default configuration. */
  CAR: 'car',
  /** A motor vehicle with three or four wheels that is not a Motorcycle, Pickup, Van, Truck, or Utility vehicle and either has a top speed of less than 60kph or an unladen weight of less than 400kg. */
  MICROCAR: 'microcar',
  /** Any motor vehicle with two wheels or a motor vehicle with no more than four wheels, does not have parallel seating, and is controlled by means of handlebars. */
  MOTORCYCLE: 'motorcycle',
  /** A motor vehicle that has an enclosed cab, is not a utility vehicle, and has a fixed, non-articulated, open-top back cargo bed that is enclosed on at least three sides. */
  PICKUP: 'pickup',
  /** A motor vehicle that has an enclosed cab and is not a Pickup or Utility vehicle. */
  TRUCK: 'truck',
  /**
   * A motor vehicle that fulfills at least one of the following conditions:
   * 1) It does not have wheels.
   * 2) It has some mode of locomotion other than wheels in its default configuration such as treads, skis, or floats.
   * 3) It is capable of air or water travel in its default configuration.
   * 4) It was manufactured primarily for some purpose other than transporting cargo or passengers.
   * 5) It does not conform to any of the criteria for the other vehicle categories.
   */
  UTILITY: 'utility',
  /**
   * A motor vehicle that does not have an enclosed cab, is not a utility vehicle, that fulfills exactly one of the following conditions:
   * 1) It is capable of carrying more than eight but less than twenty people.
   * 2) At least one third of its internal volume is dedicated to cargo space in its default configuration.
   * 3) It is the passenger variant of a vehicle that meets criterion 2.
   */
  VAN: 'van'
} as const;

export type VehicleType = typeof VehicleType[keyof typeof VehicleType];
export type VehicleVideo = {
  __typename?: 'VehicleVideo';
  /** Video id. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Full path URL of a video. */
  url?: Maybe<Scalars['String']['output']>;
};

export const VolumeUnit = {
  /** Return the volume in cubic feet. */
  CUBIC_FOOT: 'cubic_foot',
  /** Return the volume in cubic meters. */
  CUBIC_METER: 'cubic_meter',
  /** Return the volume in liters. */
  LITER: 'liter'
} as const;

export type VolumeUnit = typeof VolumeUnit[keyof typeof VolumeUnit];
/** Type of weather conditions used in the route calculation. */
export const WeatherType = {
  /** A dynamic preset that uses real weather data based on the route's departure time. Can't be used in combination with weather.custom. */
  ACTUAL: 'actual',
  /** Must be used in combination with weather.custom object. */
  CUSTOM: 'custom',
  /** Fixed seasonal preset representing typical summer weather conditions. Can't be used in combination with weather.custom. */
  SUMMER: 'summer',
  /** Fixed seasonal preset representing typical winter weather conditions. Can't be used in combination with weather.custom. */
  WINTER: 'winter'
} as const;

export type WeatherType = typeof WeatherType[keyof typeof WeatherType];
export type WeightInput = {
  /** Preferred unit for the weight */
  type: WeightUnit;
  /** Value of weight */
  value: Scalars['Float']['input'];
};

export const WeightUnit = {
  /** Return the weight in kilograms. */
  KILOGRAM: 'kilogram',
  /** Return the weight in pounds. */
  POUND: 'pound'
} as const;

export type WeightUnit = typeof WeightUnit[keyof typeof WeightUnit];
export type AmenityFragment = { __typename?: 'Amenity', external_id: string, name: string, type: Array<string | null>, station_distance: number, address?: { __typename?: 'Address', city?: string | null } | null, location: { __typename?: 'Point', type: PointType, coordinates: Array<number> } };

export type IsolinePolygonsFragment = { __typename?: 'FeatureMultiPolygon', type: FeatureType, geometry: { __typename?: 'MultiPolygon', type: MultiPolygonType, coordinates: Array<Array<Array<Array<number> | null> | null> | null> }, properties?: { __typename?: 'PolygonProperties', index?: number | null } | null };

export type IsolineFragment = { __typename?: 'Isoline', id: string, status: IsolineStatus, maximum_distance?: number | null, polygons?: Array<{ __typename?: 'FeatureMultiPolygon', type: FeatureType, geometry: { __typename?: 'MultiPolygon', type: MultiPolygonType, coordinates: Array<Array<Array<Array<number> | null> | null> | null> }, properties?: { __typename?: 'PolygonProperties', index?: number | null } | null } | null> | null, ferries?: Array<{ __typename?: 'FeatureLineString', geometry: { __typename?: 'LineString', coordinates: Array<Array<number> | null> } } | null> | null, request_input?: { __typename?: 'IsolineRequestInput', polygon_count?: number | null, state_of_charge: number, vehicle_id: string, origin: { __typename?: 'FeaturePoint', type: FeatureType, properties?: any | null, geometry: { __typename?: 'Point', type: PointType, coordinates: Array<number> } }, weather?: { __typename?: 'IsolineWeather', type: WeatherType } | null } | null };

export type PageInfoFragment = { __typename?: 'PageInfo', end_cursor?: string | null, has_next_page: boolean, has_previous_page: boolean, start_cursor?: string | null };

export type RouteDetailsLegSectionFeaturePointFragment = { __typename?: 'RouteDetailsLegSectionFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> } };

export type RouteDetailsLegSectionFragment = { __typename?: 'RouteDetailsLegSection', type: RouteDetailsLegSectionType, polyline: string, duration: number, distance: number, origin: { __typename?: 'RouteDetailsLegSectionFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> } }, destination: { __typename?: 'RouteDetailsLegSectionFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> } }, traffic?: { __typename?: 'RouteDetailsLegSectionTraffic', congestions: Array<{ __typename?: 'TrafficCongestionInterval', start_index: number, end_index: number, level: CongestionLevel }> } | null };

export type RouteDetailsLegFeaturePointFragment = { __typename?: 'RouteDetailsLegFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> }, properties?: { __typename?: 'RouteDetailsLegFeatureProperties', name?: string | null, temperature?: number | null, total_cargo_weight?: number | null } | null };

export type RouteDetailsLegFragment = { __typename?: 'RouteDetailsLeg', polyline: string, type: RouteDetailsLegType, distance: number, consumption?: number | null, range_at_origin?: number | null, range_after_charge?: number | null, range_at_destination?: number | null, tags: Array<RouteDetailsTag>, range_at_origin_percentage?: number | null, range_after_charge_percentage?: number | null, range_at_destination_percentage?: number | null, durations: { __typename?: 'RouteDetailsDurations', total: number, charging: number, driving: number, stopover: number, ferry: number }, sections: Array<{ __typename?: 'RouteDetailsLegSection', type: RouteDetailsLegSectionType, polyline: string, duration: number, distance: number, origin: { __typename?: 'RouteDetailsLegSectionFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> } }, destination: { __typename?: 'RouteDetailsLegSectionFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> } }, traffic?: { __typename?: 'RouteDetailsLegSectionTraffic', congestions: Array<{ __typename?: 'TrafficCongestionInterval', start_index: number, end_index: number, level: CongestionLevel }> } | null }>, destination: { __typename?: 'RouteDetailsLegFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> }, properties?: { __typename?: 'RouteDetailsLegFeatureProperties', name?: string | null, temperature?: number | null, total_cargo_weight?: number | null } | null }, origin: { __typename?: 'RouteDetailsLegFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> }, properties?: { __typename?: 'RouteDetailsLegFeatureProperties', name?: string | null, temperature?: number | null, total_cargo_weight?: number | null } | null }, station?: { __typename?: 'RouteDetailsLegStation', station_id: string, evse_id?: string | null, connector_id: string } | null, warnings?: Array<{ __typename?: 'RouteDetailsLegWarning', code: RouteDetailsLegWarningCode }> | null };

export type RouteDetailsFragment = { __typename?: 'RouteDetails', id: string, charges: number, consumption?: number | null, distance: number, polyline: string, tags: Array<RouteDetailsTag>, alternative_stations: Array<{ __typename?: 'RouteDetailsAlternativeStation', id: string, operator_ranking?: OperatorRankingLevel | null, operator_id?: string | null, location: { __typename?: 'Point', coordinates: Array<number> } }>, durations: { __typename?: 'RouteDetailsDurations', total: number, charging: number, driving: number }, traffic?: { __typename?: 'RouteDetailsTraffic', delay: number } | null, legs: Array<{ __typename?: 'RouteDetailsLeg', polyline: string, type: RouteDetailsLegType, distance: number, consumption?: number | null, range_at_origin?: number | null, range_after_charge?: number | null, range_at_destination?: number | null, tags: Array<RouteDetailsTag>, range_at_origin_percentage?: number | null, range_after_charge_percentage?: number | null, range_at_destination_percentage?: number | null, durations: { __typename?: 'RouteDetailsDurations', total: number, charging: number, driving: number, stopover: number, ferry: number }, sections: Array<{ __typename?: 'RouteDetailsLegSection', type: RouteDetailsLegSectionType, polyline: string, duration: number, distance: number, origin: { __typename?: 'RouteDetailsLegSectionFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> } }, destination: { __typename?: 'RouteDetailsLegSectionFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> } }, traffic?: { __typename?: 'RouteDetailsLegSectionTraffic', congestions: Array<{ __typename?: 'TrafficCongestionInterval', start_index: number, end_index: number, level: CongestionLevel }> } | null }>, destination: { __typename?: 'RouteDetailsLegFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> }, properties?: { __typename?: 'RouteDetailsLegFeatureProperties', name?: string | null, temperature?: number | null, total_cargo_weight?: number | null } | null }, origin: { __typename?: 'RouteDetailsLegFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> }, properties?: { __typename?: 'RouteDetailsLegFeatureProperties', name?: string | null, temperature?: number | null, total_cargo_weight?: number | null } | null }, station?: { __typename?: 'RouteDetailsLegStation', station_id: string, evse_id?: string | null, connector_id: string } | null, warnings?: Array<{ __typename?: 'RouteDetailsLegWarning', code: RouteDetailsLegWarningCode }> | null }>, path_plot: Array<{ __typename?: 'RouteDetailsPathSegment', consumption?: number | null, elevation: number, distance: number, state_of_charge?: number | null, average_speed: number }>, warnings?: Array<{ __typename?: 'RouteWarning', code: RouteWarningCode }> | null };

export type RoutePropertiesLocationFragment = { __typename?: 'RoutePropertiesLocation', name?: string | null };

export type RoutePropertiesViaLocationFragment = { __typename?: 'RoutePropertiesViaLocation', name?: string | null, stop_duration?: number | null };

export type RoutePropertiesVehicleFragment = { __typename?: 'RoutePropertiesVehicle', occupants: number, total_occupant_weight: { __typename?: 'TotalOccupantWeight', value: number, type: WeightUnit, source: TelemetryInputSource }, total_cargo_weight?: { __typename?: 'TotalCargoWeight', value: number, type: WeightUnit, source: TelemetryInputSource } | null };

export type RoutePropertiesStationFragment = { __typename?: 'RoutePropertiesStation', station_id?: string | null, external_station_id?: string | null };

export type CreateRouteFragment = { __typename?: 'CreateRoute', alternative_routes?: number | null, departure_time: any, avoid?: Array<RouteAvoid> | null, traffic_aware?: boolean | null, vehicle: { __typename?: 'RouteVehicle', id: string, climate: boolean, battery: { __typename?: 'RouteVehicleBattery', capacity: { __typename?: 'StateOfCharge', value: number, type: StateOfChargeUnit }, state_of_charge: { __typename?: 'StateOfCharge', value: number, type: StateOfChargeUnit }, final_state_of_charge: { __typename?: 'StateOfCharge', value: number, type: StateOfChargeUnit } }, charging: { __typename?: 'RouteVehicleCharging', minimum_power: number, risk_margin: number, mode: ChargeMode, adapters: Array<{ __typename?: 'RouteVehicleChargingConnector', standard: ConnectorType, maximum_charge_speed: { __typename?: 'ChargeSpeed', type: ChargeSpeedUnit, value: number } }> } }, origin: { __typename?: 'RouteOriginFeaturePoint', type: FeatureType, geometry: { __typename?: 'Point', type: PointType, coordinates: Array<number> }, properties?: { __typename?: 'RouteOriginProperties', vehicle?: { __typename?: 'RoutePropertiesVehicle', occupants: number, total_occupant_weight: { __typename?: 'TotalOccupantWeight', value: number, type: WeightUnit, source: TelemetryInputSource }, total_cargo_weight?: { __typename?: 'TotalCargoWeight', value: number, type: WeightUnit, source: TelemetryInputSource } | null } | null, location?: { __typename?: 'RoutePropertiesLocation', name?: string | null } | null } | null }, destination: { __typename?: 'RouteDestinationFeaturePoint', type: FeatureType, geometry?: { __typename?: 'Point', type: PointType, coordinates: Array<number> } | null, properties?: { __typename?: 'RouteDestinationProperties', location?: { __typename?: 'RoutePropertiesLocation', name?: string | null } | null, station?: { __typename?: 'RoutePropertiesStation', station_id?: string | null, external_station_id?: string | null } | null } | null }, via?: Array<{ __typename?: 'RouteViaFeaturePoint', type: FeatureType, geometry?: { __typename?: 'Point', type: PointType, coordinates: Array<number> } | null, properties?: { __typename?: 'RouteViaProperties', vehicle?: { __typename?: 'RoutePropertiesVehicle', occupants: number, total_occupant_weight: { __typename?: 'TotalOccupantWeight', value: number, type: WeightUnit, source: TelemetryInputSource }, total_cargo_weight?: { __typename?: 'TotalCargoWeight', value: number, type: WeightUnit, source: TelemetryInputSource } | null } | null, location?: { __typename?: 'RoutePropertiesViaLocation', name?: string | null, stop_duration?: number | null } | null, station?: { __typename?: 'RoutePropertiesStation', station_id?: string | null, external_station_id?: string | null } | null } | null }> | null, weather?: { __typename?: 'RouteWeather', type: WeatherType } | null, operators?: { __typename?: 'RouteOperatorPreferences', exclude?: Array<{ __typename?: 'RouteOperatorsValue', id: string, countries?: Array<CountryCodeAlpha2> | null }> | null, ranking?: { __typename?: 'RouteOperatorPreferencesRanking', type: RouteOperatorsType, levels?: { __typename?: 'RouteOperatorPreferencesRankingLevels', high?: Array<{ __typename?: 'RouteOperatorsValue', id: string, countries?: Array<CountryCodeAlpha2> | null }> | null, medium?: Array<{ __typename?: 'RouteOperatorsValue', id: string, countries?: Array<CountryCodeAlpha2> | null }> | null, low?: Array<{ __typename?: 'RouteOperatorsValue', id: string, countries?: Array<CountryCodeAlpha2> | null }> | null } | null } | null } | null, driving_preferences?: { __typename?: 'RouteDrivingPreferences', speed_factor?: number | null, style?: RouteDrivingStyle | null, maximum_speed?: { __typename?: 'MaximumSpeed', value: number, type: SpeedUnit } | null } | null, station_preferences?: { __typename?: 'RouteStationPreferences', prefer_highway_charging?: boolean | null } | null, alternative_station_radius?: { __typename?: 'AlternativeStationRadius', value: number, type: DistanceUnit } | null };

export type RouteResponseFragment = { __typename?: 'RouteResponse', id: string, status: RouteStatus, meta: { __typename?: 'RouteMetadata', created_at: any }, recommended?: { __typename?: 'RouteDetails', id: string, charges: number, consumption?: number | null, distance: number, polyline: string, tags: Array<RouteDetailsTag>, alternative_stations: Array<{ __typename?: 'RouteDetailsAlternativeStation', id: string, operator_ranking?: OperatorRankingLevel | null, operator_id?: string | null, location: { __typename?: 'Point', coordinates: Array<number> } }>, durations: { __typename?: 'RouteDetailsDurations', total: number, charging: number, driving: number }, traffic?: { __typename?: 'RouteDetailsTraffic', delay: number } | null, legs: Array<{ __typename?: 'RouteDetailsLeg', polyline: string, type: RouteDetailsLegType, distance: number, consumption?: number | null, range_at_origin?: number | null, range_after_charge?: number | null, range_at_destination?: number | null, tags: Array<RouteDetailsTag>, range_at_origin_percentage?: number | null, range_after_charge_percentage?: number | null, range_at_destination_percentage?: number | null, durations: { __typename?: 'RouteDetailsDurations', total: number, charging: number, driving: number, stopover: number, ferry: number }, sections: Array<{ __typename?: 'RouteDetailsLegSection', type: RouteDetailsLegSectionType, polyline: string, duration: number, distance: number, origin: { __typename?: 'RouteDetailsLegSectionFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> } }, destination: { __typename?: 'RouteDetailsLegSectionFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> } }, traffic?: { __typename?: 'RouteDetailsLegSectionTraffic', congestions: Array<{ __typename?: 'TrafficCongestionInterval', start_index: number, end_index: number, level: CongestionLevel }> } | null }>, destination: { __typename?: 'RouteDetailsLegFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> }, properties?: { __typename?: 'RouteDetailsLegFeatureProperties', name?: string | null, temperature?: number | null, total_cargo_weight?: number | null } | null }, origin: { __typename?: 'RouteDetailsLegFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> }, properties?: { __typename?: 'RouteDetailsLegFeatureProperties', name?: string | null, temperature?: number | null, total_cargo_weight?: number | null } | null }, station?: { __typename?: 'RouteDetailsLegStation', station_id: string, evse_id?: string | null, connector_id: string } | null, warnings?: Array<{ __typename?: 'RouteDetailsLegWarning', code: RouteDetailsLegWarningCode }> | null }>, path_plot: Array<{ __typename?: 'RouteDetailsPathSegment', consumption?: number | null, elevation: number, distance: number, state_of_charge?: number | null, average_speed: number }>, warnings?: Array<{ __typename?: 'RouteWarning', code: RouteWarningCode }> | null } | null, alternatives?: Array<{ __typename?: 'RouteDetails', id: string, charges: number, consumption?: number | null, distance: number, polyline: string, tags: Array<RouteDetailsTag>, alternative_stations: Array<{ __typename?: 'RouteDetailsAlternativeStation', id: string, operator_ranking?: OperatorRankingLevel | null, operator_id?: string | null, location: { __typename?: 'Point', coordinates: Array<number> } }>, durations: { __typename?: 'RouteDetailsDurations', total: number, charging: number, driving: number }, traffic?: { __typename?: 'RouteDetailsTraffic', delay: number } | null, legs: Array<{ __typename?: 'RouteDetailsLeg', polyline: string, type: RouteDetailsLegType, distance: number, consumption?: number | null, range_at_origin?: number | null, range_after_charge?: number | null, range_at_destination?: number | null, tags: Array<RouteDetailsTag>, range_at_origin_percentage?: number | null, range_after_charge_percentage?: number | null, range_at_destination_percentage?: number | null, durations: { __typename?: 'RouteDetailsDurations', total: number, charging: number, driving: number, stopover: number, ferry: number }, sections: Array<{ __typename?: 'RouteDetailsLegSection', type: RouteDetailsLegSectionType, polyline: string, duration: number, distance: number, origin: { __typename?: 'RouteDetailsLegSectionFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> } }, destination: { __typename?: 'RouteDetailsLegSectionFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> } }, traffic?: { __typename?: 'RouteDetailsLegSectionTraffic', congestions: Array<{ __typename?: 'TrafficCongestionInterval', start_index: number, end_index: number, level: CongestionLevel }> } | null }>, destination: { __typename?: 'RouteDetailsLegFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> }, properties?: { __typename?: 'RouteDetailsLegFeatureProperties', name?: string | null, temperature?: number | null, total_cargo_weight?: number | null } | null }, origin: { __typename?: 'RouteDetailsLegFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> }, properties?: { __typename?: 'RouteDetailsLegFeatureProperties', name?: string | null, temperature?: number | null, total_cargo_weight?: number | null } | null }, station?: { __typename?: 'RouteDetailsLegStation', station_id: string, evse_id?: string | null, connector_id: string } | null, warnings?: Array<{ __typename?: 'RouteDetailsLegWarning', code: RouteDetailsLegWarningCode }> | null }>, path_plot: Array<{ __typename?: 'RouteDetailsPathSegment', consumption?: number | null, elevation: number, distance: number, state_of_charge?: number | null, average_speed: number }>, warnings?: Array<{ __typename?: 'RouteWarning', code: RouteWarningCode }> | null }> | null, request_input: { __typename?: 'CreateRoute', alternative_routes?: number | null, departure_time: any, avoid?: Array<RouteAvoid> | null, traffic_aware?: boolean | null, vehicle: { __typename?: 'RouteVehicle', id: string, climate: boolean, battery: { __typename?: 'RouteVehicleBattery', capacity: { __typename?: 'StateOfCharge', value: number, type: StateOfChargeUnit }, state_of_charge: { __typename?: 'StateOfCharge', value: number, type: StateOfChargeUnit }, final_state_of_charge: { __typename?: 'StateOfCharge', value: number, type: StateOfChargeUnit } }, charging: { __typename?: 'RouteVehicleCharging', minimum_power: number, risk_margin: number, mode: ChargeMode, adapters: Array<{ __typename?: 'RouteVehicleChargingConnector', standard: ConnectorType, maximum_charge_speed: { __typename?: 'ChargeSpeed', type: ChargeSpeedUnit, value: number } }> } }, origin: { __typename?: 'RouteOriginFeaturePoint', type: FeatureType, geometry: { __typename?: 'Point', type: PointType, coordinates: Array<number> }, properties?: { __typename?: 'RouteOriginProperties', vehicle?: { __typename?: 'RoutePropertiesVehicle', occupants: number, total_occupant_weight: { __typename?: 'TotalOccupantWeight', value: number, type: WeightUnit, source: TelemetryInputSource }, total_cargo_weight?: { __typename?: 'TotalCargoWeight', value: number, type: WeightUnit, source: TelemetryInputSource } | null } | null, location?: { __typename?: 'RoutePropertiesLocation', name?: string | null } | null } | null }, destination: { __typename?: 'RouteDestinationFeaturePoint', type: FeatureType, geometry?: { __typename?: 'Point', type: PointType, coordinates: Array<number> } | null, properties?: { __typename?: 'RouteDestinationProperties', location?: { __typename?: 'RoutePropertiesLocation', name?: string | null } | null, station?: { __typename?: 'RoutePropertiesStation', station_id?: string | null, external_station_id?: string | null } | null } | null }, via?: Array<{ __typename?: 'RouteViaFeaturePoint', type: FeatureType, geometry?: { __typename?: 'Point', type: PointType, coordinates: Array<number> } | null, properties?: { __typename?: 'RouteViaProperties', vehicle?: { __typename?: 'RoutePropertiesVehicle', occupants: number, total_occupant_weight: { __typename?: 'TotalOccupantWeight', value: number, type: WeightUnit, source: TelemetryInputSource }, total_cargo_weight?: { __typename?: 'TotalCargoWeight', value: number, type: WeightUnit, source: TelemetryInputSource } | null } | null, location?: { __typename?: 'RoutePropertiesViaLocation', name?: string | null, stop_duration?: number | null } | null, station?: { __typename?: 'RoutePropertiesStation', station_id?: string | null, external_station_id?: string | null } | null } | null }> | null, weather?: { __typename?: 'RouteWeather', type: WeatherType } | null, operators?: { __typename?: 'RouteOperatorPreferences', exclude?: Array<{ __typename?: 'RouteOperatorsValue', id: string, countries?: Array<CountryCodeAlpha2> | null }> | null, ranking?: { __typename?: 'RouteOperatorPreferencesRanking', type: RouteOperatorsType, levels?: { __typename?: 'RouteOperatorPreferencesRankingLevels', high?: Array<{ __typename?: 'RouteOperatorsValue', id: string, countries?: Array<CountryCodeAlpha2> | null }> | null, medium?: Array<{ __typename?: 'RouteOperatorsValue', id: string, countries?: Array<CountryCodeAlpha2> | null }> | null, low?: Array<{ __typename?: 'RouteOperatorsValue', id: string, countries?: Array<CountryCodeAlpha2> | null }> | null } | null } | null } | null, driving_preferences?: { __typename?: 'RouteDrivingPreferences', speed_factor?: number | null, style?: RouteDrivingStyle | null, maximum_speed?: { __typename?: 'MaximumSpeed', value: number, type: SpeedUnit } | null } | null, station_preferences?: { __typename?: 'RouteStationPreferences', prefer_highway_charging?: boolean | null } | null, alternative_station_radius?: { __typename?: 'AlternativeStationRadius', value: number, type: DistanceUnit } | null } };

export type OcpiPriceComponentFragment = { __typename?: 'OCPIPriceComponent', type?: OcpiTariffDimensionType | null, price?: number | null, vat?: number | null, step_size?: number | null };

export type OcpiTarrifRestrictionsFragment = { __typename?: 'OCPITariffRestrictions', start_time?: string | null, end_time?: string | null, start_date?: string | null, end_date?: string | null, min_kwh?: number | null, max_kwh?: number | null, min_power?: number | null, max_power?: number | null, min_current?: number | null, max_current?: number | null, day_of_week?: OcpiDayOfWeek | null, reservation?: OcpiReservationRestrictionType | null, max_duration?: number | null, min_duration?: number | null };

export type TariffPriceElementFragment = { __typename?: 'OCPITariffElement', price_components?: Array<{ __typename?: 'OCPIPriceComponent', type?: OcpiTariffDimensionType | null, price?: number | null, vat?: number | null, step_size?: number | null } | null> | null, restrictions?: Array<{ __typename?: 'OCPITariffRestrictions', start_time?: string | null, end_time?: string | null, start_date?: string | null, end_date?: string | null, min_kwh?: number | null, max_kwh?: number | null, min_power?: number | null, max_power?: number | null, min_current?: number | null, max_current?: number | null, day_of_week?: OcpiDayOfWeek | null, reservation?: OcpiReservationRestrictionType | null, max_duration?: number | null, min_duration?: number | null } | null> | null };

export type TariffFragment = { __typename?: 'OCPITariff', currency?: string | null, party_id?: string | null, id?: string | null, type?: OcpiTariffType | null, elements?: Array<{ __typename?: 'OCPITariffElement', price_components?: Array<{ __typename?: 'OCPIPriceComponent', type?: OcpiTariffDimensionType | null, price?: number | null, vat?: number | null, step_size?: number | null } | null> | null, restrictions?: Array<{ __typename?: 'OCPITariffRestrictions', start_time?: string | null, end_time?: string | null, start_date?: string | null, end_date?: string | null, min_kwh?: number | null, max_kwh?: number | null, min_power?: number | null, max_power?: number | null, min_current?: number | null, max_current?: number | null, day_of_week?: OcpiDayOfWeek | null, reservation?: OcpiReservationRestrictionType | null, max_duration?: number | null, min_duration?: number | null } | null> | null } | null> | null };

export type ConnectorPriceElementFragment = { __typename?: 'ConnectorPriceElement', components: Array<{ __typename?: 'ConnectorPriceElementComponent', type: ConnectorPriceElementComponentType, price_excl_vat: number, vat: number, step_size: number }>, restrictions?: { __typename?: 'ConnectorPriceElementRestrictions', start_time?: string | null, end_time?: string | null, start_date?: string | null, end_date?: string | null, minimum_kwh?: number | null, maximum_kwh?: number | null, minimum_power?: number | null, maximum_power?: number | null, minimum_current?: number | null, maximum_current?: number | null, minimum_duration?: number | null, maximum_duration?: number | null, minimum_price?: number | null, maximum_price?: number | null, overstay_battery_percentage?: { __typename?: 'ConnectorPriceRestrictionsOverstayBatteryPercentage', minimum?: number | null, maximum?: number | null, unit?: ConnectorPriceRestrictionsOverstayTimeUnit | null } | null, overstay_time?: { __typename?: 'ConnectorPriceRestrictionsOverstayTime', minimum?: number | null, maximum?: number | null, unit?: ConnectorPriceRestrictionsOverstayTimeUnit | null } | null } | null };

export type ConnectorPriceProductFragment = { __typename?: 'ConnectorPriceProduct', name: string, type: ConnectorPriceProductType, description: string, subscription_type: ConnectorPriceProductSubscriptionType, subscription_fee_excl_vat: number, currency: CurrencyUnit };

export type ConnectorPriceFragment = { __typename?: 'ConnectorPrice', external_id: string, partner_id: string, partner?: string | null, product: { __typename?: 'ConnectorPriceProduct', name: string, type: ConnectorPriceProductType, description: string, subscription_type: ConnectorPriceProductSubscriptionType, subscription_fee_excl_vat: number, currency: CurrencyUnit }, elements: Array<{ __typename?: 'ConnectorPriceElement', components: Array<{ __typename?: 'ConnectorPriceElementComponent', type: ConnectorPriceElementComponentType, price_excl_vat: number, vat: number, step_size: number }>, restrictions?: { __typename?: 'ConnectorPriceElementRestrictions', start_time?: string | null, end_time?: string | null, start_date?: string | null, end_date?: string | null, minimum_kwh?: number | null, maximum_kwh?: number | null, minimum_power?: number | null, maximum_power?: number | null, minimum_current?: number | null, maximum_current?: number | null, minimum_duration?: number | null, maximum_duration?: number | null, minimum_price?: number | null, maximum_price?: number | null, overstay_battery_percentage?: { __typename?: 'ConnectorPriceRestrictionsOverstayBatteryPercentage', minimum?: number | null, maximum?: number | null, unit?: ConnectorPriceRestrictionsOverstayTimeUnit | null } | null, overstay_time?: { __typename?: 'ConnectorPriceRestrictionsOverstayTime', minimum?: number | null, maximum?: number | null, unit?: ConnectorPriceRestrictionsOverstayTimeUnit | null } | null } | null }> };

export type StationPricingFragment = { __typename?: 'Connector', prices?: Array<{ __typename?: 'ConnectorPrice', external_id: string, partner_id: string, partner?: string | null, product: { __typename?: 'ConnectorPriceProduct', name: string, type: ConnectorPriceProductType, description: string, subscription_type: ConnectorPriceProductSubscriptionType, subscription_fee_excl_vat: number, currency: CurrencyUnit }, elements: Array<{ __typename?: 'ConnectorPriceElement', components: Array<{ __typename?: 'ConnectorPriceElementComponent', type: ConnectorPriceElementComponentType, price_excl_vat: number, vat: number, step_size: number }>, restrictions?: { __typename?: 'ConnectorPriceElementRestrictions', start_time?: string | null, end_time?: string | null, start_date?: string | null, end_date?: string | null, minimum_kwh?: number | null, maximum_kwh?: number | null, minimum_power?: number | null, maximum_power?: number | null, minimum_current?: number | null, maximum_current?: number | null, minimum_duration?: number | null, maximum_duration?: number | null, minimum_price?: number | null, maximum_price?: number | null, overstay_battery_percentage?: { __typename?: 'ConnectorPriceRestrictionsOverstayBatteryPercentage', minimum?: number | null, maximum?: number | null, unit?: ConnectorPriceRestrictionsOverstayTimeUnit | null } | null, overstay_time?: { __typename?: 'ConnectorPriceRestrictionsOverstayTime', minimum?: number | null, maximum?: number | null, unit?: ConnectorPriceRestrictionsOverstayTimeUnit | null } | null } | null }> }> | null, tariff?: Array<{ __typename?: 'OCPITariff', currency?: string | null, party_id?: string | null, id?: string | null, type?: OcpiTariffType | null, elements?: Array<{ __typename?: 'OCPITariffElement', price_components?: Array<{ __typename?: 'OCPIPriceComponent', type?: OcpiTariffDimensionType | null, price?: number | null, vat?: number | null, step_size?: number | null } | null> | null, restrictions?: Array<{ __typename?: 'OCPITariffRestrictions', start_time?: string | null, end_time?: string | null, start_date?: string | null, end_date?: string | null, min_kwh?: number | null, max_kwh?: number | null, min_power?: number | null, max_power?: number | null, min_current?: number | null, max_current?: number | null, day_of_week?: OcpiDayOfWeek | null, reservation?: OcpiReservationRestrictionType | null, max_duration?: number | null, min_duration?: number | null } | null> | null } | null> | null } | null> | null };

export type ConnectorFragment = { __typename?: 'Connector', id?: string | null, standard?: ConnectorType | null, format?: OcpiConnectorFormat | null, power?: number | null, last_updated?: any | null, properties?: any | null, prices?: Array<{ __typename?: 'ConnectorPrice', external_id: string, partner_id: string, partner?: string | null, product: { __typename?: 'ConnectorPriceProduct', name: string, type: ConnectorPriceProductType, description: string, subscription_type: ConnectorPriceProductSubscriptionType, subscription_fee_excl_vat: number, currency: CurrencyUnit }, elements: Array<{ __typename?: 'ConnectorPriceElement', components: Array<{ __typename?: 'ConnectorPriceElementComponent', type: ConnectorPriceElementComponentType, price_excl_vat: number, vat: number, step_size: number }>, restrictions?: { __typename?: 'ConnectorPriceElementRestrictions', start_time?: string | null, end_time?: string | null, start_date?: string | null, end_date?: string | null, minimum_kwh?: number | null, maximum_kwh?: number | null, minimum_power?: number | null, maximum_power?: number | null, minimum_current?: number | null, maximum_current?: number | null, minimum_duration?: number | null, maximum_duration?: number | null, minimum_price?: number | null, maximum_price?: number | null, overstay_battery_percentage?: { __typename?: 'ConnectorPriceRestrictionsOverstayBatteryPercentage', minimum?: number | null, maximum?: number | null, unit?: ConnectorPriceRestrictionsOverstayTimeUnit | null } | null, overstay_time?: { __typename?: 'ConnectorPriceRestrictionsOverstayTime', minimum?: number | null, maximum?: number | null, unit?: ConnectorPriceRestrictionsOverstayTimeUnit | null } | null } | null }> }> | null, tariff?: Array<{ __typename?: 'OCPITariff', currency?: string | null, party_id?: string | null, id?: string | null, type?: OcpiTariffType | null, elements?: Array<{ __typename?: 'OCPITariffElement', price_components?: Array<{ __typename?: 'OCPIPriceComponent', type?: OcpiTariffDimensionType | null, price?: number | null, vat?: number | null, step_size?: number | null } | null> | null, restrictions?: Array<{ __typename?: 'OCPITariffRestrictions', start_time?: string | null, end_time?: string | null, start_date?: string | null, end_date?: string | null, min_kwh?: number | null, max_kwh?: number | null, min_power?: number | null, max_power?: number | null, min_current?: number | null, max_current?: number | null, day_of_week?: OcpiDayOfWeek | null, reservation?: OcpiReservationRestrictionType | null, max_duration?: number | null, min_duration?: number | null } | null> | null } | null> | null } | null> | null };

export type EvseFragment = { __typename?: 'EVSE', uid?: string | null, last_updated?: any | null, evse_id?: string | null, capabilities?: Array<OcpiCapability | null> | null, status?: OcpiStatus | null, connectors?: Array<{ __typename?: 'Connector', id?: string | null, standard?: ConnectorType | null, format?: OcpiConnectorFormat | null, power?: number | null, last_updated?: any | null, properties?: any | null, prices?: Array<{ __typename?: 'ConnectorPrice', external_id: string, partner_id: string, partner?: string | null, product: { __typename?: 'ConnectorPriceProduct', name: string, type: ConnectorPriceProductType, description: string, subscription_type: ConnectorPriceProductSubscriptionType, subscription_fee_excl_vat: number, currency: CurrencyUnit }, elements: Array<{ __typename?: 'ConnectorPriceElement', components: Array<{ __typename?: 'ConnectorPriceElementComponent', type: ConnectorPriceElementComponentType, price_excl_vat: number, vat: number, step_size: number }>, restrictions?: { __typename?: 'ConnectorPriceElementRestrictions', start_time?: string | null, end_time?: string | null, start_date?: string | null, end_date?: string | null, minimum_kwh?: number | null, maximum_kwh?: number | null, minimum_power?: number | null, maximum_power?: number | null, minimum_current?: number | null, maximum_current?: number | null, minimum_duration?: number | null, maximum_duration?: number | null, minimum_price?: number | null, maximum_price?: number | null, overstay_battery_percentage?: { __typename?: 'ConnectorPriceRestrictionsOverstayBatteryPercentage', minimum?: number | null, maximum?: number | null, unit?: ConnectorPriceRestrictionsOverstayTimeUnit | null } | null, overstay_time?: { __typename?: 'ConnectorPriceRestrictionsOverstayTime', minimum?: number | null, maximum?: number | null, unit?: ConnectorPriceRestrictionsOverstayTimeUnit | null } | null } | null }> }> | null, tariff?: Array<{ __typename?: 'OCPITariff', currency?: string | null, party_id?: string | null, id?: string | null, type?: OcpiTariffType | null, elements?: Array<{ __typename?: 'OCPITariffElement', price_components?: Array<{ __typename?: 'OCPIPriceComponent', type?: OcpiTariffDimensionType | null, price?: number | null, vat?: number | null, step_size?: number | null } | null> | null, restrictions?: Array<{ __typename?: 'OCPITariffRestrictions', start_time?: string | null, end_time?: string | null, start_date?: string | null, end_date?: string | null, min_kwh?: number | null, max_kwh?: number | null, min_power?: number | null, max_power?: number | null, min_current?: number | null, max_current?: number | null, day_of_week?: OcpiDayOfWeek | null, reservation?: OcpiReservationRestrictionType | null, max_duration?: number | null, min_duration?: number | null } | null> | null } | null> | null } | null> | null } | null> | null };

export type StationFragment = { __typename?: 'Station', id: string, name?: string | null, address?: string | null, last_updated?: any | null, external_id?: string | null, country?: string | null, time_zone?: string | null, amenities?: any | null, access_type?: AccessType | null, parking_type?: OcpiParkingType | null, reliability_score?: number | null, adhoc_authorisation_payment_method?: Array<StationAdhocAuthorisationPaymentMethod> | null, speed?: StationSpeedType | null, status?: ChargerStatus | null, coordinates?: { __typename?: 'OCPIGeoLocation', latitude?: string | null, longitude?: string | null } | null, opening_times?: { __typename?: 'OCPIHours', twentyfourseven?: boolean | null, regular_hours?: Array<{ __typename?: 'OCPIRegularHours', weekday?: number | null, period_begin?: string | null, period_end?: string | null } | null> | null } | null, predicted_occupancy?: Array<{ __typename?: 'StationPredictedOccupancy', weekday?: number | null, occupancy?: number | null, period_begin?: string | null, period_end?: string | null } | null> | null, operator?: { __typename?: 'Operator', id?: string | null, name?: string | null, website?: string | null } | null, roaming?: Array<{ __typename?: 'StationRoaming', emsp?: string | null, card?: string | null, partner_id?: string | null, android_app_link?: string | null, ios_app_link?: string | null } | null> | null, evses?: Array<{ __typename?: 'EVSE', uid?: string | null, last_updated?: any | null, evse_id?: string | null, capabilities?: Array<OcpiCapability | null> | null, status?: OcpiStatus | null, connectors?: Array<{ __typename?: 'Connector', id?: string | null, standard?: ConnectorType | null, format?: OcpiConnectorFormat | null, power?: number | null, last_updated?: any | null, properties?: any | null, prices?: Array<{ __typename?: 'ConnectorPrice', external_id: string, partner_id: string, partner?: string | null, product: { __typename?: 'ConnectorPriceProduct', name: string, type: ConnectorPriceProductType, description: string, subscription_type: ConnectorPriceProductSubscriptionType, subscription_fee_excl_vat: number, currency: CurrencyUnit }, elements: Array<{ __typename?: 'ConnectorPriceElement', components: Array<{ __typename?: 'ConnectorPriceElementComponent', type: ConnectorPriceElementComponentType, price_excl_vat: number, vat: number, step_size: number }>, restrictions?: { __typename?: 'ConnectorPriceElementRestrictions', start_time?: string | null, end_time?: string | null, start_date?: string | null, end_date?: string | null, minimum_kwh?: number | null, maximum_kwh?: number | null, minimum_power?: number | null, maximum_power?: number | null, minimum_current?: number | null, maximum_current?: number | null, minimum_duration?: number | null, maximum_duration?: number | null, minimum_price?: number | null, maximum_price?: number | null, overstay_battery_percentage?: { __typename?: 'ConnectorPriceRestrictionsOverstayBatteryPercentage', minimum?: number | null, maximum?: number | null, unit?: ConnectorPriceRestrictionsOverstayTimeUnit | null } | null, overstay_time?: { __typename?: 'ConnectorPriceRestrictionsOverstayTime', minimum?: number | null, maximum?: number | null, unit?: ConnectorPriceRestrictionsOverstayTimeUnit | null } | null } | null }> }> | null, tariff?: Array<{ __typename?: 'OCPITariff', currency?: string | null, party_id?: string | null, id?: string | null, type?: OcpiTariffType | null, elements?: Array<{ __typename?: 'OCPITariffElement', price_components?: Array<{ __typename?: 'OCPIPriceComponent', type?: OcpiTariffDimensionType | null, price?: number | null, vat?: number | null, step_size?: number | null } | null> | null, restrictions?: Array<{ __typename?: 'OCPITariffRestrictions', start_time?: string | null, end_time?: string | null, start_date?: string | null, end_date?: string | null, min_kwh?: number | null, max_kwh?: number | null, min_power?: number | null, max_power?: number | null, min_current?: number | null, max_current?: number | null, day_of_week?: OcpiDayOfWeek | null, reservation?: OcpiReservationRestrictionType | null, max_duration?: number | null, min_duration?: number | null } | null> | null } | null> | null } | null> | null } | null> | null } | null> | null, vehicle_restrictions?: { __typename?: 'StationVehicleRestrictions', mass?: number | null, width?: number | null, height?: number | null, length?: number | null } | null, heavy_vehicles_restrictions?: { __typename?: 'StationHeavyVehiclesRestrictions', mass?: number | null, width?: number | null, height?: number | null, length?: number | null, allowed_types_EU?: Array<HeavyVehiclesEuType> | null } | null, heavy_vehicles_properties?: { __typename?: 'StationHeavyVehiclesProperties', facilities?: Array<HeavyVehiclesFacility> | null, is_trailer_accessible?: boolean | null, is_drive_through?: boolean | null, allows_dangerous_goods?: boolean | null, allows_rigid_vehicles?: boolean | null, allows_overnight_parking?: boolean | null } | null };

export type StationAroundFragment = { __typename?: 'Station', id: string, name?: string | null, last_updated?: any | null, location?: { __typename?: 'Point', coordinates: Array<number> } | null, operator?: { __typename?: 'Operator', id?: string | null, name?: string | null } | null, evses?: Array<{ __typename?: 'EVSE', status?: OcpiStatus | null, connectors?: Array<{ __typename?: 'Connector', standard?: ConnectorType | null, power?: number | null } | null> | null } | null> | null };

export type AmenityStationFragment = { __typename?: 'Station', id: string, name?: string | null, speed?: StationSpeedType | null, status?: ChargerStatus | null, operator?: { __typename?: 'Operator', id?: string | null, name?: string | null } | null, coordinates?: { __typename?: 'OCPIGeoLocation', latitude?: string | null, longitude?: string | null } | null, evses?: Array<{ __typename?: 'EVSE', status?: OcpiStatus | null, evse_id?: string | null, connectors?: Array<{ __typename?: 'Connector', id?: string | null, standard?: ConnectorType | null, power?: number | null } | null> | null } | null> | null };

export type RouteTruckPropertiesVehicleFragment = { __typename?: 'RouteTruckPropertiesVehicle', axles_in_use?: number | null, occupants: number, total_cargo_weight?: { __typename?: 'TotalCargoWeight', value: number, type: WeightUnit, source: TelemetryInputSource } | null, total_occupant_weight?: { __typename?: 'TotalOccupantWeight', value: number, type: WeightUnit, source: TelemetryInputSource } | null, trailer?: { __typename?: 'RouteTruckVehicleTrailer', axles_in_use: number, count: number, unladen_weight: number, combined_vehicle_dimensions: { __typename?: 'TruckTrailerCombinedDimensions', height: number, length: number, width: number } } | null };

export type TruckRouteDetailsLegSectionFeaturePointFragment = { __typename?: 'TruckRouteDetailsLegSectionFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> }, properties: { __typename?: 'TruckRouteDetailsLegSectionFeaturePointProperties', occupants: number, total_cargo_weight?: number | null, total_occupant_weight?: number | null, trailer_count: number } };

export type TruckRouteDetailsLegFeaturePointFragment = { __typename?: 'TruckRouteDetailsLegFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> }, properties?: { __typename?: 'TruckRouteDetailsLegFeatureProperties', name?: string | null, temperature?: number | null, total_cargo_weight?: number | null, total_occupant_weight: number, trailer_count: number } | null };

export type TruckRouteDetailsLegFragment = { __typename?: 'TruckRouteDetailsLeg', polyline: string, type: RouteDetailsLegType, distance: number, consumption?: number | null, range_at_origin?: number | null, range_after_charge?: number | null, range_at_destination?: number | null, tags: Array<RouteDetailsTag>, range_at_origin_percentage?: number | null, range_after_charge_percentage?: number | null, range_at_destination_percentage?: number | null, durations: { __typename?: 'RouteDetailsDurations', total: number, charging: number, driving: number, stopover: number, ferry: number }, sections: Array<{ __typename?: 'TruckRouteDetailsLegSection', type: RouteDetailsLegSectionType, polyline: string, duration: number, distance: number, consumption?: number | null, tags: Array<RouteDetailsTag>, origin: { __typename?: 'TruckRouteDetailsLegSectionFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> }, properties: { __typename?: 'TruckRouteDetailsLegSectionFeaturePointProperties', occupants: number, total_cargo_weight?: number | null, total_occupant_weight?: number | null, trailer_count: number } }, destination: { __typename?: 'TruckRouteDetailsLegSectionFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> }, properties: { __typename?: 'TruckRouteDetailsLegSectionFeaturePointProperties', occupants: number, total_cargo_weight?: number | null, total_occupant_weight?: number | null, trailer_count: number } } }>, destination: { __typename?: 'TruckRouteDetailsLegFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> }, properties?: { __typename?: 'TruckRouteDetailsLegFeatureProperties', name?: string | null, temperature?: number | null, total_cargo_weight?: number | null, total_occupant_weight: number, trailer_count: number } | null }, origin: { __typename?: 'TruckRouteDetailsLegFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> }, properties?: { __typename?: 'TruckRouteDetailsLegFeatureProperties', name?: string | null, temperature?: number | null, total_cargo_weight?: number | null, total_occupant_weight: number, trailer_count: number } | null }, station?: { __typename?: 'RouteDetailsLegStation', station_id: string, evse_id?: string | null, connector_id: string } | null };

export type TruckRouteDetailsFragment = { __typename?: 'TruckRouteDetails', id: string, charges: number, consumption?: number | null, distance: number, polyline: string, range_at_origin?: number | null, range_at_destination?: number | null, tags: Array<RouteDetailsTag>, alternative_stations: Array<{ __typename?: 'RouteDetailsAlternativeStation', id: string, operator_ranking?: OperatorRankingLevel | null, operator_id?: string | null, location: { __typename?: 'Point', coordinates: Array<number> } }>, durations: { __typename?: 'RouteDetailsDurations', total: number, charging: number }, elevation: { __typename?: 'RouteDetailsElevation', down: number, maximum: number, minimum: number, up: number }, legs: Array<{ __typename?: 'TruckRouteDetailsLeg', polyline: string, type: RouteDetailsLegType, distance: number, consumption?: number | null, range_at_origin?: number | null, range_after_charge?: number | null, range_at_destination?: number | null, tags: Array<RouteDetailsTag>, range_at_origin_percentage?: number | null, range_after_charge_percentage?: number | null, range_at_destination_percentage?: number | null, durations: { __typename?: 'RouteDetailsDurations', total: number, charging: number, driving: number, stopover: number, ferry: number }, sections: Array<{ __typename?: 'TruckRouteDetailsLegSection', type: RouteDetailsLegSectionType, polyline: string, duration: number, distance: number, consumption?: number | null, tags: Array<RouteDetailsTag>, origin: { __typename?: 'TruckRouteDetailsLegSectionFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> }, properties: { __typename?: 'TruckRouteDetailsLegSectionFeaturePointProperties', occupants: number, total_cargo_weight?: number | null, total_occupant_weight?: number | null, trailer_count: number } }, destination: { __typename?: 'TruckRouteDetailsLegSectionFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> }, properties: { __typename?: 'TruckRouteDetailsLegSectionFeaturePointProperties', occupants: number, total_cargo_weight?: number | null, total_occupant_weight?: number | null, trailer_count: number } } }>, destination: { __typename?: 'TruckRouteDetailsLegFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> }, properties?: { __typename?: 'TruckRouteDetailsLegFeatureProperties', name?: string | null, temperature?: number | null, total_cargo_weight?: number | null, total_occupant_weight: number, trailer_count: number } | null }, origin: { __typename?: 'TruckRouteDetailsLegFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> }, properties?: { __typename?: 'TruckRouteDetailsLegFeatureProperties', name?: string | null, temperature?: number | null, total_cargo_weight?: number | null, total_occupant_weight: number, trailer_count: number } | null }, station?: { __typename?: 'RouteDetailsLegStation', station_id: string, evse_id?: string | null, connector_id: string } | null }>, path_plot: Array<{ __typename?: 'RouteDetailsPathSegment', consumption?: number | null, elevation: number, distance: number, state_of_charge?: number | null, average_speed: number }>, savings?: { __typename?: 'RouteDetailsSavings', money?: number | null, average_gas_price: number, average_energy_price: number } | null };

export type CreateTruckRouteFragment = { __typename?: 'CreateTruckRoute', departure_time?: any | null, avoid?: Array<RouteTruckAvoid> | null, vehicle: { __typename?: 'RouteTruckVehicle', id: string, climate: boolean, battery: { __typename?: 'RouteVehicleBattery', capacity: { __typename?: 'StateOfCharge', value: number, type: StateOfChargeUnit }, state_of_charge: { __typename?: 'StateOfCharge', value: number, type: StateOfChargeUnit }, final_state_of_charge: { __typename?: 'StateOfCharge', value: number, type: StateOfChargeUnit } }, charging: { __typename?: 'RouteVehicleCharging', mode: ChargeMode, adapters: Array<{ __typename?: 'RouteVehicleChargingConnector', standard: ConnectorType, maximum_charge_speed: { __typename?: 'ChargeSpeed', type: ChargeSpeedUnit, value: number } }> } }, origin: { __typename?: 'RouteTruckOriginFeaturePoint', type: FeatureType, geometry: { __typename?: 'Point', type: PointType, coordinates: Array<number> }, properties?: { __typename?: 'RouteTruckOriginProperties', location?: { __typename?: 'RouteTruckPropertiesLocation', name?: string | null } | null, vehicle?: { __typename?: 'RouteTruckPropertiesVehicle', axles_in_use?: number | null, occupants: number, total_cargo_weight?: { __typename?: 'TotalCargoWeight', value: number, type: WeightUnit, source: TelemetryInputSource } | null, total_occupant_weight?: { __typename?: 'TotalOccupantWeight', value: number, type: WeightUnit, source: TelemetryInputSource } | null, trailer?: { __typename?: 'RouteTruckVehicleTrailer', axles_in_use: number, count: number, unladen_weight: number, combined_vehicle_dimensions: { __typename?: 'TruckTrailerCombinedDimensions', height: number, length: number, width: number } } | null } | null } | null }, destination: { __typename?: 'RouteDestinationFeaturePoint', type: FeatureType, geometry?: { __typename?: 'Point', type: PointType, coordinates: Array<number> } | null, properties?: { __typename?: 'RouteDestinationProperties', location?: { __typename?: 'RoutePropertiesLocation', name?: string | null } | null, station?: { __typename?: 'RoutePropertiesStation', station_id?: string | null, external_station_id?: string | null } | null } | null }, via?: Array<{ __typename?: 'RouteTruckViaFeaturePoint', type: FeatureType, geometry?: { __typename?: 'Point', type: PointType, coordinates: Array<number> } | null, properties?: { __typename?: 'RouteTruckViaProperties', vehicle?: { __typename?: 'RouteTruckPropertiesVehicle', axles_in_use?: number | null, occupants: number, total_cargo_weight?: { __typename?: 'TotalCargoWeight', value: number, type: WeightUnit, source: TelemetryInputSource } | null, total_occupant_weight?: { __typename?: 'TotalOccupantWeight', value: number, type: WeightUnit, source: TelemetryInputSource } | null, trailer?: { __typename?: 'RouteTruckVehicleTrailer', axles_in_use: number, count: number, unladen_weight: number, combined_vehicle_dimensions: { __typename?: 'TruckTrailerCombinedDimensions', height: number, length: number, width: number } } | null } | null, location?: { __typename?: 'RoutePropertiesViaLocation', name?: string | null, stop_duration?: number | null } | null, station?: { __typename?: 'RoutePropertiesStation', station_id?: string | null, external_station_id?: string | null } | null } | null }> | null, alternative_station_radius?: { __typename?: 'AlternativeStationRadius', value: number, type: DistanceUnit } | null, maximum_speed?: { __typename?: 'MaximumSpeed', value: number, type: SpeedUnit } | null, operators?: { __typename?: 'RouteOperatorPreferences', exclude?: Array<{ __typename?: 'RouteOperatorsValue', id: string, countries?: Array<CountryCodeAlpha2> | null }> | null, ranking?: { __typename?: 'RouteOperatorPreferencesRanking', type: RouteOperatorsType, levels?: { __typename?: 'RouteOperatorPreferencesRankingLevels', high?: Array<{ __typename?: 'RouteOperatorsValue', id: string, countries?: Array<CountryCodeAlpha2> | null }> | null, medium?: Array<{ __typename?: 'RouteOperatorsValue', id: string, countries?: Array<CountryCodeAlpha2> | null }> | null, low?: Array<{ __typename?: 'RouteOperatorsValue', id: string, countries?: Array<CountryCodeAlpha2> | null }> | null } | null } | null } | null, weather?: { __typename?: 'RouteWeather', type: WeatherType, custom?: { __typename?: 'RouteWeatherCustomConditions', air_pressure: { __typename?: 'AirPressure', type: AirPressureUnit, value: number }, solar_irradiance: { __typename?: 'SolarIrradiance', type: SolarIrradianceUnit, value: number }, temperature: { __typename?: 'Temperature', value: number, type: TemperatureUnit } } | null } | null };

export type TruckRouteResponseFragment = { __typename?: 'TruckRouteResponse', id: string, status: RouteStatus, meta: { __typename?: 'RouteMetadata', created_at: any }, recommended?: { __typename?: 'TruckRouteDetails', id: string, charges: number, consumption?: number | null, distance: number, polyline: string, range_at_origin?: number | null, range_at_destination?: number | null, tags: Array<RouteDetailsTag>, alternative_stations: Array<{ __typename?: 'RouteDetailsAlternativeStation', id: string, operator_ranking?: OperatorRankingLevel | null, operator_id?: string | null, location: { __typename?: 'Point', coordinates: Array<number> } }>, durations: { __typename?: 'RouteDetailsDurations', total: number, charging: number }, elevation: { __typename?: 'RouteDetailsElevation', down: number, maximum: number, minimum: number, up: number }, legs: Array<{ __typename?: 'TruckRouteDetailsLeg', polyline: string, type: RouteDetailsLegType, distance: number, consumption?: number | null, range_at_origin?: number | null, range_after_charge?: number | null, range_at_destination?: number | null, tags: Array<RouteDetailsTag>, range_at_origin_percentage?: number | null, range_after_charge_percentage?: number | null, range_at_destination_percentage?: number | null, durations: { __typename?: 'RouteDetailsDurations', total: number, charging: number, driving: number, stopover: number, ferry: number }, sections: Array<{ __typename?: 'TruckRouteDetailsLegSection', type: RouteDetailsLegSectionType, polyline: string, duration: number, distance: number, consumption?: number | null, tags: Array<RouteDetailsTag>, origin: { __typename?: 'TruckRouteDetailsLegSectionFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> }, properties: { __typename?: 'TruckRouteDetailsLegSectionFeaturePointProperties', occupants: number, total_cargo_weight?: number | null, total_occupant_weight?: number | null, trailer_count: number } }, destination: { __typename?: 'TruckRouteDetailsLegSectionFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> }, properties: { __typename?: 'TruckRouteDetailsLegSectionFeaturePointProperties', occupants: number, total_cargo_weight?: number | null, total_occupant_weight?: number | null, trailer_count: number } } }>, destination: { __typename?: 'TruckRouteDetailsLegFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> }, properties?: { __typename?: 'TruckRouteDetailsLegFeatureProperties', name?: string | null, temperature?: number | null, total_cargo_weight?: number | null, total_occupant_weight: number, trailer_count: number } | null }, origin: { __typename?: 'TruckRouteDetailsLegFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> }, properties?: { __typename?: 'TruckRouteDetailsLegFeatureProperties', name?: string | null, temperature?: number | null, total_cargo_weight?: number | null, total_occupant_weight: number, trailer_count: number } | null }, station?: { __typename?: 'RouteDetailsLegStation', station_id: string, evse_id?: string | null, connector_id: string } | null }>, path_plot: Array<{ __typename?: 'RouteDetailsPathSegment', consumption?: number | null, elevation: number, distance: number, state_of_charge?: number | null, average_speed: number }>, savings?: { __typename?: 'RouteDetailsSavings', money?: number | null, average_gas_price: number, average_energy_price: number } | null } | null, request_input: { __typename?: 'CreateTruckRoute', departure_time?: any | null, avoid?: Array<RouteTruckAvoid> | null, vehicle: { __typename?: 'RouteTruckVehicle', id: string, climate: boolean, battery: { __typename?: 'RouteVehicleBattery', capacity: { __typename?: 'StateOfCharge', value: number, type: StateOfChargeUnit }, state_of_charge: { __typename?: 'StateOfCharge', value: number, type: StateOfChargeUnit }, final_state_of_charge: { __typename?: 'StateOfCharge', value: number, type: StateOfChargeUnit } }, charging: { __typename?: 'RouteVehicleCharging', mode: ChargeMode, adapters: Array<{ __typename?: 'RouteVehicleChargingConnector', standard: ConnectorType, maximum_charge_speed: { __typename?: 'ChargeSpeed', type: ChargeSpeedUnit, value: number } }> } }, origin: { __typename?: 'RouteTruckOriginFeaturePoint', type: FeatureType, geometry: { __typename?: 'Point', type: PointType, coordinates: Array<number> }, properties?: { __typename?: 'RouteTruckOriginProperties', location?: { __typename?: 'RouteTruckPropertiesLocation', name?: string | null } | null, vehicle?: { __typename?: 'RouteTruckPropertiesVehicle', axles_in_use?: number | null, occupants: number, total_cargo_weight?: { __typename?: 'TotalCargoWeight', value: number, type: WeightUnit, source: TelemetryInputSource } | null, total_occupant_weight?: { __typename?: 'TotalOccupantWeight', value: number, type: WeightUnit, source: TelemetryInputSource } | null, trailer?: { __typename?: 'RouteTruckVehicleTrailer', axles_in_use: number, count: number, unladen_weight: number, combined_vehicle_dimensions: { __typename?: 'TruckTrailerCombinedDimensions', height: number, length: number, width: number } } | null } | null } | null }, destination: { __typename?: 'RouteDestinationFeaturePoint', type: FeatureType, geometry?: { __typename?: 'Point', type: PointType, coordinates: Array<number> } | null, properties?: { __typename?: 'RouteDestinationProperties', location?: { __typename?: 'RoutePropertiesLocation', name?: string | null } | null, station?: { __typename?: 'RoutePropertiesStation', station_id?: string | null, external_station_id?: string | null } | null } | null }, via?: Array<{ __typename?: 'RouteTruckViaFeaturePoint', type: FeatureType, geometry?: { __typename?: 'Point', type: PointType, coordinates: Array<number> } | null, properties?: { __typename?: 'RouteTruckViaProperties', vehicle?: { __typename?: 'RouteTruckPropertiesVehicle', axles_in_use?: number | null, occupants: number, total_cargo_weight?: { __typename?: 'TotalCargoWeight', value: number, type: WeightUnit, source: TelemetryInputSource } | null, total_occupant_weight?: { __typename?: 'TotalOccupantWeight', value: number, type: WeightUnit, source: TelemetryInputSource } | null, trailer?: { __typename?: 'RouteTruckVehicleTrailer', axles_in_use: number, count: number, unladen_weight: number, combined_vehicle_dimensions: { __typename?: 'TruckTrailerCombinedDimensions', height: number, length: number, width: number } } | null } | null, location?: { __typename?: 'RoutePropertiesViaLocation', name?: string | null, stop_duration?: number | null } | null, station?: { __typename?: 'RoutePropertiesStation', station_id?: string | null, external_station_id?: string | null } | null } | null }> | null, alternative_station_radius?: { __typename?: 'AlternativeStationRadius', value: number, type: DistanceUnit } | null, maximum_speed?: { __typename?: 'MaximumSpeed', value: number, type: SpeedUnit } | null, operators?: { __typename?: 'RouteOperatorPreferences', exclude?: Array<{ __typename?: 'RouteOperatorsValue', id: string, countries?: Array<CountryCodeAlpha2> | null }> | null, ranking?: { __typename?: 'RouteOperatorPreferencesRanking', type: RouteOperatorsType, levels?: { __typename?: 'RouteOperatorPreferencesRankingLevels', high?: Array<{ __typename?: 'RouteOperatorsValue', id: string, countries?: Array<CountryCodeAlpha2> | null }> | null, medium?: Array<{ __typename?: 'RouteOperatorsValue', id: string, countries?: Array<CountryCodeAlpha2> | null }> | null, low?: Array<{ __typename?: 'RouteOperatorsValue', id: string, countries?: Array<CountryCodeAlpha2> | null }> | null } | null } | null } | null, weather?: { __typename?: 'RouteWeather', type: WeatherType, custom?: { __typename?: 'RouteWeatherCustomConditions', air_pressure: { __typename?: 'AirPressure', type: AirPressureUnit, value: number }, solar_irradiance: { __typename?: 'SolarIrradiance', type: SolarIrradianceUnit, value: number }, temperature: { __typename?: 'Temperature', value: number, type: TemperatureUnit } } | null } | null } };

export type VehicleImageThumbnailFragment = { __typename?: 'VehicleImage', thumbnail_url: string, thumbnail_width: number, thumbnail_height: number };

export type VehicleListFieldsFragment = { __typename?: 'VehicleList', id: string, naming: { __typename?: 'VehicleListNaming', make: string, model: string, chargetrip_version: string }, media: { __typename?: 'VehicleListMedia', image: { __typename?: 'VehicleImage', thumbnail_url: string, thumbnail_width: number, thumbnail_height: number }, make: { __typename?: 'VehicleImage', thumbnail_url: string, thumbnail_width: number, thumbnail_height: number } }, range: { __typename?: 'VehicleListRange', chargetrip_range: { __typename?: 'ChargetripRange', best?: number | null, worst?: number | null } } };

export type VehicleDetailsFragment = { __typename?: 'Vehicle', id: string, purpose: VehiclePurpose, naming: { __typename?: 'VehicleNaming', make: string, model: string, chargetrip_version: string }, range: { __typename?: 'VehicleRange', chargetrip_range: { __typename?: 'ChargetripRange', best?: number | null, worst?: number | null }, best: { __typename?: 'VehicleRangeValue', highway: number, city: number, combined: number }, worst: { __typename?: 'VehicleRangeValue', highway: number, city: number, combined: number } }, drivetrain: { __typename?: 'VehicleDrivetrain', type: VehicleDrivetrainType }, battery: { __typename?: 'VehicleBattery', usable_kwh: number }, media: { __typename?: 'VehicleMedia', image: { __typename?: 'VehicleImage', url: string, width: number, height: number, thumbnail_url: string, thumbnail_width: number, thumbnail_height: number }, make: { __typename?: 'VehicleImage', thumbnail_url: string, thumbnail_width: number, thumbnail_height: number } }, connect: { __typename?: 'Connect', providers?: Array<ConnectProvider> | null }, connectors: Array<{ __typename?: 'VehicleConnector', standard: ConnectorType, power: number }>, adapters: Array<{ __typename?: 'VehicleConnector', standard: ConnectorType, power: number, time: number }>, body: { __typename?: 'VehicleBody', seats: number, width: number, height: number, weight: { __typename?: 'VehicleBodyWeight', nominal?: number | null } } };

export type CreateRouteMutationVariables = Exact<{
  input: CreateRouteInput;
}>;


export type CreateRouteMutation = { __typename?: 'Mutation', createRoute: string };

export type CreateTruckRouteMutationVariables = Exact<{
  input: CreateTruckRouteInput;
}>;


export type CreateTruckRouteMutation = { __typename?: 'Mutation', createTruckRoute: string };

export type AmenityListQueryVariables = Exact<{
  stationId: Scalars['ID']['input'];
  filter?: InputMaybe<AmenityListFilter>;
  size?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AmenityListQuery = { __typename?: 'Query', amenityList?: Array<{ __typename?: 'Amenity', external_id: string, name: string, type: Array<string | null>, station_distance: number, address?: { __typename?: 'Address', city?: string | null } | null, location: { __typename?: 'Point', type: PointType, coordinates: Array<number> } } | null> | null };

export type GetRouteStationsWithAmenitiesQueryVariables = Exact<{
  routeDetailsId: Scalars['ID']['input'];
  routeId: Scalars['ID']['input'];
  timeWindow: RouteTimeWindow;
  amenityTypes: Array<AmenityType> | AmenityType;
  filter?: InputMaybe<RouteStationsWithAmenityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetRouteStationsWithAmenitiesQuery = { __typename?: 'Query', getRouteStationsWithAmenities: { __typename?: 'RouteStationsWithAmenitiesConnection', total_count: number, nodes: Array<{ __typename?: 'RouteStationWithAmenities', id: string, distance_from_path: number, location: { __typename?: 'Point', type: PointType, coordinates: Array<number> }, operator: { __typename?: 'RouteStationOperator', id?: string | null, preference_type: OperatorPreferenceType }, matching_amenities: Array<{ __typename?: 'Amenity', external_id: string, name: string, type: Array<string | null>, station_distance: number, address?: { __typename?: 'Address', city?: string | null } | null, location: { __typename?: 'Point', type: PointType, coordinates: Array<number> } }> }>, page_info: { __typename?: 'PageInfo', end_cursor?: string | null, has_next_page: boolean, has_previous_page: boolean, start_cursor?: string | null } } };

export type GetRouteEmissionsQueryVariables = Exact<{
  routeId: Scalars['ID']['input'];
  routeDetailsId: Scalars['ID']['input'];
}>;


export type GetRouteEmissionsQuery = { __typename?: 'Query', getRouteEmissions: { __typename?: 'RouteDetailsEmissions', route_vehicle: { __typename?: 'RouteVehicleEmissions', total: number, legs: Array<{ __typename?: 'RouteVehicleLegEmissions', operational: { __typename?: 'RouteVehicleLegOperationalEmissions', electricity: { __typename?: 'RouteLegOperationalElectricityEmissions', intensity: { __typename?: 'RouteLegOperationalElectricityEmissionsIntensity', total: number, energy_sources: { __typename?: 'RouteOperationalElectricityEnergySources', coal: { __typename?: 'ElectricityGenerationMethod', fraction: number }, gas: { __typename?: 'ElectricityGenerationMethod', fraction: number }, hydro: { __typename?: 'ElectricityGenerationMethod', fraction: number }, geothermal: { __typename?: 'ElectricityGenerationMethod', fraction: number }, solar: { __typename?: 'ElectricityGenerationMethod', fraction: number }, wind: { __typename?: 'ElectricityGenerationMethod', fraction: number }, oil: { __typename?: 'ElectricityGenerationMethod', fraction: number }, nuclear: { __typename?: 'ElectricityGenerationMethod', fraction: number }, biofuel: { __typename?: 'ElectricityGenerationMethod', fraction: number }, other: { __typename?: 'ElectricityGenerationMethod', fraction: number } } } } } }>, operational: { __typename?: 'RouteVehicleOperationalEmissions', total: number, electricity: { __typename?: 'RouteOperationalElectricityEmissions', intensity: { __typename?: 'RouteOperationalElectricityEmissionsIntensity', total: number, average_demand: number, energy_sources: { __typename?: 'RouteOperationalElectricityEnergySources', coal: { __typename?: 'ElectricityGenerationMethod', fraction: number }, gas: { __typename?: 'ElectricityGenerationMethod', fraction: number }, hydro: { __typename?: 'ElectricityGenerationMethod', fraction: number }, geothermal: { __typename?: 'ElectricityGenerationMethod', fraction: number }, solar: { __typename?: 'ElectricityGenerationMethod', fraction: number }, wind: { __typename?: 'ElectricityGenerationMethod', fraction: number }, oil: { __typename?: 'ElectricityGenerationMethod', fraction: number }, nuclear: { __typename?: 'ElectricityGenerationMethod', fraction: number }, biofuel: { __typename?: 'ElectricityGenerationMethod', fraction: number }, other: { __typename?: 'ElectricityGenerationMethod', fraction: number } } } } }, end_of_life: { __typename?: 'RouteEndOfLifeEmissions', total: number } }, internal_combustion_vehicle: { __typename?: 'RouteInternalCombustionVehicleEmissions', total: number } } };

export type CreateIsolineMutationVariables = Exact<{
  input: IsolineInput;
}>;


export type CreateIsolineMutation = { __typename?: 'Mutation', createIsoline?: string | null };

export type IsolineQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IsolineQuery = { __typename?: 'Query', isoline?: { __typename?: 'Isoline', id: string, status: IsolineStatus, maximum_distance?: number | null, polygons?: Array<{ __typename?: 'FeatureMultiPolygon', type: FeatureType, geometry: { __typename?: 'MultiPolygon', type: MultiPolygonType, coordinates: Array<Array<Array<Array<number> | null> | null> | null> }, properties?: { __typename?: 'PolygonProperties', index?: number | null } | null } | null> | null, ferries?: Array<{ __typename?: 'FeatureLineString', geometry: { __typename?: 'LineString', coordinates: Array<Array<number> | null> } } | null> | null, request_input?: { __typename?: 'IsolineRequestInput', polygon_count?: number | null, state_of_charge: number, vehicle_id: string, origin: { __typename?: 'FeaturePoint', type: FeatureType, properties?: any | null, geometry: { __typename?: 'Point', type: PointType, coordinates: Array<number> } }, weather?: { __typename?: 'IsolineWeather', type: WeatherType } | null } | null } | null };

export type IsolineVehicleQueryVariables = Exact<{
  vehicle_id: Scalars['ID']['input'];
}>;


export type IsolineVehicleQuery = { __typename?: 'Query', vehicle?: { __typename?: 'Vehicle', id: string, naming: { __typename?: 'VehicleNaming', make: string, model: string, chargetrip_version: string }, range: { __typename?: 'VehicleRange', chargetrip_range: { __typename?: 'ChargetripRange', worst?: number | null, best?: number | null } }, media: { __typename?: 'VehicleMedia', image: { __typename?: 'VehicleImage', url: string, width: number, height: number, thumbnail_url: string, thumbnail_width: number, thumbnail_height: number } } } | null };

export type GetRouteQueryVariables = Exact<{
  routeId: Scalars['ID']['input'];
  hasAlternatives: Scalars['Boolean']['input'];
}>;


export type GetRouteQuery = { __typename?: 'Query', getRoute: { __typename?: 'RouteResponse', id: string, status: RouteStatus, meta: { __typename?: 'RouteMetadata', created_at: any }, recommended?: { __typename?: 'RouteDetails', id: string, charges: number, consumption?: number | null, distance: number, polyline: string, tags: Array<RouteDetailsTag>, alternative_stations: Array<{ __typename?: 'RouteDetailsAlternativeStation', id: string, operator_ranking?: OperatorRankingLevel | null, operator_id?: string | null, location: { __typename?: 'Point', coordinates: Array<number> } }>, durations: { __typename?: 'RouteDetailsDurations', total: number, charging: number, driving: number }, traffic?: { __typename?: 'RouteDetailsTraffic', delay: number } | null, legs: Array<{ __typename?: 'RouteDetailsLeg', polyline: string, type: RouteDetailsLegType, distance: number, consumption?: number | null, range_at_origin?: number | null, range_after_charge?: number | null, range_at_destination?: number | null, tags: Array<RouteDetailsTag>, range_at_origin_percentage?: number | null, range_after_charge_percentage?: number | null, range_at_destination_percentage?: number | null, durations: { __typename?: 'RouteDetailsDurations', total: number, charging: number, driving: number, stopover: number, ferry: number }, sections: Array<{ __typename?: 'RouteDetailsLegSection', type: RouteDetailsLegSectionType, polyline: string, duration: number, distance: number, origin: { __typename?: 'RouteDetailsLegSectionFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> } }, destination: { __typename?: 'RouteDetailsLegSectionFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> } }, traffic?: { __typename?: 'RouteDetailsLegSectionTraffic', congestions: Array<{ __typename?: 'TrafficCongestionInterval', start_index: number, end_index: number, level: CongestionLevel }> } | null }>, destination: { __typename?: 'RouteDetailsLegFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> }, properties?: { __typename?: 'RouteDetailsLegFeatureProperties', name?: string | null, temperature?: number | null, total_cargo_weight?: number | null } | null }, origin: { __typename?: 'RouteDetailsLegFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> }, properties?: { __typename?: 'RouteDetailsLegFeatureProperties', name?: string | null, temperature?: number | null, total_cargo_weight?: number | null } | null }, station?: { __typename?: 'RouteDetailsLegStation', station_id: string, evse_id?: string | null, connector_id: string } | null, warnings?: Array<{ __typename?: 'RouteDetailsLegWarning', code: RouteDetailsLegWarningCode }> | null }>, path_plot: Array<{ __typename?: 'RouteDetailsPathSegment', consumption?: number | null, elevation: number, distance: number, state_of_charge?: number | null, average_speed: number }>, warnings?: Array<{ __typename?: 'RouteWarning', code: RouteWarningCode }> | null } | null, alternatives?: Array<{ __typename?: 'RouteDetails', id: string, charges: number, consumption?: number | null, distance: number, polyline: string, tags: Array<RouteDetailsTag>, alternative_stations: Array<{ __typename?: 'RouteDetailsAlternativeStation', id: string, operator_ranking?: OperatorRankingLevel | null, operator_id?: string | null, location: { __typename?: 'Point', coordinates: Array<number> } }>, durations: { __typename?: 'RouteDetailsDurations', total: number, charging: number, driving: number }, traffic?: { __typename?: 'RouteDetailsTraffic', delay: number } | null, legs: Array<{ __typename?: 'RouteDetailsLeg', polyline: string, type: RouteDetailsLegType, distance: number, consumption?: number | null, range_at_origin?: number | null, range_after_charge?: number | null, range_at_destination?: number | null, tags: Array<RouteDetailsTag>, range_at_origin_percentage?: number | null, range_after_charge_percentage?: number | null, range_at_destination_percentage?: number | null, durations: { __typename?: 'RouteDetailsDurations', total: number, charging: number, driving: number, stopover: number, ferry: number }, sections: Array<{ __typename?: 'RouteDetailsLegSection', type: RouteDetailsLegSectionType, polyline: string, duration: number, distance: number, origin: { __typename?: 'RouteDetailsLegSectionFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> } }, destination: { __typename?: 'RouteDetailsLegSectionFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> } }, traffic?: { __typename?: 'RouteDetailsLegSectionTraffic', congestions: Array<{ __typename?: 'TrafficCongestionInterval', start_index: number, end_index: number, level: CongestionLevel }> } | null }>, destination: { __typename?: 'RouteDetailsLegFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> }, properties?: { __typename?: 'RouteDetailsLegFeatureProperties', name?: string | null, temperature?: number | null, total_cargo_weight?: number | null } | null }, origin: { __typename?: 'RouteDetailsLegFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> }, properties?: { __typename?: 'RouteDetailsLegFeatureProperties', name?: string | null, temperature?: number | null, total_cargo_weight?: number | null } | null }, station?: { __typename?: 'RouteDetailsLegStation', station_id: string, evse_id?: string | null, connector_id: string } | null, warnings?: Array<{ __typename?: 'RouteDetailsLegWarning', code: RouteDetailsLegWarningCode }> | null }>, path_plot: Array<{ __typename?: 'RouteDetailsPathSegment', consumption?: number | null, elevation: number, distance: number, state_of_charge?: number | null, average_speed: number }>, warnings?: Array<{ __typename?: 'RouteWarning', code: RouteWarningCode }> | null }> | null, request_input: { __typename?: 'CreateRoute', alternative_routes?: number | null, departure_time: any, avoid?: Array<RouteAvoid> | null, traffic_aware?: boolean | null, vehicle: { __typename?: 'RouteVehicle', id: string, climate: boolean, battery: { __typename?: 'RouteVehicleBattery', capacity: { __typename?: 'StateOfCharge', value: number, type: StateOfChargeUnit }, state_of_charge: { __typename?: 'StateOfCharge', value: number, type: StateOfChargeUnit }, final_state_of_charge: { __typename?: 'StateOfCharge', value: number, type: StateOfChargeUnit } }, charging: { __typename?: 'RouteVehicleCharging', minimum_power: number, risk_margin: number, mode: ChargeMode, adapters: Array<{ __typename?: 'RouteVehicleChargingConnector', standard: ConnectorType, maximum_charge_speed: { __typename?: 'ChargeSpeed', type: ChargeSpeedUnit, value: number } }> } }, origin: { __typename?: 'RouteOriginFeaturePoint', type: FeatureType, geometry: { __typename?: 'Point', type: PointType, coordinates: Array<number> }, properties?: { __typename?: 'RouteOriginProperties', vehicle?: { __typename?: 'RoutePropertiesVehicle', occupants: number, total_occupant_weight: { __typename?: 'TotalOccupantWeight', value: number, type: WeightUnit, source: TelemetryInputSource }, total_cargo_weight?: { __typename?: 'TotalCargoWeight', value: number, type: WeightUnit, source: TelemetryInputSource } | null } | null, location?: { __typename?: 'RoutePropertiesLocation', name?: string | null } | null } | null }, destination: { __typename?: 'RouteDestinationFeaturePoint', type: FeatureType, geometry?: { __typename?: 'Point', type: PointType, coordinates: Array<number> } | null, properties?: { __typename?: 'RouteDestinationProperties', location?: { __typename?: 'RoutePropertiesLocation', name?: string | null } | null, station?: { __typename?: 'RoutePropertiesStation', station_id?: string | null, external_station_id?: string | null } | null } | null }, via?: Array<{ __typename?: 'RouteViaFeaturePoint', type: FeatureType, geometry?: { __typename?: 'Point', type: PointType, coordinates: Array<number> } | null, properties?: { __typename?: 'RouteViaProperties', vehicle?: { __typename?: 'RoutePropertiesVehicle', occupants: number, total_occupant_weight: { __typename?: 'TotalOccupantWeight', value: number, type: WeightUnit, source: TelemetryInputSource }, total_cargo_weight?: { __typename?: 'TotalCargoWeight', value: number, type: WeightUnit, source: TelemetryInputSource } | null } | null, location?: { __typename?: 'RoutePropertiesViaLocation', name?: string | null, stop_duration?: number | null } | null, station?: { __typename?: 'RoutePropertiesStation', station_id?: string | null, external_station_id?: string | null } | null } | null }> | null, weather?: { __typename?: 'RouteWeather', type: WeatherType } | null, operators?: { __typename?: 'RouteOperatorPreferences', exclude?: Array<{ __typename?: 'RouteOperatorsValue', id: string, countries?: Array<CountryCodeAlpha2> | null }> | null, ranking?: { __typename?: 'RouteOperatorPreferencesRanking', type: RouteOperatorsType, levels?: { __typename?: 'RouteOperatorPreferencesRankingLevels', high?: Array<{ __typename?: 'RouteOperatorsValue', id: string, countries?: Array<CountryCodeAlpha2> | null }> | null, medium?: Array<{ __typename?: 'RouteOperatorsValue', id: string, countries?: Array<CountryCodeAlpha2> | null }> | null, low?: Array<{ __typename?: 'RouteOperatorsValue', id: string, countries?: Array<CountryCodeAlpha2> | null }> | null } | null } | null } | null, driving_preferences?: { __typename?: 'RouteDrivingPreferences', speed_factor?: number | null, style?: RouteDrivingStyle | null, maximum_speed?: { __typename?: 'MaximumSpeed', value: number, type: SpeedUnit } | null } | null, station_preferences?: { __typename?: 'RouteStationPreferences', prefer_highway_charging?: boolean | null } | null, alternative_station_radius?: { __typename?: 'AlternativeStationRadius', value: number, type: DistanceUnit } | null } } };

export type StationQueryVariables = Exact<{
  stationId: Scalars['ID']['input'];
  useTariff: Scalars['Boolean']['input'];
}>;


export type StationQuery = { __typename?: 'Query', station?: { __typename?: 'Station', id: string, name?: string | null, address?: string | null, last_updated?: any | null, external_id?: string | null, country?: string | null, time_zone?: string | null, amenities?: any | null, access_type?: AccessType | null, parking_type?: OcpiParkingType | null, reliability_score?: number | null, adhoc_authorisation_payment_method?: Array<StationAdhocAuthorisationPaymentMethod> | null, speed?: StationSpeedType | null, status?: ChargerStatus | null, coordinates?: { __typename?: 'OCPIGeoLocation', latitude?: string | null, longitude?: string | null } | null, opening_times?: { __typename?: 'OCPIHours', twentyfourseven?: boolean | null, regular_hours?: Array<{ __typename?: 'OCPIRegularHours', weekday?: number | null, period_begin?: string | null, period_end?: string | null } | null> | null } | null, predicted_occupancy?: Array<{ __typename?: 'StationPredictedOccupancy', weekday?: number | null, occupancy?: number | null, period_begin?: string | null, period_end?: string | null } | null> | null, operator?: { __typename?: 'Operator', id?: string | null, name?: string | null, website?: string | null } | null, roaming?: Array<{ __typename?: 'StationRoaming', emsp?: string | null, card?: string | null, partner_id?: string | null, android_app_link?: string | null, ios_app_link?: string | null } | null> | null, evses?: Array<{ __typename?: 'EVSE', uid?: string | null, last_updated?: any | null, evse_id?: string | null, capabilities?: Array<OcpiCapability | null> | null, status?: OcpiStatus | null, connectors?: Array<{ __typename?: 'Connector', id?: string | null, standard?: ConnectorType | null, format?: OcpiConnectorFormat | null, power?: number | null, last_updated?: any | null, properties?: any | null, prices?: Array<{ __typename?: 'ConnectorPrice', external_id: string, partner_id: string, partner?: string | null, product: { __typename?: 'ConnectorPriceProduct', name: string, type: ConnectorPriceProductType, description: string, subscription_type: ConnectorPriceProductSubscriptionType, subscription_fee_excl_vat: number, currency: CurrencyUnit }, elements: Array<{ __typename?: 'ConnectorPriceElement', components: Array<{ __typename?: 'ConnectorPriceElementComponent', type: ConnectorPriceElementComponentType, price_excl_vat: number, vat: number, step_size: number }>, restrictions?: { __typename?: 'ConnectorPriceElementRestrictions', start_time?: string | null, end_time?: string | null, start_date?: string | null, end_date?: string | null, minimum_kwh?: number | null, maximum_kwh?: number | null, minimum_power?: number | null, maximum_power?: number | null, minimum_current?: number | null, maximum_current?: number | null, minimum_duration?: number | null, maximum_duration?: number | null, minimum_price?: number | null, maximum_price?: number | null, overstay_battery_percentage?: { __typename?: 'ConnectorPriceRestrictionsOverstayBatteryPercentage', minimum?: number | null, maximum?: number | null, unit?: ConnectorPriceRestrictionsOverstayTimeUnit | null } | null, overstay_time?: { __typename?: 'ConnectorPriceRestrictionsOverstayTime', minimum?: number | null, maximum?: number | null, unit?: ConnectorPriceRestrictionsOverstayTimeUnit | null } | null } | null }> }> | null, tariff?: Array<{ __typename?: 'OCPITariff', currency?: string | null, party_id?: string | null, id?: string | null, type?: OcpiTariffType | null, elements?: Array<{ __typename?: 'OCPITariffElement', price_components?: Array<{ __typename?: 'OCPIPriceComponent', type?: OcpiTariffDimensionType | null, price?: number | null, vat?: number | null, step_size?: number | null } | null> | null, restrictions?: Array<{ __typename?: 'OCPITariffRestrictions', start_time?: string | null, end_time?: string | null, start_date?: string | null, end_date?: string | null, min_kwh?: number | null, max_kwh?: number | null, min_power?: number | null, max_power?: number | null, min_current?: number | null, max_current?: number | null, day_of_week?: OcpiDayOfWeek | null, reservation?: OcpiReservationRestrictionType | null, max_duration?: number | null, min_duration?: number | null } | null> | null } | null> | null } | null> | null } | null> | null } | null> | null, vehicle_restrictions?: { __typename?: 'StationVehicleRestrictions', mass?: number | null, width?: number | null, height?: number | null, length?: number | null } | null, heavy_vehicles_restrictions?: { __typename?: 'StationHeavyVehiclesRestrictions', mass?: number | null, width?: number | null, height?: number | null, length?: number | null, allowed_types_EU?: Array<HeavyVehiclesEuType> | null } | null, heavy_vehicles_properties?: { __typename?: 'StationHeavyVehiclesProperties', facilities?: Array<HeavyVehiclesFacility> | null, is_trailer_accessible?: boolean | null, is_drive_through?: boolean | null, allows_dangerous_goods?: boolean | null, allows_rigid_vehicles?: boolean | null, allows_overnight_parking?: boolean | null } | null } | null };

export type GetStationAroundQueryVariables = Exact<{
  query?: InputMaybe<StationAroundQuery>;
  filter?: InputMaybe<StationAroundFilter>;
  size?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetStationAroundQuery = { __typename?: 'Query', stationAround?: Array<{ __typename?: 'Station', id: string, name?: string | null, last_updated?: any | null, location?: { __typename?: 'Point', coordinates: Array<number> } | null, operator?: { __typename?: 'Operator', id?: string | null, name?: string | null } | null, evses?: Array<{ __typename?: 'EVSE', status?: OcpiStatus | null, connectors?: Array<{ __typename?: 'Connector', standard?: ConnectorType | null, power?: number | null } | null> | null } | null> | null } | null> | null };

export type GetTruckRouteQueryVariables = Exact<{
  routeId: Scalars['ID']['input'];
}>;


export type GetTruckRouteQuery = { __typename?: 'Query', getRoute: { __typename?: 'TruckRouteResponse', id: string, status: RouteStatus, meta: { __typename?: 'RouteMetadata', created_at: any }, recommended?: { __typename?: 'TruckRouteDetails', id: string, charges: number, consumption?: number | null, distance: number, polyline: string, range_at_origin?: number | null, range_at_destination?: number | null, tags: Array<RouteDetailsTag>, alternative_stations: Array<{ __typename?: 'RouteDetailsAlternativeStation', id: string, operator_ranking?: OperatorRankingLevel | null, operator_id?: string | null, location: { __typename?: 'Point', coordinates: Array<number> } }>, durations: { __typename?: 'RouteDetailsDurations', total: number, charging: number }, elevation: { __typename?: 'RouteDetailsElevation', down: number, maximum: number, minimum: number, up: number }, legs: Array<{ __typename?: 'TruckRouteDetailsLeg', polyline: string, type: RouteDetailsLegType, distance: number, consumption?: number | null, range_at_origin?: number | null, range_after_charge?: number | null, range_at_destination?: number | null, tags: Array<RouteDetailsTag>, range_at_origin_percentage?: number | null, range_after_charge_percentage?: number | null, range_at_destination_percentage?: number | null, durations: { __typename?: 'RouteDetailsDurations', total: number, charging: number, driving: number, stopover: number, ferry: number }, sections: Array<{ __typename?: 'TruckRouteDetailsLegSection', type: RouteDetailsLegSectionType, polyline: string, duration: number, distance: number, consumption?: number | null, tags: Array<RouteDetailsTag>, origin: { __typename?: 'TruckRouteDetailsLegSectionFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> }, properties: { __typename?: 'TruckRouteDetailsLegSectionFeaturePointProperties', occupants: number, total_cargo_weight?: number | null, total_occupant_weight?: number | null, trailer_count: number } }, destination: { __typename?: 'TruckRouteDetailsLegSectionFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> }, properties: { __typename?: 'TruckRouteDetailsLegSectionFeaturePointProperties', occupants: number, total_cargo_weight?: number | null, total_occupant_weight?: number | null, trailer_count: number } } }>, destination: { __typename?: 'TruckRouteDetailsLegFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> }, properties?: { __typename?: 'TruckRouteDetailsLegFeatureProperties', name?: string | null, temperature?: number | null, total_cargo_weight?: number | null, total_occupant_weight: number, trailer_count: number } | null }, origin: { __typename?: 'TruckRouteDetailsLegFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> }, properties?: { __typename?: 'TruckRouteDetailsLegFeatureProperties', name?: string | null, temperature?: number | null, total_cargo_weight?: number | null, total_occupant_weight: number, trailer_count: number } | null }, station?: { __typename?: 'RouteDetailsLegStation', station_id: string, evse_id?: string | null, connector_id: string } | null }>, path_plot: Array<{ __typename?: 'RouteDetailsPathSegment', consumption?: number | null, elevation: number, distance: number, state_of_charge?: number | null, average_speed: number }>, savings?: { __typename?: 'RouteDetailsSavings', money?: number | null, average_gas_price: number, average_energy_price: number } | null } | null, request_input: { __typename?: 'CreateTruckRoute', departure_time?: any | null, avoid?: Array<RouteTruckAvoid> | null, vehicle: { __typename?: 'RouteTruckVehicle', id: string, climate: boolean, battery: { __typename?: 'RouteVehicleBattery', capacity: { __typename?: 'StateOfCharge', value: number, type: StateOfChargeUnit }, state_of_charge: { __typename?: 'StateOfCharge', value: number, type: StateOfChargeUnit }, final_state_of_charge: { __typename?: 'StateOfCharge', value: number, type: StateOfChargeUnit } }, charging: { __typename?: 'RouteVehicleCharging', mode: ChargeMode, adapters: Array<{ __typename?: 'RouteVehicleChargingConnector', standard: ConnectorType, maximum_charge_speed: { __typename?: 'ChargeSpeed', type: ChargeSpeedUnit, value: number } }> } }, origin: { __typename?: 'RouteTruckOriginFeaturePoint', type: FeatureType, geometry: { __typename?: 'Point', type: PointType, coordinates: Array<number> }, properties?: { __typename?: 'RouteTruckOriginProperties', location?: { __typename?: 'RouteTruckPropertiesLocation', name?: string | null } | null, vehicle?: { __typename?: 'RouteTruckPropertiesVehicle', axles_in_use?: number | null, occupants: number, total_cargo_weight?: { __typename?: 'TotalCargoWeight', value: number, type: WeightUnit, source: TelemetryInputSource } | null, total_occupant_weight?: { __typename?: 'TotalOccupantWeight', value: number, type: WeightUnit, source: TelemetryInputSource } | null, trailer?: { __typename?: 'RouteTruckVehicleTrailer', axles_in_use: number, count: number, unladen_weight: number, combined_vehicle_dimensions: { __typename?: 'TruckTrailerCombinedDimensions', height: number, length: number, width: number } } | null } | null } | null }, destination: { __typename?: 'RouteDestinationFeaturePoint', type: FeatureType, geometry?: { __typename?: 'Point', type: PointType, coordinates: Array<number> } | null, properties?: { __typename?: 'RouteDestinationProperties', location?: { __typename?: 'RoutePropertiesLocation', name?: string | null } | null, station?: { __typename?: 'RoutePropertiesStation', station_id?: string | null, external_station_id?: string | null } | null } | null }, via?: Array<{ __typename?: 'RouteTruckViaFeaturePoint', type: FeatureType, geometry?: { __typename?: 'Point', type: PointType, coordinates: Array<number> } | null, properties?: { __typename?: 'RouteTruckViaProperties', vehicle?: { __typename?: 'RouteTruckPropertiesVehicle', axles_in_use?: number | null, occupants: number, total_cargo_weight?: { __typename?: 'TotalCargoWeight', value: number, type: WeightUnit, source: TelemetryInputSource } | null, total_occupant_weight?: { __typename?: 'TotalOccupantWeight', value: number, type: WeightUnit, source: TelemetryInputSource } | null, trailer?: { __typename?: 'RouteTruckVehicleTrailer', axles_in_use: number, count: number, unladen_weight: number, combined_vehicle_dimensions: { __typename?: 'TruckTrailerCombinedDimensions', height: number, length: number, width: number } } | null } | null, location?: { __typename?: 'RoutePropertiesViaLocation', name?: string | null, stop_duration?: number | null } | null, station?: { __typename?: 'RoutePropertiesStation', station_id?: string | null, external_station_id?: string | null } | null } | null }> | null, alternative_station_radius?: { __typename?: 'AlternativeStationRadius', value: number, type: DistanceUnit } | null, maximum_speed?: { __typename?: 'MaximumSpeed', value: number, type: SpeedUnit } | null, operators?: { __typename?: 'RouteOperatorPreferences', exclude?: Array<{ __typename?: 'RouteOperatorsValue', id: string, countries?: Array<CountryCodeAlpha2> | null }> | null, ranking?: { __typename?: 'RouteOperatorPreferencesRanking', type: RouteOperatorsType, levels?: { __typename?: 'RouteOperatorPreferencesRankingLevels', high?: Array<{ __typename?: 'RouteOperatorsValue', id: string, countries?: Array<CountryCodeAlpha2> | null }> | null, medium?: Array<{ __typename?: 'RouteOperatorsValue', id: string, countries?: Array<CountryCodeAlpha2> | null }> | null, low?: Array<{ __typename?: 'RouteOperatorsValue', id: string, countries?: Array<CountryCodeAlpha2> | null }> | null } | null } | null } | null, weather?: { __typename?: 'RouteWeather', type: WeatherType, custom?: { __typename?: 'RouteWeatherCustomConditions', air_pressure: { __typename?: 'AirPressure', type: AirPressureUnit, value: number }, solar_irradiance: { __typename?: 'SolarIrradiance', type: SolarIrradianceUnit, value: number }, temperature: { __typename?: 'Temperature', value: number, type: TemperatureUnit } } | null } | null } } };

export type VehicleListQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<VehicleListFilter>;
  size?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<CountryCodeAlpha2>;
}>;


export type VehicleListQuery = { __typename?: 'Query', vehicleList?: Array<{ __typename?: 'VehicleList', id: string, naming: { __typename?: 'VehicleListNaming', make: string, model: string, chargetrip_version: string }, media: { __typename?: 'VehicleListMedia', image: { __typename?: 'VehicleImage', thumbnail_url: string, thumbnail_width: number, thumbnail_height: number }, make: { __typename?: 'VehicleImage', thumbnail_url: string, thumbnail_width: number, thumbnail_height: number } }, range: { __typename?: 'VehicleListRange', chargetrip_range: { __typename?: 'ChargetripRange', best?: number | null, worst?: number | null } } } | null> | null };

export type VehicleMakesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCodeAlpha2>;
  filter?: InputMaybe<VehicleMakesFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type VehicleMakesQuery = { __typename?: 'Query', vehicleMakes?: { __typename?: 'VehicleMakesConnection', nodes: Array<{ __typename?: 'VehicleMake', id: string, name: string, model_count: number, image: { __typename?: 'VehicleImage', thumbnail_width: number, thumbnail_height: number, thumbnail_url: string } }>, page_info: { __typename?: 'PageInfo', end_cursor?: string | null, has_next_page: boolean, has_previous_page: boolean, start_cursor?: string | null } } | null };

export type VehicleModelsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCodeAlpha2>;
  filter?: InputMaybe<VehicleModelsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type VehicleModelsQuery = { __typename?: 'Query', vehicleModels?: { __typename?: 'VehicleModelsConnection', nodes: Array<{ __typename?: 'VehicleModel', name: string, vehicle_count: number }>, page_info: { __typename?: 'PageInfo', end_cursor?: string | null, has_next_page: boolean, has_previous_page: boolean, start_cursor?: string | null } } | null };

export type VehicleQueryVariables = Exact<{
  vehicle_id: Scalars['ID']['input'];
  country?: InputMaybe<CountryCodeAlpha2>;
}>;


export type VehicleQuery = { __typename?: 'Query', vehicle?: { __typename?: 'Vehicle', id: string, purpose: VehiclePurpose, naming: { __typename?: 'VehicleNaming', make: string, model: string, chargetrip_version: string }, range: { __typename?: 'VehicleRange', chargetrip_range: { __typename?: 'ChargetripRange', best?: number | null, worst?: number | null }, best: { __typename?: 'VehicleRangeValue', highway: number, city: number, combined: number }, worst: { __typename?: 'VehicleRangeValue', highway: number, city: number, combined: number } }, drivetrain: { __typename?: 'VehicleDrivetrain', type: VehicleDrivetrainType }, battery: { __typename?: 'VehicleBattery', usable_kwh: number }, media: { __typename?: 'VehicleMedia', image: { __typename?: 'VehicleImage', url: string, width: number, height: number, thumbnail_url: string, thumbnail_width: number, thumbnail_height: number }, make: { __typename?: 'VehicleImage', thumbnail_url: string, thumbnail_width: number, thumbnail_height: number } }, connect: { __typename?: 'Connect', providers?: Array<ConnectProvider> | null }, connectors: Array<{ __typename?: 'VehicleConnector', standard: ConnectorType, power: number }>, adapters: Array<{ __typename?: 'VehicleConnector', standard: ConnectorType, power: number, time: number }>, body: { __typename?: 'VehicleBody', seats: number, width: number, height: number, weight: { __typename?: 'VehicleBodyWeight', nominal?: number | null } } } | null };

export type VehicleNamingQueryVariables = Exact<{
  vehicle_id: Scalars['ID']['input'];
}>;


export type VehicleNamingQuery = { __typename?: 'Query', vehicle?: { __typename?: 'Vehicle', id: string, drivetrain: { __typename?: 'VehicleDrivetrain', type: VehicleDrivetrainType }, media: { __typename?: 'VehicleMedia', image: { __typename?: 'VehicleImage', thumbnail_url: string } }, naming: { __typename?: 'VehicleNaming', make: string, model: string, chargetrip_version: string }, connectors: Array<{ __typename?: 'VehicleConnector', standard: ConnectorType, power: number }>, battery: { __typename?: 'VehicleBattery', usable_kwh: number } } | null };

export type IsolineSubscriptionSubscriptionVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IsolineSubscriptionSubscription = { __typename?: 'Subscription', isoline?: { __typename?: 'Isoline', id: string, status: IsolineStatus, maximum_distance?: number | null, polygons?: Array<{ __typename?: 'FeatureMultiPolygon', type: FeatureType, geometry: { __typename?: 'MultiPolygon', type: MultiPolygonType, coordinates: Array<Array<Array<Array<number> | null> | null> | null> }, properties?: { __typename?: 'PolygonProperties', index?: number | null } | null } | null> | null, ferries?: Array<{ __typename?: 'FeatureLineString', geometry: { __typename?: 'LineString', coordinates: Array<Array<number> | null> } } | null> | null, request_input?: { __typename?: 'IsolineRequestInput', polygon_count?: number | null, state_of_charge: number, vehicle_id: string, origin: { __typename?: 'FeaturePoint', type: FeatureType, properties?: any | null, geometry: { __typename?: 'Point', type: PointType, coordinates: Array<number> } }, weather?: { __typename?: 'IsolineWeather', type: WeatherType } | null } | null } | null };

export type RouteSubscriptionVariables = Exact<{
  routeId: Scalars['ID']['input'];
  hasAlternatives: Scalars['Boolean']['input'];
}>;


export type RouteSubscription = { __typename?: 'Subscription', route: { __typename?: 'RouteResponse', id: string, status: RouteStatus, meta: { __typename?: 'RouteMetadata', created_at: any }, recommended?: { __typename?: 'RouteDetails', id: string, charges: number, consumption?: number | null, distance: number, polyline: string, tags: Array<RouteDetailsTag>, alternative_stations: Array<{ __typename?: 'RouteDetailsAlternativeStation', id: string, operator_ranking?: OperatorRankingLevel | null, operator_id?: string | null, location: { __typename?: 'Point', coordinates: Array<number> } }>, durations: { __typename?: 'RouteDetailsDurations', total: number, charging: number, driving: number }, traffic?: { __typename?: 'RouteDetailsTraffic', delay: number } | null, legs: Array<{ __typename?: 'RouteDetailsLeg', polyline: string, type: RouteDetailsLegType, distance: number, consumption?: number | null, range_at_origin?: number | null, range_after_charge?: number | null, range_at_destination?: number | null, tags: Array<RouteDetailsTag>, range_at_origin_percentage?: number | null, range_after_charge_percentage?: number | null, range_at_destination_percentage?: number | null, durations: { __typename?: 'RouteDetailsDurations', total: number, charging: number, driving: number, stopover: number, ferry: number }, sections: Array<{ __typename?: 'RouteDetailsLegSection', type: RouteDetailsLegSectionType, polyline: string, duration: number, distance: number, origin: { __typename?: 'RouteDetailsLegSectionFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> } }, destination: { __typename?: 'RouteDetailsLegSectionFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> } }, traffic?: { __typename?: 'RouteDetailsLegSectionTraffic', congestions: Array<{ __typename?: 'TrafficCongestionInterval', start_index: number, end_index: number, level: CongestionLevel }> } | null }>, destination: { __typename?: 'RouteDetailsLegFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> }, properties?: { __typename?: 'RouteDetailsLegFeatureProperties', name?: string | null, temperature?: number | null, total_cargo_weight?: number | null } | null }, origin: { __typename?: 'RouteDetailsLegFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> }, properties?: { __typename?: 'RouteDetailsLegFeatureProperties', name?: string | null, temperature?: number | null, total_cargo_weight?: number | null } | null }, station?: { __typename?: 'RouteDetailsLegStation', station_id: string, evse_id?: string | null, connector_id: string } | null, warnings?: Array<{ __typename?: 'RouteDetailsLegWarning', code: RouteDetailsLegWarningCode }> | null }>, path_plot: Array<{ __typename?: 'RouteDetailsPathSegment', consumption?: number | null, elevation: number, distance: number, state_of_charge?: number | null, average_speed: number }>, warnings?: Array<{ __typename?: 'RouteWarning', code: RouteWarningCode }> | null } | null, alternatives?: Array<{ __typename?: 'RouteDetails', id: string, charges: number, consumption?: number | null, distance: number, polyline: string, tags: Array<RouteDetailsTag>, alternative_stations: Array<{ __typename?: 'RouteDetailsAlternativeStation', id: string, operator_ranking?: OperatorRankingLevel | null, operator_id?: string | null, location: { __typename?: 'Point', coordinates: Array<number> } }>, durations: { __typename?: 'RouteDetailsDurations', total: number, charging: number, driving: number }, traffic?: { __typename?: 'RouteDetailsTraffic', delay: number } | null, legs: Array<{ __typename?: 'RouteDetailsLeg', polyline: string, type: RouteDetailsLegType, distance: number, consumption?: number | null, range_at_origin?: number | null, range_after_charge?: number | null, range_at_destination?: number | null, tags: Array<RouteDetailsTag>, range_at_origin_percentage?: number | null, range_after_charge_percentage?: number | null, range_at_destination_percentage?: number | null, durations: { __typename?: 'RouteDetailsDurations', total: number, charging: number, driving: number, stopover: number, ferry: number }, sections: Array<{ __typename?: 'RouteDetailsLegSection', type: RouteDetailsLegSectionType, polyline: string, duration: number, distance: number, origin: { __typename?: 'RouteDetailsLegSectionFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> } }, destination: { __typename?: 'RouteDetailsLegSectionFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> } }, traffic?: { __typename?: 'RouteDetailsLegSectionTraffic', congestions: Array<{ __typename?: 'TrafficCongestionInterval', start_index: number, end_index: number, level: CongestionLevel }> } | null }>, destination: { __typename?: 'RouteDetailsLegFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> }, properties?: { __typename?: 'RouteDetailsLegFeatureProperties', name?: string | null, temperature?: number | null, total_cargo_weight?: number | null } | null }, origin: { __typename?: 'RouteDetailsLegFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> }, properties?: { __typename?: 'RouteDetailsLegFeatureProperties', name?: string | null, temperature?: number | null, total_cargo_weight?: number | null } | null }, station?: { __typename?: 'RouteDetailsLegStation', station_id: string, evse_id?: string | null, connector_id: string } | null, warnings?: Array<{ __typename?: 'RouteDetailsLegWarning', code: RouteDetailsLegWarningCode }> | null }>, path_plot: Array<{ __typename?: 'RouteDetailsPathSegment', consumption?: number | null, elevation: number, distance: number, state_of_charge?: number | null, average_speed: number }>, warnings?: Array<{ __typename?: 'RouteWarning', code: RouteWarningCode }> | null }> | null, request_input: { __typename?: 'CreateRoute', alternative_routes?: number | null, departure_time: any, avoid?: Array<RouteAvoid> | null, traffic_aware?: boolean | null, vehicle: { __typename?: 'RouteVehicle', id: string, climate: boolean, battery: { __typename?: 'RouteVehicleBattery', capacity: { __typename?: 'StateOfCharge', value: number, type: StateOfChargeUnit }, state_of_charge: { __typename?: 'StateOfCharge', value: number, type: StateOfChargeUnit }, final_state_of_charge: { __typename?: 'StateOfCharge', value: number, type: StateOfChargeUnit } }, charging: { __typename?: 'RouteVehicleCharging', minimum_power: number, risk_margin: number, mode: ChargeMode, adapters: Array<{ __typename?: 'RouteVehicleChargingConnector', standard: ConnectorType, maximum_charge_speed: { __typename?: 'ChargeSpeed', type: ChargeSpeedUnit, value: number } }> } }, origin: { __typename?: 'RouteOriginFeaturePoint', type: FeatureType, geometry: { __typename?: 'Point', type: PointType, coordinates: Array<number> }, properties?: { __typename?: 'RouteOriginProperties', vehicle?: { __typename?: 'RoutePropertiesVehicle', occupants: number, total_occupant_weight: { __typename?: 'TotalOccupantWeight', value: number, type: WeightUnit, source: TelemetryInputSource }, total_cargo_weight?: { __typename?: 'TotalCargoWeight', value: number, type: WeightUnit, source: TelemetryInputSource } | null } | null, location?: { __typename?: 'RoutePropertiesLocation', name?: string | null } | null } | null }, destination: { __typename?: 'RouteDestinationFeaturePoint', type: FeatureType, geometry?: { __typename?: 'Point', type: PointType, coordinates: Array<number> } | null, properties?: { __typename?: 'RouteDestinationProperties', location?: { __typename?: 'RoutePropertiesLocation', name?: string | null } | null, station?: { __typename?: 'RoutePropertiesStation', station_id?: string | null, external_station_id?: string | null } | null } | null }, via?: Array<{ __typename?: 'RouteViaFeaturePoint', type: FeatureType, geometry?: { __typename?: 'Point', type: PointType, coordinates: Array<number> } | null, properties?: { __typename?: 'RouteViaProperties', vehicle?: { __typename?: 'RoutePropertiesVehicle', occupants: number, total_occupant_weight: { __typename?: 'TotalOccupantWeight', value: number, type: WeightUnit, source: TelemetryInputSource }, total_cargo_weight?: { __typename?: 'TotalCargoWeight', value: number, type: WeightUnit, source: TelemetryInputSource } | null } | null, location?: { __typename?: 'RoutePropertiesViaLocation', name?: string | null, stop_duration?: number | null } | null, station?: { __typename?: 'RoutePropertiesStation', station_id?: string | null, external_station_id?: string | null } | null } | null }> | null, weather?: { __typename?: 'RouteWeather', type: WeatherType } | null, operators?: { __typename?: 'RouteOperatorPreferences', exclude?: Array<{ __typename?: 'RouteOperatorsValue', id: string, countries?: Array<CountryCodeAlpha2> | null }> | null, ranking?: { __typename?: 'RouteOperatorPreferencesRanking', type: RouteOperatorsType, levels?: { __typename?: 'RouteOperatorPreferencesRankingLevels', high?: Array<{ __typename?: 'RouteOperatorsValue', id: string, countries?: Array<CountryCodeAlpha2> | null }> | null, medium?: Array<{ __typename?: 'RouteOperatorsValue', id: string, countries?: Array<CountryCodeAlpha2> | null }> | null, low?: Array<{ __typename?: 'RouteOperatorsValue', id: string, countries?: Array<CountryCodeAlpha2> | null }> | null } | null } | null } | null, driving_preferences?: { __typename?: 'RouteDrivingPreferences', speed_factor?: number | null, style?: RouteDrivingStyle | null, maximum_speed?: { __typename?: 'MaximumSpeed', value: number, type: SpeedUnit } | null } | null, station_preferences?: { __typename?: 'RouteStationPreferences', prefer_highway_charging?: boolean | null } | null, alternative_station_radius?: { __typename?: 'AlternativeStationRadius', value: number, type: DistanceUnit } | null } } };

export type TruckRouteSubscriptionVariables = Exact<{
  routeId: Scalars['ID']['input'];
}>;


export type TruckRouteSubscription = { __typename?: 'Subscription', route: { __typename?: 'TruckRouteResponse', id: string, status: RouteStatus, meta: { __typename?: 'RouteMetadata', created_at: any }, recommended?: { __typename?: 'TruckRouteDetails', id: string, charges: number, consumption?: number | null, distance: number, polyline: string, range_at_origin?: number | null, range_at_destination?: number | null, tags: Array<RouteDetailsTag>, alternative_stations: Array<{ __typename?: 'RouteDetailsAlternativeStation', id: string, operator_ranking?: OperatorRankingLevel | null, operator_id?: string | null, location: { __typename?: 'Point', coordinates: Array<number> } }>, durations: { __typename?: 'RouteDetailsDurations', total: number, charging: number }, elevation: { __typename?: 'RouteDetailsElevation', down: number, maximum: number, minimum: number, up: number }, legs: Array<{ __typename?: 'TruckRouteDetailsLeg', polyline: string, type: RouteDetailsLegType, distance: number, consumption?: number | null, range_at_origin?: number | null, range_after_charge?: number | null, range_at_destination?: number | null, tags: Array<RouteDetailsTag>, range_at_origin_percentage?: number | null, range_after_charge_percentage?: number | null, range_at_destination_percentage?: number | null, durations: { __typename?: 'RouteDetailsDurations', total: number, charging: number, driving: number, stopover: number, ferry: number }, sections: Array<{ __typename?: 'TruckRouteDetailsLegSection', type: RouteDetailsLegSectionType, polyline: string, duration: number, distance: number, consumption?: number | null, tags: Array<RouteDetailsTag>, origin: { __typename?: 'TruckRouteDetailsLegSectionFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> }, properties: { __typename?: 'TruckRouteDetailsLegSectionFeaturePointProperties', occupants: number, total_cargo_weight?: number | null, total_occupant_weight?: number | null, trailer_count: number } }, destination: { __typename?: 'TruckRouteDetailsLegSectionFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> }, properties: { __typename?: 'TruckRouteDetailsLegSectionFeaturePointProperties', occupants: number, total_cargo_weight?: number | null, total_occupant_weight?: number | null, trailer_count: number } } }>, destination: { __typename?: 'TruckRouteDetailsLegFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> }, properties?: { __typename?: 'TruckRouteDetailsLegFeatureProperties', name?: string | null, temperature?: number | null, total_cargo_weight?: number | null, total_occupant_weight: number, trailer_count: number } | null }, origin: { __typename?: 'TruckRouteDetailsLegFeaturePoint', geometry: { __typename?: 'Point', coordinates: Array<number> }, properties?: { __typename?: 'TruckRouteDetailsLegFeatureProperties', name?: string | null, temperature?: number | null, total_cargo_weight?: number | null, total_occupant_weight: number, trailer_count: number } | null }, station?: { __typename?: 'RouteDetailsLegStation', station_id: string, evse_id?: string | null, connector_id: string } | null }>, path_plot: Array<{ __typename?: 'RouteDetailsPathSegment', consumption?: number | null, elevation: number, distance: number, state_of_charge?: number | null, average_speed: number }>, savings?: { __typename?: 'RouteDetailsSavings', money?: number | null, average_gas_price: number, average_energy_price: number } | null } | null, request_input: { __typename?: 'CreateTruckRoute', departure_time?: any | null, avoid?: Array<RouteTruckAvoid> | null, vehicle: { __typename?: 'RouteTruckVehicle', id: string, climate: boolean, battery: { __typename?: 'RouteVehicleBattery', capacity: { __typename?: 'StateOfCharge', value: number, type: StateOfChargeUnit }, state_of_charge: { __typename?: 'StateOfCharge', value: number, type: StateOfChargeUnit }, final_state_of_charge: { __typename?: 'StateOfCharge', value: number, type: StateOfChargeUnit } }, charging: { __typename?: 'RouteVehicleCharging', mode: ChargeMode, adapters: Array<{ __typename?: 'RouteVehicleChargingConnector', standard: ConnectorType, maximum_charge_speed: { __typename?: 'ChargeSpeed', type: ChargeSpeedUnit, value: number } }> } }, origin: { __typename?: 'RouteTruckOriginFeaturePoint', type: FeatureType, geometry: { __typename?: 'Point', type: PointType, coordinates: Array<number> }, properties?: { __typename?: 'RouteTruckOriginProperties', location?: { __typename?: 'RouteTruckPropertiesLocation', name?: string | null } | null, vehicle?: { __typename?: 'RouteTruckPropertiesVehicle', axles_in_use?: number | null, occupants: number, total_cargo_weight?: { __typename?: 'TotalCargoWeight', value: number, type: WeightUnit, source: TelemetryInputSource } | null, total_occupant_weight?: { __typename?: 'TotalOccupantWeight', value: number, type: WeightUnit, source: TelemetryInputSource } | null, trailer?: { __typename?: 'RouteTruckVehicleTrailer', axles_in_use: number, count: number, unladen_weight: number, combined_vehicle_dimensions: { __typename?: 'TruckTrailerCombinedDimensions', height: number, length: number, width: number } } | null } | null } | null }, destination: { __typename?: 'RouteDestinationFeaturePoint', type: FeatureType, geometry?: { __typename?: 'Point', type: PointType, coordinates: Array<number> } | null, properties?: { __typename?: 'RouteDestinationProperties', location?: { __typename?: 'RoutePropertiesLocation', name?: string | null } | null, station?: { __typename?: 'RoutePropertiesStation', station_id?: string | null, external_station_id?: string | null } | null } | null }, via?: Array<{ __typename?: 'RouteTruckViaFeaturePoint', type: FeatureType, geometry?: { __typename?: 'Point', type: PointType, coordinates: Array<number> } | null, properties?: { __typename?: 'RouteTruckViaProperties', vehicle?: { __typename?: 'RouteTruckPropertiesVehicle', axles_in_use?: number | null, occupants: number, total_cargo_weight?: { __typename?: 'TotalCargoWeight', value: number, type: WeightUnit, source: TelemetryInputSource } | null, total_occupant_weight?: { __typename?: 'TotalOccupantWeight', value: number, type: WeightUnit, source: TelemetryInputSource } | null, trailer?: { __typename?: 'RouteTruckVehicleTrailer', axles_in_use: number, count: number, unladen_weight: number, combined_vehicle_dimensions: { __typename?: 'TruckTrailerCombinedDimensions', height: number, length: number, width: number } } | null } | null, location?: { __typename?: 'RoutePropertiesViaLocation', name?: string | null, stop_duration?: number | null } | null, station?: { __typename?: 'RoutePropertiesStation', station_id?: string | null, external_station_id?: string | null } | null } | null }> | null, alternative_station_radius?: { __typename?: 'AlternativeStationRadius', value: number, type: DistanceUnit } | null, maximum_speed?: { __typename?: 'MaximumSpeed', value: number, type: SpeedUnit } | null, operators?: { __typename?: 'RouteOperatorPreferences', exclude?: Array<{ __typename?: 'RouteOperatorsValue', id: string, countries?: Array<CountryCodeAlpha2> | null }> | null, ranking?: { __typename?: 'RouteOperatorPreferencesRanking', type: RouteOperatorsType, levels?: { __typename?: 'RouteOperatorPreferencesRankingLevels', high?: Array<{ __typename?: 'RouteOperatorsValue', id: string, countries?: Array<CountryCodeAlpha2> | null }> | null, medium?: Array<{ __typename?: 'RouteOperatorsValue', id: string, countries?: Array<CountryCodeAlpha2> | null }> | null, low?: Array<{ __typename?: 'RouteOperatorsValue', id: string, countries?: Array<CountryCodeAlpha2> | null }> | null } | null } | null } | null, weather?: { __typename?: 'RouteWeather', type: WeatherType, custom?: { __typename?: 'RouteWeatherCustomConditions', air_pressure: { __typename?: 'AirPressure', type: AirPressureUnit, value: number }, solar_irradiance: { __typename?: 'SolarIrradiance', type: SolarIrradianceUnit, value: number }, temperature: { __typename?: 'Temperature', value: number, type: TemperatureUnit } } | null } | null } } };
